window["Telescope"] = window["Telescope"] || {}; window["Telescope"]["App"] = window["Telescope"]["App"] || {}; window["Telescope"]["App"]["MTVAwards"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 112);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lo-Dash 2.4.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash underscore exports="amd,commonjs,global,node" -o ./dist/lodash.underscore.js`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre ES5 environments */
  var undefined;

  /** Used to generate unique IDs */
  var idCounter = 0;

  /** Used internally to indicate various things */
  var indicatorObject = {};

  /** Used to prefix keys to avoid issues with `__proto__` and properties on `Object.prototype` */
  var keyPrefix = +new Date + '';

  /** Used to match "interpolate" template delimiters */
  var reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to ensure capturing order of template delimiters */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals */
  var reUnescapedString = /['\n\r\t\u2028\u2029\\]/g;

  /** `Object#toString` result shortcuts */
  var argsClass = '[object Arguments]',
      arrayClass = '[object Array]',
      boolClass = '[object Boolean]',
      dateClass = '[object Date]',
      funcClass = '[object Function]',
      numberClass = '[object Number]',
      objectClass = '[object Object]',
      regexpClass = '[object RegExp]',
      stringClass = '[object String]';

  /** Used to determine if values are of the language type Object */
  var objectTypes = {
    'boolean': false,
    'function': true,
    'object': true,
    'number': false,
    'string': false,
    'undefined': false
  };

  /** Used to escape characters for inclusion in compiled string literals */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\t': 't',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Used as a reference to the global object */
  var root = (objectTypes[typeof window] && window) || this;

  /** Detect free variable `exports` */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module` */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports` */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */
  var freeGlobal = objectTypes[typeof global] && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal)) {
    root = freeGlobal;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `_.indexOf` without support for binary searches
   * or `fromIndex` constraints.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the matched value or `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    var index = (fromIndex || 0) - 1,
        length = array ? array.length : 0;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Used by `sortBy` to compare transformed `collection` elements, stable sorting
   * them in ascending order.
   *
   * @private
   * @param {Object} a The object to compare to `b`.
   * @param {Object} b The object to compare to `a`.
   * @returns {number} Returns the sort order indicator of `1` or `-1`.
   */
  function compareAscending(a, b) {
    var ac = a.criteria,
        bc = b.criteria,
        index = -1,
        length = ac.length;

    while (++index < length) {
      var value = ac[index],
          other = bc[index];

      if (value !== other) {
        if (value > other || typeof value == 'undefined') {
          return 1;
        }
        if (value < other || typeof other == 'undefined') {
          return -1;
        }
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to return the same value for
    // `a` and `b`. See https://github.com/jashkenas/underscore/pull/1247
    //
    // This also ensures a stable sort in V8 and other engines.
    // See http://code.google.com/p/v8/issues/detail?id=90
    return a.index - b.index;
  }

  /**
   * Used by `template` to escape characters for inclusion in compiled
   * string literals.
   *
   * @private
   * @param {string} match The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(match) {
    return '\\' + stringEscapes[match];
  }

  /**
   * Slices the `collection` from the `start` index up to, but not including,
   * the `end` index.
   *
   * Note: This function is used instead of `Array#slice` to support node lists
   * in IE < 9 and to ensure dense arrays are returned.
   *
   * @private
   * @param {Array|Object|string} collection The collection to slice.
   * @param {number} start The start index.
   * @param {number} end The end index.
   * @returns {Array} Returns the new array.
   */
  function slice(array, start, end) {
    start || (start = 0);
    if (typeof end == 'undefined') {
      end = array ? array.length : 0;
    }
    var index = -1,
        length = end - start || 0,
        result = Array(length < 0 ? 0 : length);

    while (++index < length) {
      result[index] = array[start + index];
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Used for `Array` method references.
   *
   * Normally `Array.prototype` would suffice, however, using an array literal
   * avoids issues in Narwhal.
   */
  var arrayRef = [];

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to restore the original `_` reference in `noConflict` */
  var oldDash = root._;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Used to detect if a method is native */
  var reNative = RegExp('^' +
    String(toString)
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      .replace(/toString| for [^\]]+/g, '.*?') + '$'
  );

  /** Native method shortcuts */
  var ceil = Math.ceil,
      floor = Math.floor,
      hasOwnProperty = objectProto.hasOwnProperty,
      push = arrayRef.push,
      propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /* Native method shortcuts for methods with the same name as other `lodash` methods */
  var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate,
      nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray,
      nativeIsFinite = root.isFinite,
      nativeIsNaN = root.isNaN,
      nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys,
      nativeMax = Math.max,
      nativeMin = Math.min,
      nativeRandom = Math.random;

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a `lodash` object which wraps the given value to enable intuitive
   * method chaining.
   *
   * In addition to Lo-Dash methods, wrappers also have the following `Array` methods:
   * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`, `splice`,
   * and `unshift`
   *
   * Chaining is supported in custom builds as long as the `value` method is
   * implicitly or explicitly included in the build.
   *
   * The chainable wrapper functions are:
   * `after`, `assign`, `bind`, `bindAll`, `bindKey`, `chain`, `compact`,
   * `compose`, `concat`, `countBy`, `create`, `createCallback`, `curry`,
   * `debounce`, `defaults`, `defer`, `delay`, `difference`, `filter`, `flatten`,
   * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
   * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
   * `invoke`, `keys`, `map`, `max`, `memoize`, `merge`, `min`, `object`, `omit`,
   * `once`, `pairs`, `partial`, `partialRight`, `pick`, `pluck`, `pull`, `push`,
   * `range`, `reject`, `remove`, `rest`, `reverse`, `shuffle`, `slice`, `sort`,
   * `sortBy`, `splice`, `tap`, `throttle`, `times`, `toArray`, `transform`,
   * `union`, `uniq`, `unshift`, `unzip`, `values`, `where`, `without`, `wrap`,
   * and `zip`
   *
   * The non-chainable wrapper functions are:
   * `clone`, `cloneDeep`, `contains`, `escape`, `every`, `find`, `findIndex`,
   * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `has`, `identity`,
   * `indexOf`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
   * `isEmpty`, `isEqual`, `isFinite`, `isFunction`, `isNaN`, `isNull`, `isNumber`,
   * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`, `join`,
   * `lastIndexOf`, `mixin`, `noConflict`, `parseInt`, `pop`, `random`, `reduce`,
   * `reduceRight`, `result`, `shift`, `size`, `some`, `sortedIndex`, `runInContext`,
   * `template`, `unescape`, `uniqueId`, and `value`
   *
   * The wrapper functions `first` and `last` return wrapped values when `n` is
   * provided, otherwise they return unwrapped values.
   *
   * Explicit chaining can be enabled by using the `_.chain` method.
   *
   * @name _
   * @constructor
   * @category Chaining
   * @param {*} value The value to wrap in a `lodash` instance.
   * @returns {Object} Returns a `lodash` instance.
   * @example
   *
   * var wrapped = _([1, 2, 3]);
   *
   * // returns an unwrapped value
   * wrapped.reduce(function(sum, num) {
   *   return sum + num;
   * });
   * // => 6
   *
   * // returns a wrapped value
   * var squares = wrapped.map(function(num) {
   *   return num * num;
   * });
   *
   * _.isArray(squares);
   * // => false
   *
   * _.isArray(squares.value());
   * // => true
   */
  function lodash(value) {
    return (value instanceof lodash)
      ? value
      : new lodashWrapper(value);
  }

  /**
   * A fast path for creating `lodash` wrapper objects.
   *
   * @private
   * @param {*} value The value to wrap in a `lodash` instance.
   * @param {boolean} chainAll A flag to enable chaining for all methods
   * @returns {Object} Returns a `lodash` instance.
   */
  function lodashWrapper(value, chainAll) {
    this.__chain__ = !!chainAll;
    this.__wrapped__ = value;
  }
  // ensure `new lodashWrapper` is an instance of `lodash`
  lodashWrapper.prototype = lodash.prototype;

  /**
   * An object used to flag environments features.
   *
   * @static
   * @memberOf _
   * @type Object
   */
  var support = {};

  (function() {
    var object = { '0': 1, 'length': 1 };

    /**
     * Detect if `Array#shift` and `Array#splice` augment array-like objects correctly.
     *
     * Firefox < 10, IE compatibility mode, and IE < 9 have buggy Array `shift()`
     * and `splice()` functions that fail to remove the last element, `value[0]`,
     * of array-like objects even though the `length` property is set to `0`.
     * The `shift()` method is buggy in IE 8 compatibility mode, while `splice()`
     * is buggy regardless of mode in IE < 9 and buggy in compatibility mode in IE 9.
     *
     * @memberOf _.support
     * @type boolean
     */
    support.spliceObjects = (arrayRef.splice.call(object, 0, 1), !object[0]);
  }(1));

  /**
   * By default, the template delimiters used by Lo-Dash are similar to those in
   * embedded Ruby (ERB). Change the following template settings to use alternative
   * delimiters.
   *
   * @static
   * @memberOf _
   * @type Object
   */
  lodash.templateSettings = {

    /**
     * Used to detect `data` property values to be HTML-escaped.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'escape': /<%-([\s\S]+?)%>/g,

    /**
     * Used to detect code to be evaluated.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'evaluate': /<%([\s\S]+?)%>/g,

    /**
     * Used to detect `data` property values to inject.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'interpolate': reInterpolate,

    /**
     * Used to reference the data object in the template text.
     *
     * @memberOf _.templateSettings
     * @type string
     */
    'variable': ''
  };

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `_.bind` that creates the bound function and
   * sets its meta data.
   *
   * @private
   * @param {Array} bindData The bind data array.
   * @returns {Function} Returns the new bound function.
   */
  function baseBind(bindData) {
    var func = bindData[0],
        partialArgs = bindData[2],
        thisArg = bindData[4];

    function bound() {
      // `Function#bind` spec
      // http://es5.github.io/#x15.3.4.5
      if (partialArgs) {
        // avoid `arguments` object deoptimizations by using `slice` instead
        // of `Array.prototype.slice.call` and not assigning `arguments` to a
        // variable as a ternary expression
        var args = slice(partialArgs);
        push.apply(args, arguments);
      }
      // mimic the constructor's `return` behavior
      // http://es5.github.io/#x13.2.2
      if (this instanceof bound) {
        // ensure `new bound` is an instance of `func`
        var thisBinding = baseCreate(func.prototype),
            result = func.apply(thisBinding, args || arguments);
        return isObject(result) ? result : thisBinding;
      }
      return func.apply(thisArg, args || arguments);
    }
    return bound;
  }

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} prototype The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  function baseCreate(prototype, properties) {
    return isObject(prototype) ? nativeCreate(prototype) : {};
  }
  // fallback for browsers without `Object.create`
  if (!nativeCreate) {
    baseCreate = (function() {
      function Object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          Object.prototype = prototype;
          var result = new Object;
          Object.prototype = null;
        }
        return result || root.Object();
      };
    }());
  }

  /**
   * The base implementation of `_.createCallback` without support for creating
   * "_.pluck" or "_.where" style callbacks.
   *
   * @private
   * @param {*} [func=identity] The value to convert to a callback.
   * @param {*} [thisArg] The `this` binding of the created callback.
   * @param {number} [argCount] The number of arguments the callback accepts.
   * @returns {Function} Returns a callback function.
   */
  function baseCreateCallback(func, thisArg, argCount) {
    if (typeof func != 'function') {
      return identity;
    }
    // exit early for no `thisArg` or already bound by `Function#bind`
    if (typeof thisArg == 'undefined' || !('prototype' in func)) {
      return func;
    }
    switch (argCount) {
      case 1: return function(value) {
        return func.call(thisArg, value);
      };
      case 2: return function(a, b) {
        return func.call(thisArg, a, b);
      };
      case 3: return function(value, index, collection) {
        return func.call(thisArg, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(thisArg, accumulator, value, index, collection);
      };
    }
    return bind(func, thisArg);
  }

  /**
   * The base implementation of `createWrapper` that creates the wrapper and
   * sets its meta data.
   *
   * @private
   * @param {Array} bindData The bind data array.
   * @returns {Function} Returns the new function.
   */
  function baseCreateWrapper(bindData) {
    var func = bindData[0],
        bitmask = bindData[1],
        partialArgs = bindData[2],
        partialRightArgs = bindData[3],
        thisArg = bindData[4],
        arity = bindData[5];

    var isBind = bitmask & 1,
        isBindKey = bitmask & 2,
        isCurry = bitmask & 4,
        isCurryBound = bitmask & 8,
        key = func;

    function bound() {
      var thisBinding = isBind ? thisArg : this;
      if (partialArgs) {
        var args = slice(partialArgs);
        push.apply(args, arguments);
      }
      if (partialRightArgs || isCurry) {
        args || (args = slice(arguments));
        if (partialRightArgs) {
          push.apply(args, partialRightArgs);
        }
        if (isCurry && args.length < arity) {
          bitmask |= 16 & ~32;
          return baseCreateWrapper([func, (isCurryBound ? bitmask : bitmask & ~3), args, null, thisArg, arity]);
        }
      }
      args || (args = arguments);
      if (isBindKey) {
        func = thisBinding[key];
      }
      if (this instanceof bound) {
        thisBinding = baseCreate(func.prototype);
        var result = func.apply(thisBinding, args);
        return isObject(result) ? result : thisBinding;
      }
      return func.apply(thisBinding, args);
    }
    return bound;
  }

  /**
   * The base implementation of `_.difference` that accepts a single array
   * of values to exclude.
   *
   * @private
   * @param {Array} array The array to process.
   * @param {Array} [values] The array of values to exclude.
   * @returns {Array} Returns a new array of filtered values.
   */
  function baseDifference(array, values) {
    var index = -1,
        indexOf = getIndexOf(),
        length = array ? array.length : 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (indexOf(values, value) < 0) {
        result.push(value);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.flatten` without support for callback
   * shorthands or `thisArg` binding.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
   * @param {boolean} [isStrict=false] A flag to restrict flattening to arrays and `arguments` objects.
   * @param {number} [fromIndex=0] The index to start from.
   * @returns {Array} Returns a new flattened array.
   */
  function baseFlatten(array, isShallow, isStrict, fromIndex) {
    var index = (fromIndex || 0) - 1,
        length = array ? array.length : 0,
        result = [];

    while (++index < length) {
      var value = array[index];

      if (value && typeof value == 'object' && typeof value.length == 'number'
          && (isArray(value) || isArguments(value))) {
        // recursively flatten arrays (susceptible to call stack limits)
        if (!isShallow) {
          value = baseFlatten(value, isShallow, isStrict);
        }
        var valIndex = -1,
            valLength = value.length,
            resIndex = result.length;

        result.length += valLength;
        while (++valIndex < valLength) {
          result[resIndex++] = value[valIndex];
        }
      } else if (!isStrict) {
        result.push(value);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.isEqual`, without support for `thisArg` binding,
   * that allows partial "_.where" style comparisons.
   *
   * @private
   * @param {*} a The value to compare.
   * @param {*} b The other value to compare.
   * @param {Function} [callback] The function to customize comparing values.
   * @param {Function} [isWhere=false] A flag to indicate performing partial comparisons.
   * @param {Array} [stackA=[]] Tracks traversed `a` objects.
   * @param {Array} [stackB=[]] Tracks traversed `b` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(a, b, stackA, stackB) {
    if (a === b) {
      return a !== 0 || (1 / a == 1 / b);
    }
    var type = typeof a,
        otherType = typeof b;

    if (a === a &&
        !(a && objectTypes[type]) &&
        !(b && objectTypes[otherType])) {
      return false;
    }
    if (a == null || b == null) {
      return a === b;
    }
    var className = toString.call(a),
        otherClass = toString.call(b);

    if (className != otherClass) {
      return false;
    }
    switch (className) {
      case boolClass:
      case dateClass:
        return +a == +b;

      case numberClass:
        return a != +a
          ? b != +b
          : (a == 0 ? (1 / a == 1 / b) : a == +b);

      case regexpClass:
      case stringClass:
        return a == String(b);
    }
    var isArr = className == arrayClass;
    if (!isArr) {
      var aWrapped = a instanceof lodash,
          bWrapped = b instanceof lodash;

      if (aWrapped || bWrapped) {
        return baseIsEqual(aWrapped ? a.__wrapped__ : a, bWrapped ? b.__wrapped__ : b, stackA, stackB);
      }
      if (className != objectClass) {
        return false;
      }
      var ctorA = a.constructor,
          ctorB = b.constructor;

      if (ctorA != ctorB &&
            !(isFunction(ctorA) && ctorA instanceof ctorA && isFunction(ctorB) && ctorB instanceof ctorB) &&
            ('constructor' in a && 'constructor' in b)
          ) {
        return false;
      }
    }
    stackA || (stackA = []);
    stackB || (stackB = []);

    var length = stackA.length;
    while (length--) {
      if (stackA[length] == a) {
        return stackB[length] == b;
      }
    }
    var result = true,
        size = 0;

    stackA.push(a);
    stackB.push(b);

    if (isArr) {
      size = b.length;
      result = size == a.length;

      if (result) {
        while (size--) {
          if (!(result = baseIsEqual(a[size], b[size], stackA, stackB))) {
            break;
          }
        }
      }
    }
    else {
      forIn(b, function(value, key, b) {
        if (hasOwnProperty.call(b, key)) {
          size++;
          return !(result = hasOwnProperty.call(a, key) && baseIsEqual(a[key], value, stackA, stackB)) && indicatorObject;
        }
      });

      if (result) {
        forIn(a, function(value, key, a) {
          if (hasOwnProperty.call(a, key)) {
            return !(result = --size > -1) && indicatorObject;
          }
        });
      }
    }
    stackA.pop();
    stackB.pop();
    return result;
  }

  /**
   * The base implementation of `_.random` without argument juggling or support
   * for returning floating-point numbers.
   *
   * @private
   * @param {number} min The minimum possible value.
   * @param {number} max The maximum possible value.
   * @returns {number} Returns a random number.
   */
  function baseRandom(min, max) {
    return min + floor(nativeRandom() * (max - min + 1));
  }

  /**
   * The base implementation of `_.uniq` without support for callback shorthands
   * or `thisArg` binding.
   *
   * @private
   * @param {Array} array The array to process.
   * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
   * @param {Function} [callback] The function called per iteration.
   * @returns {Array} Returns a duplicate-value-free array.
   */
  function baseUniq(array, isSorted, callback) {
    var index = -1,
        indexOf = getIndexOf(),
        length = array ? array.length : 0,
        result = [],
        seen = callback ? [] : result;

    while (++index < length) {
      var value = array[index],
          computed = callback ? callback(value, index, array) : value;

      if (isSorted
            ? !index || seen[seen.length - 1] !== computed
            : indexOf(seen, computed) < 0
          ) {
        if (callback) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
    return result;
  }

  /**
   * Creates a function that aggregates a collection, creating an object composed
   * of keys generated from the results of running each element of the collection
   * through a callback. The given `setter` function sets the keys and values
   * of the composed object.
   *
   * @private
   * @param {Function} setter The setter function.
   * @returns {Function} Returns the new aggregator function.
   */
  function createAggregator(setter) {
    return function(collection, callback, thisArg) {
      var result = {};
      callback = createCallback(callback, thisArg, 3);

      var index = -1,
          length = collection ? collection.length : 0;

      if (typeof length == 'number') {
        while (++index < length) {
          var value = collection[index];
          setter(result, value, callback(value, index, collection), collection);
        }
      } else {
        forOwn(collection, function(value, key, collection) {
          setter(result, value, callback(value, key, collection), collection);
        });
      }
      return result;
    };
  }

  /**
   * Creates a function that, when called, either curries or invokes `func`
   * with an optional `this` binding and partially applied arguments.
   *
   * @private
   * @param {Function|string} func The function or method name to reference.
   * @param {number} bitmask The bitmask of method flags to compose.
   *  The bitmask may be composed of the following flags:
   *  1 - `_.bind`
   *  2 - `_.bindKey`
   *  4 - `_.curry`
   *  8 - `_.curry` (bound)
   *  16 - `_.partial`
   *  32 - `_.partialRight`
   * @param {Array} [partialArgs] An array of arguments to prepend to those
   *  provided to the new function.
   * @param {Array} [partialRightArgs] An array of arguments to append to those
   *  provided to the new function.
   * @param {*} [thisArg] The `this` binding of `func`.
   * @param {number} [arity] The arity of `func`.
   * @returns {Function} Returns the new function.
   */
  function createWrapper(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
    var isBind = bitmask & 1,
        isBindKey = bitmask & 2,
        isCurry = bitmask & 4,
        isCurryBound = bitmask & 8,
        isPartial = bitmask & 16,
        isPartialRight = bitmask & 32;

    if (!isBindKey && !isFunction(func)) {
      throw new TypeError;
    }
    if (isPartial && !partialArgs.length) {
      bitmask &= ~16;
      isPartial = partialArgs = false;
    }
    if (isPartialRight && !partialRightArgs.length) {
      bitmask &= ~32;
      isPartialRight = partialRightArgs = false;
    }
    // fast path for `_.bind`
    var creater = (bitmask == 1 || bitmask === 17) ? baseBind : baseCreateWrapper;
    return creater([func, bitmask, partialArgs, partialRightArgs, thisArg, arity]);
  }

  /**
   * Used by `escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} match The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(match) {
    return htmlEscapes[match];
  }

  /**
   * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
   * customized, this method returns the custom method, otherwise it returns
   * the `baseIndexOf` function.
   *
   * @private
   * @returns {Function} Returns the "indexOf" function.
   */
  function getIndexOf() {
    var result = (result = lodash.indexOf) === indexOf ? baseIndexOf : result;
    return result;
  }

  /**
   * Checks if `value` is a native function.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a native function, else `false`.
   */
  function isNative(value) {
    return typeof value == 'function' && reNative.test(value);
  }

  /**
   * Used by `unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} match The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(match) {
    return htmlUnescapes[match];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Checks if `value` is an `arguments` object.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is an `arguments` object, else `false`.
   * @example
   *
   * (function() { return _.isArguments(arguments); })(1, 2, 3);
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  function isArguments(value) {
    return value && typeof value == 'object' && typeof value.length == 'number' &&
      toString.call(value) == argsClass || false;
  }
  // fallback for browsers that can't detect `arguments` objects by [[Class]]
  if (!isArguments(arguments)) {
    isArguments = function(value) {
      return value && typeof value == 'object' && typeof value.length == 'number' &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee') || false;
    };
  }

  /**
   * Checks if `value` is an array.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is an array, else `false`.
   * @example
   *
   * (function() { return _.isArray(arguments); })();
   * // => false
   *
   * _.isArray([1, 2, 3]);
   * // => true
   */
  var isArray = nativeIsArray || function(value) {
    return value && typeof value == 'object' && typeof value.length == 'number' &&
      toString.call(value) == arrayClass || false;
  };

  /**
   * A fallback implementation of `Object.keys` which produces an array of the
   * given object's own enumerable property names.
   *
   * @private
   * @type Function
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names.
   */
  var shimKeys = function(object) {
    var index, iterable = object, result = [];
    if (!iterable) return result;
    if (!(objectTypes[typeof object])) return result;
      for (index in iterable) {
        if (hasOwnProperty.call(iterable, index)) {
          result.push(index);
        }
      }
    return result
  };

  /**
   * Creates an array composed of the own enumerable property names of an object.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names.
   * @example
   *
   * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
   * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
   */
  var keys = !nativeKeys ? shimKeys : function(object) {
    if (!isObject(object)) {
      return [];
    }
    return nativeKeys(object);
  };

  /**
   * Used to convert characters to HTML entities:
   *
   * Though the `>` character is escaped for symmetry, characters like `>` and `/`
   * don't require escaping in HTML and have no special meaning unless they're part
   * of a tag or an unquoted attribute value.
   * http://mathiasbynens.be/notes/ambiguous-ampersands (under "semi-related fun fact")
   */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;'
  };

  /** Used to convert HTML entities to characters */
  var htmlUnescapes = invert(htmlEscapes);

  /** Used to match HTML entities and HTML characters */
  var reEscapedHtml = RegExp('(' + keys(htmlUnescapes).join('|') + ')', 'g'),
      reUnescapedHtml = RegExp('[' + keys(htmlEscapes).join('') + ']', 'g');

  /*--------------------------------------------------------------------------*/

  /**
   * Assigns own enumerable properties of source object(s) to the destination
   * object. Subsequent sources will overwrite property assignments of previous
   * sources. If a callback is provided it will be executed to produce the
   * assigned values. The callback is bound to `thisArg` and invoked with two
   * arguments; (objectValue, sourceValue).
   *
   * @static
   * @memberOf _
   * @type Function
   * @alias extend
   * @category Objects
   * @param {Object} object The destination object.
   * @param {...Object} [source] The source objects.
   * @param {Function} [callback] The function to customize assigning values.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the destination object.
   * @example
   *
   * _.assign({ 'name': 'fred' }, { 'employer': 'slate' });
   * // => { 'name': 'fred', 'employer': 'slate' }
   *
   * var defaults = _.partialRight(_.assign, function(a, b) {
   *   return typeof a == 'undefined' ? b : a;
   * });
   *
   * var object = { 'name': 'barney' };
   * defaults(object, { 'name': 'fred', 'employer': 'slate' });
   * // => { 'name': 'barney', 'employer': 'slate' }
   */
  function assign(object) {
    if (!object) {
      return object;
    }
    for (var argsIndex = 1, argsLength = arguments.length; argsIndex < argsLength; argsIndex++) {
      var iterable = arguments[argsIndex];
      if (iterable) {
        for (var key in iterable) {
          object[key] = iterable[key];
        }
      }
    }
    return object;
  }

  /**
   * Creates a clone of `value`. If `isDeep` is `true` nested objects will also
   * be cloned, otherwise they will be assigned by reference. If a callback
   * is provided it will be executed to produce the cloned values. If the
   * callback returns `undefined` cloning will be handled by the method instead.
   * The callback is bound to `thisArg` and invoked with one argument; (value).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to clone.
   * @param {boolean} [isDeep=false] Specify a deep clone.
   * @param {Function} [callback] The function to customize cloning values.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the cloned value.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * var shallow = _.clone(characters);
   * shallow[0] === characters[0];
   * // => true
   *
   * var deep = _.clone(characters, true);
   * deep[0] === characters[0];
   * // => false
   *
   * _.mixin({
   *   'clone': _.partialRight(_.clone, function(value) {
   *     return _.isElement(value) ? value.cloneNode(false) : undefined;
   *   })
   * });
   *
   * var clone = _.clone(document.body);
   * clone.childNodes.length;
   * // => 0
   */
  function clone(value) {
    return isObject(value)
      ? (isArray(value) ? slice(value) : assign({}, value))
      : value;
  }

  /**
   * Assigns own enumerable properties of source object(s) to the destination
   * object for all destination properties that resolve to `undefined`. Once a
   * property is set, additional defaults of the same property will be ignored.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The destination object.
   * @param {...Object} [source] The source objects.
   * @param- {Object} [guard] Allows working with `_.reduce` without using its
   *  `key` and `object` arguments as sources.
   * @returns {Object} Returns the destination object.
   * @example
   *
   * var object = { 'name': 'barney' };
   * _.defaults(object, { 'name': 'fred', 'employer': 'slate' });
   * // => { 'name': 'barney', 'employer': 'slate' }
   */
  function defaults(object) {
    if (!object) {
      return object;
    }
    for (var argsIndex = 1, argsLength = arguments.length; argsIndex < argsLength; argsIndex++) {
      var iterable = arguments[argsIndex];
      if (iterable) {
        for (var key in iterable) {
          if (typeof object[key] == 'undefined') {
            object[key] = iterable[key];
          }
        }
      }
    }
    return object;
  }

  /**
   * Iterates over own and inherited enumerable properties of an object,
   * executing the callback for each property. The callback is bound to `thisArg`
   * and invoked with three arguments; (value, key, object). Callbacks may exit
   * iteration early by explicitly returning `false`.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The object to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns `object`.
   * @example
   *
   * function Shape() {
   *   this.x = 0;
   *   this.y = 0;
   * }
   *
   * Shape.prototype.move = function(x, y) {
   *   this.x += x;
   *   this.y += y;
   * };
   *
   * _.forIn(new Shape, function(value, key) {
   *   console.log(key);
   * });
   * // => logs 'x', 'y', and 'move' (property order is not guaranteed across environments)
   */
  var forIn = function(collection, callback) {
    var index, iterable = collection, result = iterable;
    if (!iterable) return result;
    if (!objectTypes[typeof iterable]) return result;
      for (index in iterable) {
        if (callback(iterable[index], index, collection) === indicatorObject) return result;
      }
    return result
  };

  /**
   * Iterates over own enumerable properties of an object, executing the callback
   * for each property. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, key, object). Callbacks may exit iteration early by
   * explicitly returning `false`.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The object to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns `object`.
   * @example
   *
   * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
   *   console.log(key);
   * });
   * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
   */
  var forOwn = function(collection, callback) {
    var index, iterable = collection, result = iterable;
    if (!iterable) return result;
    if (!objectTypes[typeof iterable]) return result;
      for (index in iterable) {
        if (hasOwnProperty.call(iterable, index)) {
          if (callback(iterable[index], index, collection) === indicatorObject) return result;
        }
      }
    return result
  };

  /**
   * Creates a sorted array of property names of all enumerable properties,
   * own and inherited, of `object` that have function values.
   *
   * @static
   * @memberOf _
   * @alias methods
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names that have function values.
   * @example
   *
   * _.functions(_);
   * // => ['all', 'any', 'bind', 'bindAll', 'clone', 'compact', 'compose', ...]
   */
  function functions(object) {
    var result = [];
    forIn(object, function(value, key) {
      if (isFunction(value)) {
        result.push(key);
      }
    });
    return result.sort();
  }

  /**
   * Checks if the specified property name exists as a direct property of `object`,
   * instead of an inherited property.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @param {string} key The name of the property to check.
   * @returns {boolean} Returns `true` if key is a direct property, else `false`.
   * @example
   *
   * _.has({ 'a': 1, 'b': 2, 'c': 3 }, 'b');
   * // => true
   */
  function has(object, key) {
    return object ? hasOwnProperty.call(object, key) : false;
  }

  /**
   * Creates an object composed of the inverted keys and values of the given object.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to invert.
   * @returns {Object} Returns the created inverted object.
   * @example
   *
   * _.invert({ 'first': 'fred', 'second': 'barney' });
   * // => { 'fred': 'first', 'barney': 'second' }
   */
  function invert(object) {
    var index = -1,
        props = keys(object),
        length = props.length,
        result = {};

    while (++index < length) {
      var key = props[index];
      result[object[key]] = key;
    }
    return result;
  }

  /**
   * Checks if `value` is a boolean value.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a boolean value, else `false`.
   * @example
   *
   * _.isBoolean(null);
   * // => false
   */
  function isBoolean(value) {
    return value === true || value === false ||
      value && typeof value == 'object' && toString.call(value) == boolClass || false;
  }

  /**
   * Checks if `value` is a date.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a date, else `false`.
   * @example
   *
   * _.isDate(new Date);
   * // => true
   */
  function isDate(value) {
    return value && typeof value == 'object' && toString.call(value) == dateClass || false;
  }

  /**
   * Checks if `value` is a DOM element.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a DOM element, else `false`.
   * @example
   *
   * _.isElement(document.body);
   * // => true
   */
  function isElement(value) {
    return value && value.nodeType === 1 || false;
  }

  /**
   * Checks if `value` is empty. Arrays, strings, or `arguments` objects with a
   * length of `0` and objects with no own enumerable properties are considered
   * "empty".
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Array|Object|string} value The value to inspect.
   * @returns {boolean} Returns `true` if the `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({});
   * // => true
   *
   * _.isEmpty('');
   * // => true
   */
  function isEmpty(value) {
    if (!value) {
      return true;
    }
    if (isArray(value) || isString(value)) {
      return !value.length;
    }
    for (var key in value) {
      if (hasOwnProperty.call(value, key)) {
        return false;
      }
    }
    return true;
  }

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent to each other. If a callback is provided it will be executed
   * to compare values. If the callback returns `undefined` comparisons will
   * be handled by the method instead. The callback is bound to `thisArg` and
   * invoked with two arguments; (a, b).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} a The value to compare.
   * @param {*} b The other value to compare.
   * @param {Function} [callback] The function to customize comparing values.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'name': 'fred' };
   * var copy = { 'name': 'fred' };
   *
   * object == copy;
   * // => false
   *
   * _.isEqual(object, copy);
   * // => true
   *
   * var words = ['hello', 'goodbye'];
   * var otherWords = ['hi', 'goodbye'];
   *
   * _.isEqual(words, otherWords, function(a, b) {
   *   var reGreet = /^(?:hello|hi)$/i,
   *       aGreet = _.isString(a) && reGreet.test(a),
   *       bGreet = _.isString(b) && reGreet.test(b);
   *
   *   return (aGreet || bGreet) ? (aGreet == bGreet) : undefined;
   * });
   * // => true
   */
  function isEqual(a, b) {
    return baseIsEqual(a, b);
  }

  /**
   * Checks if `value` is, or can be coerced to, a finite number.
   *
   * Note: This is not the same as native `isFinite` which will return true for
   * booleans and empty strings. See http://es5.github.io/#x15.1.2.5.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is finite, else `false`.
   * @example
   *
   * _.isFinite(-101);
   * // => true
   *
   * _.isFinite('10');
   * // => true
   *
   * _.isFinite(true);
   * // => false
   *
   * _.isFinite('');
   * // => false
   *
   * _.isFinite(Infinity);
   * // => false
   */
  function isFinite(value) {
    return nativeIsFinite(value) && !nativeIsNaN(parseFloat(value));
  }

  /**
   * Checks if `value` is a function.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   */
  function isFunction(value) {
    return typeof value == 'function';
  }
  // fallback for older versions of Chrome and Safari
  if (isFunction(/x/)) {
    isFunction = function(value) {
      return typeof value == 'function' && toString.call(value) == funcClass;
    };
  }

  /**
   * Checks if `value` is the language type of Object.
   * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(1);
   * // => false
   */
  function isObject(value) {
    // check if the value is the ECMAScript language type of Object
    // http://es5.github.io/#x8
    // and avoid a V8 bug
    // http://code.google.com/p/v8/issues/detail?id=2291
    return !!(value && objectTypes[typeof value]);
  }

  /**
   * Checks if `value` is `NaN`.
   *
   * Note: This is not the same as native `isNaN` which will return `true` for
   * `undefined` and other non-numeric values. See http://es5.github.io/#x15.1.2.4.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `NaN`, else `false`.
   * @example
   *
   * _.isNaN(NaN);
   * // => true
   *
   * _.isNaN(new Number(NaN));
   * // => true
   *
   * isNaN(undefined);
   * // => true
   *
   * _.isNaN(undefined);
   * // => false
   */
  function isNaN(value) {
    // `NaN` as a primitive is the only value that is not equal to itself
    // (perform the [[Class]] check first to avoid errors with some host objects in IE)
    return isNumber(value) && value != +value;
  }

  /**
   * Checks if `value` is `null`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `null`, else `false`.
   * @example
   *
   * _.isNull(null);
   * // => true
   *
   * _.isNull(undefined);
   * // => false
   */
  function isNull(value) {
    return value === null;
  }

  /**
   * Checks if `value` is a number.
   *
   * Note: `NaN` is considered a number. See http://es5.github.io/#x8.5.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(8.4 * 5);
   * // => true
   */
  function isNumber(value) {
    return typeof value == 'number' ||
      value && typeof value == 'object' && toString.call(value) == numberClass || false;
  }

  /**
   * Checks if `value` is a regular expression.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a regular expression, else `false`.
   * @example
   *
   * _.isRegExp(/fred/);
   * // => true
   */
  function isRegExp(value) {
    return value && objectTypes[typeof value] && toString.call(value) == regexpClass || false;
  }

  /**
   * Checks if `value` is a string.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a string, else `false`.
   * @example
   *
   * _.isString('fred');
   * // => true
   */
  function isString(value) {
    return typeof value == 'string' ||
      value && typeof value == 'object' && toString.call(value) == stringClass || false;
  }

  /**
   * Checks if `value` is `undefined`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `undefined`, else `false`.
   * @example
   *
   * _.isUndefined(void 0);
   * // => true
   */
  function isUndefined(value) {
    return typeof value == 'undefined';
  }

  /**
   * Creates a shallow clone of `object` excluding the specified properties.
   * Property names may be specified as individual arguments or as arrays of
   * property names. If a callback is provided it will be executed for each
   * property of `object` omitting the properties the callback returns truey
   * for. The callback is bound to `thisArg` and invoked with three arguments;
   * (value, key, object).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The source object.
   * @param {Function|...string|string[]} [callback] The properties to omit or the
   *  function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns an object without the omitted properties.
   * @example
   *
   * _.omit({ 'name': 'fred', 'age': 40 }, 'age');
   * // => { 'name': 'fred' }
   *
   * _.omit({ 'name': 'fred', 'age': 40 }, function(value) {
   *   return typeof value == 'number';
   * });
   * // => { 'name': 'fred' }
   */
  function omit(object) {
    var props = [];
    forIn(object, function(value, key) {
      props.push(key);
    });
    props = baseDifference(props, baseFlatten(arguments, true, false, 1));

    var index = -1,
        length = props.length,
        result = {};

    while (++index < length) {
      var key = props[index];
      result[key] = object[key];
    }
    return result;
  }

  /**
   * Creates a two dimensional array of an object's key-value pairs,
   * i.e. `[[key1, value1], [key2, value2]]`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns new array of key-value pairs.
   * @example
   *
   * _.pairs({ 'barney': 36, 'fred': 40 });
   * // => [['barney', 36], ['fred', 40]] (property order is not guaranteed across environments)
   */
  function pairs(object) {
    var index = -1,
        props = keys(object),
        length = props.length,
        result = Array(length);

    while (++index < length) {
      var key = props[index];
      result[index] = [key, object[key]];
    }
    return result;
  }

  /**
   * Creates a shallow clone of `object` composed of the specified properties.
   * Property names may be specified as individual arguments or as arrays of
   * property names. If a callback is provided it will be executed for each
   * property of `object` picking the properties the callback returns truey
   * for. The callback is bound to `thisArg` and invoked with three arguments;
   * (value, key, object).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The source object.
   * @param {Function|...string|string[]} [callback] The function called per
   *  iteration or property names to pick, specified as individual property
   *  names or arrays of property names.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns an object composed of the picked properties.
   * @example
   *
   * _.pick({ 'name': 'fred', '_userid': 'fred1' }, 'name');
   * // => { 'name': 'fred' }
   *
   * _.pick({ 'name': 'fred', '_userid': 'fred1' }, function(value, key) {
   *   return key.charAt(0) != '_';
   * });
   * // => { 'name': 'fred' }
   */
  function pick(object) {
    var index = -1,
        props = baseFlatten(arguments, true, false, 1),
        length = props.length,
        result = {};

    while (++index < length) {
      var key = props[index];
      if (key in object) {
        result[key] = object[key];
      }
    }
    return result;
  }

  /**
   * Creates an array composed of the own enumerable property values of `object`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property values.
   * @example
   *
   * _.values({ 'one': 1, 'two': 2, 'three': 3 });
   * // => [1, 2, 3] (property order is not guaranteed across environments)
   */
  function values(object) {
    var index = -1,
        props = keys(object),
        length = props.length,
        result = Array(length);

    while (++index < length) {
      result[index] = object[props[index]];
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Checks if a given value is present in a collection using strict equality
   * for comparisons, i.e. `===`. If `fromIndex` is negative, it is used as the
   * offset from the end of the collection.
   *
   * @static
   * @memberOf _
   * @alias include
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {*} target The value to check for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {boolean} Returns `true` if the `target` element is found, else `false`.
   * @example
   *
   * _.contains([1, 2, 3], 1);
   * // => true
   *
   * _.contains([1, 2, 3], 1, 2);
   * // => false
   *
   * _.contains({ 'name': 'fred', 'age': 40 }, 'fred');
   * // => true
   *
   * _.contains('pebbles', 'eb');
   * // => true
   */
  function contains(collection, target) {
    var indexOf = getIndexOf(),
        length = collection ? collection.length : 0,
        result = false;
    if (length && typeof length == 'number') {
      result = indexOf(collection, target) > -1;
    } else {
      forOwn(collection, function(value) {
        return (result = value === target) && indicatorObject;
      });
    }
    return result;
  }

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of `collection` through the callback. The corresponding value
   * of each key is the number of times the key was returned by the callback.
   * The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * _.countBy([4.3, 6.1, 6.4], function(num) { return Math.floor(num); });
   * // => { '4': 1, '6': 2 }
   *
   * _.countBy([4.3, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
   * // => { '4': 1, '6': 2 }
   *
   * _.countBy(['one', 'two', 'three'], 'length');
   * // => { '3': 2, '5': 1 }
   */
  var countBy = createAggregator(function(result, value, key) {
    (hasOwnProperty.call(result, key) ? result[key]++ : result[key] = 1);
  });

  /**
   * Checks if the given callback returns truey value for **all** elements of
   * a collection. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias all
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {boolean} Returns `true` if all elements passed the callback check,
   *  else `false`.
   * @example
   *
   * _.every([true, 1, null, 'yes']);
   * // => false
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.every(characters, 'age');
   * // => true
   *
   * // using "_.where" callback shorthand
   * _.every(characters, { 'age': 36 });
   * // => false
   */
  function every(collection, callback, thisArg) {
    var result = true;
    callback = createCallback(callback, thisArg, 3);

    var index = -1,
        length = collection ? collection.length : 0;

    if (typeof length == 'number') {
      while (++index < length) {
        if (!(result = !!callback(collection[index], index, collection))) {
          break;
        }
      }
    } else {
      forOwn(collection, function(value, index, collection) {
        return !(result = !!callback(value, index, collection)) && indicatorObject;
      });
    }
    return result;
  }

  /**
   * Iterates over elements of a collection, returning an array of all elements
   * the callback returns truey for. The callback is bound to `thisArg` and
   * invoked with three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias select
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of elements that passed the callback check.
   * @example
   *
   * var evens = _.filter([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
   * // => [2, 4, 6]
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'blocked': false },
   *   { 'name': 'fred',   'age': 40, 'blocked': true }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.filter(characters, 'blocked');
   * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
   *
   * // using "_.where" callback shorthand
   * _.filter(characters, { 'age': 36 });
   * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
   */
  function filter(collection, callback, thisArg) {
    var result = [];
    callback = createCallback(callback, thisArg, 3);

    var index = -1,
        length = collection ? collection.length : 0;

    if (typeof length == 'number') {
      while (++index < length) {
        var value = collection[index];
        if (callback(value, index, collection)) {
          result.push(value);
        }
      }
    } else {
      forOwn(collection, function(value, index, collection) {
        if (callback(value, index, collection)) {
          result.push(value);
        }
      });
    }
    return result;
  }

  /**
   * Iterates over elements of a collection, returning the first element that
   * the callback returns truey for. The callback is bound to `thisArg` and
   * invoked with three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias detect, findWhere
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the found element, else `undefined`.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney',  'age': 36, 'blocked': false },
   *   { 'name': 'fred',    'age': 40, 'blocked': true },
   *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
   * ];
   *
   * _.find(characters, function(chr) {
   *   return chr.age < 40;
   * });
   * // => { 'name': 'barney', 'age': 36, 'blocked': false }
   *
   * // using "_.where" callback shorthand
   * _.find(characters, { 'age': 1 });
   * // =>  { 'name': 'pebbles', 'age': 1, 'blocked': false }
   *
   * // using "_.pluck" callback shorthand
   * _.find(characters, 'blocked');
   * // => { 'name': 'fred', 'age': 40, 'blocked': true }
   */
  function find(collection, callback, thisArg) {
    callback = createCallback(callback, thisArg, 3);

    var index = -1,
        length = collection ? collection.length : 0;

    if (typeof length == 'number') {
      while (++index < length) {
        var value = collection[index];
        if (callback(value, index, collection)) {
          return value;
        }
      }
    } else {
      var result;
      forOwn(collection, function(value, index, collection) {
        if (callback(value, index, collection)) {
          result = value;
          return indicatorObject;
        }
      });
      return result;
    }
  }

  /**
   * Examines each element in a `collection`, returning the first that
   * has the given properties. When checking `properties`, this method
   * performs a deep comparison between values to determine if they are
   * equivalent to each other.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Object} properties The object of property values to filter by.
   * @returns {*} Returns the found element, else `undefined`.
   * @example
   *
   * var food = [
   *   { 'name': 'apple',  'organic': false, 'type': 'fruit' },
   *   { 'name': 'banana', 'organic': true,  'type': 'fruit' },
   *   { 'name': 'beet',   'organic': false, 'type': 'vegetable' }
   * ];
   *
   * _.findWhere(food, { 'type': 'vegetable' });
   * // => { 'name': 'beet', 'organic': false, 'type': 'vegetable' }
   */
  function findWhere(object, properties) {
    return where(object, properties, true);
  }

  /**
   * Iterates over elements of a collection, executing the callback for each
   * element. The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection). Callbacks may exit iteration early by
   * explicitly returning `false`.
   *
   * Note: As with other "Collections" methods, objects with a `length` property
   * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
   * may be used for object iteration.
   *
   * @static
   * @memberOf _
   * @alias each
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array|Object|string} Returns `collection`.
   * @example
   *
   * _([1, 2, 3]).forEach(function(num) { console.log(num); }).join(',');
   * // => logs each number and returns '1,2,3'
   *
   * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { console.log(num); });
   * // => logs each number and returns the object (property order is not guaranteed across environments)
   */
  function forEach(collection, callback, thisArg) {
    var index = -1,
        length = collection ? collection.length : 0;

    callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3);
    if (typeof length == 'number') {
      while (++index < length) {
        if (callback(collection[index], index, collection) === indicatorObject) {
          break;
        }
      }
    } else {
      forOwn(collection, callback);
    }
  }

  /**
   * This method is like `_.forEach` except that it iterates over elements
   * of a `collection` from right to left.
   *
   * @static
   * @memberOf _
   * @alias eachRight
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array|Object|string} Returns `collection`.
   * @example
   *
   * _([1, 2, 3]).forEachRight(function(num) { console.log(num); }).join(',');
   * // => logs each number from right to left and returns '3,2,1'
   */
  function forEachRight(collection, callback) {
    var length = collection ? collection.length : 0;
    if (typeof length == 'number') {
      while (length--) {
        if (callback(collection[length], length, collection) === false) {
          break;
        }
      }
    } else {
      var props = keys(collection);
      length = props.length;
      forOwn(collection, function(value, key, collection) {
        key = props ? props[--length] : --length;
        return callback(collection[key], key, collection) === false && indicatorObject;
      });
    }
  }

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of a collection through the callback. The corresponding value
   * of each key is an array of the elements responsible for generating the key.
   * The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * _.groupBy([4.2, 6.1, 6.4], function(num) { return Math.floor(num); });
   * // => { '4': [4.2], '6': [6.1, 6.4] }
   *
   * _.groupBy([4.2, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
   * // => { '4': [4.2], '6': [6.1, 6.4] }
   *
   * // using "_.pluck" callback shorthand
   * _.groupBy(['one', 'two', 'three'], 'length');
   * // => { '3': ['one', 'two'], '5': ['three'] }
   */
  var groupBy = createAggregator(function(result, value, key) {
    (hasOwnProperty.call(result, key) ? result[key] : result[key] = []).push(value);
  });

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of the collection through the given callback. The corresponding
   * value of each key is the last element responsible for generating the key.
   * The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * var keys = [
   *   { 'dir': 'left', 'code': 97 },
   *   { 'dir': 'right', 'code': 100 }
   * ];
   *
   * _.indexBy(keys, 'dir');
   * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
   *
   * _.indexBy(keys, function(key) { return String.fromCharCode(key.code); });
   * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
   *
   * _.indexBy(characters, function(key) { this.fromCharCode(key.code); }, String);
   * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
   */
  var indexBy = createAggregator(function(result, value, key) {
    result[key] = value;
  });

  /**
   * Invokes the method named by `methodName` on each element in the `collection`
   * returning an array of the results of each invoked method. Additional arguments
   * will be provided to each invoked method. If `methodName` is a function it
   * will be invoked for, and `this` bound to, each element in the `collection`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|string} methodName The name of the method to invoke or
   *  the function invoked per iteration.
   * @param {...*} [arg] Arguments to invoke the method with.
   * @returns {Array} Returns a new array of the results of each invoked method.
   * @example
   *
   * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
   * // => [[1, 5, 7], [1, 2, 3]]
   *
   * _.invoke([123, 456], String.prototype.split, '');
   * // => [['1', '2', '3'], ['4', '5', '6']]
   */
  function invoke(collection, methodName) {
    var args = slice(arguments, 2),
        index = -1,
        isFunc = typeof methodName == 'function',
        length = collection ? collection.length : 0,
        result = Array(typeof length == 'number' ? length : 0);

    forEach(collection, function(value) {
      result[++index] = (isFunc ? methodName : value[methodName]).apply(value, args);
    });
    return result;
  }

  /**
   * Creates an array of values by running each element in the collection
   * through the callback. The callback is bound to `thisArg` and invoked with
   * three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias collect
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of the results of each `callback` execution.
   * @example
   *
   * _.map([1, 2, 3], function(num) { return num * 3; });
   * // => [3, 6, 9]
   *
   * _.map({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { return num * 3; });
   * // => [3, 6, 9] (property order is not guaranteed across environments)
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.map(characters, 'name');
   * // => ['barney', 'fred']
   */
  function map(collection, callback, thisArg) {
    var index = -1,
        length = collection ? collection.length : 0;

    callback = createCallback(callback, thisArg, 3);
    if (typeof length == 'number') {
      var result = Array(length);
      while (++index < length) {
        result[index] = callback(collection[index], index, collection);
      }
    } else {
      result = [];
      forOwn(collection, function(value, key, collection) {
        result[++index] = callback(value, key, collection);
      });
    }
    return result;
  }

  /**
   * Retrieves the maximum value of a collection. If the collection is empty or
   * falsey `-Infinity` is returned. If a callback is provided it will be executed
   * for each value in the collection to generate the criterion by which the value
   * is ranked. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the maximum value.
   * @example
   *
   * _.max([4, 2, 8, 6]);
   * // => 8
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * _.max(characters, function(chr) { return chr.age; });
   * // => { 'name': 'fred', 'age': 40 };
   *
   * // using "_.pluck" callback shorthand
   * _.max(characters, 'age');
   * // => { 'name': 'fred', 'age': 40 };
   */
  function max(collection, callback, thisArg) {
    var computed = -Infinity,
        result = computed;

    // allows working with functions like `_.map` without using
    // their `index` argument as a callback
    if (typeof callback != 'function' && thisArg && thisArg[callback] === collection) {
      callback = null;
    }
    var index = -1,
        length = collection ? collection.length : 0;

    if (callback == null && typeof length == 'number') {
      while (++index < length) {
        var value = collection[index];
        if (value > result) {
          result = value;
        }
      }
    } else {
      callback = createCallback(callback, thisArg, 3);

      forEach(collection, function(value, index, collection) {
        var current = callback(value, index, collection);
        if (current > computed) {
          computed = current;
          result = value;
        }
      });
    }
    return result;
  }

  /**
   * Retrieves the minimum value of a collection. If the collection is empty or
   * falsey `Infinity` is returned. If a callback is provided it will be executed
   * for each value in the collection to generate the criterion by which the value
   * is ranked. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the minimum value.
   * @example
   *
   * _.min([4, 2, 8, 6]);
   * // => 2
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * _.min(characters, function(chr) { return chr.age; });
   * // => { 'name': 'barney', 'age': 36 };
   *
   * // using "_.pluck" callback shorthand
   * _.min(characters, 'age');
   * // => { 'name': 'barney', 'age': 36 };
   */
  function min(collection, callback, thisArg) {
    var computed = Infinity,
        result = computed;

    // allows working with functions like `_.map` without using
    // their `index` argument as a callback
    if (typeof callback != 'function' && thisArg && thisArg[callback] === collection) {
      callback = null;
    }
    var index = -1,
        length = collection ? collection.length : 0;

    if (callback == null && typeof length == 'number') {
      while (++index < length) {
        var value = collection[index];
        if (value < result) {
          result = value;
        }
      }
    } else {
      callback = createCallback(callback, thisArg, 3);

      forEach(collection, function(value, index, collection) {
        var current = callback(value, index, collection);
        if (current < computed) {
          computed = current;
          result = value;
        }
      });
    }
    return result;
  }

  /**
   * Retrieves the value of a specified property from all elements in the collection.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {string} property The name of the property to pluck.
   * @returns {Array} Returns a new array of property values.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * _.pluck(characters, 'name');
   * // => ['barney', 'fred']
   */
  var pluck = map;

  /**
   * Reduces a collection to a value which is the accumulated result of running
   * each element in the collection through the callback, where each successive
   * callback execution consumes the return value of the previous execution. If
   * `accumulator` is not provided the first element of the collection will be
   * used as the initial `accumulator` value. The callback is bound to `thisArg`
   * and invoked with four arguments; (accumulator, value, index|key, collection).
   *
   * @static
   * @memberOf _
   * @alias foldl, inject
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [accumulator] Initial value of the accumulator.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the accumulated value.
   * @example
   *
   * var sum = _.reduce([1, 2, 3], function(sum, num) {
   *   return sum + num;
   * });
   * // => 6
   *
   * var mapped = _.reduce({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
   *   result[key] = num * 3;
   *   return result;
   * }, {});
   * // => { 'a': 3, 'b': 6, 'c': 9 }
   */
  function reduce(collection, callback, accumulator, thisArg) {
    if (!collection) return accumulator;
    var noaccum = arguments.length < 3;
    callback = createCallback(callback, thisArg, 4);

    var index = -1,
        length = collection.length;

    if (typeof length == 'number') {
      if (noaccum) {
        accumulator = collection[++index];
      }
      while (++index < length) {
        accumulator = callback(accumulator, collection[index], index, collection);
      }
    } else {
      forOwn(collection, function(value, index, collection) {
        accumulator = noaccum
          ? (noaccum = false, value)
          : callback(accumulator, value, index, collection)
      });
    }
    return accumulator;
  }

  /**
   * This method is like `_.reduce` except that it iterates over elements
   * of a `collection` from right to left.
   *
   * @static
   * @memberOf _
   * @alias foldr
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [accumulator] Initial value of the accumulator.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the accumulated value.
   * @example
   *
   * var list = [[0, 1], [2, 3], [4, 5]];
   * var flat = _.reduceRight(list, function(a, b) { return a.concat(b); }, []);
   * // => [4, 5, 2, 3, 0, 1]
   */
  function reduceRight(collection, callback, accumulator, thisArg) {
    var noaccum = arguments.length < 3;
    callback = createCallback(callback, thisArg, 4);
    forEachRight(collection, function(value, index, collection) {
      accumulator = noaccum
        ? (noaccum = false, value)
        : callback(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The opposite of `_.filter` this method returns the elements of a
   * collection that the callback does **not** return truey for.
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of elements that failed the callback check.
   * @example
   *
   * var odds = _.reject([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
   * // => [1, 3, 5]
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'blocked': false },
   *   { 'name': 'fred',   'age': 40, 'blocked': true }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.reject(characters, 'blocked');
   * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
   *
   * // using "_.where" callback shorthand
   * _.reject(characters, { 'age': 36 });
   * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
   */
  function reject(collection, callback, thisArg) {
    callback = createCallback(callback, thisArg, 3);
    return filter(collection, function(value, index, collection) {
      return !callback(value, index, collection);
    });
  }

  /**
   * Retrieves a random element or `n` random elements from a collection.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to sample.
   * @param {number} [n] The number of elements to sample.
   * @param- {Object} [guard] Allows working with functions like `_.map`
   *  without using their `index` arguments as `n`.
   * @returns {Array} Returns the random sample(s) of `collection`.
   * @example
   *
   * _.sample([1, 2, 3, 4]);
   * // => 2
   *
   * _.sample([1, 2, 3, 4], 2);
   * // => [3, 1]
   */
  function sample(collection, n, guard) {
    if (collection && typeof collection.length != 'number') {
      collection = values(collection);
    }
    if (n == null || guard) {
      return collection ? collection[baseRandom(0, collection.length - 1)] : undefined;
    }
    var result = shuffle(collection);
    result.length = nativeMin(nativeMax(0, n), result.length);
    return result;
  }

  /**
   * Creates an array of shuffled values, using a version of the Fisher-Yates
   * shuffle. See http://en.wikipedia.org/wiki/Fisher-Yates_shuffle.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to shuffle.
   * @returns {Array} Returns a new shuffled collection.
   * @example
   *
   * _.shuffle([1, 2, 3, 4, 5, 6]);
   * // => [4, 1, 6, 3, 5, 2]
   */
  function shuffle(collection) {
    var index = -1,
        length = collection ? collection.length : 0,
        result = Array(typeof length == 'number' ? length : 0);

    forEach(collection, function(value) {
      var rand = baseRandom(0, ++index);
      result[index] = result[rand];
      result[rand] = value;
    });
    return result;
  }

  /**
   * Gets the size of the `collection` by returning `collection.length` for arrays
   * and array-like objects or the number of own enumerable properties for objects.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to inspect.
   * @returns {number} Returns `collection.length` or number of own enumerable properties.
   * @example
   *
   * _.size([1, 2]);
   * // => 2
   *
   * _.size({ 'one': 1, 'two': 2, 'three': 3 });
   * // => 3
   *
   * _.size('pebbles');
   * // => 7
   */
  function size(collection) {
    var length = collection ? collection.length : 0;
    return typeof length == 'number' ? length : keys(collection).length;
  }

  /**
   * Checks if the callback returns a truey value for **any** element of a
   * collection. The function returns as soon as it finds a passing value and
   * does not iterate over the entire collection. The callback is bound to
   * `thisArg` and invoked with three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias any
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {boolean} Returns `true` if any element passed the callback check,
   *  else `false`.
   * @example
   *
   * _.some([null, 0, 'yes', false], Boolean);
   * // => true
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'blocked': false },
   *   { 'name': 'fred',   'age': 40, 'blocked': true }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.some(characters, 'blocked');
   * // => true
   *
   * // using "_.where" callback shorthand
   * _.some(characters, { 'age': 1 });
   * // => false
   */
  function some(collection, callback, thisArg) {
    var result;
    callback = createCallback(callback, thisArg, 3);

    var index = -1,
        length = collection ? collection.length : 0;

    if (typeof length == 'number') {
      while (++index < length) {
        if ((result = callback(collection[index], index, collection))) {
          break;
        }
      }
    } else {
      forOwn(collection, function(value, index, collection) {
        return (result = callback(value, index, collection)) && indicatorObject;
      });
    }
    return !!result;
  }

  /**
   * Creates an array of elements, sorted in ascending order by the results of
   * running each element in a collection through the callback. This method
   * performs a stable sort, that is, it will preserve the original sort order
   * of equal elements. The callback is bound to `thisArg` and invoked with
   * three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an array of property names is provided for `callback` the collection
   * will be sorted by each property value.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Array|Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of sorted elements.
   * @example
   *
   * _.sortBy([1, 2, 3], function(num) { return Math.sin(num); });
   * // => [3, 1, 2]
   *
   * _.sortBy([1, 2, 3], function(num) { return this.sin(num); }, Math);
   * // => [3, 1, 2]
   *
   * var characters = [
   *   { 'name': 'barney',  'age': 36 },
   *   { 'name': 'fred',    'age': 40 },
   *   { 'name': 'barney',  'age': 26 },
   *   { 'name': 'fred',    'age': 30 }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.map(_.sortBy(characters, 'age'), _.values);
   * // => [['barney', 26], ['fred', 30], ['barney', 36], ['fred', 40]]
   *
   * // sorting by multiple properties
   * _.map(_.sortBy(characters, ['name', 'age']), _.values);
   * // = > [['barney', 26], ['barney', 36], ['fred', 30], ['fred', 40]]
   */
  function sortBy(collection, callback, thisArg) {
    var index = -1,
        length = collection ? collection.length : 0,
        result = Array(typeof length == 'number' ? length : 0);

    callback = createCallback(callback, thisArg, 3);
    forEach(collection, function(value, key, collection) {
      result[++index] = {
        'criteria': [callback(value, key, collection)],
        'index': index,
        'value': value
      };
    });

    length = result.length;
    result.sort(compareAscending);
    while (length--) {
      result[length] = result[length].value;
    }
    return result;
  }

  /**
   * Converts the `collection` to an array.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to convert.
   * @returns {Array} Returns the new converted array.
   * @example
   *
   * (function() { return _.toArray(arguments).slice(1); })(1, 2, 3, 4);
   * // => [2, 3, 4]
   */
  function toArray(collection) {
    if (isArray(collection)) {
      return slice(collection);
    }
    if (collection && typeof collection.length == 'number') {
      return map(collection);
    }
    return values(collection);
  }

  /**
   * Performs a deep comparison of each element in a `collection` to the given
   * `properties` object, returning an array of all elements that have equivalent
   * property values.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Object} props The object of property values to filter by.
   * @returns {Array} Returns a new array of elements that have the given properties.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'pets': ['hoppy'] },
   *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
   * ];
   *
   * _.where(characters, { 'age': 36 });
   * // => [{ 'name': 'barney', 'age': 36, 'pets': ['hoppy'] }]
   *
   * _.where(characters, { 'pets': ['dino'] });
   * // => [{ 'name': 'fred', 'age': 40, 'pets': ['baby puss', 'dino'] }]
   */
  function where(collection, properties, first) {
    return (first && isEmpty(properties))
      ? undefined
      : (first ? find : filter)(collection, properties);
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates an array with all falsey values removed. The values `false`, `null`,
   * `0`, `""`, `undefined`, and `NaN` are all falsey.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to compact.
   * @returns {Array} Returns a new array of filtered values.
   * @example
   *
   * _.compact([0, 1, false, 2, '', 3]);
   * // => [1, 2, 3]
   */
  function compact(array) {
    var index = -1,
        length = array ? array.length : 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result.push(value);
      }
    }
    return result;
  }

  /**
   * Creates an array excluding all values of the provided arrays using strict
   * equality for comparisons, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to process.
   * @param {...Array} [values] The arrays of values to exclude.
   * @returns {Array} Returns a new array of filtered values.
   * @example
   *
   * _.difference([1, 2, 3, 4, 5], [5, 2, 10]);
   * // => [1, 3, 4]
   */
  function difference(array) {
    return baseDifference(array, baseFlatten(arguments, true, true, 1));
  }

  /**
   * Gets the first element or first `n` elements of an array. If a callback
   * is provided elements at the beginning of the array are returned as long
   * as the callback returns truey. The callback is bound to `thisArg` and
   * invoked with three arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias head, take
   * @category Arrays
   * @param {Array} array The array to query.
   * @param {Function|Object|number|string} [callback] The function called
   *  per element or the number of elements to return. If a property name or
   *  object is provided it will be used to create a "_.pluck" or "_.where"
   *  style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the first element(s) of `array`.
   * @example
   *
   * _.first([1, 2, 3]);
   * // => 1
   *
   * _.first([1, 2, 3], 2);
   * // => [1, 2]
   *
   * _.first([1, 2, 3], function(num) {
   *   return num < 3;
   * });
   * // => [1, 2]
   *
   * var characters = [
   *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
   *   { 'name': 'fred',    'blocked': false, 'employer': 'slate' },
   *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.first(characters, 'blocked');
   * // => [{ 'name': 'barney', 'blocked': true, 'employer': 'slate' }]
   *
   * // using "_.where" callback shorthand
   * _.pluck(_.first(characters, { 'employer': 'slate' }), 'name');
   * // => ['barney', 'fred']
   */
  function first(array, callback, thisArg) {
    var n = 0,
        length = array ? array.length : 0;

    if (typeof callback != 'number' && callback != null) {
      var index = -1;
      callback = createCallback(callback, thisArg, 3);
      while (++index < length && callback(array[index], index, array)) {
        n++;
      }
    } else {
      n = callback;
      if (n == null || thisArg) {
        return array ? array[0] : undefined;
      }
    }
    return slice(array, 0, nativeMin(nativeMax(0, n), length));
  }

  /**
   * Flattens a nested array (the nesting can be to any depth). If `isShallow`
   * is truey, the array will only be flattened a single level. If a callback
   * is provided each element of the array is passed through the callback before
   * flattening. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to flatten.
   * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new flattened array.
   * @example
   *
   * _.flatten([1, [2], [3, [[4]]]]);
   * // => [1, 2, 3, 4];
   *
   * _.flatten([1, [2], [3, [[4]]]], true);
   * // => [1, 2, 3, [[4]]];
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 30, 'pets': ['hoppy'] },
   *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.flatten(characters, 'pets');
   * // => ['hoppy', 'baby puss', 'dino']
   */
  function flatten(array, isShallow) {
    return baseFlatten(array, isShallow);
  }

  /**
   * Gets the index at which the first occurrence of `value` is found using
   * strict equality for comparisons, i.e. `===`. If the array is already sorted
   * providing `true` for `fromIndex` will run a faster binary search.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {boolean|number} [fromIndex=0] The index to search from or `true`
   *  to perform a binary search on a sorted array.
   * @returns {number} Returns the index of the matched value or `-1`.
   * @example
   *
   * _.indexOf([1, 2, 3, 1, 2, 3], 2);
   * // => 1
   *
   * _.indexOf([1, 2, 3, 1, 2, 3], 2, 3);
   * // => 4
   *
   * _.indexOf([1, 1, 2, 2, 3, 3], 2, true);
   * // => 2
   */
  function indexOf(array, value, fromIndex) {
    if (typeof fromIndex == 'number') {
      var length = array ? array.length : 0;
      fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex || 0);
    } else if (fromIndex) {
      var index = sortedIndex(array, value);
      return array[index] === value ? index : -1;
    }
    return baseIndexOf(array, value, fromIndex);
  }

  /**
   * Gets all but the last element or last `n` elements of an array. If a
   * callback is provided elements at the end of the array are excluded from
   * the result as long as the callback returns truey. The callback is bound
   * to `thisArg` and invoked with three arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to query.
   * @param {Function|Object|number|string} [callback=1] The function called
   *  per element or the number of elements to exclude. If a property name or
   *  object is provided it will be used to create a "_.pluck" or "_.where"
   *  style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a slice of `array`.
   * @example
   *
   * _.initial([1, 2, 3]);
   * // => [1, 2]
   *
   * _.initial([1, 2, 3], 2);
   * // => [1]
   *
   * _.initial([1, 2, 3], function(num) {
   *   return num > 1;
   * });
   * // => [1]
   *
   * var characters = [
   *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
   *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
   *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.initial(characters, 'blocked');
   * // => [{ 'name': 'barney',  'blocked': false, 'employer': 'slate' }]
   *
   * // using "_.where" callback shorthand
   * _.pluck(_.initial(characters, { 'employer': 'na' }), 'name');
   * // => ['barney', 'fred']
   */
  function initial(array, callback, thisArg) {
    var n = 0,
        length = array ? array.length : 0;

    if (typeof callback != 'number' && callback != null) {
      var index = length;
      callback = createCallback(callback, thisArg, 3);
      while (index-- && callback(array[index], index, array)) {
        n++;
      }
    } else {
      n = (callback == null || thisArg) ? 1 : callback || n;
    }
    return slice(array, 0, nativeMin(nativeMax(0, length - n), length));
  }

  /**
   * Creates an array of unique values present in all provided arrays using
   * strict equality for comparisons, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {...Array} [array] The arrays to inspect.
   * @returns {Array} Returns an array of shared values.
   * @example
   *
   * _.intersection([1, 2, 3], [5, 2, 1, 4], [2, 1]);
   * // => [1, 2]
   */
  function intersection() {
    var args = [],
        argsIndex = -1,
        argsLength = arguments.length;

    while (++argsIndex < argsLength) {
      var value = arguments[argsIndex];
       if (isArray(value) || isArguments(value)) {
         args.push(value);
       }
    }
    var array = args[0],
        index = -1,
        indexOf = getIndexOf(),
        length = array ? array.length : 0,
        result = [];

    outer:
    while (++index < length) {
      value = array[index];
      if (indexOf(result, value) < 0) {
        var argsIndex = argsLength;
        while (--argsIndex) {
          if (indexOf(args[argsIndex], value) < 0) {
            continue outer;
          }
        }
        result.push(value);
      }
    }
    return result;
  }

  /**
   * Gets the last element or last `n` elements of an array. If a callback is
   * provided elements at the end of the array are returned as long as the
   * callback returns truey. The callback is bound to `thisArg` and invoked
   * with three arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to query.
   * @param {Function|Object|number|string} [callback] The function called
   *  per element or the number of elements to return. If a property name or
   *  object is provided it will be used to create a "_.pluck" or "_.where"
   *  style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the last element(s) of `array`.
   * @example
   *
   * _.last([1, 2, 3]);
   * // => 3
   *
   * _.last([1, 2, 3], 2);
   * // => [2, 3]
   *
   * _.last([1, 2, 3], function(num) {
   *   return num > 1;
   * });
   * // => [2, 3]
   *
   * var characters = [
   *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
   *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
   *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.pluck(_.last(characters, 'blocked'), 'name');
   * // => ['fred', 'pebbles']
   *
   * // using "_.where" callback shorthand
   * _.last(characters, { 'employer': 'na' });
   * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
   */
  function last(array, callback, thisArg) {
    var n = 0,
        length = array ? array.length : 0;

    if (typeof callback != 'number' && callback != null) {
      var index = length;
      callback = createCallback(callback, thisArg, 3);
      while (index-- && callback(array[index], index, array)) {
        n++;
      }
    } else {
      n = callback;
      if (n == null || thisArg) {
        return array ? array[length - 1] : undefined;
      }
    }
    return slice(array, nativeMax(0, length - n));
  }

  /**
   * Gets the index at which the last occurrence of `value` is found using strict
   * equality for comparisons, i.e. `===`. If `fromIndex` is negative, it is used
   * as the offset from the end of the collection.
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=array.length-1] The index to search from.
   * @returns {number} Returns the index of the matched value or `-1`.
   * @example
   *
   * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2);
   * // => 4
   *
   * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2, 3);
   * // => 1
   */
  function lastIndexOf(array, value, fromIndex) {
    var index = array ? array.length : 0;
    if (typeof fromIndex == 'number') {
      index = (fromIndex < 0 ? nativeMax(0, index + fromIndex) : nativeMin(fromIndex, index - 1)) + 1;
    }
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Creates an array of numbers (positive and/or negative) progressing from
   * `start` up to but not including `end`. If `start` is less than `stop` a
   * zero-length range is created unless a negative `step` is specified.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {number} [start=0] The start of the range.
   * @param {number} end The end of the range.
   * @param {number} [step=1] The value to increment or decrement by.
   * @returns {Array} Returns a new range array.
   * @example
   *
   * _.range(4);
   * // => [0, 1, 2, 3]
   *
   * _.range(1, 5);
   * // => [1, 2, 3, 4]
   *
   * _.range(0, 20, 5);
   * // => [0, 5, 10, 15]
   *
   * _.range(0, -4, -1);
   * // => [0, -1, -2, -3]
   *
   * _.range(1, 4, 0);
   * // => [1, 1, 1]
   *
   * _.range(0);
   * // => []
   */
  function range(start, end, step) {
    start = +start || 0;
    step =  (+step || 1);

    if (end == null) {
      end = start;
      start = 0;
    }
    // use `Array(length)` so engines like Chakra and V8 avoid slower modes
    // http://youtu.be/XAqIpGU8ZZk#t=17m25s
    var index = -1,
        length = nativeMax(0, ceil((end - start) / step)),
        result = Array(length);

    while (++index < length) {
      result[index] = start;
      start += step;
    }
    return result;
  }

  /**
   * The opposite of `_.initial` this method gets all but the first element or
   * first `n` elements of an array. If a callback function is provided elements
   * at the beginning of the array are excluded from the result as long as the
   * callback returns truey. The callback is bound to `thisArg` and invoked
   * with three arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias drop, tail
   * @category Arrays
   * @param {Array} array The array to query.
   * @param {Function|Object|number|string} [callback=1] The function called
   *  per element or the number of elements to exclude. If a property name or
   *  object is provided it will be used to create a "_.pluck" or "_.where"
   *  style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a slice of `array`.
   * @example
   *
   * _.rest([1, 2, 3]);
   * // => [2, 3]
   *
   * _.rest([1, 2, 3], 2);
   * // => [3]
   *
   * _.rest([1, 2, 3], function(num) {
   *   return num < 3;
   * });
   * // => [3]
   *
   * var characters = [
   *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
   *   { 'name': 'fred',    'blocked': false,  'employer': 'slate' },
   *   { 'name': 'pebbles', 'blocked': true, 'employer': 'na' }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.pluck(_.rest(characters, 'blocked'), 'name');
   * // => ['fred', 'pebbles']
   *
   * // using "_.where" callback shorthand
   * _.rest(characters, { 'employer': 'slate' });
   * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
   */
  function rest(array, callback, thisArg) {
    if (typeof callback != 'number' && callback != null) {
      var n = 0,
          index = -1,
          length = array ? array.length : 0;

      callback = createCallback(callback, thisArg, 3);
      while (++index < length && callback(array[index], index, array)) {
        n++;
      }
    } else {
      n = (callback == null || thisArg) ? 1 : nativeMax(0, callback);
    }
    return slice(array, n);
  }

  /**
   * Uses a binary search to determine the smallest index at which a value
   * should be inserted into a given sorted array in order to maintain the sort
   * order of the array. If a callback is provided it will be executed for
   * `value` and each element of `array` to compute their sort ranking. The
   * callback is bound to `thisArg` and invoked with one argument; (value).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to inspect.
   * @param {*} value The value to evaluate.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {number} Returns the index at which `value` should be inserted
   *  into `array`.
   * @example
   *
   * _.sortedIndex([20, 30, 50], 40);
   * // => 2
   *
   * // using "_.pluck" callback shorthand
   * _.sortedIndex([{ 'x': 20 }, { 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
   * // => 2
   *
   * var dict = {
   *   'wordToNumber': { 'twenty': 20, 'thirty': 30, 'fourty': 40, 'fifty': 50 }
   * };
   *
   * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
   *   return dict.wordToNumber[word];
   * });
   * // => 2
   *
   * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
   *   return this.wordToNumber[word];
   * }, dict);
   * // => 2
   */
  function sortedIndex(array, value, callback, thisArg) {
    var low = 0,
        high = array ? array.length : low;

    // explicitly reference `identity` for better inlining in Firefox
    callback = callback ? createCallback(callback, thisArg, 1) : identity;
    value = callback(value);

    while (low < high) {
      var mid = (low + high) >>> 1;
      (callback(array[mid]) < value)
        ? low = mid + 1
        : high = mid;
    }
    return low;
  }

  /**
   * Creates an array of unique values, in order, of the provided arrays using
   * strict equality for comparisons, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {...Array} [array] The arrays to inspect.
   * @returns {Array} Returns an array of combined values.
   * @example
   *
   * _.union([1, 2, 3], [5, 2, 1, 4], [2, 1]);
   * // => [1, 2, 3, 5, 4]
   */
  function union() {
    return baseUniq(baseFlatten(arguments, true, true));
  }

  /**
   * Creates a duplicate-value-free version of an array using strict equality
   * for comparisons, i.e. `===`. If the array is sorted, providing
   * `true` for `isSorted` will use a faster algorithm. If a callback is provided
   * each element of `array` is passed through the callback before uniqueness
   * is computed. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias unique
   * @category Arrays
   * @param {Array} array The array to process.
   * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a duplicate-value-free array.
   * @example
   *
   * _.uniq([1, 2, 1, 3, 1]);
   * // => [1, 2, 3]
   *
   * _.uniq([1, 1, 2, 2, 3], true);
   * // => [1, 2, 3]
   *
   * _.uniq(['A', 'b', 'C', 'a', 'B', 'c'], function(letter) { return letter.toLowerCase(); });
   * // => ['A', 'b', 'C']
   *
   * _.uniq([1, 2.5, 3, 1.5, 2, 3.5], function(num) { return this.floor(num); }, Math);
   * // => [1, 2.5, 3]
   *
   * // using "_.pluck" callback shorthand
   * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
   * // => [{ 'x': 1 }, { 'x': 2 }]
   */
  function uniq(array, isSorted, callback, thisArg) {
    // juggle arguments
    if (typeof isSorted != 'boolean' && isSorted != null) {
      thisArg = callback;
      callback = (typeof isSorted != 'function' && thisArg && thisArg[isSorted] === array) ? null : isSorted;
      isSorted = false;
    }
    if (callback != null) {
      callback = createCallback(callback, thisArg, 3);
    }
    return baseUniq(array, isSorted, callback);
  }

  /**
   * Creates an array excluding all provided values using strict equality for
   * comparisons, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to filter.
   * @param {...*} [value] The values to exclude.
   * @returns {Array} Returns a new array of filtered values.
   * @example
   *
   * _.without([1, 2, 1, 0, 3, 1, 4], 0, 1);
   * // => [2, 3, 4]
   */
  function without(array) {
    return baseDifference(array, slice(arguments, 1));
  }

  /**
   * Creates an array of grouped elements, the first of which contains the first
   * elements of the given arrays, the second of which contains the second
   * elements of the given arrays, and so on.
   *
   * @static
   * @memberOf _
   * @alias unzip
   * @category Arrays
   * @param {...Array} [array] Arrays to process.
   * @returns {Array} Returns a new array of grouped elements.
   * @example
   *
   * _.zip(['fred', 'barney'], [30, 40], [true, false]);
   * // => [['fred', 30, true], ['barney', 40, false]]
   */
  function zip() {
    var index = -1,
        length = max(pluck(arguments, 'length')),
        result = Array(length < 0 ? 0 : length);

    while (++index < length) {
      result[index] = pluck(arguments, index);
    }
    return result;
  }

  /**
   * Creates an object composed from arrays of `keys` and `values`. Provide
   * either a single two dimensional array, i.e. `[[key1, value1], [key2, value2]]`
   * or two arrays, one of `keys` and one of corresponding `values`.
   *
   * @static
   * @memberOf _
   * @alias object
   * @category Arrays
   * @param {Array} keys The array of keys.
   * @param {Array} [values=[]] The array of values.
   * @returns {Object} Returns an object composed of the given keys and
   *  corresponding values.
   * @example
   *
   * _.zipObject(['fred', 'barney'], [30, 40]);
   * // => { 'fred': 30, 'barney': 40 }
   */
  function zipObject(keys, values) {
    var index = -1,
        length = keys ? keys.length : 0,
        result = {};

    if (!values && length && !isArray(keys[0])) {
      values = [];
    }
    while (++index < length) {
      var key = keys[index];
      if (values) {
        result[key] = values[index];
      } else if (key) {
        result[key[0]] = key[1];
      }
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a function that executes `func`, with  the `this` binding and
   * arguments of the created function, only after being called `n` times.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {number} n The number of times the function must be called before
   *  `func` is executed.
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * var saves = ['profile', 'settings'];
   *
   * var done = _.after(saves.length, function() {
   *   console.log('Done saving!');
   * });
   *
   * _.forEach(saves, function(type) {
   *   asyncSave({ 'type': type, 'complete': done });
   * });
   * // => logs 'Done saving!', after all saves have completed
   */
  function after(n, func) {
    if (!isFunction(func)) {
      throw new TypeError;
    }
    return function() {
      if (--n < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  /**
   * Creates a function that, when called, invokes `func` with the `this`
   * binding of `thisArg` and prepends any additional `bind` arguments to those
   * provided to the bound function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to bind.
   * @param {*} [thisArg] The `this` binding of `func`.
   * @param {...*} [arg] Arguments to be partially applied.
   * @returns {Function} Returns the new bound function.
   * @example
   *
   * var func = function(greeting) {
   *   return greeting + ' ' + this.name;
   * };
   *
   * func = _.bind(func, { 'name': 'fred' }, 'hi');
   * func();
   * // => 'hi fred'
   */
  function bind(func, thisArg) {
    return arguments.length > 2
      ? createWrapper(func, 17, slice(arguments, 2), null, thisArg)
      : createWrapper(func, 1, null, null, thisArg);
  }

  /**
   * Binds methods of an object to the object itself, overwriting the existing
   * method. Method names may be specified as individual arguments or as arrays
   * of method names. If no method names are provided all the function properties
   * of `object` will be bound.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Object} object The object to bind and assign the bound methods to.
   * @param {...string} [methodName] The object method names to
   *  bind, specified as individual method names or arrays of method names.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var view = {
   *   'label': 'docs',
   *   'onClick': function() { console.log('clicked ' + this.label); }
   * };
   *
   * _.bindAll(view);
   * jQuery('#docs').on('click', view.onClick);
   * // => logs 'clicked docs', when the button is clicked
   */
  function bindAll(object) {
    var funcs = arguments.length > 1 ? baseFlatten(arguments, true, false, 1) : functions(object),
        index = -1,
        length = funcs.length;

    while (++index < length) {
      var key = funcs[index];
      object[key] = createWrapper(object[key], 1, null, null, object);
    }
    return object;
  }

  /**
   * Creates a function that is the composition of the provided functions,
   * where each function consumes the return value of the function that follows.
   * For example, composing the functions `f()`, `g()`, and `h()` produces `f(g(h()))`.
   * Each function is executed with the `this` binding of the composed function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {...Function} [func] Functions to compose.
   * @returns {Function} Returns the new composed function.
   * @example
   *
   * var realNameMap = {
   *   'pebbles': 'penelope'
   * };
   *
   * var format = function(name) {
   *   name = realNameMap[name.toLowerCase()] || name;
   *   return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
   * };
   *
   * var greet = function(formatted) {
   *   return 'Hiya ' + formatted + '!';
   * };
   *
   * var welcome = _.compose(greet, format);
   * welcome('pebbles');
   * // => 'Hiya Penelope!'
   */
  function compose() {
    var funcs = arguments,
        length = funcs.length;

    while (length--) {
      if (!isFunction(funcs[length])) {
        throw new TypeError;
      }
    }
    return function() {
      var args = arguments,
          length = funcs.length;

      while (length--) {
        args = [funcs[length].apply(this, args)];
      }
      return args[0];
    };
  }

  /**
   * Creates a function that will delay the execution of `func` until after
   * `wait` milliseconds have elapsed since the last time it was invoked.
   * Provide an options object to indicate that `func` should be invoked on
   * the leading and/or trailing edge of the `wait` timeout. Subsequent calls
   * to the debounced function will return the result of the last `func` call.
   *
   * Note: If `leading` and `trailing` options are `true` `func` will be called
   * on the trailing edge of the timeout only if the the debounced function is
   * invoked more than once during the `wait` timeout.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to debounce.
   * @param {number} wait The number of milliseconds to delay.
   * @param {Object} [options] The options object.
   * @param {boolean} [options.leading=false] Specify execution on the leading edge of the timeout.
   * @param {number} [options.maxWait] The maximum time `func` is allowed to be delayed before it's called.
   * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // avoid costly calculations while the window size is in flux
   * var lazyLayout = _.debounce(calculateLayout, 150);
   * jQuery(window).on('resize', lazyLayout);
   *
   * // execute `sendMail` when the click event is fired, debouncing subsequent calls
   * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
   *   'leading': true,
   *   'trailing': false
   * });
   *
   * // ensure `batchLog` is executed once after 1 second of debounced calls
   * var source = new EventSource('/stream');
   * source.addEventListener('message', _.debounce(batchLog, 250, {
   *   'maxWait': 1000
   * }, false);
   */
  function debounce(func, wait, options) {
    var args,
        maxTimeoutId,
        result,
        stamp,
        thisArg,
        timeoutId,
        trailingCall,
        lastCalled = 0,
        maxWait = false,
        trailing = true;

    if (!isFunction(func)) {
      throw new TypeError;
    }
    wait = nativeMax(0, wait) || 0;
    if (options === true) {
      var leading = true;
      trailing = false;
    } else if (isObject(options)) {
      leading = options.leading;
      maxWait = 'maxWait' in options && (nativeMax(wait, options.maxWait) || 0);
      trailing = 'trailing' in options ? options.trailing : trailing;
    }
    var delayed = function() {
      var remaining = wait - (now() - stamp);
      if (remaining <= 0) {
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        var isCalled = trailingCall;
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = null;
          }
        }
      } else {
        timeoutId = setTimeout(delayed, remaining);
      }
    };

    var maxDelayed = function() {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      maxTimeoutId = timeoutId = trailingCall = undefined;
      if (trailing || (maxWait !== wait)) {
        lastCalled = now();
        result = func.apply(thisArg, args);
        if (!timeoutId && !maxTimeoutId) {
          args = thisArg = null;
        }
      }
    };

    return function() {
      args = arguments;
      stamp = now();
      thisArg = this;
      trailingCall = trailing && (timeoutId || !leading);

      if (maxWait === false) {
        var leadingCall = leading && !timeoutId;
      } else {
        if (!maxTimeoutId && !leading) {
          lastCalled = stamp;
        }
        var remaining = maxWait - (stamp - lastCalled),
            isCalled = remaining <= 0;

        if (isCalled) {
          if (maxTimeoutId) {
            maxTimeoutId = clearTimeout(maxTimeoutId);
          }
          lastCalled = stamp;
          result = func.apply(thisArg, args);
        }
        else if (!maxTimeoutId) {
          maxTimeoutId = setTimeout(maxDelayed, remaining);
        }
      }
      if (isCalled && timeoutId) {
        timeoutId = clearTimeout(timeoutId);
      }
      else if (!timeoutId && wait !== maxWait) {
        timeoutId = setTimeout(delayed, wait);
      }
      if (leadingCall) {
        isCalled = true;
        result = func.apply(thisArg, args);
      }
      if (isCalled && !timeoutId && !maxTimeoutId) {
        args = thisArg = null;
      }
      return result;
    };
  }

  /**
   * Defers executing the `func` function until the current call stack has cleared.
   * Additional arguments will be provided to `func` when it is invoked.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to defer.
   * @param {...*} [arg] Arguments to invoke the function with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.defer(function(text) { console.log(text); }, 'deferred');
   * // logs 'deferred' after one or more milliseconds
   */
  function defer(func) {
    if (!isFunction(func)) {
      throw new TypeError;
    }
    var args = slice(arguments, 1);
    return setTimeout(function() { func.apply(undefined, args); }, 1);
  }

  /**
   * Executes the `func` function after `wait` milliseconds. Additional arguments
   * will be provided to `func` when it is invoked.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to delay.
   * @param {number} wait The number of milliseconds to delay execution.
   * @param {...*} [arg] Arguments to invoke the function with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.delay(function(text) { console.log(text); }, 1000, 'later');
   * // => logs 'later' after one second
   */
  function delay(func, wait) {
    if (!isFunction(func)) {
      throw new TypeError;
    }
    var args = slice(arguments, 2);
    return setTimeout(function() { func.apply(undefined, args); }, wait);
  }

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided it will be used to determine the cache key for storing the result
   * based on the arguments provided to the memoized function. By default, the
   * first argument provided to the memoized function is used as the cache key.
   * The `func` is executed with the `this` binding of the memoized function.
   * The result cache is exposed as the `cache` property on the memoized function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] A function used to resolve the cache key.
   * @returns {Function} Returns the new memoizing function.
   * @example
   *
   * var fibonacci = _.memoize(function(n) {
   *   return n < 2 ? n : fibonacci(n - 1) + fibonacci(n - 2);
   * });
   *
   * fibonacci(9)
   * // => 34
   *
   * var data = {
   *   'fred': { 'name': 'fred', 'age': 40 },
   *   'pebbles': { 'name': 'pebbles', 'age': 1 }
   * };
   *
   * // modifying the result cache
   * var get = _.memoize(function(name) { return data[name]; }, _.identity);
   * get('pebbles');
   * // => { 'name': 'pebbles', 'age': 1 }
   *
   * get.cache.pebbles.name = 'penelope';
   * get('pebbles');
   * // => { 'name': 'penelope', 'age': 1 }
   */
  function memoize(func, resolver) {
    var cache = {};
    return function() {
      var key = resolver ? resolver.apply(this, arguments) : keyPrefix + arguments[0];
      return hasOwnProperty.call(cache, key)
        ? cache[key]
        : (cache[key] = func.apply(this, arguments));
    };
  }

  /**
   * Creates a function that is restricted to execute `func` once. Repeat calls to
   * the function will return the value of the first call. The `func` is executed
   * with the `this` binding of the created function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * var initialize = _.once(createApplication);
   * initialize();
   * initialize();
   * // `initialize` executes `createApplication` once
   */
  function once(func) {
    var ran,
        result;

    if (!isFunction(func)) {
      throw new TypeError;
    }
    return function() {
      if (ran) {
        return result;
      }
      ran = true;
      result = func.apply(this, arguments);

      // clear the `func` variable so the function may be garbage collected
      func = null;
      return result;
    };
  }

  /**
   * Creates a function that, when called, invokes `func` with any additional
   * `partial` arguments prepended to those provided to the new function. This
   * method is similar to `_.bind` except it does **not** alter the `this` binding.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to partially apply arguments to.
   * @param {...*} [arg] Arguments to be partially applied.
   * @returns {Function} Returns the new partially applied function.
   * @example
   *
   * var greet = function(greeting, name) { return greeting + ' ' + name; };
   * var hi = _.partial(greet, 'hi');
   * hi('fred');
   * // => 'hi fred'
   */
  function partial(func) {
    return createWrapper(func, 16, slice(arguments, 1));
  }

  /**
   * Creates a function that, when executed, will only call the `func` function
   * at most once per every `wait` milliseconds. Provide an options object to
   * indicate that `func` should be invoked on the leading and/or trailing edge
   * of the `wait` timeout. Subsequent calls to the throttled function will
   * return the result of the last `func` call.
   *
   * Note: If `leading` and `trailing` options are `true` `func` will be called
   * on the trailing edge of the timeout only if the the throttled function is
   * invoked more than once during the `wait` timeout.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to throttle.
   * @param {number} wait The number of milliseconds to throttle executions to.
   * @param {Object} [options] The options object.
   * @param {boolean} [options.leading=true] Specify execution on the leading edge of the timeout.
   * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
   * @returns {Function} Returns the new throttled function.
   * @example
   *
   * // avoid excessively updating the position while scrolling
   * var throttled = _.throttle(updatePosition, 100);
   * jQuery(window).on('scroll', throttled);
   *
   * // execute `renewToken` when the click event is fired, but not more than once every 5 minutes
   * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
   *   'trailing': false
   * }));
   */
  function throttle(func, wait, options) {
    var leading = true,
        trailing = true;

    if (!isFunction(func)) {
      throw new TypeError;
    }
    if (options === false) {
      leading = false;
    } else if (isObject(options)) {
      leading = 'leading' in options ? options.leading : leading;
      trailing = 'trailing' in options ? options.trailing : trailing;
    }
    options = {};
    options.leading = leading;
    options.maxWait = wait;
    options.trailing = trailing;

    return debounce(func, wait, options);
  }

  /**
   * Creates a function that provides `value` to the wrapper function as its
   * first argument. Additional arguments provided to the function are appended
   * to those provided to the wrapper function. The wrapper is executed with
   * the `this` binding of the created function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {*} value The value to wrap.
   * @param {Function} wrapper The wrapper function.
   * @returns {Function} Returns the new function.
   * @example
   *
   * var p = _.wrap(_.escape, function(func, text) {
   *   return '<p>' + func(text) + '</p>';
   * });
   *
   * p('Fred, Wilma, & Pebbles');
   * // => '<p>Fred, Wilma, &amp; Pebbles</p>'
   */
  function wrap(value, wrapper) {
    return createWrapper(wrapper, 16, [value]);
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Produces a callback bound to an optional `thisArg`. If `func` is a property
   * name the created callback will return the property value for a given element.
   * If `func` is an object the created callback will return `true` for elements
   * that contain the equivalent object properties, otherwise it will return `false`.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {*} [func=identity] The value to convert to a callback.
   * @param {*} [thisArg] The `this` binding of the created callback.
   * @param {number} [argCount] The number of arguments the callback accepts.
   * @returns {Function} Returns a callback function.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // wrap to create custom callback shorthands
   * _.createCallback = _.wrap(_.createCallback, function(func, callback, thisArg) {
   *   var match = /^(.+?)__([gl]t)(.+)$/.exec(callback);
   *   return !match ? func(callback, thisArg) : function(object) {
   *     return match[2] == 'gt' ? object[match[1]] > match[3] : object[match[1]] < match[3];
   *   };
   * });
   *
   * _.filter(characters, 'age__gt38');
   * // => [{ 'name': 'fred', 'age': 40 }]
   */
  function createCallback(func, thisArg, argCount) {
    var type = typeof func;
    if (func == null || type == 'function') {
      return baseCreateCallback(func, thisArg, argCount);
    }
    // handle "_.pluck" style callback shorthands
    if (type != 'object') {
      return property(func);
    }
    var props = keys(func);
    return function(object) {
      var length = props.length,
          result = false;

      while (length--) {
        if (!(result = object[props[length]] === func[props[length]])) {
          break;
        }
      }
      return result;
    };
  }

  /**
   * Converts the characters `&`, `<`, `>`, `"`, and `'` in `string` to their
   * corresponding HTML entities.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} string The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escape('Fred, Wilma, & Pebbles');
   * // => 'Fred, Wilma, &amp; Pebbles'
   */
  function escape(string) {
    return string == null ? '' : String(string).replace(reUnescapedHtml, escapeHtmlChar);
  }

  /**
   * This method returns the first argument provided to it.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'name': 'fred' };
   * _.identity(object) === object;
   * // => true
   */
  function identity(value) {
    return value;
  }

  /**
   * Adds function properties of a source object to the destination object.
   * If `object` is a function methods will be added to its prototype as well.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {Function|Object} [object=lodash] object The destination object.
   * @param {Object} source The object of functions to add.
   * @param {Object} [options] The options object.
   * @param {boolean} [options.chain=true] Specify whether the functions added are chainable.
   * @example
   *
   * function capitalize(string) {
   *   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
   * }
   *
   * _.mixin({ 'capitalize': capitalize });
   * _.capitalize('fred');
   * // => 'Fred'
   *
   * _('fred').capitalize().value();
   * // => 'Fred'
   *
   * _.mixin({ 'capitalize': capitalize }, { 'chain': false });
   * _('fred').capitalize();
   * // => 'Fred'
   */
  function mixin(object) {
    forEach(functions(object), function(methodName) {
      var func = lodash[methodName] = object[methodName];

      lodash.prototype[methodName] = function() {
        var args = [this.__wrapped__];
        push.apply(args, arguments);

        var result = func.apply(lodash, args);
        return this.__chain__
          ? new lodashWrapper(result, true)
          : result;
      };
    });
  }

  /**
   * Reverts the '_' variable to its previous value and returns a reference to
   * the `lodash` function.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @returns {Function} Returns the `lodash` function.
   * @example
   *
   * var lodash = _.noConflict();
   */
  function noConflict() {
    root._ = oldDash;
    return this;
  }

  /**
   * A no-operation function.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @example
   *
   * var object = { 'name': 'fred' };
   * _.noop(object) === undefined;
   * // => true
   */
  function noop() {
    // no operation performed
  }

  /**
   * Gets the number of milliseconds that have elapsed since the Unix epoch
   * (1 January 1970 00:00:00 UTC).
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @example
   *
   * var stamp = _.now();
   * _.defer(function() { console.log(_.now() - stamp); });
   * // => logs the number of milliseconds it took for the deferred function to be called
   */
  var now = isNative(now = Date.now) && now || function() {
    return new Date().getTime();
  };

  /**
   * Creates a "_.pluck" style function, which returns the `key` value of a
   * given object.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} key The name of the property to retrieve.
   * @returns {Function} Returns the new function.
   * @example
   *
   * var characters = [
   *   { 'name': 'fred',   'age': 40 },
   *   { 'name': 'barney', 'age': 36 }
   * ];
   *
   * var getName = _.property('name');
   *
   * _.map(characters, getName);
   * // => ['barney', 'fred']
   *
   * _.sortBy(characters, getName);
   * // => [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred',   'age': 40 }]
   */
  function property(key) {
    return function(object) {
      return object[key];
    };
  }

  /**
   * Produces a random number between `min` and `max` (inclusive). If only one
   * argument is provided a number between `0` and the given number will be
   * returned. If `floating` is truey or either `min` or `max` are floats a
   * floating-point number will be returned instead of an integer.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {number} [min=0] The minimum possible value.
   * @param {number} [max=1] The maximum possible value.
   * @param {boolean} [floating=false] Specify returning a floating-point number.
   * @returns {number} Returns a random number.
   * @example
   *
   * _.random(0, 5);
   * // => an integer between 0 and 5
   *
   * _.random(5);
   * // => also an integer between 0 and 5
   *
   * _.random(5, true);
   * // => a floating-point number between 0 and 5
   *
   * _.random(1.2, 5.2);
   * // => a floating-point number between 1.2 and 5.2
   */
  function random(min, max) {
    if (min == null && max == null) {
      max = 1;
    }
    min = +min || 0;
    if (max == null) {
      max = min;
      min = 0;
    } else {
      max = +max || 0;
    }
    return min + floor(nativeRandom() * (max - min + 1));
  }

  /**
   * Resolves the value of property `key` on `object`. If `key` is a function
   * it will be invoked with the `this` binding of `object` and its result returned,
   * else the property value is returned. If `object` is falsey then `undefined`
   * is returned.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {Object} object The object to inspect.
   * @param {string} key The name of the property to resolve.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = {
   *   'cheese': 'crumpets',
   *   'stuff': function() {
   *     return 'nonsense';
   *   }
   * };
   *
   * _.result(object, 'cheese');
   * // => 'crumpets'
   *
   * _.result(object, 'stuff');
   * // => 'nonsense'
   */
  function result(object, key) {
    if (object) {
      var value = object[key];
      return isFunction(value) ? object[key]() : value;
    }
  }

  /**
   * A micro-templating method that handles arbitrary delimiters, preserves
   * whitespace, and correctly escapes quotes within interpolated code.
   *
   * Note: In the development build, `_.template` utilizes sourceURLs for easier
   * debugging. See http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
   *
   * For more information on precompiling templates see:
   * https://lodash.com/custom-builds
   *
   * For more information on Chrome extension sandboxes see:
   * http://developer.chrome.com/stable/extensions/sandboxingEval.html
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} text The template text.
   * @param {Object} data The data object used to populate the text.
   * @param {Object} [options] The options object.
   * @param {RegExp} [options.escape] The "escape" delimiter.
   * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
   * @param {Object} [options.imports] An object to import into the template as local variables.
   * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
   * @param {string} [sourceURL] The sourceURL of the template's compiled source.
   * @param {string} [variable] The data object variable name.
   * @returns {Function|string} Returns a compiled function when no `data` object
   *  is given, else it returns the interpolated text.
   * @example
   *
   * // using the "interpolate" delimiter to create a compiled template
   * var compiled = _.template('hello <%= name %>');
   * compiled({ 'name': 'fred' });
   * // => 'hello fred'
   *
   * // using the "escape" delimiter to escape HTML in data property values
   * _.template('<b><%- value %></b>', { 'value': '<script>' });
   * // => '<b>&lt;script&gt;</b>'
   *
   * // using the "evaluate" delimiter to generate HTML
   * var list = '<% _.forEach(people, function(name) { %><li><%- name %></li><% }); %>';
   * _.template(list, { 'people': ['fred', 'barney'] });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // using the ES6 delimiter as an alternative to the default "interpolate" delimiter
   * _.template('hello ${ name }', { 'name': 'pebbles' });
   * // => 'hello pebbles'
   *
   * // using the internal `print` function in "evaluate" delimiters
   * _.template('<% print("hello " + name); %>!', { 'name': 'barney' });
   * // => 'hello barney!'
   *
   * // using a custom template delimiters
   * _.templateSettings = {
   *   'interpolate': /{{([\s\S]+?)}}/g
   * };
   *
   * _.template('hello {{ name }}!', { 'name': 'mustache' });
   * // => 'hello mustache!'
   *
   * // using the `imports` option to import jQuery
   * var list = '<% jq.each(people, function(name) { %><li><%- name %></li><% }); %>';
   * _.template(list, { 'people': ['fred', 'barney'] }, { 'imports': { 'jq': jQuery } });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // using the `sourceURL` option to specify a custom sourceURL for the template
   * var compiled = _.template('hello <%= name %>', null, { 'sourceURL': '/basic/greeting.jst' });
   * compiled(data);
   * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
   *
   * // using the `variable` option to ensure a with-statement isn't used in the compiled template
   * var compiled = _.template('hi <%= data.name %>!', null, { 'variable': 'data' });
   * compiled.source;
   * // => function(data) {
   *   var __t, __p = '', __e = _.escape;
   *   __p += 'hi ' + ((__t = ( data.name )) == null ? '' : __t) + '!';
   *   return __p;
   * }
   *
   * // using the `source` property to inline compiled templates for meaningful
   * // line numbers in error messages and a stack trace
   * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
   *   var JST = {\
   *     "main": ' + _.template(mainText).source + '\
   *   };\
   * ');
   */
  function template(text, data, options) {
    var _ = lodash,
        settings = _.templateSettings;

    text = String(text || '');
    options = defaults({}, options, settings);

    var index = 0,
        source = "__p += '",
        variable = options.variable;

    var reDelimiters = RegExp(
      (options.escape || reNoMatch).source + '|' +
      (options.interpolate || reNoMatch).source + '|' +
      (options.evaluate || reNoMatch).source + '|$'
    , 'g');

    text.replace(reDelimiters, function(match, escapeValue, interpolateValue, evaluateValue, offset) {
      source += text.slice(index, offset).replace(reUnescapedString, escapeStringChar);
      if (escapeValue) {
        source += "' +\n_.escape(" + escapeValue + ") +\n'";
      }
      if (evaluateValue) {
        source += "';\n" + evaluateValue + ";\n__p += '";
      }
      if (interpolateValue) {
        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
      }
      index = offset + match.length;
      return match;
    });

    source += "';\n";
    if (!variable) {
      variable = 'obj';
      source = 'with (' + variable + ' || {}) {\n' + source + '\n}\n';
    }
    source = 'function(' + variable + ') {\n' +
      "var __t, __p = '', __j = Array.prototype.join;\n" +
      "function print() { __p += __j.call(arguments, '') }\n" +
      source +
      'return __p\n}';

    try {
      var result = Function('_', 'return ' + source)(_);
    } catch(e) {
      e.source = source;
      throw e;
    }
    if (data) {
      return result(data);
    }
    result.source = source;
    return result;
  }

  /**
   * Executes the callback `n` times, returning an array of the results
   * of each callback execution. The callback is bound to `thisArg` and invoked
   * with one argument; (index).
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {number} n The number of times to execute the callback.
   * @param {Function} callback The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns an array of the results of each `callback` execution.
   * @example
   *
   * var diceRolls = _.times(3, _.partial(_.random, 1, 6));
   * // => [3, 6, 4]
   *
   * _.times(3, function(n) { mage.castSpell(n); });
   * // => calls `mage.castSpell(n)` three times, passing `n` of `0`, `1`, and `2` respectively
   *
   * _.times(3, function(n) { this.cast(n); }, mage);
   * // => also calls `mage.castSpell(n)` three times
   */
  function times(n, callback, thisArg) {
    n = (n = +n) > -1 ? n : 0;
    var index = -1,
        result = Array(n);

    callback = baseCreateCallback(callback, thisArg, 1);
    while (++index < n) {
      result[index] = callback(index);
    }
    return result;
  }

  /**
   * The inverse of `_.escape` this method converts the HTML entities
   * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to their
   * corresponding characters.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} string The string to unescape.
   * @returns {string} Returns the unescaped string.
   * @example
   *
   * _.unescape('Fred, Barney &amp; Pebbles');
   * // => 'Fred, Barney & Pebbles'
   */
  function unescape(string) {
    return string == null ? '' : String(string).replace(reEscapedHtml, unescapeHtmlChar);
  }

  /**
   * Generates a unique ID. If `prefix` is provided the ID will be appended to it.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} [prefix] The value to prefix the ID with.
   * @returns {string} Returns the unique ID.
   * @example
   *
   * _.uniqueId('contact_');
   * // => 'contact_104'
   *
   * _.uniqueId();
   * // => '105'
   */
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a `lodash` object that wraps the given value with explicit
   * method chaining enabled.
   *
   * @static
   * @memberOf _
   * @category Chaining
   * @param {*} value The value to wrap.
   * @returns {Object} Returns the wrapper object.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney',  'age': 36 },
   *   { 'name': 'fred',    'age': 40 },
   *   { 'name': 'pebbles', 'age': 1 }
   * ];
   *
   * var youngest = _.chain(characters)
   *     .sortBy('age')
   *     .map(function(chr) { return chr.name + ' is ' + chr.age; })
   *     .first()
   *     .value();
   * // => 'pebbles is 1'
   */
  function chain(value) {
    value = new lodashWrapper(value);
    value.__chain__ = true;
    return value;
  }

  /**
   * Invokes `interceptor` with the `value` as the first argument and then
   * returns `value`. The purpose of this method is to "tap into" a method
   * chain in order to perform operations on intermediate results within
   * the chain.
   *
   * @static
   * @memberOf _
   * @category Chaining
   * @param {*} value The value to provide to `interceptor`.
   * @param {Function} interceptor The function to invoke.
   * @returns {*} Returns `value`.
   * @example
   *
   * _([1, 2, 3, 4])
   *  .tap(function(array) { array.pop(); })
   *  .reverse()
   *  .value();
   * // => [3, 2, 1]
   */
  function tap(value, interceptor) {
    interceptor(value);
    return value;
  }

  /**
   * Enables explicit method chaining on the wrapper object.
   *
   * @name chain
   * @memberOf _
   * @category Chaining
   * @returns {*} Returns the wrapper object.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // without explicit chaining
   * _(characters).first();
   * // => { 'name': 'barney', 'age': 36 }
   *
   * // with explicit chaining
   * _(characters).chain()
   *   .first()
   *   .pick('age')
   *   .value();
   * // => { 'age': 36 }
   */
  function wrapperChain() {
    this.__chain__ = true;
    return this;
  }

  /**
   * Extracts the wrapped value.
   *
   * @name valueOf
   * @memberOf _
   * @alias value
   * @category Chaining
   * @returns {*} Returns the wrapped value.
   * @example
   *
   * _([1, 2, 3]).valueOf();
   * // => [1, 2, 3]
   */
  function wrapperValueOf() {
    return this.__wrapped__;
  }

  /*--------------------------------------------------------------------------*/

  // add functions that return wrapped values when chaining
  lodash.after = after;
  lodash.bind = bind;
  lodash.bindAll = bindAll;
  lodash.chain = chain;
  lodash.compact = compact;
  lodash.compose = compose;
  lodash.countBy = countBy;
  lodash.debounce = debounce;
  lodash.defaults = defaults;
  lodash.defer = defer;
  lodash.delay = delay;
  lodash.difference = difference;
  lodash.filter = filter;
  lodash.flatten = flatten;
  lodash.forEach = forEach;
  lodash.functions = functions;
  lodash.groupBy = groupBy;
  lodash.indexBy = indexBy;
  lodash.initial = initial;
  lodash.intersection = intersection;
  lodash.invert = invert;
  lodash.invoke = invoke;
  lodash.keys = keys;
  lodash.map = map;
  lodash.max = max;
  lodash.memoize = memoize;
  lodash.min = min;
  lodash.omit = omit;
  lodash.once = once;
  lodash.pairs = pairs;
  lodash.partial = partial;
  lodash.pick = pick;
  lodash.pluck = pluck;
  lodash.range = range;
  lodash.reject = reject;
  lodash.rest = rest;
  lodash.shuffle = shuffle;
  lodash.sortBy = sortBy;
  lodash.tap = tap;
  lodash.throttle = throttle;
  lodash.times = times;
  lodash.toArray = toArray;
  lodash.union = union;
  lodash.uniq = uniq;
  lodash.values = values;
  lodash.where = where;
  lodash.without = without;
  lodash.wrap = wrap;
  lodash.zip = zip;

  // add aliases
  lodash.collect = map;
  lodash.drop = rest;
  lodash.each = forEach;
  lodash.extend = assign;
  lodash.methods = functions;
  lodash.object = zipObject;
  lodash.select = filter;
  lodash.tail = rest;
  lodash.unique = uniq;

  /*--------------------------------------------------------------------------*/

  // add functions that return unwrapped values when chaining
  lodash.clone = clone;
  lodash.contains = contains;
  lodash.escape = escape;
  lodash.every = every;
  lodash.find = find;
  lodash.has = has;
  lodash.identity = identity;
  lodash.indexOf = indexOf;
  lodash.isArguments = isArguments;
  lodash.isArray = isArray;
  lodash.isBoolean = isBoolean;
  lodash.isDate = isDate;
  lodash.isElement = isElement;
  lodash.isEmpty = isEmpty;
  lodash.isEqual = isEqual;
  lodash.isFinite = isFinite;
  lodash.isFunction = isFunction;
  lodash.isNaN = isNaN;
  lodash.isNull = isNull;
  lodash.isNumber = isNumber;
  lodash.isObject = isObject;
  lodash.isRegExp = isRegExp;
  lodash.isString = isString;
  lodash.isUndefined = isUndefined;
  lodash.lastIndexOf = lastIndexOf;
  lodash.mixin = mixin;
  lodash.noConflict = noConflict;
  lodash.random = random;
  lodash.reduce = reduce;
  lodash.reduceRight = reduceRight;
  lodash.result = result;
  lodash.size = size;
  lodash.some = some;
  lodash.sortedIndex = sortedIndex;
  lodash.template = template;
  lodash.unescape = unescape;
  lodash.uniqueId = uniqueId;

  // add aliases
  lodash.all = every;
  lodash.any = some;
  lodash.detect = find;
  lodash.findWhere = findWhere;
  lodash.foldl = reduce;
  lodash.foldr = reduceRight;
  lodash.include = contains;
  lodash.inject = reduce;

  /*--------------------------------------------------------------------------*/

  // add functions capable of returning wrapped and unwrapped values when chaining
  lodash.first = first;
  lodash.last = last;
  lodash.sample = sample;

  // add aliases
  lodash.take = first;
  lodash.head = first;

  /*--------------------------------------------------------------------------*/

  // add functions to `lodash.prototype`
  mixin(lodash);

  /**
   * The semantic version number.
   *
   * @static
   * @memberOf _
   * @type string
   */
  lodash.VERSION = '2.4.2';

  // add "Chaining" functions to the wrapper
  lodash.prototype.chain = wrapperChain;
  lodash.prototype.value = wrapperValueOf;

    // add `Array` mutator functions to the wrapper
    forEach(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayRef[methodName];
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__;
        func.apply(value, arguments);

        // avoid array-like object bugs with `Array#shift` and `Array#splice`
        // in Firefox < 10 and IE < 9
        if (!support.spliceObjects && value.length === 0) {
          delete value[0];
        }
        return this;
      };
    });

    // add `Array` accessor functions to the wrapper
    forEach(['concat', 'join', 'slice'], function(methodName) {
      var func = arrayRef[methodName];
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            result = func.apply(value, arguments);

        if (this.__chain__) {
          result = new lodashWrapper(result);
          result.__chain__ = true;
        }
        return result;
      };
    });

  /*--------------------------------------------------------------------------*/

  // some AMD build optimizers like r.js check for condition patterns like the following:
  if (true) {
    // Expose Lo-Dash to the global object even when an AMD loader is present in
    // case Lo-Dash is loaded with a RequireJS shim config.
    // See http://requirejs.org/docs/api.html#config-shim
    root._ = lodash;

    // define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return lodash;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // check for `exports` after `define` in case a build optimizer adds an `exports` object
  else if (freeExports && freeModule) {
    // in Node.js or RingoJS
    if (moduleExports) {
      (freeModule.exports = lodash)._ = lodash;
    }
    // in Narwhal or Rhino -require
    else {
      freeExports._ = lodash;
    }
  }
  else {
    // in a browser or Rhino
    root._ = lodash;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)(module), __webpack_require__(30)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Backbone.js 1.4.0

//     (c) 2010-2019 Jeremy Ashkenas and DocumentCloud
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global;

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(116), __webpack_require__(4), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch (e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, root.jQuery || root.Zepto || root.ender || root.$);
  }

})(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.4.0';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // A private global variable to share between listeners and listenees.
  var _listening;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    this._events = eventsApi(onApi, this._events || {}, name, callback, {
      context: context,
      ctx: this,
      listening: _listening
    });

    if (_listening) {
      var listeners = this._listeners || (this._listeners = {});
      listeners[_listening.id] = _listening;
      // Allow the listening to use a counter, instead of tracking
      // callbacks for library interop
      _listening.interop = false;
    }

    return this;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = _listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      this._listenId || (this._listenId = _.uniqueId('l'));
      listening = _listening = listeningTo[id] = new Listening(this, obj);
    }

    // Bind callbacks on obj.
    var error = tryCatchOn(obj, name, callback, this);
    _listening = void 0;

    if (error) throw error;
    // If the target obj is not Backbone.Events, track events manually.
    if (listening.interop) listening.on(name, callback);

    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // An try-catch guarded #on function, to prevent poisoning the global
  // `_listening` variable.
  var tryCatchOn = function(obj, name, callback, context) {
    try {
      obj.on(name, callback, context);
    } catch (e) {
      return e;
    }
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });

    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);
    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
      if (listening.interop) listening.off(name, callback);
    }
    if (_.isEmpty(listeningTo)) this._listeningTo = void 0;

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var context = options.context, listeners = options.listeners;
    var i = 0, names;

    // Delete all event listeners and "drop" events.
    if (!name && !context && !callback) {
      for (names = _.keys(listeners); i < names.length; i++) {
        listeners[names[i]].cleanup();
      }
      return;
    }

    names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Find any remaining events.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          var listening = handler.listening;
          if (listening) listening.off(name, callback);
        }
      }

      // Replace events if there are any remaining.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }

    return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
    if (typeof name === 'string' && context == null) callback = void 0;
    return this.on(events, callback, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // A listening class that tracks and cleans up memory bindings
  // when all callbacks have been offed.
  var Listening = function(listener, obj) {
    this.id = listener._listenId;
    this.listener = listener;
    this.obj = obj;
    this.interop = true;
    this.count = 0;
    this._events = void 0;
  };

  Listening.prototype.on = Events.on;

  // Offs a callback (or several).
  // Uses an optimized counter if the listenee uses Backbone.Events.
  // Otherwise, falls back to manual tracking to support events
  // library interop.
  Listening.prototype.off = function(name, callback) {
    var cleanup;
    if (this.interop) {
      this._events = eventsApi(offApi, this._events, name, callback, {
        context: void 0,
        listeners: void 0
      });
      cleanup = !this._events;
    } else {
      this.count--;
      cleanup = this.count === 0;
    }
    if (cleanup) this.cleanup();
  };

  // Cleans up memory bindings between the listener and the listenee.
  Listening.prototype.cleanup = function() {
    delete this.listener._listeningTo[this.obj._listenId];
    if (!this.interop) delete this.obj._listeners[this.id];
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.preinitialize.apply(this, arguments);
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    var defaults = _.result(this, 'defaults');
    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // preinitialize is an empty function by default. You can override it with a function
    // or object.  preinitialize will run before any instantiation logic is run in the Model.
    preinitialize: function(){},

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Update the `id`.
      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      var hasChanged;
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
        hasChanged = true;
      }
      return hasChanged ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else if (!this._validate(attrs, options)) {
        return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend({}, options, {validate: true}));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    this.preinitialize.apply(this, arguments);
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Splices `insert` into `array` at index `at`.
  var splice = function(array, insert, at) {
    at = Math.min(Math.max(at, 0), array.length);
    var tail = Array(array.length - at);
    var length = insert.length;
    var i;
    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
    for (i = 0; i < length; i++) array[i + at] = insert[i];
    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
  };

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,


    // preinitialize is an empty function by default. You can override it with a function
    // or object.  preinitialize will run before any instantiation logic is run in the Collection.
    preinitialize: function(){},

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set. `models` may be Backbone
    // Models or raw JavaScript objects to be converted to Models, or any
    // combination of the two.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();
      var removed = this._removeModels(models, options);
      if (!options.silent && removed.length) {
        options.changes = {added: [], merged: [], removed: removed};
        this.trigger('update', this, options);
      }
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      if (models == null) return;

      options = _.extend({}, setOptions, options);
      if (options.parse && !this._isModel(models)) {
        models = this.parse(models, options) || [];
      }

      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();

      var at = options.at;
      if (at != null) at = +at;
      if (at > this.length) at = this.length;
      if (at < 0) at += this.length + 1;

      var set = [];
      var toAdd = [];
      var toMerge = [];
      var toRemove = [];
      var modelMap = {};

      var add = options.add;
      var merge = options.merge;
      var remove = options.remove;

      var sort = false;
      var sortable = this.comparator && at == null && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      var model, i;
      for (i = 0; i < models.length; i++) {
        model = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        var existing = this.get(model);
        if (existing) {
          if (merge && model !== existing) {
            var attrs = this._isModel(model) ? model.attributes : model;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            toMerge.push(existing);
            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
          }
          if (!modelMap[existing.cid]) {
            modelMap[existing.cid] = true;
            set.push(existing);
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(model, options);
          if (model) {
            toAdd.push(model);
            this._addReference(model, options);
            modelMap[model.cid] = true;
            set.push(model);
          }
        }
      }

      // Remove stale models.
      if (remove) {
        for (i = 0; i < this.length; i++) {
          model = this.models[i];
          if (!modelMap[model.cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      var orderChanged = false;
      var replace = !sortable && add && remove;
      if (set.length && replace) {
        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
          return m !== set[index];
        });
        this.models.length = 0;
        splice(this.models, set, 0);
        this.length = this.models.length;
      } else if (toAdd.length) {
        if (sortable) sort = true;
        splice(this.models, toAdd, at == null ? this.length : at);
        this.length = this.models.length;
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort/update events.
      if (!options.silent) {
        for (i = 0; i < toAdd.length; i++) {
          if (at != null) options.index = at + i;
          model = toAdd[i];
          model.trigger('add', model, this, options);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length || toMerge.length) {
          options.changes = {
            added: toAdd,
            removed: toRemove,
            merged: toMerge
          };
          this.trigger('update', this, options);
        }
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id, cid, model object with id or cid
    // properties, or an attributes object that is transformed through modelId.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] ||
        this._byId[this.modelId(this._isModel(obj) ? obj.attributes : obj)] ||
        obj.cid && this._byId[obj.cid];
    },

    // Returns `true` if the model is in the collection.
    has: function(obj) {
      return this.get(obj) != null;
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      return this[first ? 'find' : 'filter'](attrs);
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      var comparator = this.comparator;
      if (!comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      var length = comparator.length;
      if (_.isFunction(comparator)) comparator = comparator.bind(this);

      // Run sort based on type of `comparator`.
      if (length === 1 || _.isString(comparator)) {
        this.models = this.sortBy(comparator);
      } else {
        this.models.sort(comparator);
      }
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return this.map(attr + '');
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(m, resp, callbackOpts) {
        if (wait) collection.add(m, callbackOpts);
        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function(attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Get an iterator of all models in this collection.
    values: function() {
      return new CollectionIterator(this, ITERATOR_VALUES);
    },

    // Get an iterator of all model IDs in this collection.
    keys: function() {
      return new CollectionIterator(this, ITERATOR_KEYS);
    },

    // Get an iterator of all [ID, model] tuples in this collection.
    entries: function() {
      return new CollectionIterator(this, ITERATOR_KEYSVALUES);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        // Remove references before triggering 'remove' event to prevent an
        // infinite loop. #3693
        delete this._byId[model.cid];
        var id = this.modelId(model.attributes);
        if (id != null) delete this._byId[id];

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function(model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if (model) {
        if ((event === 'add' || event === 'remove') && collection !== this) return;
        if (event === 'destroy') this.remove(model, options);
        if (event === 'change') {
          var prevId = this.modelId(model.previousAttributes());
          var id = this.modelId(model.attributes);
          if (prevId !== id) {
            if (prevId != null) delete this._byId[prevId];
            if (id != null) this._byId[id] = model;
          }
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Defining an @@iterator method implements JavaScript's Iterable protocol.
  // In modern ES2015 browsers, this value is found at Symbol.iterator.
  /* global Symbol */
  var $$iterator = typeof Symbol === 'function' && Symbol.iterator;
  if ($$iterator) {
    Collection.prototype[$$iterator] = Collection.prototype.values;
  }

  // CollectionIterator
  // ------------------

  // A CollectionIterator implements JavaScript's Iterator protocol, allowing the
  // use of `for of` loops in modern browsers and interoperation between
  // Backbone.Collection and other JavaScript functions and third-party libraries
  // which can operate on Iterables.
  var CollectionIterator = function(collection, kind) {
    this._collection = collection;
    this._kind = kind;
    this._index = 0;
  };

  // This "enum" defines the three possible kinds of values which can be emitted
  // by a CollectionIterator that correspond to the values(), keys() and entries()
  // methods on Collection, respectively.
  var ITERATOR_VALUES = 1;
  var ITERATOR_KEYS = 2;
  var ITERATOR_KEYSVALUES = 3;

  // All Iterators should themselves be Iterable.
  if ($$iterator) {
    CollectionIterator.prototype[$$iterator] = function() {
      return this;
    };
  }

  CollectionIterator.prototype.next = function() {
    if (this._collection) {

      // Only continue iterating if the iterated collection is long enough.
      if (this._index < this._collection.length) {
        var model = this._collection.at(this._index);
        this._index++;

        // Construct a value depending on what kind of values should be iterated.
        var value;
        if (this._kind === ITERATOR_VALUES) {
          value = model;
        } else {
          var id = this._collection.modelId(model.attributes);
          if (this._kind === ITERATOR_KEYS) {
            value = id;
          } else { // ITERATOR_KEYSVALUES
            value = [id, model];
          }
        }
        return {value: value, done: false};
      }

      // Once exhausted, remove the reference to the collection so future
      // calls to the next method always return done.
      this._collection = void 0;
    }

    return {value: void 0, done: true};
  };

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this.preinitialize.apply(this, arguments);
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // preinitialize is an empty function by default. You can override it with a function
    // or object.  preinitialize will run before any instantiation logic is run in the View
    preinitialize: function(){},

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], method.bind(this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Proxy Backbone class methods to Underscore functions, wrapping the model's
  // `attributes` object or collection's `models` array behind the scenes.
  //
  // collection.filter(function(model) { return model.get('age') > 10 });
  // collection.each(this.addView);
  //
  // `Function#apply` can be slow so we use the method's arg count, if we know it.
  var addMethod = function(base, length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return base[method](this[attribute]);
      };
      case 2: return function(value) {
        return base[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return base[method](this[attribute], cb(iteratee, this), context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return base[method](this[attribute], cb(iteratee, this), defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return base[method].apply(base, args);
      };
    }
  };

  var addUnderscoreMethods = function(Class, base, methods, attribute) {
    _.each(methods, function(length, method) {
      if (base[method]) Class.prototype[method] = addMethod(base, length, method, attribute);
    });
  };

  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
  var cb = function(iteratee, instance) {
    if (_.isFunction(iteratee)) return iteratee;
    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
    return iteratee;
  };
  var modelMatcher = function(attrs) {
    var matcher = _.matches(attrs);
    return function(model) {
      return matcher(model.attributes);
    };
  };

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
    foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
    select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
    contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
    head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
    without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
    isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
    sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};


  // Underscore methods that we want to implement on the Model, mapped to the
  // number of arguments they take.
  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
    omit: 0, chain: 1, isEmpty: 1};

  // Mix in each Underscore method as a proxy to `Collection#models`.

  _.each([
    [Collection, collectionMethods, 'models'],
    [Model, modelMethods, 'attributes']
  ], function(config) {
    var Base = config[0],
        methods = config[1],
        attribute = config[2];

    Base.mixin = function(obj) {
      var mappings = _.reduce(_.functions(obj), function(memo, name) {
        memo[name] = 0;
        return memo;
      }, {});
      addUnderscoreMethods(Base, obj, mappings, attribute);
    };

    addUnderscoreMethods(Base, _, methods, attribute);
  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    create: 'POST',
    update: 'PUT',
    patch: 'PATCH',
    delete: 'DELETE',
    read: 'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    this.preinitialize.apply(this, arguments);
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // preinitialize is an empty function by default. You can override it with a function
    // or object.  preinitialize will run before any instantiation logic is run in the Router.
    preinitialize: function(){},

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
        .replace(optionalParam, '(?:$1)?')
        .replace(namedParam, function(match, optional) {
          return optional ? match : '([^/?]+)';
        })
        .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    this.checkUrl = this.checkUrl.bind(this);

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var rootPath = path.slice(0, this.root.length - 1) + '/';
      return rootPath === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var rootPath = this.root.slice(0, -1) || '/';
          this.location.replace(rootPath + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function(eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function(eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.some(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var rootPath = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        rootPath = rootPath.slice(0, -1) || '/';
      }
      var url = rootPath + fragment;

      // Strip the fragment of the query and hash for matching.
      fragment = fragment.replace(pathStripper, '');

      // Decode for matching.
      var decodedFragment = this.decodeFragment(fragment);

      if (this.fragment === decodedFragment) return;
      this.fragment = decodedFragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = _.create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0),
    Backbone = __webpack_require__(1);
module.exports = _.extend({}, Backbone.Events);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrayProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SymbolProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return supportsArrayBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return supportsDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return nativeIsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return nativeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return nativeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return nativeIsView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _isNaN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _isFinite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasEnumBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return nonEnumerableProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_ARRAY_INDEX; });
// Current version.
var VERSION = '1.12.0';

// Establish the root object, `window` (`self`) in the browser, `global`
// on the server, or `this` in some virtual machines. We use `self`
// instead of `window` for `WebWorker` support.
var root = typeof self == 'object' && self.self === self && self ||
          typeof global == 'object' && global.global === global && global ||
          Function('return this')() ||
          {};

// Save bytes in the minified (but not gzipped) version:
var ArrayProto = Array.prototype, ObjProto = Object.prototype;
var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

// Create quick reference variables for speed access to core prototypes.
var push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

// Modern feature detection.
var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
    supportsDataView = typeof DataView !== 'undefined';

// All **ECMAScript 5+** native function implementations that we hope to use
// are declared here.
var nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create,
    nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

// Create references to these builtin functions because we override them.
var _isNaN = isNaN,
    _isFinite = isFinite;

// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
  'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

// The largest integer that can be represented exactly.
var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(115);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collectNonEnumProps_js__ = __webpack_require__(63);





// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`.
function keys(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return [];
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["m" /* nativeKeys */]) return Object(__WEBPACK_IMPORTED_MODULE_1__setup_js__["m" /* nativeKeys */])(obj);
  var keys = [];
  for (var key in obj) if (Object(__WEBPACK_IMPORTED_MODULE_2__has_js__["a" /* default */])(obj, key)) keys.push(key);
  // Ahem, IE < 9.
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["h" /* hasEnumBug */]) Object(__WEBPACK_IMPORTED_MODULE_3__collectNonEnumProps_js__["a" /* default */])(obj, keys);
  return keys;
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tagTester;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);


// Internal function for creating a `toString`-based type tester.
function tagTester(name) {
  var tag = '[object ' + name + ']';
  return function(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj) === tag;
  };
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iteratee_js__ = __webpack_require__(74);




// The function we call internally to generate a callback. It invokes
// `_.iteratee` if overridden, otherwise `baseIteratee`.
function cb(value, context, argCount) {
  if (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee !== __WEBPACK_IMPORTED_MODULE_2__iteratee_js__["a" /* default */]) return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee(value, context);
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(value, context, argCount);
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = restArguments;
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function restArguments(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function() {
    var length = Math.max(arguments.length - startIndex, 0),
        rest = Array(length),
        index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, arguments[0], rest);
      case 2: return func.call(this, arguments[0], arguments[1], rest);
    }
    var args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);


// If Underscore is called as a function, it returns a wrapped object that can
// be used OO-style. This wrapper holds altered versions of all functions added
// through `_.mixin`. Wrapped objects may be chained.
function _(obj) {
  if (obj instanceof _) return obj;
  if (!(this instanceof _)) return new _(obj);
  this._wrapped = obj;
}

_.VERSION = __WEBPACK_IMPORTED_MODULE_0__setup_js__["e" /* VERSION */];

// Extracts the result from a wrapped and chained object.
_.prototype.value = function() {
  return this._wrapped;
};

// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
_.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

_.prototype.toString = function() {
  return String(this._wrapped);
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(13);



// Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */]));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    AD: __webpack_require__(101),
    APP_SETTINGS: __webpack_require__(198),
    CONNECT: __webpack_require__(199),
    COUNTDOWN: __webpack_require__(200),
    FACEBOOK: __webpack_require__(201),
    OMNITURE: __webpack_require__(202),
    REGEX: __webpack_require__(203),
    STORAGE: __webpack_require__(204),
    USER_AGENT: __webpack_require__(205)
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(3);



var isFunction = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Function');

// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var nodelist = __WEBPACK_IMPORTED_MODULE_1__setup_js__["p" /* root */].document && __WEBPACK_IMPORTED_MODULE_1__setup_js__["p" /* root */].document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
  isFunction = function(obj) {
    return typeof obj == 'function' || false;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__ = __webpack_require__(62);


// Internal helper to obtain the `length` property of an object.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__["a" /* default */])('length'));


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = has;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);


// Internal function to check whether `key` is an own property name of `obj`.
function has(obj, key) {
  return obj != null && __WEBPACK_IMPORTED_MODULE_0__setup_js__["i" /* hasOwnProperty */].call(obj, key);
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
// Is a given variable an object?
function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tagTester_js__ = __webpack_require__(6);



// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__setup_js__["k" /* nativeIsArray */] || Object(__WEBPACK_IMPORTED_MODULE_1__tagTester_js__["a" /* default */])('Array'));


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = each;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(5);




// The cornerstone for collection functions, an `each`
// implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
function each(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__["a" /* default */])(iteratee, context);
  var i, length;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var _keys = Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj);
    for (i = 0, length = _keys.length; i < length; i++) {
      iteratee(obj[_keys[i]], _keys[i], obj);
    }
  }
  return obj;
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = values;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(5);


// Retrieve the values of an object's properties.
function values(obj) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArguments_js__ = __webpack_require__(39);





// Internal implementation of a recursive `flatten` function.
function flatten(input, depth, strict, output) {
  output = output || [];
  if (!depth && depth !== 0) {
    depth = Infinity;
  } else if (depth <= 0) {
    return output.concat(input);
  }
  var idx = output.length;
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(input); i < length; i++) {
    var value = input[i];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(value) && (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_3__isArguments_js__["a" /* default */])(value))) {
      // Flatten current level of array or arguments object.
      if (depth > 1) {
        flatten(value, depth - 1, strict, output);
        idx = output.length;
      } else {
        var j = 0, len = value.length;
        while (j < len) output[idx++] = value[j++];
      }
    } else if (!strict) {
      output[idx++] = value;
    }
  }
  return output;
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(5);




// Return the results of applying the iteratee to each element.
function map(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length,
      results = Array(length);
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    results[index] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Detect mobile only. Excludes tablets.
 */
var isMobile = exports.isMobile = {
    Android: function Android() {
        return (/Android/i.test(navigator.userAgent)
        );
    },
    iOS: function iOS() {
        return (/iPhone|iPod/i.test(navigator.userAgent)
        );
    },
    any: function any() {
        if (window.innerWidth < 480) {
            return isMobile.Android() || isMobile.iOS();
        }
    }
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasStringTagBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isIE11; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__ = __webpack_require__(123);



// In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.
var hasStringTagBug = (
      __WEBPACK_IMPORTED_MODULE_0__setup_js__["s" /* supportsDataView */] && Object(__WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__["a" /* default */])(new DataView(new ArrayBuffer(8)))
    ),
    isIE11 = (typeof Map !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__["a" /* default */])(new Map));


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collectNonEnumProps_js__ = __webpack_require__(63);




// Retrieve all the enumerable property names of an object.
function allKeys(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return [];
  var keys = [];
  for (var key in obj) keys.push(key);
  // Ahem, IE < 9.
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["h" /* hasEnumBug */]) Object(__WEBPACK_IMPORTED_MODULE_2__collectNonEnumProps_js__["a" /* default */])(obj, keys);
  return keys;
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(72);



// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
function toPath(path) {
  return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].toPath(path);
}


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optimizeCb;
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function optimizeCb(func, context, argCount) {
  if (context === void 0) return func;
  switch (argCount == null ? 3 : argCount) {
    case 1: return function(value) {
      return func.call(context, value);
    };
    // The 2-argument case is omitted because we’re not using it.
    case 3: return function(value, index, collection) {
      return func.call(context, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(context, accumulator, value, index, collection);
    };
  }
  return function() {
    return func.apply(context, arguments);
  };
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(17);



// Return all the elements that pass a truth test.
function filter(obj, predicate, context) {
  var results = [];
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(obj, function(value, index, list) {
    if (predicate(value, index, list)) results.push(value);
  });
  return results;
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indexOf_js__ = __webpack_require__(88);




// Determine if the array or object contains a given item (using `===`).
function contains(obj, item, fromIndex, guard) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj)) obj = Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
  if (typeof fromIndex != 'number' || guard) fromIndex = 0;
  return Object(__WEBPACK_IMPORTED_MODULE_2__indexOf_js__["a" /* default */])(obj, item, fromIndex) >= 0;
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports['default'] = factory()
  }
  /* istanbul ignore next */
  else if (typeof define === 'function' && define.amd) {
    define(factory)
  }
  else {
    root[name] = factory()
  }
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
  var locales = JSON.parse('{"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"vi":{"Đ":"D","đ":"d"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var slug = string.split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        return result + (locale[ch] || charMap[ch] || ch)
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '')
      // trim leading/trailing spaces
      .trim()
      // convert spaces to replacement character
      // also remove duplicates of the replacement character
      .replace(new RegExp('[\\s' + replacement + ']+', 'g'), replacement)

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    if (options.strict) {
      // remove anything besides letters, numbers, and the replacement char
      slug = slug
        .replace(new RegExp('[^a-zA-Z0-9' + replacement + ']', 'g'), '')
        // remove duplicates of the replacement character
        .replace(new RegExp('[\\s' + replacement + ']+', 'g'), replacement)
    }

    return slug
  }

  replace.extend = function (customMap) {
    for (var key in customMap) {
      charMap[key] = customMap[key]
    }
  }

  return replace
}))


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {
	        function F() {}

	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                F.prototype = this;
	                var subtype = new F();

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init')) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extendOwn_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMatch_js__ = __webpack_require__(64);



// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher(attrs) {
  attrs = Object(__WEBPACK_IMPORTED_MODULE_0__extendOwn_js__["a" /* default */])({}, attrs);
  return function(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__isMatch_js__["a" /* default */])(obj, attrs);
  };
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__executeBound_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__underscore_js__ = __webpack_require__(9);




// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var partial = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, boundArgs) {
  var placeholder = partial.placeholder;
  var bound = function() {
    var position = 0, length = boundArgs.length;
    var args = Array(length);
    for (var i = 0; i < length; i++) {
      args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
    }
    while (position < arguments.length) args.push(arguments[position++]);
    return Object(__WEBPACK_IMPORTED_MODULE_1__executeBound_js__["a" /* default */])(func, bound, this, this, args);
  };
  return bound;
});

partial.placeholder = __WEBPACK_IMPORTED_MODULE_2__underscore_js__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (partial);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = group;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(17);



// An internal function used for aggregate "group by" operations.
function group(behavior, partition) {
  return function(obj, iteratee, context) {
    var result = partition ? [[], []] : {};
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(obj, function(value, index) {
      var key = iteratee(value, index, obj);
      behavior(result, value, key);
    });
    return result;
  };
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slugify = __webpack_require__(28);

var USER_AGENT = __webpack_require__(11).USER_AGENT;

module.exports = {
    slugify: function slugify(str) {
        str = str.replace(/&|\//g, '-');

        return _slugify(str, {
            lower: true,
            strict: true,
            trim: true
        });
    },

    /**
     * getQueryParamByName
     */
    getQueryParamByName: function getQueryParamByName(name) {
        var regexS = '[\\?&]' + name + '=([^&#]*)';
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);

        return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
    },
    /**
     * getDeviceType
     */
    getDeviceType: function getDeviceType() {

        var userAgent = navigator.userAgent;
        var device = USER_AGENT.SUPPORTED.exec(userAgent);
        var isUnsupported = USER_AGENT.UNSUPPORTED.test(userAgent);

        if (device) {
            return device[0].toLowerCase();
        }

        return isUnsupported ? 'unknown' : 'pc';
    }
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var template = __webpack_require__(216);

module.exports = Backbone.View.extend({
    tagName: 'style',
    className: 'view-css',
    initialize: function initialize(options) {
        options = options || {};
        this.template = options.template ? options.template : template;
        this.style_id = options.style_id;
        this.namespace = options.namespace || '';
        this.namespaceModal = options.namespaceModal || '';
        this.uid = options.uid || '';
        this.model = _.extend(_.clone(this.model, 'true'), {
            namespace: this.namespace,
            namespaceModal: this.namespaceModal,
            uid: this.uid
        });

        // The CSS method from the Router has been called
        // Load any font family necessary
        if (this.namespace == '#' + this.uid) {
            var fonts = [];
            var objFonts = {};

            _.forEach(this.model.custom_font_urls, function (value, index) {
                if (value['url'].length > 0) fonts.push(value['url']);
            });

            for (var i = 0; i < fonts.length; i++) {
                objFonts[i] = fonts[i];
            };

            // this is to ensure the styles are updated properly
            var style = '.' + this.style_id;
            if (_.size(objFonts) > 0) {
                _.extend(this.model, { fonts: objFonts, styleID: style });
            } else {
                _.extend(this.model, { fonts: {}, styleID: style });
            }
        }

        this.$el.prop('type', 'text/css');
        this.$el.prop('id', this.style_id);
    },
    /**
     *
     */
    render: function render() {

        this.$el.append(this.template(this.model));

        return this;
    },
    /** 
     * 
     */
    remove: function remove() {
        this.template = null;
        this.namespace = null;
        this.namespaceModal = null;
        this.model = null;
        this.off();
        Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__setup_js__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__restArguments_js__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__restArguments_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_2__isObject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isNull_js__ = __webpack_require__(118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_3__isNull_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isUndefined_js__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_4__isUndefined_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBoolean_js__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_5__isBoolean_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isElement_js__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_6__isElement_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isString_js__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_7__isString_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isNumber_js__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_8__isNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isDate_js__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_9__isDate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isRegExp_js__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_10__isRegExp_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isError_js__ = __webpack_require__(122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_11__isError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isSymbol_js__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_12__isSymbol_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__isArrayBuffer_js__ = __webpack_require__(57);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return __WEBPACK_IMPORTED_MODULE_13__isArrayBuffer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isDataView_js__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDataView", function() { return __WEBPACK_IMPORTED_MODULE_14__isDataView_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_15__isArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isFunction_js__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_16__isFunction_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isArguments_js__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_17__isArguments_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isFinite_js__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_18__isFinite_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isNaN_js__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_19__isNaN_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__isTypedArray_js__ = __webpack_require__(59);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return __WEBPACK_IMPORTED_MODULE_20__isTypedArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__isEmpty_js__ = __webpack_require__(126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_21__isEmpty_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__isMatch_js__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_22__isMatch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__isEqual_js__ = __webpack_require__(127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_23__isEqual_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isMap_js__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_24__isMap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isWeakMap_js__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_25__isWeakMap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isSet_js__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_26__isSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isWeakSet_js__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_27__isWeakSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__keys_js__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_28__keys_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__allKeys_js__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_29__allKeys_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__values_js__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_30__values_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pairs_js__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_31__pairs_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__invert_js__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_32__invert_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__functions_js__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_33__functions_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_33__functions_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__extend_js__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_34__extend_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__defaults_js__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_36__defaults_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__create_js__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_37__create_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__clone_js__ = __webpack_require__(70);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_38__clone_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__tap_js__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_39__tap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__get_js__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_40__get_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__has_js__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_41__has_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__mapObject_js__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_42__mapObject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__identity_js__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_43__identity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__constant_js__ = __webpack_require__(60);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_44__constant_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__noop_js__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_45__noop_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__toPath_js__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toPath", function() { return __WEBPACK_IMPORTED_MODULE_46__toPath_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__property_js__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_47__property_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__propertyOf_js__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_48__propertyOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__matcher_js__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_49__matcher_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_49__matcher_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__times_js__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_50__times_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__random_js__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_51__random_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__now_js__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_52__now_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__escape_js__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_53__escape_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__unescape_js__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_54__unescape_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__templateSettings_js__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_55__templateSettings_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__template_js__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_56__template_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__result_js__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_57__result_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__uniqueId_js__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_58__uniqueId_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__chain_js__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_59__chain_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__iteratee_js__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_60__iteratee_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__partial_js__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_61__partial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__bind_js__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_62__bind_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__bindAll_js__ = __webpack_require__(147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_63__bindAll_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__memoize_js__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_64__memoize_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__delay_js__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_65__delay_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__defer_js__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_66__defer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__throttle_js__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_67__throttle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__debounce_js__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_68__debounce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__wrap_js__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_69__wrap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__negate_js__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_70__negate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__compose_js__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_71__compose_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__after_js__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_72__after_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__before_js__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_73__before_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__once_js__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_74__once_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__findKey_js__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_75__findKey_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__findIndex_js__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_76__findIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__findLastIndex_js__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_77__findLastIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__sortedIndex_js__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_78__sortedIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__indexOf_js__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_79__indexOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__lastIndexOf_js__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_80__lastIndexOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__find_js__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_81__find_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_81__find_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__findWhere_js__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_82__findWhere_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__each_js__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_83__each_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_83__each_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__map_js__ = __webpack_require__(20);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_84__map_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_84__map_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__reduce_js__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__ = __webpack_require__(159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__filter_js__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_87__filter_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_87__filter_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__reject_js__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_88__reject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__every_js__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_89__every_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_89__every_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__some_js__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_90__some_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_90__some_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__contains_js__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__invoke_js__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_92__invoke_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__pluck_js__ = __webpack_require__(50);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_93__pluck_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__where_js__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_94__where_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__max_js__ = __webpack_require__(92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_95__max_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__min_js__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_96__min_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__shuffle_js__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_97__shuffle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__sample_js__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_98__sample_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__sortBy_js__ = __webpack_require__(167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_99__sortBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__groupBy_js__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_100__groupBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__indexBy_js__ = __webpack_require__(169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_101__indexBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__countBy_js__ = __webpack_require__(170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_102__countBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__partition_js__ = __webpack_require__(171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_103__partition_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__toArray_js__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_104__toArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__size_js__ = __webpack_require__(173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_105__size_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__pick_js__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_106__pick_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__omit_js__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_107__omit_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__first_js__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__initial_js__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_109__initial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__last_js__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_110__last_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__rest_js__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__compact_js__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_112__compact_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__flatten_js__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_113__flatten_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__without_js__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_114__without_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__uniq_js__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_115__uniq_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_115__uniq_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__union_js__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_116__union_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__intersection_js__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_117__intersection_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__difference_js__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_118__difference_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__unzip_js__ = __webpack_require__(99);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_119__unzip_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_119__unzip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__zip_js__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_120__zip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__object_js__ = __webpack_require__(184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_121__object_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__range_js__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_122__range_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__chunk_js__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_123__chunk_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__mixin_js__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_124__mixin_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__underscore_array_methods_js__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_125__underscore_array_methods_js__["a"]; });
// Named Exports
// =============

//     Underscore.js 1.12.0
//     https://underscorejs.org
//     (c) 2009-2020 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

// Baseline setup.



// Object Functions
// ----------------
// Our most fundamental functions operate on any JavaScript object.
// Most functions in Underscore depend on at least one function in this section.

// A group of functions that check the types of core JavaScript values.
// These are often informally referred to as the "isType" functions.



























// Functions that treat an object as a dictionary of key-value pairs.
















// Utility Functions
// -----------------
// A bit of a grab bag: Predicate-generating functions for use with filters and
// loops, string escaping and templating, create random numbers and unique ids,
// and functions that facilitate Underscore's chaining and iteration conventions.



















// Function (ahem) Functions
// -------------------------
// These functions take a function as an argument and return a new function
// as the result. Also known as higher-order functions.















// Finders
// -------
// Functions that extract (the position of) a single element from an object
// or array based on some criterion.









// Collection Functions
// --------------------
// Functions that work on any collection of elements: either an array, or
// an object of key-value pairs.
























// `_.pick` and `_.omit` are actually object functions, but we put
// them here in order to create a more natural reading order in the
// monolithic build as they depend on `_.contains`.



// Array Functions
// ---------------
// Functions that operate on arrays (and array-likes) only, because they’re
// expressed in terms of operations on an ordered list of values.

















// OOP
// ---
// These modules support the "object-oriented" calling style. See also
// `underscore.js` and `index-default.js`.




/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('String'));


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayBuffer_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stringTagBug_js__ = __webpack_require__(22);





var isDataView = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('DataView');

// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
function ie10IsDataView(obj) {
  return obj != null && Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj.getInt8) && Object(__WEBPACK_IMPORTED_MODULE_2__isArrayBuffer_js__["a" /* default */])(obj.buffer);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__stringTagBug_js__["a" /* hasStringTagBug */] ? ie10IsDataView : isDataView);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(14);



var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Arguments');

// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
  if (!isArguments(arguments)) {
    isArguments = function(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(obj, 'callee');
    };
  }
}());

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__ = __webpack_require__(62);


// Internal helper to obtain the `byteLength` property of an object.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__["a" /* default */])('byteLength'));


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ie11fingerprint;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return weakMapMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setMethods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__allKeys_js__ = __webpack_require__(23);




// Since the regular `Object.prototype.toString` type tests don't work for
// some types in IE 11, we use a fingerprinting heuristic instead, based
// on the methods. It's not great, but it's the best we got.
// The fingerprint method lists are defined below.
function ie11fingerprint(methods) {
  var length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(methods);
  return function(obj) {
    if (obj == null) return false;
    // `Map`, `WeakMap` and `Set` have no enumerable keys.
    var keys = Object(__WEBPACK_IMPORTED_MODULE_2__allKeys_js__["a" /* default */])(obj);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(keys)) return false;
    for (var i = 0; i < length; i++) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj[methods[i]])) return false;
    }
    // If we are testing against `WeakMap`, we need to ensure that
    // `obj` doesn't have a `forEach` method in order to distinguish
    // it from a regular `Map`.
    return methods !== weakMapMethods || !Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj[forEachName]);
  };
}

// In the interest of compact minification, we write
// each string in the fingerprints only once.
var forEachName = 'forEach',
    hasName = 'has',
    commonInit = ['clear', 'delete'],
    mapTail = ['get', hasName, 'set'];

// `Map`, `WeakMap` and `Set` each have slightly different
// combinations of the above sublists.
var mapMethods = commonInit.concat(forEachName, mapTail),
    weakMapMethods = commonInit.concat(mapTail),
    setMethods = ['add'].concat(commonInit, forEachName, hasName);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAssigner;
// An internal function for creating assigner functions.
function createAssigner(keysFunc, defaults) {
  return function(obj) {
    var length = arguments.length;
    if (defaults) obj = Object(obj);
    if (length < 2 || obj == null) return obj;
    for (var index = 1; index < length; index++) {
      var source = arguments[index],
          keys = keysFunc(source),
          l = keys.length;
      for (var i = 0; i < l; i++) {
        var key = keys[i];
        if (!defaults || obj[key] === void 0) obj[key] = source[key];
      }
    }
    return obj;
  };
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(5);



// Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]));


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deepGet;
// Internal function to obtain a nested property in `obj` along `path`.
function deepGet(obj, path) {
  var length = path.length;
  for (var i = 0; i < length; i++) {
    if (obj == null) return void 0;
    obj = obj[path[i]];
  }
  return length ? obj : void 0;
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
// Keep the identity function around for default iteratees.
function identity(value) {
  return value;
}


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = property;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deepGet_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(24);



// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indices.
function property(path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  return function(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__deepGet_js__["a" /* default */])(obj, path);
  };
}


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);


// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
}));


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = negate;
// Returns a negated version of the passed-in predicate.
function negate(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__ = __webpack_require__(85);


// Returns the first index on an array-like that passes a truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__["a" /* default */])(1));


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pluck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__property_js__ = __webpack_require__(46);



// Convenience version of a common use case of `_.map`: fetching a property.
function pluck(obj, key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__property_js__["a" /* default */])(key));
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(227);
var slugify = __webpack_require__(34).slugify;

module.exports = Backbone.View.extend({
    className: 'contestant flex-child-container',
    events: {
        'click .btn-minus': 'minusVote',
        'click .btn-plus': 'plusVote',
        'click .img-position': 'loadVideo',
        'click .edit-container': 'handleContainerClick'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};
        this.category = options.category;
        this.user = options.user;
        this.temp = options.temp;
        this.voteLimit = parseInt(options.cms.turboVote.get('voteLimit'), 10);

        this.customization = options.customization;

        this.listenTo(this.user, 'change:isAuthorized', function () {
            this.$el.removeClass('voted');
            this.$el.find('.overlay').hide();
        }.bind(this));

        this.person = options.person;
        this.dimensions = options.dimensions;
        this.copy = options.copy;
        this.professional = options.professional;
        this.social = options.social;
        this.category = options.category;

        this.width = 50;
        this.height = 50;
        this.imageQsp = '?';
        this.incrementAfterAuth = false;

        this.blankContestant = options.blankContestant || false;

        this.listenTo(this.user, 'change:isAuthorized', function (model, isAuth) {
            if (isAuth && this.incrementAfterAuth) {
                this.incrementAfterAuth = false;
                this.plusVote();
            }
        }.bind(this));

        this.listenTo(this.model, 'change:voteCount', this.updateVoteUI.bind(this));
        this.listenTo(this.category, 'change:isSubmitted', this.checkCatSubmitted.bind(this));
        this.listenTo(this.category, 'updateEditButtons', this.updateVoteUI.bind(this));
        this.listenTo(this.category, 'updatePlusButtons', this.updatePlusButtons.bind(this));
    },
    /**
     *
     */
    render: function render() {

        var isWinner = _.checkIfTrue(this.model.get('winner'));

        if (isWinner) {
            this.$el.addClass('winner');
        }

        var modelData = _.extend({}, this.model.toJSON(), {
            voteLimit: this.voteLimit,
            singleVote: this.singleVote,
            copy: this.copy,
            professional: this.professional,
            social: this.social,
            active: this.category.get('active'),
            live_vote: this.category.get('live_vote'),
            winner: isWinner
        });

        var updatedModel = this.buildImageURLs(modelData);

        if (this.temp) {
            this.$el.addClass('temp');
        }

        this.$el.html(template(updatedModel));
        this.$el.find('img').unveil(2 * window.innerHeight);

        return this;
    },
    /**
     * https://telescopetv.atlassian.net/browse/MV-1159
     * this fixes an issue that causes ios safari to zoom in on double tap
     */
    handleContainerClick: function handleContainerClick(e) {
        e.preventDefault();
    },
    /**
     * [buildImageURLs description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    buildImageURLs: function buildImageURLs(data) {
        var node = parseInt(this.person) ? 'circle' : 'rectangle';

        _.forEach(this.dimensions[node], function (value, index) {
            if (value != '') {
                this.imageQsp = this.imageQsp + index + '=' + value + "&";

                if (/(width)/.test(index)) {
                    this.width = value;
                } else if (/(height)/.test(index)) {
                    this.height = value;
                }
            }
        }.bind(this));

        this.imageQsp = this.imageQsp.slice(0, -1);

        data.formatted_image = data.image_url.length > 0 ? data.image_url + this.imageQsp : '';
        data.width = this.width;
        data.height = this.height;
        data.external_url = data.external_url || '';

        return data;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom(toBeIncremented) {

        if (toBeIncremented) this.plusVote();

        this.checkCatSubmitted();
    },
    /**
     * Update contestant UI once category is submitted
     */
    checkCatSubmitted: function checkCatSubmitted() {
        if (this.category.get('isSubmitted')) {
            this.$el.addClass('voted');
            this.disableEditButtons();
            return true;
        }
        return false;
    },
    /**
     * Disable all edit buttons when user has submitted the category
     */
    disableEditButtons: function disableEditButtons() {
        this.$('.btn-minus').prop('disabled', 'disabled');
        this.$('.btn-plus').prop('disabled', 'disabled');
    },
    /**
     * Subtract vote count
     */
    minusVote: function minusVote(e) {
        e.preventDefault();

        var lowerCategoryName = this.category.get('name').toLowerCase();
        var lowerContestantName = this.model.get('name').toLowerCase();

        var omParams = {
            name: 'minus button_' + lowerCategoryName + '_' + lowerContestantName,
            section: slugify(this.category.get('name')),
            url: window.location.href
        };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Minus Button' };
        PubSub.trigger('linkClick', omParams, gaParams);

        var votes = this.model.get('voteCount');
        var totalAllocatedVotes = this.category.get('totalAllocatedVotes');
        if (totalAllocatedVotes > 0 && votes > 0) {
            this.model.set('voteCount', votes - 1);
            this.category.updateEditButtons();
            this.category.voteCountUpdate('minus', this.model.get('id'), this.model.get('voteCount'));
        }
    },
    /**
     * Add vote count
     */
    plusVote: function plusVote(e) {
        if (e) e.preventDefault();

        if (!this.user.get('isAuthorized')) {
            var selected = {
                categoryID: this.category.get('id'),
                contestantID: this.model.id
            };
            this.incrementAfterAuth = true;
            return PubSub.trigger('directRoute', 'auth', selected);
        }

        var lowerCategoryName = this.category.get('name').toLowerCase();
        var lowerContestantName = this.model.get('name').toLowerCase();

        var omParams = {
            name: 'plus button_' + lowerCategoryName + '_' + lowerContestantName,
            section: slugify(this.category.get('name')),
            url: window.location.href
        };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Plus Button' };
        PubSub.trigger('linkClick', omParams, gaParams);

        var votes = this.model.get('voteCount');
        var totalAllocatedVotes = this.category.get('totalAllocatedVotes');
        if (totalAllocatedVotes < this.voteLimit && votes < this.voteLimit) {
            this.model.set('voteCount', votes + 1);
            this.category.voteCountUpdate('plus', this.model.get('id'), this.model.get('voteCount'));
        }
    },
    /**
     * Update the edit buttons and vote count in the UI
     */
    updateVoteUI: function updateVoteUI(data) {
        if (typeof data === 'string' && data !== this.category.get('id')) return;

        var voteCount = this.model.get('voteCount');
        this.$('.vote-count').text(voteCount);

        if (this.checkCatSubmitted()) return;

        if (!voteCount) {
            this.$('.btn-minus').prop('disabled', 'disabled');
            this.$('.btn-plus').prop('disabled', false);
        } else if (voteCount === this.voteLimit) {
            this.$('.btn-plus').prop('disabled', 'disabled');
        } else {
            this.$('.btn-minus').prop('disabled', false);
            this.$('.btn-plus').prop('disabled', false);
        }
    },
    /**
     * Update the plus buttons once all votes are allocated for category
     */
    updatePlusButtons: function updatePlusButtons(categoryID) {
        if (categoryID && categoryID === this.category.get('id')) {
            this.$('.btn-plus').prop('disabled', 'disabled');
        }
    },
    /**
     *
     */
    loadVideo: function loadVideo(e) {
        if (this.temp || !this.model.get('video_url')) return;

        var lowerCategoryName = this.category.get('name').toLowerCase();
        var lowerContestantName = this.model.get('name').toLowerCase();

        var omParams = {
            name: 'video_' + lowerCategoryName + '_' + lowerContestantName,
            section: slugify(this.category.get('name')),
            url: window.location.href
        };
        var gaParams = {
            eventCategory: 'Button Click',
            eventAction: 'Watch Video : ' + this.category.get('name') + ' : ' + this.model.id
        };
        PubSub.trigger('loadVideo', this.model.toJSON(), this.category);
        PubSub.trigger('linkClick', omParams, gaParams);
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function remove() {
        this.off();
        this.stopListening();

        this.model = null;
        this.width = null;
        this.height = null;

        if (typeof this.transitionTimeout == 'number') clearTimeout(this.transitionTimeout);

        this.imageQsp = null;
        this.person = null;
        this.dimensions = null;

        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var template = __webpack_require__(228);

var _require = __webpack_require__(21),
    isMobile = _require.isMobile;

module.exports = Backbone.View.extend({
    className: 'view-ad',
    events: {},
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.categoryIndex = options.categoryIndex;
        this.adTag = options.adTag;

        var adType = isMobile.any() ? "mobile_mpu_inc" : "mpu_inc";
        this.adId = adType + '-' + this.categoryIndex;
        this.adConfig = [adType, this.categoryIndex, { pos: "inc" }];
    },
    /**
     *
     */
    render: function render() {
        this.$el.html(template({
            adId: this.adId
        }));

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom() {
        this.model.createAd(this.adConfig, this.adTag);
    },

    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function remove() {
        this.model.removeAd(this.adId);
        this.model = null;

        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isUndefined;
// Is a given variable undefined?
function isUndefined(obj) {
  return obj === void 0;
}


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBoolean;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);


// Is a given value a boolean?
function isBoolean(obj) {
  return obj === true || obj === false || __WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj) === '[object Boolean]';
}


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Number'));


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Symbol'));


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('ArrayBuffer'));


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNaN;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNumber_js__ = __webpack_require__(55);



// Is the given value `NaN`?
function isNaN(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isNumber_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["g" /* _isNaN */])(obj);
}


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isDataView_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBufferLike_js__ = __webpack_require__(125);





// Is a given value a typed array?
var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(obj) {
  // `ArrayBuffer.isView` is the most future-proof, so use it when available.
  // Otherwise, fall back on the above regular expression.
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* nativeIsView */] ? (Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* nativeIsView */])(obj) && !Object(__WEBPACK_IMPORTED_MODULE_1__isDataView_js__["a" /* default */])(obj)) :
                Object(__WEBPACK_IMPORTED_MODULE_3__isBufferLike_js__["a" /* default */])(obj) && typedArrayPattern.test(__WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__setup_js__["r" /* supportsArrayBuffer */] ? isTypedArray : Object(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* default */])(false));


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constant;
// Predicate-generating function. Often useful outside of Underscore.
function constant(value) {
  return function() {
    return value;
  };
}


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSizePropertyCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);


// Common internal logic for `isArrayLike` and `isBufferLike`.
function createSizePropertyCheck(getSizeProperty) {
  return function(collection) {
    var sizeProperty = getSizeProperty(collection);
    return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= __WEBPACK_IMPORTED_MODULE_0__setup_js__["b" /* MAX_ARRAY_INDEX */];
  }
}


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowProperty;
// Internal helper to generate a function to obtain property `key` from `obj`.
function shallowProperty(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
}


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = collectNonEnumProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_js__ = __webpack_require__(14);




// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function emulatedSet(keys) {
  var hash = {};
  for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
  return {
    contains: function(key) { return hash[key]; },
    push: function(key) {
      hash[key] = true;
      return keys.push(key);
    }
  };
}

// Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
// be iterated by `for key in ...` and thus missed. Extends `keys` in place if
// needed.
function collectNonEnumProps(obj, keys) {
  keys = emulatedSet(keys);
  var nonEnumIdx = __WEBPACK_IMPORTED_MODULE_0__setup_js__["n" /* nonEnumerableProps */].length;
  var constructor = obj.constructor;
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(constructor) && constructor.prototype || __WEBPACK_IMPORTED_MODULE_0__setup_js__["c" /* ObjProto */];

  // Constructor is a special case.
  var prop = 'constructor';
  if (Object(__WEBPACK_IMPORTED_MODULE_2__has_js__["a" /* default */])(obj, prop) && !keys.contains(prop)) keys.push(prop);

  while (nonEnumIdx--) {
    prop = __WEBPACK_IMPORTED_MODULE_0__setup_js__["n" /* nonEnumerableProps */][nonEnumIdx];
    if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
      keys.push(prop);
    }
  }
}


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(5);


// Returns whether an object has a given set of `key:value` pairs.
function isMatch(object, attrs) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(attrs), length = _keys.length;
  if (object == null) return !length;
  var obj = Object(object);
  for (var i = 0; i < length; i++) {
    var key = _keys[i];
    if (attrs[key] !== obj[key] || !(key in obj)) return false;
  }
  return true;
}


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(5);


// Invert the keys and values of an object. The values must be serializable.
function invert(obj) {
  var result = {};
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  for (var i = 0, length = _keys.length; i < length; i++) {
    result[obj[_keys[i]]] = _keys[i];
  }
  return result;
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = functions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(12);


// Return a sorted list of the function names available on the object.
function functions(obj) {
  var names = [];
  for (var key in obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(obj[key])) names.push(key);
  }
  return names.sort();
}


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allKeys_js__ = __webpack_require__(23);



// Extend a given object with all the properties in passed-in object(s).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__allKeys_js__["a" /* default */]));


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allKeys_js__ = __webpack_require__(23);



// Fill in a given object with default properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__allKeys_js__["a" /* default */], true));


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseCreate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(3);



// Create a naked function reference for surrogate-prototype-swapping.
function ctor() {
  return function(){};
}

// An internal function for creating a new object that inherits from another.
function baseCreate(prototype) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(prototype)) return {};
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["j" /* nativeCreate */]) return Object(__WEBPACK_IMPORTED_MODULE_1__setup_js__["j" /* nativeCreate */])(prototype);
  var Ctor = ctor();
  Ctor.prototype = prototype;
  var result = new Ctor;
  Ctor.prototype = null;
  return result;
}


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extend_js__ = __webpack_require__(67);




// Create a (shallow-cloned) duplicate of an object.
function clone(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return obj;
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(obj) ? obj.slice() : Object(__WEBPACK_IMPORTED_MODULE_2__extend_js__["a" /* default */])({}, obj);
}


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPath_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepGet_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isUndefined_js__ = __webpack_require__(53);




// Get the value of the (deep) property on `path` from `object`.
// If any property in `path` does not exist or if the value is
// `undefined`, return `defaultValue` instead.
// The `path` is normalized through `_.toPath`.
function get(object, path, defaultValue) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__deepGet_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_0__toPath_js__["a" /* default */])(path));
  return Object(__WEBPACK_IMPORTED_MODULE_2__isUndefined_js__["a" /* default */])(value) ? defaultValue : value;
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(16);



// Normalize a (deep) property `path` to array.
// Like `_.iteratee`, this function can be customized.
function toPath(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(path) ? path : [path];
}
__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].toPath = toPath;


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseIteratee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matcher_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__property_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__optimizeCb_js__ = __webpack_require__(25);








// An internal function to generate callbacks that can be applied to each
// element in a collection, returning the desired result — either `_.identity`,
// an arbitrary callback, a property matcher, or a property accessor.
function baseIteratee(value, context, argCount) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */];
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(value)) return Object(__WEBPACK_IMPORTED_MODULE_6__optimizeCb_js__["a" /* default */])(value, context, argCount);
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)) return Object(__WEBPACK_IMPORTED_MODULE_4__matcher_js__["a" /* default */])(value);
  return Object(__WEBPACK_IMPORTED_MODULE_5__property_js__["a" /* default */])(value);
}


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iteratee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(73);



// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only `argCount` argument.
function iteratee(value, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(value, context, Infinity);
}
__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee = iteratee;


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
// Predicate-generating function. Often useful outside of Underscore.
function noop(){}


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = random;
// Return a random integer between `min` and `max` (inclusive).
function random(min, max) {
  if (max == null) {
    max = min;
    min = 0;
  }
  return min + Math.floor(Math.random() * (max - min + 1));
}


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// A (possibly faster) way to get the current timestamp as an integer.
/* harmony default export */ __webpack_exports__["a"] = (Date.now || function() {
  return new Date().getTime();
});


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEscaper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(5);


// Internal helper to generate functions for escaping and unescaping strings
// to/from HTML interpolation.
function createEscaper(map) {
  var escaper = function(match) {
    return map[match];
  };
  // Regexes for identifying a key that needs to be escaped.
  var source = '(?:' + Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(map).join('|') + ')';
  var testRegexp = RegExp(source);
  var replaceRegexp = RegExp(source, 'g');
  return function(string) {
    string = string == null ? '' : '' + string;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
}


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Internal list of HTML entities for escaping.
/* harmony default export */ __webpack_exports__["a"] = ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
});


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);


// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
});


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = executeBound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(15);



// Internal function to execute `sourceFunc` bound to `context` with optional
// `args`. Determines whether to execute a function as a constructor or as a
// normal function.
function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
  if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
  var self = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(sourceFunc.prototype);
  var result = sourceFunc.apply(self, args);
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(result)) return result;
  return self;
}


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__executeBound_js__ = __webpack_require__(81);




// Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, context, args) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(func)) throw new TypeError('Bind must be called on a function');
  var bound = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(callArgs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__executeBound_js__["a" /* default */])(func, bound, context, this, args.concat(callArgs));
  });
  return bound;
}));


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = before;
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function before(times, func) {
  var memo;
  return function() {
    if (--times > 0) {
      memo = func.apply(this, arguments);
    }
    if (times <= 1) func = null;
    return memo;
  };
}


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(5);



// Returns the first key on an object that passes a truth test.
function findKey(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj), key;
  for (var i = 0, length = _keys.length; i < length; i++) {
    key = _keys[i];
    if (predicate(obj[key], key, obj)) return key;
  }
}


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPredicateIndexFinder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(13);



// Internal function to generate `_.findIndex` and `_.findLastIndex`.
function createPredicateIndexFinder(dir) {
  return function(array, predicate, context) {
    predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
    var length = Object(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */])(array);
    var index = dir > 0 ? 0 : length - 1;
    for (; index >= 0 && index < length; index += dir) {
      if (predicate(array[index], index, array)) return index;
    }
    return -1;
  };
}


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__ = __webpack_require__(85);


// Returns the last index on an array-like that passes a truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__["a" /* default */])(-1));


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortedIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(13);



// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
function sortedIndex(array, obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context, 1);
  var value = iteratee(obj);
  var low = 0, high = Object(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */])(array);
  while (low < high) {
    var mid = Math.floor((low + high) / 2);
    if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
  }
  return low;
}


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sortedIndex_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createIndexFinder_js__ = __webpack_require__(89);




// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__createIndexFinder_js__["a" /* default */])(1, __WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__sortedIndex_js__["a" /* default */]));


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createIndexFinder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isNaN_js__ = __webpack_require__(58);




// Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
function createIndexFinder(dir, predicateFind, sortedIndex) {
  return function(array, item, idx) {
    var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(array);
    if (typeof idx == 'number') {
      if (dir > 0) {
        i = idx >= 0 ? idx : Math.max(idx + length, i);
      } else {
        length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
      }
    } else if (sortedIndex && idx && length) {
      idx = sortedIndex(array, item);
      return array[idx] === item ? idx : -1;
    }
    if (item !== item) {
      idx = predicateFind(__WEBPACK_IMPORTED_MODULE_1__setup_js__["q" /* slice */].call(array, i, length), __WEBPACK_IMPORTED_MODULE_2__isNaN_js__["a" /* default */]);
      return idx >= 0 ? idx + i : -1;
    }
    for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
      if (array[idx] === item) return idx;
    }
    return -1;
  };
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = find;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findKey_js__ = __webpack_require__(84);




// Return the first value which passes a truth test.
function find(obj, predicate, context) {
  var keyFinder = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? __WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__findKey_js__["a" /* default */];
  var key = keyFinder(obj, predicate, context);
  if (key !== void 0 && key !== -1) return obj[key];
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__ = __webpack_require__(25);




// Internal helper to create a reducing function, iterating left or right.
function createReduce(dir) {
  // Wrap code that reassigns argument variables in a separate function than
  // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
  var reducer = function(obj, iteratee, memo, initial) {
    var _keys = !Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj),
        length = (_keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
    if (!initial) {
      memo = obj[_keys ? _keys[index] : index];
      index += dir;
    }
    for (; index >= 0 && index < length; index += dir) {
      var currentKey = _keys ? _keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };

  return function(obj, iteratee, memo, context) {
    var initial = arguments.length >= 3;
    return reducer(obj, Object(__WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__["a" /* default */])(iteratee, context, 4), memo, initial);
  };
}


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__each_js__ = __webpack_require__(17);





// Return the maximum element (or element-based computation).
function max(obj, iteratee, context) {
  var result = -Infinity, lastComputed = -Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj : Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value > result) {
        result = value;
      }
    }
  } else {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_3__each_js__["a" /* default */])(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clone_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getLength_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__random_js__ = __webpack_require__(76);






// Sample **n** random values from a collection using the modern version of the
// [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `_.map`.
function sample(obj, n, guard) {
  if (n == null || guard) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj)) obj = Object(__WEBPACK_IMPORTED_MODULE_2__values_js__["a" /* default */])(obj);
    return obj[Object(__WEBPACK_IMPORTED_MODULE_4__random_js__["a" /* default */])(obj.length - 1)];
  }
  var sample = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? Object(__WEBPACK_IMPORTED_MODULE_1__clone_js__["a" /* default */])(obj) : Object(__WEBPACK_IMPORTED_MODULE_2__values_js__["a" /* default */])(obj);
  var length = Object(__WEBPACK_IMPORTED_MODULE_3__getLength_js__["a" /* default */])(sample);
  n = Math.max(Math.min(n, length), 0);
  var last = length - 1;
  for (var index = 0; index < n; index++) {
    var rand = Object(__WEBPACK_IMPORTED_MODULE_4__random_js__["a" /* default */])(index, last);
    var temp = sample[index];
    sample[index] = sample[rand];
    sample[rand] = temp;
  }
  return sample.slice(0, n);
}


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__allKeys_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyInObj_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flatten_js__ = __webpack_require__(19);







// Return a copy of the object only containing the allowed properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  var result = {}, iteratee = keys[0];
  if (obj == null) return result;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(iteratee)) {
    if (keys.length > 1) iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__["a" /* default */])(iteratee, keys[1]);
    keys = Object(__WEBPACK_IMPORTED_MODULE_3__allKeys_js__["a" /* default */])(obj);
  } else {
    iteratee = __WEBPACK_IMPORTED_MODULE_4__keyInObj_js__["a" /* default */];
    keys = Object(__WEBPACK_IMPORTED_MODULE_5__flatten_js__["a" /* default */])(keys, false, false);
    obj = Object(obj);
  }
  for (var i = 0, length = keys.length; i < length; i++) {
    var key = keys[i];
    var value = obj[key];
    if (iteratee(value, key, obj)) result[key] = value;
  }
  return result;
}));


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);


// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
function initial(array, n, guard) {
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);


// Returns everything but the first entry of the `array`. Especially useful on
// the `arguments` object. Passing an **n** will return the rest N values in the
// `array`.
function rest(array, n, guard) {
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, n == null || guard ? 1 : n);
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatten_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains_js__ = __webpack_require__(27);





// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(array, rest) {
  rest = Object(__WEBPACK_IMPORTED_MODULE_1__flatten_js__["a" /* default */])(rest, true, true);
  return Object(__WEBPACK_IMPORTED_MODULE_2__filter_js__["a" /* default */])(array, function(value){
    return !Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(rest, value);
  });
}));


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniq;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isBoolean_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getLength_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains_js__ = __webpack_require__(27);





// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// The faster algorithm will not work with an iteratee if the iteratee
// is not a one-to-one function, so providing an iteratee will disable
// the faster algorithm.
function uniq(array, isSorted, iteratee, context) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isBoolean_js__["a" /* default */])(isSorted)) {
    context = iteratee;
    iteratee = isSorted;
    isSorted = false;
  }
  if (iteratee != null) iteratee = Object(__WEBPACK_IMPORTED_MODULE_1__cb_js__["a" /* default */])(iteratee, context);
  var result = [];
  var seen = [];
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_2__getLength_js__["a" /* default */])(array); i < length; i++) {
    var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
    if (isSorted && !iteratee) {
      if (!i || seen !== computed) result.push(value);
      seen = computed;
    } else if (iteratee) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(seen, computed)) {
        seen.push(computed);
        result.push(value);
      }
    } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(result, value)) {
      result.push(value);
    }
  }
  return result;
}


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unzip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__max_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pluck_js__ = __webpack_require__(50);




// Complement of zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices.
function unzip(array) {
  var length = array && Object(__WEBPACK_IMPORTED_MODULE_0__max_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */]).length || 0;
  var result = Array(length);

  for (var index = 0; index < length; index++) {
    result[index] = Object(__WEBPACK_IMPORTED_MODULE_2__pluck_js__["a" /* default */])(array, index);
  }
  return result;
}


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);


// Helper function to continue chaining intermediate results.
function chainResult(instance, obj) {
  return instance._chain ? Object(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */])(obj).chain() : obj;
}


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  /**
   * The pagePath might be provided in the following format:
   * 8264,aw-cmt,cmt-music-awards,voting
   * 
   * Use the third and fourth values in the comma separated list to create the pagePath.
   * e.g. cmt-music-awards/voting
   */

  pagePath: 'movie-and-tv-awards/voting',
  ptype: 'vote',
  franchise: 'movie-and-tv-awards',
  event: 'movie-and-tv-awards-2023'
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(213);
var CONST_TIMER = __webpack_require__(11).COUNTDOWN;

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-timer',
    /**
     * Initialize countdown view
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');
        this.model = options.model;
        this.copy = {
            labels: {
                singular: CONST_TIMER.SINGULAR,
                plural: CONST_TIMER.PLURAL
            },
            text: options.countdownCopy
        };
        this.displayCountdown = true;

        this.listenTo(this.model, 'change:timerEnded', this.checkTimer.bind(this));
        this.listenTo(this.model, 'change:seconds', this.checkTimer.bind(this));
    },
    /**
     * Render the countdown
     */
    render: function render() {
        this.copy.timer = _.clone(this.model.toJSON());
        this.$el.html(template(this.copy));
        return this;
    },
    /**
     * Call after rendering
     */
    renderedToDom: function renderedToDom() {
        this.model.startCountdown();
    },
    /**
     * Check if countdown ended
     */
    checkTimer: function checkTimer() {

        var date = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
        this.displayCountdown = date.getTime() < this.model.get('endTimestamp');

        if (!this.model.get('timerEnded') && this.model.get('isResetting') && this.displayCountdown) {
            return this.render();
        }

        // checks if timer is supposed to be reset at 00:00:00 or stop being displayed altogether
        if (this.model.get('timerEnded') && this.model.get('isResetting') && this.displayCountdown) {
            var resetTime = this.copy.text.reset_time;
            var date = new Date();
            var month = date.getMonth() + 1; // January returns 0
            var day = date.getDate() + 1; // Since the reset time has expired, set for the next day
            var nextDay = ('0' + month).slice(-2) + '/' + ('0' + day).slice(-2) + '/' + date.getFullYear();
            var resetDate = nextDay + ' ' + resetTime;

            PubSub.trigger('resetCategories');

            this.model.set({ endTime: resetDate }, { silent: true });
            this.model.startCountdown();
            this.render();
        } else {
            this.$el.hide();
            this.model.stopCountdown();
            this.stopListening();
        }
    },
    /**
     * Remove the view
     */
    remove: function remove() {
        this.model.stopCountdown();
        this.stopListening();
        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(4);

module.exports = function () {
    return window.scrollY || document.documentElement.scrollTop || $(window).scrollTop();
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(241);

var _require = __webpack_require__(21),
    isMobile = _require.isMobile;

module.exports = Backbone.View.extend({
    className: 'view-share',
    events: {
        'click a': 'share'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};
        this.model = options.model;
        this.isThanks = options.isThanks;
        this.shareUrl = options.shareUrl;
    },
    /**
     *
     */
    render: function render() {
        var model = this.model.toJSON();
        this.$el.html(template(model));

        if (isMobile.any()) {
            this.$('.whatsapp').css('display', 'inline-block');
        }

        return this;
    },
    /**
     * [share description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    share: function share(e) {
        var platform = e.currentTarget.className;

        var omParams = {
            name: (this.isThanks ? 'thanks ' : 'footer ') + platform + ' share button',
            section: this.isThanks ? 'thanks-modal' : '',
            url: window.location.href
        };
        var gaParams = {
            eventCategory: 'Button Click',
            eventAction: 'Click Share Button : ' + (this.isThanks ? 'Thanks' : 'Footer') + ' : ' + platform
        };

        PubSub.trigger('linkClick', omParams, gaParams);

        if (platform === 'facebook') {
            e.preventDefault();
            var shareUrl = this.model.get('share').facebook.redirect_uri || this.shareUrl;

            this.shareToFacebook(shareUrl);
        }
    },
    shareToFacebook: function shareToFacebook(url) {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, 'popup', 'width=600, height=400, scrollbars=no');
    },
    /**
     *
     */
    remove: function remove() {
        this.stopListening();
        this.off();
        this.model = null;
        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0),
    $ = __webpack_require__(4),
    Backbone = __webpack_require__(1);

var base = function base(attrs, options) {
    options = options || {};
    this.cms = options.cms;
    this.textKey = options.textKey;

    Backbone.Model.apply(this, arguments);
};
_.extend(base.prototype, Backbone.Model.prototype, {
    defaults: function defaults() {
        return {
            copy: {},
            uid: ''
        };
    },
    initialize: function initialize(attrs, options) {
        if (this.cms) {
            this.listenTo(this.cms, 'change:text', function (model, value) {
                this.updateCopy(model, value);
            }.bind(this));
        }
    }
    /**
     *
     */
    , fetch: function fetch(options) {
        console.log('The Base model does not support "fetch"');
    }
    /**
     *
     */
    , save: function save(attrs, options) {
        console.log('The Base model does not support "save"');
    }
    /**
     *
     */
    , destroy: function destroy(options) {
        options = options ? _.clone(options) : {};
        var model = this;
        var wait = options.wait;

        var destroy = function destroy() {
            model.stopListening();
            model.trigger('destroy', model, model.collection, options);
        };

        if (!wait) destroy();

        console.log('The Base model does not support "destroy"');
    }
    /**
     * [updateCopy description]
     * @param  {[type]} model [description]
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    , updateCopy: function updateCopy(model, value) {
        if (!this.textKey) {
            return;
        }

        this.set({
            copy: value[this.textKey]
        });
    }
});
base.extend = Backbone.Model.extend;

module.exports = base;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var getQueryParamByName = __webpack_require__(258).getQueryParamByName;

function CmsManager (){
  var cmsList = [];

  // Simple count of all CMS objects in the system
  this.count = function() {
    return cmsList.length;
  };

  // This is called automatically by every CMS object
  // created, and should never need to be called manually
  this.add = function (cms) {
    this.listenTo(cms, 'change', function(model){
      this.trigger('change', model);
    }.bind(this));
    cmsList.push(cms);
  };

  // Returns all CMS objects with the given widget ID,
  // or if widget ID is not set, returns all tracked
  // CMS objects.
  this.get = function(wid) {
    if(typeof wid !== 'string') {
      return cmsList.slice();
    }

    var retList = [];
    for(var i = 0; i < cmsList.length; i++) {
      if(cmsList[i].get('wid') === wid) {
        retList.push(cmsList[i]);
      }
    }
    return retList;
  }

  // Allows an individual CMS object to be removed from
  // the system.  Use this when the CMS object is destroyed.
  // Stops listening to this object's events.  Boolean
  // return for whether the CMS object existed to begin with.
  this.remove = function(cms) {
    for(var i = 0; i < cmsList.length; i++) {
      if(cms === cmsList[i]) {
        this.stopListening(cms);
        cmsList.splice(i,1);
        // There should only ever be one instance
        // of this object in the array, so return now
        return true;
      }
    }
    return false;
  };

  // Remove all CMS objects from the system. Stops listening to all objects.
  this.clear = function() {
    var tempList = cmsList.slice();
      for(var i = 0; i < tempList.length; i++) {
        this.remove(tempList[i]);
      }
  };
};

var managerSingleton = new CmsManager();
_.extend(managerSingleton, Backbone.Events);

var TSComCMS = Backbone.Model.extend({

  defaults: {
    /**
     * Where to pull the data from.
     * Different servers have different needs / capabilities.  Like caching.
     */
    apiUrl: 'https://widgetstate.votenow.tv/v1/state/',
    /**
     * The widget ID to retrieve.
     * Should be found in the URL Query String Parameter or hardcoded in 'initialize()'
     */
    wid: 'data/data.json', // default template widget
    /**
     * The etag.
     * to access the cdn's etag cache
     */
    etag: null,
    /**
     * The snapshot ID (if necessary).
     * Should be found in the URL Query String Parameter
     */
    sid: null,
    useSID: null,
    /**
     *  Timestamp of widget
     */
    ts: null,
    /**
     * Window Status, abstracted from the widget 'settings' key
     */
    windowStatus: null,
    /**
     * Widget Text
     */
    text: {},
    /**
     * Widget Settings
     */
    settings: {},
    /**
     * Widget CSS
     */
    css: {},
    /**
     * Widget Data: Vote Options, Poll and Trivia Questions, Mood Buttons
     */
    data: [],
    /**
     * Social Configuration: Facebook and Twitter app and share info
     */
    social: {},
    /**
     * All data from CMS API
     */
    raw: {},
    /**
     * The number of seconds to wait before updating again.
     */
    updateFrequency: 30,
    /**
     *
     */
    pollTimer: null,
    /**
     *
     */
    initialized: false
  },

  /**
   * enable polling?
   */
  poll: true,

  /**
   * Initialize the Model
   * @param  {Object} attrs
   * @param  {Object} options
   */
  initialize: function(attrs, options) {
    
    managerSingleton.add(this);

    var wid = ((getQueryParamByName('wid').length === 0 || options.ignoreQSP) ? undefined : getQueryParamByName('wid')) || attrs.wid || this.defaults.wid;
    var sid = ((getQueryParamByName('sid').length === 0 || options.ignoreQSP) ? undefined : getQueryParamByName('sid')) || attrs.sid || this.defaults.sid;
    var useSID = (!_.isNull(sid)) ? sid : null; // Force the Cms to use a specific Snapshot ID from Connect's CMS

    if (typeof options === 'object') {
      for (var prop in options) {
        if (typeof this[prop] !== 'undefined') {
          this[prop] = options[prop];
        }
      }
    }

    this.set({
      wid: wid,
      useSID: useSID
    });
  },

  /**
   * Builds the URL to fetch data from the Connect API
   * @return {String}
   */
  urlRoot: function() {
    var url = (
      this.get('wid').search(/\//) === -1 ?
      // If there is a numeric wid provided, then use the base url and query for that particular id
      this.get('apiUrl') + this.get('wid') + (!_.isNull(this.get('useSID')) ? '/snapshot/' + this.get('useSID') : '')
      // Otherwise, get the file specified by the wid field, i.e. '/test/cms/widget_data.php'
      : this.get('wid') + '?' + Math.random()
    );
    return url;
  },

  /**
   * Override the sync function of the Backbone Model
   * @param  {[type]} crud
   * @param  {[type]} model
   * @param  {Object} options
   */
  sync: function(crud, model, options) {
    var params = {
      url: this.urlRoot(),
      type: 'GET',
      dataType: 'json',
      crossDomain: true
    };
    var etag = this.get('etag');
    if(etag){
      options.beforeSend = function(xhr) {
      xhr.setRequestHeader('if-none-match', etag);
      };
    }
    _.extend(params, options);
    this.xhr = Backbone.sync(crud, model, params);
    return this.xhr;
  },

  /**
   * Handle call for save function
   * @param  {Object} attrs
   * @param  {Object} options
   */
  save: function(attrs, options) {
    console.warn('The CMS model does not support "save"');
  },

  /**
   * Handle call for destroy function
   * @param  {Object} options
   */
  destroy: function(options) {
    console.warn('The CMS model does not support "destroy"');
  },

  /**
   * Alias for fetch function
   * @param  {Object} options
   */
  requestData: function(options) {
    this.fetch(options);
  },

  /**
   * Override the fetch function of the Backbone Model
   * @param {Object} options 
   */
  fetch: function(options) {
    if (this.poll) {
      this.pollData();
    }
    return Backbone.Model.prototype.fetch.call(this, options);
  },

  /**
   * Parse the widget data
   * @param {Object} data 
   * @param {*} option 
   */
  parse: function(data, option) {
    if( data === undefined ) {
      return undefined;
    }

    var type = data.snapshot.data.type;

    // Widget State API does not return a type property
    // for Document Widgets. Instead, we have to detect
    // based on JSON shape.
    if( data.snapshot.data.data && data.snapshot.data.data.document ) {
      type = 'document';
    }

    var parsedData = _.extend({}, {
      initialized: true,
      raw: data, // Update full CMS output
      metadata: {
        current_timestamp: Math.floor( parseInt(data.current_timestamp) / 1000 ),
        current_timestamp_ms: data.current_timestamp,
        snapshot_start_timestamp: data.snapshot.schedule,
        name: data.snapshot.name,
      },
      type: type,
      sid: data.snapshot.snapshot_id,
      data: data.snapshot.data.data,
      settings: data.snapshot.data.settings,
      social: data.snapshot.data.social,
      text: data.snapshot.data.text,
      windowStatus: parseInt(data.snapshot.data.settings.window_status),
      ts: data.current_timestamp,
      etag: this.xhr.getResponseHeader('etag')
    });

    return parsedData;
  },

  /**
   * Sets the polling timer
   */
  pollData: function() {
    clearTimeout(this.get('pollTimer'));
    this.set({
      pollTimer: setTimeout(_.bind(this.fetch, this), parseInt(this.get('updateFrequency'), 10) * 1000)
    });
  },

  /**
   * Stop polling and clear the timer
   */
  stopPolling: function() {
    this.poll = false;
    var pollTimer = this.get('pollTimer');
    if(typeof pollTimer == 'number') clearTimeout(pollTimer);
      this.set('pollTimer', null);
  }
});

module.exports = TSComCMS;
module.exports.manager = managerSingleton;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);

var BASE64 = __webpack_require__(108);
var SHA256 = __webpack_require__(266);

module.exports = Backbone.Model.extend({

    apiUrl: 'https://voteapi.votenow.tv/s2/vote',

    defaults: {
        apiKey: ''
    },

    /**
     * Internal options and values
     */
    secretKey: '',
    version_id: '',
    device: 'unknownpc',
    response: null,
    versionCheck: '',

    /**
     * Initialize
     * @param  {Object} attr    [description]
     * @param  {Object} options [description]
     */
    initialize: function(attr, options) {
        _.bindAll(this, 'syncSuccess', 'syncError');

        if (typeof options === 'object') {
            for (var prop in options) {
                if (typeof this[prop] !== 'undefined') {
                    this[prop] = options[prop];
                }
            }
        }

    },

    /**
     * Override sync method to make requests to the Vote API.
     * @param {String}         crud    - Will be one of: 'create', 'read', 'update', 'destroy'.  We use the value to determine action type.
     * @param {Backbone.Model} model   - A reference to this model.
     * @param {Object}         options - A JS object with options for $.ajax.
     * @return {[type]}                [description]
     */
    sync: function(crud, model, options) {
        var qsp = this.paramsLiteralToQsp(model.toJSON());
        var b64hash = this.qspToHash(qsp);

        var params = {
            url: this.urlRoot(),
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: 'Authorization=' + encodeURIComponent(b64hash)
        };

        _.extend(params, options);

        return Backbone.sync(crud, model, params).done(this.syncSuccess).fail(this.syncFail);
    },

    /**
     * Fetch
     * @param  {Object} options [description]
     */
    fetch: function(options) {
        this.set({ action_type: 'get' }, { silent: true });
        return this.sync('read', this, options);
    },

    /**
     * Save
     * @param  {Object} attrs   [description]
     * @param  {Object} options [description]
     * @return {[type]}         [description]
     */
    save: function(attrs, options) {
        attrs = attrs || {};
        attrs.action_type = attrs.action_type || this.get('action_type') || 'vote';

        delete attrs.response;
        delete attrs.status;
        this.unset('response', { silent: true });
        this.unset('status', { silent: true });

        this.set(attrs, { silent: true });
        return this.sync('create', this, options);
    },

    /**
     * Override Backbone's urlRoot to generate the URL with hashed params.
     * @return {String} [description]
     */
    urlRoot: function() {
        var params = this.paramsLiteralToQsp(this.toJSON());
        var b64hash = this.qspToHash(params);

        return this.apiUrl + '?' + params;
    },

    /**
     * Connect doesn't support 'destroy' so let's warn the user.
     * @param {Object} options [description]
     */
    destroy: function(options) {
        console.warn('Connect API does not support the "destroy" method.');
    },

    /**
     * Callback for If AJAX send vote success
     * @param {[type]} response [description]
     */
    syncSuccess: function(response) {
        if (!response) response = {};
        this.set({
            response: response,
            status: "success"
        });

        this.trigger('sync', this);
    },

    /**
     * Callback for AJAX send vote fail
     * @param {[type]} response [description]
     */
    syncError: function(response) {
        this.set({
            response: {},
            status: 'error'
        });

        this.trigger('error', this);
    },

    /**
     * [qspToHash description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    qspToHash: function(data) {
        var secret = this.version_id + this.versionCheck;
        var hash = SHA256(data, secret);
        return BASE64.stringify(hash);
    },

    /**
     * [paramsLiteralToQsp description]
     * @param  {Object} params [description]
     * @return {String}        [description]
     */
    paramsLiteralToQsp: function(params) {
        var pars = [],
            params_str;
        _.each(params, _.bind(function(value, key, list) {
            if (typeof value !== 'undefined') {
                pars.push(key + '=' + this.fixedEncodeURIComponent(value));
            }
        }, this));
        params_str = pars.join('&');
        return params_str;
    },

    /**
     * [fixedEncodeURIComponent description]
     * @param  {String} str [description]
     * @return {[type]}     [description]
     */
    fixedEncodeURIComponent: function(str) {
        return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    }
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(29));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex != -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            var words = [];
	            var nBytes = 0;
	            for (var i = 0; i < base64StrLength; i++) {
	                if (i % 4) {
	                    var bits1 = map.indexOf(base64Str.charAt(i - 1)) << ((i % 4) * 2);
	                    var bits2 = map.indexOf(base64Str.charAt(i)) >>> (6 - (i % 4) * 2);
	                    words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	                    nBytes++;
	                }
	            }

	            return WordArray.create(words, nBytes);
	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var Base64 = __webpack_require__(108);
var Utf8 = __webpack_require__(269);
var CONSTANTS = __webpack_require__(11).STORAGE;
var KEY_PREFIX = CONSTANTS.KEY_PREFIX; // UPDATE EVERY YEAR inside /constants/index.js

module.exports = Backbone.Model.extend({

  initialize: function initialize(options) {

    options = options || {};

    if (options.storageMethod && options.storageMethod.match(/cookie/i)) {
      this._storeMethod = 'Cookie';
    } else {

      try {
        localStorage.setItem('local_storage_test', 'test');
        localStorage.removeItem('local_storage_test');
        this._storeMethod = 'LocalStorage';
      } catch (e) {
        this._storeMethod = 'Cookie';
      }
    }
  },

  /* Exposed Functions
  -------------------------*/
  save: function save(name, value, days) {
    var key = this.get('namespace') ? this.get('namespace') + '_' + name : name;
    this['_set' + this._storeMethod](this.hashKey(key), this.encode(value), days);
  },

  fetch: function fetch(name) {
    var key = this.get('namespace') ? this.get('namespace') + '_' + name : name;
    return this.decode(this['_read' + this._storeMethod](this.hashKey(key)));
  },

  destroy: function destroy(name) {
    var key = this.get('namespace') ? this.get('namespace') + '_' + name : name;
    this['_delete' + this._storeMethod](this.hashKey(key));
  },

  /* COOKIE Functions
  -------------------------*/
  _setCookie: function _setCookie(key, value, timeGMT) {

    var today = new Date();
    var tomorrow = new Date(today);

    tomorrow.setDate(tomorrow.getDate() + 1);
    var expirationDate = new Date(tomorrow.toDateString() + ' ' + timeGMT);

    document.cookie = key + '=' + value + '; expires=' + expirationDate.toGMTString() + '; path=/';
  },

  _readCookie: function _readCookie(name) {

    var regEx = new RegExp(name + "=[^;]+(;|$)");
    var result = document.cookie.match(regEx);

    if (result) return result[0].split(/[;=]/g)[1];
    return null;
  },

  _deleteCookie: function _deleteCookie(name) {
    this._setCookie(name, '', -1);
  },

  /* LOCALSTORAGE Functions
  -------------------------*/
  _setLocalStorage: function _setLocalStorage(name, value) {
    localStorage.setItem(name, value);
  },

  _readLocalStorage: function _readLocalStorage(name) {
    return localStorage.getItem(name);
  },

  _deleteLocalStorage: function _deleteLocalStorage(name) {
    localStorage.removeItem(name);
  },

  hashKey: function hashKey(key) {

    var hash = 0,
        i,
        chr;
    if (key.length === 0) return hash;

    key = KEY_PREFIX + key;

    for (i = 0; i < key.length; i++) {
      chr = key.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }

    return hash;
  },

  encode: function encode(word) {
    return Base64.stringify(Utf8.parse(word));
  },

  decode: function decode(hash) {

    if (hash) {
      try {
        var words = Base64.parse(hash);
        return Utf8.stringify(words);
      } catch (err) {
        throw new Error('Storage Model: Error decoding');
      }
    } else {
      return hash;
    }
  }

}, {
  KEY_PREFIX: KEY_PREFIX
});

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gtag = gtag;
exports.initializeGA4 = initializeGA4;
exports.trackPageView = trackPageView;
exports.trackLogin = trackLogin;
function gtag() {
  window.dataLayer.push(arguments);
}

function initializeGA4(measurementId) {
  var script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];

  gtag('js', new Date());
  gtag('config', measurementId);
}

function trackPageView(pageTitle) {
  gtag('event', 'page_view', {
    page_title: pageTitle,
    page_location: window.location.href
  });
}

function trackLogin(method) {
  gtag('event', 'login', {
    method: method
  });
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var jwt_decode = __webpack_require__(274).default;

module.exports = Backbone.Model.extend({
    /**
     * Default values for the model
     */
    defaults: {
        googleClientId: null,
        user: {
            id: ''
        }
    },
    /**
     * Initialize the model
     */
    initialize: function initialize(attrs, options) {
        if (!window.google) {
            window.onGoogleLibraryLoad = this.onGoogleLoaded.bind(this);
            loadScript('https://accounts.google.com/gsi/client');
        }
    },
    onGoogleLoaded: function onGoogleLoaded() {
        window.google.accounts.id.initialize({
            client_id: this.get('googleClientId'),
            callback: this.onCredentialResponse.bind(this),
            ux_mode: 'popup',
            auto_select: true,
            width: 400,
            logo_alignment: 'center',
            prompt_parent_id: 'g_id_onload'
        });

        this.trigger('prompt');
    },
    onCredentialResponse: function onCredentialResponse(response) {
        var payload = jwt_decode(response.credential);
        this.set({
            user: {
                id: payload.sub,
                name: payload.name,
                email: payload.email
            }
        });

        PubSub.trigger('directRoute', 'closeCurrentModal');
        PubSub.trigger('authenticated', 'google');
    },


    /**
     * Render a custom Google button
     */
    renderButton: function renderButton(element, callback) {
        callback = callback || function () {};

        window.google.accounts.id.renderButton(element, {
            theme: 'filled_blue',
            size: 'large',
            type: 'standard',
            click_listener: callback
        });
    },

    /**
     * Signs out the user
     */
    signout: function signout() {
        window.google.accounts.id.disableAutoSelect();
    },
    /**
     * Clear user object
     */
    clearUserData: function clearUserData() {
        this.set({
            user: this.defaults.user
        });
    }
});

function loadScript(url, callback) {
    var script = document.createElement('script');
    script.src = url;
    script.onload = callback;
    document.head.appendChild(script);
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(113);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
Backbone.$ = $;

// relative utils
__webpack_require__(189);
__webpack_require__(190);

// shimmed modules
__webpack_require__(191);

__webpack_require__(192);

_.noConflict();
$.noConflict(true);
// Backbone.noConflict();

var App = __webpack_require__(197);
var AppClassName = 'mtvawards';

/**
 *
 * @param options
 * {
 * widget_id: 'data/data.json' // REQUIRED string
 * container: $('#myApp') // REQUIRED string || jQuery selector (https://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * modal: $('#wrapper') // string || jQuery selector (https://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * uniqueId: 'name-type-namespace-rev' // string
 * cssUrl: 'https://a1.telesocpe.tv/styles/main.css' // absolute path
 * cssIsUnique: true // boolean - if true css should use an ID selector for the namespacing, otherwise use a class selector for the namespacing and restrict loading and injection of style block to a single execution
 * endpoints: {cms: '//stateapi-prod.votenow.tv/widgets/get'} // object
 * }
 */
module.exports = function (options) {

    options = options || {};

    options.container = $(options.container || document.body);
    options.modal = $(options.modal || options.container);

    options.cssIsUnique = typeof options.cssIsUnique === 'undefined' ? true : options.cssIsUnique;

    options.uniqueId = options.uniqueId || $(options.container).attr('id') || function () {
        var retval = AppClassName;
        if (options.widget_id) {
            retval += '-' + options.widget_id + '-';
        }
        retval += Date.now() % 1e6;
        return retval;
    }();

    if (!$(options.uniqueId).length) {
        $(options.container).attr('id', options.uniqueId);
    }

    App(options);
};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_default_js__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__index_default_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(36);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["VERSION"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["restArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNull"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isUndefined"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isBoolean"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isElement"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isString"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNumber"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isRegExp"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isError"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSymbol"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArrayBuffer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDataView", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDataView"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFunction"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFinite"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNaN"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isTypedArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEmpty"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMatch"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEqual"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["keys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["allKeys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["values"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pairs"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invert"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["functions"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["methods"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extend"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extendOwn"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["assign"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defaults"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["create"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["clone"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["get"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["has"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mapObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["identity"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["constant"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["noop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toPath", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toPath"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["property"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["propertyOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matcher"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matches"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["times"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["random"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["now"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["escape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unescape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["templateSettings"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["template"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["result"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniqueId"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chain"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["iteratee"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bind"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bindAll"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["memoize"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["delay"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["throttle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["debounce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["wrap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["negate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["after"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["before"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["once"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findKey"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findLastIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortedIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["lastIndexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["find"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["detect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findWhere"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["each"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["forEach"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["map"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["collect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldl"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["inject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduceRight"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldr"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["filter"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["select"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["every"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["all"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["some"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["any"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["contains"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["includes"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["include"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invoke"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pluck"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["where"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["max"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["min"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["shuffle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sample"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["groupBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["countBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partition"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["size"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pick"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["omit"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["first"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["head"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["take"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["initial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["last"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["rest"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tail"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["drop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compact"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["flatten"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["without"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniq"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unique"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["union"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["intersection"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["difference"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unzip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["transpose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["zip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["object"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["range"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chunk"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mixin"]; });
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.




/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(36);
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```



// Add all of the Underscore functions to the wrapper object.
var _ = Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["mixin"])(__WEBPACK_IMPORTED_MODULE_0__index_js__);
// Legacy Node.js API.
_._ = _;
// Export the Underscore API.
/* harmony default export */ __webpack_exports__["a"] = (_);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNull;
// Is a given value equal to null?
function isNull(obj) {
  return obj === null;
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isElement;
// Is a given value a DOM element?
function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Date'));


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('RegExp'));


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Error'));


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Object'));


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFinite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(56);



// Is a given object a finite number?
function isFinite(obj) {
  return !Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["f" /* _isFinite */])(obj) && !isNaN(parseFloat(obj));
}


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getByteLength_js__ = __webpack_require__(40);



// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__getByteLength_js__["a" /* default */]));


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArguments_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keys_js__ = __webpack_require__(5);






// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
function isEmpty(obj) {
  if (obj == null) return true;
  // Skip the more expensive `toString`-based type checks if `obj` has no
  // `.length`.
  var length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(obj);
  if (typeof length == 'number' && (
    Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(obj) || Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(obj) || Object(__WEBPACK_IMPORTED_MODULE_3__isArguments_js__["a" /* default */])(obj)
  )) return length === 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__keys_js__["a" /* default */])(obj)) === 0;
}


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getByteLength_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isTypedArray_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringTagBug_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isDataView_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keys_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__has_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toBufferView_js__ = __webpack_require__(128);











// We use this string twice, so give it a name for minification.
var tagDataView = '[object DataView]';

// Internal recursive comparison function for `_.isEqual`.
function eq(a, b, aStack, bStack) {
  // Identical objects are equal. `0 === -0`, but they aren't identical.
  // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
  if (a === b) return a !== 0 || 1 / a === 1 / b;
  // `null` or `undefined` only equal to itself (strict comparison).
  if (a == null || b == null) return false;
  // `NaN`s are equivalent, but non-reflexive.
  if (a !== a) return b !== b;
  // Exhaust primitive checks
  var type = typeof a;
  if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
  return deepEq(a, b, aStack, bStack);
}

// Internal recursive comparison function for `_.isEqual`.
function deepEq(a, b, aStack, bStack) {
  // Unwrap any wrapped objects.
  if (a instanceof __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]) a = a._wrapped;
  if (b instanceof __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]) b = b._wrapped;
  // Compare `[[Class]]` names.
  var className = __WEBPACK_IMPORTED_MODULE_1__setup_js__["t" /* toString */].call(a);
  if (className !== __WEBPACK_IMPORTED_MODULE_1__setup_js__["t" /* toString */].call(b)) return false;
  // Work around a bug in IE 10 - Edge 13.
  if (__WEBPACK_IMPORTED_MODULE_5__stringTagBug_js__["a" /* hasStringTagBug */] && className == '[object Object]' && Object(__WEBPACK_IMPORTED_MODULE_6__isDataView_js__["a" /* default */])(a)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isDataView_js__["a" /* default */])(b)) return false;
    className = tagDataView;
  }
  switch (className) {
    // These types are compared by value.
    case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case '[object String]':
      // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
      // equivalent to `new String("5")`.
      return '' + a === '' + b;
    case '[object Number]':
      // `NaN`s are equivalent, but non-reflexive.
      // Object(NaN) is equivalent to NaN.
      if (+a !== +a) return +b !== +b;
      // An `egal` comparison is performed for other numeric values.
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case '[object Date]':
    case '[object Boolean]':
      // Coerce dates and booleans to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a === +b;
    case '[object Symbol]':
      return __WEBPACK_IMPORTED_MODULE_1__setup_js__["d" /* SymbolProto */].valueOf.call(a) === __WEBPACK_IMPORTED_MODULE_1__setup_js__["d" /* SymbolProto */].valueOf.call(b);
    case '[object ArrayBuffer]':
    case tagDataView:
      // Coerce to typed array so we can fall through.
      return deepEq(Object(__WEBPACK_IMPORTED_MODULE_9__toBufferView_js__["a" /* default */])(a), Object(__WEBPACK_IMPORTED_MODULE_9__toBufferView_js__["a" /* default */])(b), aStack, bStack);
  }

  var areArrays = className === '[object Array]';
  if (!areArrays && Object(__WEBPACK_IMPORTED_MODULE_3__isTypedArray_js__["a" /* default */])(a)) {
      var byteLength = Object(__WEBPACK_IMPORTED_MODULE_2__getByteLength_js__["a" /* default */])(a);
      if (byteLength !== Object(__WEBPACK_IMPORTED_MODULE_2__getByteLength_js__["a" /* default */])(b)) return false;
      if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
      areArrays = true;
  }
  if (!areArrays) {
    if (typeof a != 'object' || typeof b != 'object') return false;

    // Objects with different constructors are not equivalent, but `Object`s or `Array`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(Object(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(aCtor) && aCtor instanceof aCtor &&
                             Object(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(bCtor) && bCtor instanceof bCtor)
                        && ('constructor' in a && 'constructor' in b)) {
      return false;
    }
  }
  // Assume equality for cyclic structures. The algorithm for detecting cyclic
  // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

  // Initializing stack of traversed objects.
  // It's done here since we only need them for objects and arrays comparison.
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    if (aStack[length] === a) return bStack[length] === b;
  }

  // Add the first object to the stack of traversed objects.
  aStack.push(a);
  bStack.push(b);

  // Recursively compare objects and arrays.
  if (areArrays) {
    // Compare array lengths to determine if a deep comparison is necessary.
    length = a.length;
    if (length !== b.length) return false;
    // Deep compare the contents, ignoring non-numeric properties.
    while (length--) {
      if (!eq(a[length], b[length], aStack, bStack)) return false;
    }
  } else {
    // Deep compare objects.
    var _keys = Object(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(a), key;
    length = _keys.length;
    // Ensure that both objects contain the same number of properties before comparing deep equality.
    if (Object(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(b).length !== length) return false;
    while (length--) {
      // Deep compare each member
      key = _keys[length];
      if (!(Object(__WEBPACK_IMPORTED_MODULE_8__has_js__["a" /* default */])(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
    }
  }
  // Remove the first object from the stack of traversed objects.
  aStack.pop();
  bStack.pop();
  return true;
}

// Perform a deep comparison to check if two objects are equal.
function isEqual(a, b) {
  return eq(a, b);
}


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toBufferView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getByteLength_js__ = __webpack_require__(40);


// Internal function to wrap or shallow-copy an ArrayBuffer,
// typed array or DataView to a new view, reusing the buffer.
function toBufferView(bufferSource) {
  return new Uint8Array(
    bufferSource.buffer || bufferSource,
    bufferSource.byteOffset || 0,
    Object(__WEBPACK_IMPORTED_MODULE_0__getByteLength_js__["a" /* default */])(bufferSource)
  );
}


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["b" /* mapMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Map'));


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["d" /* weakMapMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('WeakMap'));


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["c" /* setMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Set'));


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('WeakSet'));


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pairs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(5);


// Convert an object into a list of `[key, value]` pairs.
// The opposite of `_.object` with one argument.
function pairs(obj) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  var length = _keys.length;
  var pairs = Array(length);
  for (var i = 0; i < length; i++) {
    pairs[i] = [_keys[i], obj[_keys[i]]];
  }
  return pairs;
}


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extendOwn_js__ = __webpack_require__(43);



// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create(prototype, props) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(prototype);
  if (props) Object(__WEBPACK_IMPORTED_MODULE_1__extendOwn_js__["a" /* default */])(result, props);
  return result;
}


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tap;
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function tap(obj, interceptor) {
  interceptor(obj);
  return obj;
}


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = has;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(24);



// Shortcut function for checking if an object has a given property directly on
// itself (in other words, not on a prototype). Unlike the internal `has`
// function, this public version can also traverse nested properties.
function has(obj, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  var length = path.length;
  for (var i = 0; i < length; i++) {
    var key = path[i];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(obj, key)) return false;
    obj = obj[key];
  }
  return !!length;
}


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(5);



// Returns the results of applying the `iteratee` to each element of `obj`.
// In contrast to `_.map` it returns an object.
function mapObject(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj),
      length = _keys.length,
      results = {};
  for (var index = 0; index < length; index++) {
    var currentKey = _keys[index];
    results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = propertyOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(71);



// Generates a function for a given object that returns a given property.
function propertyOf(obj) {
  if (obj == null) return __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */];
  return function(path) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(obj, path);
  };
}


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = times;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__ = __webpack_require__(25);


// Run a function **n** times.
function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__["a" /* default */])(iteratee, context, 1);
  for (var i = 0; i < n; i++) accum[i] = iteratee(i);
  return accum;
}


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEscaper_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escapeMap_js__ = __webpack_require__(79);



// Function for escaping strings to HTML interpolation.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createEscaper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__escapeMap_js__["a" /* default */]));


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEscaper_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unescapeMap_js__ = __webpack_require__(142);



// Function for unescaping strings from HTML interpolation.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createEscaper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unescapeMap_js__["a" /* default */]));


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invert_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escapeMap_js__ = __webpack_require__(79);



// Internal list of HTML entities for unescaping.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__invert_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__escapeMap_js__["a" /* default */]));


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = template;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaults_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__underscore_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templateSettings_js__ = __webpack_require__(80);




// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var noMatch = /(.)^/;

// Certain characters need to be escaped so that they can be put into a
// string literal.
var escapes = {
  "'": "'",
  '\\': '\\',
  '\r': 'r',
  '\n': 'n',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

function escapeChar(match) {
  return '\\' + escapes[match];
}

// JavaScript micro-templating, similar to John Resig's implementation.
// Underscore templating handles arbitrary delimiters, preserves whitespace,
// and correctly escapes quotes within interpolated code.
// NB: `oldSettings` only exists for backwards compatibility.
function template(text, settings, oldSettings) {
  if (!settings && oldSettings) settings = oldSettings;
  settings = Object(__WEBPACK_IMPORTED_MODULE_0__defaults_js__["a" /* default */])({}, settings, __WEBPACK_IMPORTED_MODULE_1__underscore_js__["a" /* default */].templateSettings);

  // Combine delimiters into one regular expression via alternation.
  var matcher = RegExp([
    (settings.escape || noMatch).source,
    (settings.interpolate || noMatch).source,
    (settings.evaluate || noMatch).source
  ].join('|') + '|$', 'g');

  // Compile the template source, escaping string literals appropriately.
  var index = 0;
  var source = "__p+='";
  text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
    source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
    index = offset + match.length;

    if (escape) {
      source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
    } else if (interpolate) {
      source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
    } else if (evaluate) {
      source += "';\n" + evaluate + "\n__p+='";
    }

    // Adobe VMs need the match returned to produce the correct offset.
    return match;
  });
  source += "';\n";

  // If a variable is not specified, place data values in local scope.
  if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

  source = "var __t,__p='',__j=Array.prototype.join," +
    "print=function(){__p+=__j.call(arguments,'');};\n" +
    source + 'return __p;\n';

  var render;
  try {
    render = new Function(settings.variable || 'obj', '_', source);
  } catch (e) {
    e.source = source;
    throw e;
  }

  var template = function(data) {
    return render.call(this, data, __WEBPACK_IMPORTED_MODULE_1__underscore_js__["a" /* default */]);
  };

  // Provide the compiled source as a convenience for precompilation.
  var argument = settings.variable || 'obj';
  template.source = 'function(' + argument + '){\n' + source + '}';

  return template;
}


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = result;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(24);



// Traverses the children of `obj` along `path`. If a child is a function, it
// is invoked with its parent as context. Returns the value of the final
// child, or `fallback` if any child is undefined.
function result(obj, path, fallback) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  var length = path.length;
  if (!length) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(fallback) ? fallback.call(obj) : fallback;
  }
  for (var i = 0; i < length; i++) {
    var prop = obj == null ? void 0 : obj[path[i]];
    if (prop === void 0) {
      prop = fallback;
      i = length; // Ensure we don't continue iterating.
    }
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(prop) ? prop.call(obj) : prop;
  }
  return obj;
}


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniqueId;
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter = 0;
function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);


// Start chaining a wrapped Underscore object.
function chain(obj) {
  var instance = Object(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */])(obj);
  instance._chain = true;
  return instance;
}


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatten_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bind_js__ = __webpack_require__(82);




// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  keys = Object(__WEBPACK_IMPORTED_MODULE_1__flatten_js__["a" /* default */])(keys, false, false);
  var index = keys.length;
  if (index < 1) throw new Error('bindAll must be passed function names');
  while (index--) {
    var key = keys[index];
    obj[key] = Object(__WEBPACK_IMPORTED_MODULE_2__bind_js__["a" /* default */])(obj[key], obj);
  }
  return obj;
}));


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(14);


// Memoize an expensive function by storing its results.
function memoize(func, hasher) {
  var memoize = function(key) {
    var cache = memoize.cache;
    var address = '' + (hasher ? hasher.apply(this, arguments) : key);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(cache, address)) cache[address] = func.apply(this, arguments);
    return cache[address];
  };
  memoize.cache = {};
  return memoize;
}


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__delay_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__underscore_js__ = __webpack_require__(9);




// Defers a function, scheduling it to run after the current call stack has
// cleared.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__delay_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__underscore_js__["a" /* default */], 1));


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__now_js__ = __webpack_require__(77);


// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function() {
    previous = options.leading === false ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */])();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function() {
    var _now = Object(__WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */])();
    if (!previous && options.leading === false) previous = _now;
    var remaining = wait - (_now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = _now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function() {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__delay_js__ = __webpack_require__(47);



// When a sequence of calls of the returned function ends, the argument
// function is triggered. The end of a sequence is defined by the `wait`
// parameter. If `immediate` is passed, the argument function will be
// triggered at the beginning of the sequence instead of at the end.
function debounce(func, wait, immediate) {
  var timeout, result;

  var later = function(context, args) {
    timeout = null;
    if (args) result = func.apply(context, args);
  };

  var debounced = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(args) {
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(later, wait);
      if (callNow) result = func.apply(this, args);
    } else {
      timeout = Object(__WEBPACK_IMPORTED_MODULE_1__delay_js__["a" /* default */])(later, wait, this, args);
    }

    return result;
  });

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
}


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(32);


// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap(func, wrapper) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(wrapper, func);
}


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function compose() {
  var args = arguments;
  var start = args.length - 1;
  return function() {
    var i = start;
    var result = args[start].apply(this, arguments);
    while (i--) result = args[i].call(this, result);
    return result;
  };
}


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = after;
// Returns a function that will only be executed on and after the Nth call.
function after(times, func) {
  return function() {
    if (--times < 1) {
      return func.apply(this, arguments);
    }
  };
}


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__before_js__ = __webpack_require__(83);



// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__before_js__["a" /* default */], 2));


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findLastIndex_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createIndexFinder_js__ = __webpack_require__(89);



// Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createIndexFinder_js__["a" /* default */])(-1, __WEBPACK_IMPORTED_MODULE_0__findLastIndex_js__["a" /* default */]));


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findWhere;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__find_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher_js__ = __webpack_require__(31);



// Convenience version of a common use case of `_.find`: getting the first
// object containing specific `key:value` pairs.
function findWhere(obj, attrs) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__find_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__matcher_js__["a" /* default */])(attrs));
}


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduce_js__ = __webpack_require__(91);


// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduce_js__["a" /* default */])(1));


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduce_js__ = __webpack_require__(91);


// The right-associative version of reduce, also known as `foldr`.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduce_js__["a" /* default */])(-1));


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__negate_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(7);




// Return all the elements for which a truth test fails.
function reject(obj, predicate, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__negate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(predicate)), context);
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = every;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(5);




// Determine whether all of the elements pass a truth test.
function every(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (!predicate(obj[currentKey], currentKey, obj)) return false;
  }
  return true;
}


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = some;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(5);




// Determine if at least one element in the object passes a truth test.
function some(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (predicate(obj[currentKey], currentKey, obj)) return true;
  }
  return false;
}


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepGet_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toPath_js__ = __webpack_require__(24);






// Invoke a method (with arguments) on every item in a collection.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, path, args) {
  var contextPath, func;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(path)) {
    func = path;
  } else {
    path = Object(__WEBPACK_IMPORTED_MODULE_4__toPath_js__["a" /* default */])(path);
    contextPath = path.slice(0, -1);
    path = path[path.length - 1];
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(obj, function(context) {
    var method = func;
    if (!method) {
      if (contextPath && contextPath.length) {
        context = Object(__WEBPACK_IMPORTED_MODULE_3__deepGet_js__["a" /* default */])(context, contextPath);
      }
      if (context == null) return void 0;
      method = context[path];
    }
    return method == null ? method : method.apply(context, args);
  });
}));


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = where;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher_js__ = __webpack_require__(31);



// Convenience version of a common use case of `_.filter`: selecting only
// objects containing specific `key:value` pairs.
function where(obj, attrs) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__matcher_js__["a" /* default */])(attrs));
}


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__each_js__ = __webpack_require__(17);





// Return the minimum element (or element-based computation).
function min(obj, iteratee, context) {
  var result = Infinity, lastComputed = Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj : Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value < result) {
        result = value;
      }
    }
  } else {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_3__each_js__["a" /* default */])(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed < lastComputed || computed === Infinity && result === Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sample_js__ = __webpack_require__(93);


// Shuffle a collection.
function shuffle(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__sample_js__["a" /* default */])(obj, Infinity);
}


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortBy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pluck_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(20);




// Sort the object's values by a criterion produced by an iteratee.
function sortBy(obj, iteratee, context) {
  var index = 0;
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  return Object(__WEBPACK_IMPORTED_MODULE_1__pluck_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(obj, function(value, key, list) {
    return {
      value: value,
      index: index++,
      criteria: iteratee(value, key, list)
    };
  }).sort(function(left, right) {
    var a = left.criteria;
    var b = right.criteria;
    if (a !== b) {
      if (a > b || a === void 0) return 1;
      if (a < b || b === void 0) return -1;
    }
    return left.index - right.index;
  }), 'value');
}


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(14);



// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(result, key)) result[key].push(value); else result[key] = [value];
}));


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(33);


// Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  result[key] = value;
}));


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(14);



// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(result, key)) result[key]++; else result[key] = 1;
}));


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(33);


// Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, pass) {
  result[pass ? 0 : 1].push(value);
}, true));


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__identity_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__values_js__ = __webpack_require__(18);








// Safely create a real, live array from anything iterable.
var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray(obj) {
  if (!obj) return [];
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(obj)) return __WEBPACK_IMPORTED_MODULE_1__setup_js__["q" /* slice */].call(obj);
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(obj)) {
    // Keep surrogate pair characters together.
    return obj.match(reStrSymbol);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__["a" /* default */])(obj)) return Object(__WEBPACK_IMPORTED_MODULE_4__map_js__["a" /* default */])(obj, __WEBPACK_IMPORTED_MODULE_5__identity_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_6__values_js__["a" /* default */])(obj);
}


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = size;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(5);



// Return the number of elements in a collection.
function size(obj) {
  if (obj == null) return 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj.length : Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj).length;
}


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyInObj;
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function keyInObj(value, key, obj) {
  return key in obj;
}


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__negate_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flatten_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pick_js__ = __webpack_require__(94);








// Return a copy of the object without the disallowed properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  var iteratee = keys[0], context;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(iteratee)) {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__negate_js__["a" /* default */])(iteratee);
    if (keys.length > 1) context = keys[1];
  } else {
    keys = Object(__WEBPACK_IMPORTED_MODULE_3__map_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__flatten_js__["a" /* default */])(keys, false, false), String);
    iteratee = function(value, key) {
      return !Object(__WEBPACK_IMPORTED_MODULE_5__contains_js__["a" /* default */])(keys, key);
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_6__pick_js__["a" /* default */])(obj, iteratee, context);
}));


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = first;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__initial_js__ = __webpack_require__(95);


// Get the first element of an array. Passing **n** will return the first N
// values in the array. The **guard** check allows it to work with `_.map`.
function first(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[0];
  return Object(__WEBPACK_IMPORTED_MODULE_0__initial_js__["a" /* default */])(array, array.length - n);
}


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = last;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_js__ = __webpack_require__(96);


// Get the last element of an array. Passing **n** will return the last N
// values in the array.
function last(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[array.length - 1];
  return Object(__WEBPACK_IMPORTED_MODULE_0__rest_js__["a" /* default */])(array, Math.max(0, array.length - n));
}


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compact;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(26);


// Trim out all falsy values from an array.
function compact(array) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(array, Boolean);
}


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flatten_js__ = __webpack_require__(19);


// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
function flatten(array, depth) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__flatten_js__["a" /* default */])(array, depth, false);
}


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__difference_js__ = __webpack_require__(97);



// Return a version of the array that does not contain the specified value(s).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(array, otherArrays) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__difference_js__["a" /* default */])(array, otherArrays);
}));


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uniq_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flatten_js__ = __webpack_require__(19);




// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(arrays) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__uniq_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__flatten_js__["a" /* default */])(arrays, true, true));
}));


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intersection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contains_js__ = __webpack_require__(27);



// Produce an array that contains every item shared between all the
// passed-in arrays.
function intersection(array) {
  var result = [];
  var argsLength = arguments.length;
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(array); i < length; i++) {
    var item = array[i];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__contains_js__["a" /* default */])(result, item)) continue;
    var j;
    for (j = 1; j < argsLength; j++) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__contains_js__["a" /* default */])(arguments[j], item)) break;
    }
    if (j === argsLength) result.push(item);
  }
  return result;
}


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unzip_js__ = __webpack_require__(99);



// Zip together multiple lists into a single array -- elements that share
// an index go together.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unzip_js__["a" /* default */]));


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = object;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(13);


// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values. Passing by pairs is the reverse of `_.pairs`.
function object(list, values) {
  var result = {};
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(list); i < length; i++) {
    if (values) {
      result[list[i]] = values[i];
    } else {
      result[list[i][0]] = list[i][1];
    }
  }
  return result;
}


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function range(start, stop, step) {
  if (stop == null) {
    stop = start || 0;
    start = 0;
  }
  if (!step) {
    step = stop < start ? -1 : 1;
  }

  var length = Math.max(Math.ceil((stop - start) / step), 0);
  var range = Array(length);

  for (var idx = 0; idx < length; idx++, start += step) {
    range[idx] = start;
  }

  return range;
}


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chunk;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(3);


// Chunk a single array into multiple arrays, each containing `count` or fewer
// items.
function chunk(array, count) {
  if (count == null || count < 1) return [];
  var result = [];
  var i = 0, length = array.length;
  while (i < length) {
    result.push(__WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, i, i += count));
  }
  return result;
}


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mixin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chainResult_js__ = __webpack_require__(100);






// Add your own custom functions to the Underscore object.
function mixin(obj) {
  Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__functions_js__["a" /* default */])(obj), function(name) {
    var func = __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */][name] = obj[name];
    __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
      var args = [this._wrapped];
      __WEBPACK_IMPORTED_MODULE_3__setup_js__["o" /* push */].apply(args, arguments);
      return Object(__WEBPACK_IMPORTED_MODULE_4__chainResult_js__["a" /* default */])(this, func.apply(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */], args));
    };
  });
  return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */];
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setup_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chainResult_js__ = __webpack_require__(100);





// Add all mutator `Array` functions to the wrapper.
Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
  var method = __WEBPACK_IMPORTED_MODULE_2__setup_js__["a" /* ArrayProto */][name];
  __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) {
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) {
        delete obj[0];
      }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__chainResult_js__["a" /* default */])(this, obj);
  };
});

// Add all accessor `Array` functions to the wrapper.
Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(['concat', 'join', 'slice'], function(name) {
  var method = __WEBPACK_IMPORTED_MODULE_2__setup_js__["a" /* ArrayProto */][name];
  __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) obj = method.apply(obj, arguments);
    return Object(__WEBPACK_IMPORTED_MODULE_3__chainResult_js__["a" /* default */])(this, obj);
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var TRUTHY_VALUES = ['true', '1', 'yes', 'enabled', 'enable', 'active', 1, true];

_.mixin({
    /**
     *
     * @param string
     * @returns {string}
     */
    capitalize: function capitalize(string) {
        return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
    },
    /**
     * https://github.com/kvz/phpjs/blob/master/functions/url/urlencode.js
     * @param url
     * @return {string} encoded url
     */
    urlencode: function urlencode(str) {
        str = (str + '').toString();
        // Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
        // PHP behavior, you would need to add '.replace(/~/g, '%7E');' to the following.
        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
    },
    checkIfTrue: function checkIfTrue(value) {
        return TRUTHY_VALUES.indexOf(value) >= 0;
    }

});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(4);

/**
 * Backbone does not have a native way to listen for a "Remove Event"
 * when any View is removed. If your View has some kind of Pooling or
 * Timer, it is handy to have a trigger stopping these processes
 * and preventing memory leaks.
 *
 * this plugin will dispatch a custom jQuery event when a DOM is removed
 * which we can listen on in our view
 *
 * i.e.
 *
 * var MainView = Backbone.View.extend({
*   initialize : function(){
*     _.bindAll(this);
*     this.$el.on('destroyed', this.removeHandler);
*   },
*   removeHandler : function(){
*     console.log('View has been destroyed, do we need to stop any Timer?');
*   }
* });
 *
 */
$.event.special.destroyed = {
    remove: function remove(o) {
        if (o.handler) {
            o.handler();
        }
    }
};

/**
 * jQuery plugin
 * Mobile Web - Disable long-touch/taphold text selection
 *
 * code snippet from https://stackoverflow.com/questions/11237936/mobile-web-disable-long-touch-taphold-text-selection
 * https://jsfiddle.net/ebEqu/1/
 * usage $('.notSelectable').disableSelection();
 *
 */
$.fn.extend({
    disableSelection: function disableSelection() {
        this.each(function () {
            this.onselectstart = function () {
                return false;
            };
            this.unselectable = 'on';
            $(this).css('-moz-user-select', 'none');
            $(this).css('-webkit-user-select', 'none');
        });
    }
});

/**
 * jQuery alterClass plugin
 *
 * Remove element classes with wildcard matching. Optionally add classes:
 *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
 *
 * https://gist.github.com/peteboere/1517285
 *
 * Copyright (c) 2011 Pete Boere (the-echoplex.net)
 * Free under terms of the MIT license: https://www.opensource.org/licenses/mit-license.php
 *
 */
$.fn.alterClass = function (removals, additions) {

    var self = this;

    if (removals.indexOf('*') === -1) {
        // Use native jQuery methods if there is no wildcard matching
        self.removeClass(removals);
        return !additions ? self : self.addClass(additions);
    }

    var patt = new RegExp('\\s' + removals.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') + '\\s', 'g');

    self.each(function (i, it) {
        var cn = ' ' + it.className + ' ';
        while (patt.test(cn)) {
            cn = cn.replace(patt, ' ');
        }
        it.className = $.trim(cn);
    });

    return !additions ? self : self.addClass(additions);
};

/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * https://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

$.fn.unveil = function (threshold, callback) {

    var $w = $(window),
        th = threshold || 0,
        retina = window.devicePixelRatio > 1,
        attrib = retina ? "data-src-retina" : "data-src",
        images = this,
        loaded;

    this.on("unveil", function () {
        var source = this.getAttribute(attrib);
        source = source || this.getAttribute("data-src");
        if (source) {
            this.setAttribute("src", source);
            if (typeof callback === "function") callback.call(this);
        }
    });

    function unveil() {
        var inview = images.filter(function () {
            var $e = $(this);
            if ($e.is(":hidden")) return;

            var wt = $w.scrollTop(),
                wb = wt + $w.height(),
                et = $e.offset().top,
                eb = et + $e.height();

            return eb >= wt - th && et <= wb + th;
        });

        loaded = inview.trigger("unveil");
        images = images.not(loaded);
    }

    $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

    unveil();

    return this;
};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(193);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(195)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../webpack/loaders/purifycss-custom-loader.js??ref--1-2!../../node_modules/postcss-loader/lib/index.js??postcss!../../node_modules/sass-loader/lib/loader.js!./main.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../webpack/loaders/purifycss-custom-loader.js??ref--1-2!../../node_modules/postcss-loader/lib/index.js??postcss!../../node_modules/sass-loader/lib/loader.js!./main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(194)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:MTV Gravity;src:url(https://content.votenow.tv/app/projects/mtva/fonts/woff/MTVGravityGrotesk-Bold.woff) format(\"woff\");font-weight:800;font-style:normal;font-display:swap}@font-face{font-family:MTV Gravity;src:url(https://content.votenow.tv/app/projects/mtva/fonts/woff/MTVGravityGrotesk-Book.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:MTV Gravity;src:url(https://content.votenow.tv/app/projects/mtva/fonts/woff/MTVGravityGrotesk-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}\n\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif}details,footer,header,main,menu,nav,section,summary{display:block}progress,video{display:inline-block;vertical-align:baseline}[hidden],template{display:none}a{background-color:transparent}b{font-weight:700}h1{font-size:2em;margin:.67em 0}img{border:0}svg:not(:root){overflow:hidden}code{font-family:monospace,monospace;font-size:1em}button,input,select{color:inherit;font:inherit}button{overflow:visible}button,select{text-transform:none}button[disabled],html input[disabled]{cursor:default}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}th{padding:0}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}html{font-size:10px}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857;color:#333;background-color:#fff}button,input,select{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7}a:focus,a:hover{color:#23527c;text-decoration:underline}img{vertical-align:middle;display:block}.img-thumbnail,img{max-width:100%;height:auto}.img-thumbnail{padding:4px;line-height:1.42857;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;display:inline-block}.img-circle{border-radius:50%}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.text-capitalize{text-transform:capitalize}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ul{margin-top:0;margin-bottom:10px}.list-inline{padding-left:0;list-style:none;margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dd{line-height:1.42857;margin-left:0}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.33333%}.col-sm-2{width:16.66667%}.col-sm-3{width:25%}.col-sm-4{width:33.33333%}.col-sm-5{width:41.66667%}.col-sm-6{width:50%}.col-sm-7{width:58.33333%}.col-sm-8{width:66.66667%}.col-sm-9{width:75%}.col-sm-10{width:83.33333%}.col-sm-11{width:91.66667%}.col-sm-12{width:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.33333%}.col-sm-push-2{left:16.66667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.33333%}.col-sm-push-5{left:41.66667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.33333%}.col-sm-push-8{left:66.66667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.33333%}.col-sm-push-11{left:91.66667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.33333%}.col-sm-offset-2{margin-left:16.66667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.33333%}.col-sm-offset-5{margin-left:41.66667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.33333%}.col-sm-offset-8{margin-left:66.66667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.33333%}.col-sm-offset-11{margin-left:91.66667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.33333%}.col-md-2{width:16.66667%}.col-md-3{width:25%}.col-md-4{width:33.33333%}.col-md-5{width:41.66667%}.col-md-6{width:50%}.col-md-7{width:58.33333%}.col-md-8{width:66.66667%}.col-md-9{width:75%}.col-md-10{width:83.33333%}.col-md-11{width:91.66667%}.col-md-12{width:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.33333%}.col-md-push-2{left:16.66667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.33333%}.col-md-push-5{left:41.66667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.33333%}.col-md-push-8{left:66.66667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.33333%}.col-md-push-11{left:91.66667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.33333%}.col-md-offset-2{margin-left:16.66667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.33333%}.col-md-offset-5{margin-left:41.66667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.33333%}.col-md-offset-8{margin-left:66.66667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.33333%}.col-md-offset-11{margin-left:91.66667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.33333%}.col-lg-2{width:16.66667%}.col-lg-3{width:25%}.col-lg-4{width:33.33333%}.col-lg-5{width:41.66667%}.col-lg-6{width:50%}.col-lg-7{width:58.33333%}.col-lg-8{width:66.66667%}.col-lg-9{width:75%}.col-lg-10{width:83.33333%}.col-lg-11{width:91.66667%}.col-lg-12{width:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.33333%}.col-lg-push-2{left:16.66667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.33333%}.col-lg-push-5{left:41.66667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.33333%}.col-lg-push-8{left:66.66667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.33333%}.col-lg-push-11{left:91.66667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.33333%}.col-lg-offset-2{margin-left:16.66667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.33333%}.col-lg-offset-5{margin-left:41.66667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.33333%}.col-lg-offset-8{margin-left:66.66667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.33333%}.col-lg-offset-11{margin-left:91.66667%}.col-lg-offset-12{margin-left:100%}}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}input[type=color],input[type=date],input[type=datetime-local],input[type=datetime],input[type=email],input[type=month],input[type=number],input[type=password],input[type=search],input[type=tel],input[type=text],input[type=time],input[type=url],input[type=week],select{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}input:focus[type=color],input:focus[type=date],input:focus[type=datetime-local],input:focus[type=datetime],input:focus[type=email],input:focus[type=month],input:focus[type=number],input:focus[type=password],input:focus[type=search],input:focus[type=tel],input:focus[type=text],input:focus[type=time],input:focus[type=url],input:focus[type=week],select:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}input[type=color]::-moz-placeholder,input[type=date]::-moz-placeholder,input[type=datetime-local]::-moz-placeholder,input[type=datetime]::-moz-placeholder,input[type=email]::-moz-placeholder,input[type=month]::-moz-placeholder,input[type=number]::-moz-placeholder,input[type=password]::-moz-placeholder,input[type=search]::-moz-placeholder,input[type=tel]::-moz-placeholder,input[type=text]::-moz-placeholder,input[type=time]::-moz-placeholder,input[type=url]::-moz-placeholder,input[type=week]::-moz-placeholder,select::-moz-placeholder{color:#999;opacity:1}input:-ms-input-placeholder[type=color],input:-ms-input-placeholder[type=date],input:-ms-input-placeholder[type=datetime-local],input:-ms-input-placeholder[type=datetime],input:-ms-input-placeholder[type=email],input:-ms-input-placeholder[type=month],input:-ms-input-placeholder[type=number],input:-ms-input-placeholder[type=password],input:-ms-input-placeholder[type=search],input:-ms-input-placeholder[type=tel],input:-ms-input-placeholder[type=text],input:-ms-input-placeholder[type=time],input:-ms-input-placeholder[type=url],input:-ms-input-placeholder[type=week],select:-ms-input-placeholder{color:#999}input[type=color]::-webkit-input-placeholder,input[type=date]::-webkit-input-placeholder,input[type=datetime-local]::-webkit-input-placeholder,input[type=datetime]::-webkit-input-placeholder,input[type=email]::-webkit-input-placeholder,input[type=month]::-webkit-input-placeholder,input[type=number]::-webkit-input-placeholder,input[type=password]::-webkit-input-placeholder,input[type=search]::-webkit-input-placeholder,input[type=tel]::-webkit-input-placeholder,input[type=text]::-webkit-input-placeholder,input[type=time]::-webkit-input-placeholder,input[type=url]::-webkit-input-placeholder,input[type=week]::-webkit-input-placeholder,select::-webkit-input-placeholder{color:#999}input[type=color]::-ms-expand,input[type=date]::-ms-expand,input[type=datetime-local]::-ms-expand,input[type=datetime]::-ms-expand,input[type=email]::-ms-expand,input[type=month]::-ms-expand,input[type=number]::-ms-expand,input[type=password]::-ms-expand,input[type=search]::-ms-expand,input[type=tel]::-ms-expand,input[type=text]::-ms-expand,input[type=time]::-ms-expand,input[type=url]::-ms-expand,input[type=week]::-ms-expand,select::-ms-expand{border:0;background-color:transparent}input[disabled][type=color],input[disabled][type=date],input[disabled][type=datetime-local],input[disabled][type=datetime],input[disabled][type=email],input[disabled][type=month],input[disabled][type=number],input[disabled][type=password],input[disabled][type=search],input[disabled][type=tel],input[disabled][type=text],input[disabled][type=time],input[disabled][type=url],input[disabled][type=week],input[readonly][type=color],input[readonly][type=date],input[readonly][type=datetime-local],input[readonly][type=datetime],input[readonly][type=email],input[readonly][type=month],input[readonly][type=number],input[readonly][type=password],input[readonly][type=search],input[readonly][type=tel],input[readonly][type=text],input[readonly][type=time],input[readonly][type=url],input[readonly][type=week],select[disabled],select[readonly]{background-color:#eee;opacity:1}input[disabled][type=color],input[disabled][type=date],input[disabled][type=datetime-local],input[disabled][type=datetime],input[disabled][type=email],input[disabled][type=month],input[disabled][type=number],input[disabled][type=password],input[disabled][type=search],input[disabled][type=tel],input[disabled][type=text],input[disabled][type=time],input[disabled][type=url],input[disabled][type=week],select[disabled]{cursor:not-allowed}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date],input[type=datetime-local],input[type=month],input[type=time]{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox{margin-top:-5px}.checkbox-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm{height:auto}.form-group-sm input[type=color],.form-group-sm input[type=date],.form-group-sm input[type=datetime-local],.form-group-sm input[type=datetime],.form-group-sm input[type=email],.form-group-sm input[type=month],.form-group-sm input[type=number],.form-group-sm input[type=password],.form-group-sm input[type=search],.form-group-sm input[type=tel],.form-group-sm input[type=text],.form-group-sm input[type=time],.form-group-sm input[type=url],.form-group-sm input[type=week],.form-group-sm select{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select{height:30px;line-height:30px}.form-group-sm select[multiple]{height:auto}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg{height:auto}.form-group-lg input[type=color],.form-group-lg input[type=date],.form-group-lg input[type=datetime-local],.form-group-lg input[type=datetime],.form-group-lg input[type=email],.form-group-lg input[type=month],.form-group-lg input[type=number],.form-group-lg input[type=password],.form-group-lg input[type=search],.form-group-lg input[type=tel],.form-group-lg input[type=text],.form-group-lg input[type=time],.form-group-lg input[type=url],.form-group-lg input[type=week],.form-group-lg select{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.form-group-lg select{height:46px;line-height:46px}.form-group-lg select[multiple]{height:auto}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label{color:#3c763d}.has-success input[type=color],.has-success input[type=date],.has-success input[type=datetime-local],.has-success input[type=datetime],.has-success input[type=email],.has-success input[type=month],.has-success input[type=number],.has-success input[type=password],.has-success input[type=search],.has-success input[type=tel],.has-success input[type=text],.has-success input[type=time],.has-success input[type=url],.has-success input[type=week],.has-success select{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success input:focus[type=color],.has-success input:focus[type=date],.has-success input:focus[type=datetime-local],.has-success input:focus[type=datetime],.has-success input:focus[type=email],.has-success input:focus[type=month],.has-success input:focus[type=number],.has-success input:focus[type=password],.has-success input:focus[type=search],.has-success input:focus[type=tel],.has-success input:focus[type=text],.has-success input:focus[type=time],.has-success input:focus[type=url],.has-success input:focus[type=week],.has-success select:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label{color:#a94442}.has-error input[type=color],.has-error input[type=date],.has-error input[type=datetime-local],.has-error input[type=datetime],.has-error input[type=email],.has-error input[type=month],.has-error input[type=number],.has-error input[type=password],.has-error input[type=search],.has-error input[type=tel],.has-error input[type=text],.has-error input[type=time],.has-error input[type=url],.has-error input[type=week],.has-error select{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error input:focus[type=color],.has-error input:focus[type=date],.has-error input:focus[type=datetime-local],.has-error input:focus[type=datetime],.has-error input:focus[type=email],.has-error input:focus[type=month],.has-error input:focus[type=number],.has-error input:focus[type=password],.has-error input:focus[type=search],.has-error input:focus[type=tel],.has-error input:focus[type=text],.has-error input:focus[type=time],.has-error input:focus[type=url],.has-error input:focus[type=week],.has-error select:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline input[type=color],.form-inline input[type=date],.form-inline input[type=datetime-local],.form-inline input[type=datetime],.form-inline input[type=email],.form-inline input[type=month],.form-inline input[type=number],.form-inline input[type=password],.form-inline input[type=search],.form-inline input[type=tel],.form-inline input[type=text],.form-inline input[type=time],.form-inline input[type=url],.form-inline input[type=week],.form-inline select{display:inline-block;width:auto;vertical-align:middle}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .input-group-btn,.form-inline .input-group input[type=color],.form-inline .input-group input[type=date],.form-inline .input-group input[type=datetime-local],.form-inline .input-group input[type=datetime],.form-inline .input-group input[type=email],.form-inline .input-group input[type=month],.form-inline .input-group input[type=number],.form-inline .input-group input[type=password],.form-inline .input-group input[type=search],.form-inline .input-group input[type=tel],.form-inline .input-group input[type=text],.form-inline .input-group input[type=time],.form-inline .input-group input[type=url],.form-inline .input-group input[type=week],.form-inline .input-group select{width:auto}.form-inline .input-group>input[type=color],.form-inline .input-group>input[type=date],.form-inline .input-group>input[type=datetime-local],.form-inline .input-group>input[type=datetime],.form-inline .input-group>input[type=email],.form-inline .input-group>input[type=month],.form-inline .input-group>input[type=number],.form-inline .input-group>input[type=password],.form-inline .input-group>input[type=search],.form-inline .input-group>input[type=tel],.form-inline .input-group>input[type=text],.form-inline .input-group>input[type=time],.form-inline .input-group>input[type=url],.form-inline .input-group>input[type=week],.form-inline .input-group>select{width:100%}.form-inline .checkbox{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label{padding-left:0}.form-inline .checkbox input[type=checkbox]{position:relative;margin-left:0}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled]{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);-webkit-box-shadow:none;box-shadow:none}a.btn.disabled{pointer-events:none}.btn,.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus,.btn:focus,.focus.btn{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.active.btn,.btn-default.active,.btn-default:active,.btn-default:hover,.btn:active,.btn:hover{color:#333;background-color:#e6e6e6;border-color:#adadad}.active.btn:focus,.active.btn:hover,.active.focus.btn,.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.btn:active.focus,.btn:active:focus,.btn:active:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.active.btn,.btn-default.active,.btn-default:active,.btn:active{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,.btn[disabled].focus,.btn[disabled]:focus,.btn[disabled]:hover,.disabled.btn:focus,.disabled.btn:hover,.disabled.focus.btn{background-color:#fff;border-color:#ccc}.btn-default .badge,.btn .badge{color:#fff;background-color:#333}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled]{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover{color:#777;text-decoration:none}.btn-lg{padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right{padding-left:10px}.media-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-bottom{vertical-align:bottom}.media-list{padding-left:0;list-style:none}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.view-sweeps #vma-sweepstakes:after,.view-sweeps #vma-sweepstakes:before{content:\" \";display:table}.view-sweeps #vma-sweepstakes:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.hide{display:none!important}.show{display:block!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}@-ms-viewport{width:device-width}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}@media print{.hidden-print{display:none!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"https://assets-us.votenow.tv/fontsglyphicons-halflings-regular.eot\");src:url(\"https://assets-us.votenow.tv/fontsglyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://assets-us.votenow.tv/fontsglyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"https://assets-us.votenow.tv/fontsglyphicons-halflings-regular.woff\") format(\"woff\"),url(\"https://assets-us.votenow.tv/fontsglyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"https://assets-us.votenow.tv/fontsglyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon-modal-window:before{content:\"\\E237\"}a,a:active,a:focus,a:hover,button,button:active,button:focus{text-decoration:none;outline:none;border:none;-webkit-transition:.3s ease;-o-transition:.3s ease;transition:.3s ease}*,body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body{background:#f8f8f8;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;font-family:MTV Gravity;font-size:16px;line-height:1;position:inherit;z-index:2;z-index:10003}body *{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body>div{display:initial}h1,h2,h3,h4,h5,h6{font-family:MTV Gravity;font-weight:400;color:#f8f8f8}[class*=btn-] [class*=icon-]{float:none}.btn{-webkit-box-shadow:none;box-shadow:none;height:auto;text-shadow:none}.view-home.touch .contestant .edit-container button:hover{opacity:1}.view-home.touch .contestant .edit-container button[disabled]{opacity:.2}@font-face{font-family:mtv;src:url(\"https://www.mtv.com/sitewide/fonts/mtv_v4.eot\")}@font-face{font-family:mtv;src:url(data:application/x-font-ttf;charset=utf-8;base64,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) format(\"truetype\"),url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\");font-weight:400;font-style:normal}[class*=\" icon-\"],[class^=icon-]{font-family:mtv;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-feature-settings:\"liga\";-ms-font-feature-settings:\"liga\" 1;-o-font-feature-settings:\"liga\";font-feature-settings:\"liga\";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-zoom-in:before{content:\"\\E600\"}.icon-zoom-out:before{content:\"\\E601\"}.icon-chevron-up:before{content:\"\\E619\"}.icon-chevron-left:before{content:\"\\E613\"}.icon-chevron-right:before{content:\"\\E614\"}.icon-logo-mtv:before{content:\"\\E627\"}.icon-logo-mtv2:before{content:\"\\E61F\"}.icon-logo-viacom:before{content:\"\\E62A\"}.icon-refresh-update:before{content:\"\\E63A\"}.icon-search:before{content:\"\\E63B\"}.icon-settings:before{content:\"\\E63C\"}.icon-share-facebook:before{content:\"\\E63E\"}.icon-share-google-plus:before{content:\"\\E63F\"}.icon-share-instagram:before{content:\"\\E640\"}.icon-share-sharing:before{content:\"\\E63\"}.icon-share-twitter:before{content:\"\\E645\"}.icon-size-extend:before{content:\"\\E64A\"}.icon-size-full-size:before{content:\"\\E64B\"}.icon-tag:before{content:\"\\E64F\"}.icon-user-multiple:before{content:\"\\E65C\"}.icon-user:before{content:\"\\E65D\"}.icon-validation:before{content:\"\\E65E\"}\n\n/*!\n * Bootstrap v2.2.2\n *\n * Copyright 2012 Twitter, Inc\n * Licensed under the Apache License v2.0\n * https://www.apache.org/licenses/LICENSE-2.0\n *\n * Designed and built with all the love in the world @twitter by @mdo and @fat.\n */details,footer,header,nav,section{display:block}video{display:inline-block;*display:inline;*zoom:1}html{background-color:#3f2066;font-size:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}a:focus{outline:thin dotted #333;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}a:active,a:hover{outline:0}sub{position:relative;font-size:75%;line-height:0;vertical-align:baseline;bottom:-.25em}button,input,select{margin:0;font-size:100%;vertical-align:middle}button,input{*overflow:visible;line-height:normal}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;-moz-appearance:button;appearance:button;cursor:pointer}button,input[type=button],input[type=checkbox],input[type=radio],input[type=reset],input[type=submit],label,select{cursor:pointer}input[type=search]{-webkit-box-sizing:content-box;box-sizing:content-box;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}@media print{*{text-shadow:none!important;color:#000!important;background:transparent!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}img{page-break-inside:avoid;max-width:100%!important}@page{margin:.5cm}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}body{padding-top:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#mtv-vote+footer,.page-content,.sub-navbar,body{position:relative}.page-content{z-index:1}.sub-navbar{z-index:2}html{-webkit-tap-highlight-color:rgba(0,0,0,0)}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}section{padding-top:15px;display:block}.container{min-width:320px;max-width:1200px;width:100%;margin:0 auto;padding:0 13px}.container:after,.container:before,.row:after,.row:before,.view-sweeps #vma-sweepstakes:after,.view-sweeps #vma-sweepstakes:before,[class*=col-]>div:after,[class*=col-]>div:before{content:\"\";display:table}.container:after,.row:after,.view-sweeps #vma-sweepstakes:after,.view-sweeps #vma-sweepstakes:before,[class*=col-]>div:after{clear:both}.row{margin-left:-13px;margin-right:-13px}[class*=col-]{position:relative;float:left;min-height:1px;padding-left:13px;padding-right:13px}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:0}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}html{font-size:62.5%}body{font-size:1.6rem;color:#191919}p{margin:15px 0 0}p:first-child{margin-top:0}a{font-family:MTV Gravity;text-decoration:none;cursor:pointer}a,a:hover{color:#000}p a{font-weight:400;color:#00bbef}p a:hover{text-transform:underline}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}h1,h2,h3,h4,h5,h6{margin:0;font-family:inherit;font-size:inherit;color:inherit;text-rendering:optimizelegibility;font-weight:inherit}ul{padding:0;margin:0 0 15px}ul ul{margin-bottom:0}li{line-height:normal}ul.inline{margin-left:0;list-style:none}ul.inline>li{margin-top:0;display:inline-block}dd{line-height:1.25;margin-left:10px}q:after,q:before{content:\"\"}footer:after,footer:before{content:\"\";display:table}footer [class*=col-]{margin-bottom:0}#mtv-vote+footer{z-index:3;color:#fff;font-size:85%;padding:54px 0 64px;background-color:#3f2066}footer a{color:#fff;font-size:14px;font-family:MTV Gravity;text-transform:uppercase}footer a:active{color:#deb93b}footer a:focus{color:#fff}footer a:hover{color:#deb93b!important}footer #legal ul li{padding:0 12px;margin-bottom:15px}footer #legal ul li:last-child{border-right:none}footer #social{margin:15px 0 10px;padding-bottom:15px}footer #social ul{margin:0}footer #social ul li{padding:0 18px;vertical-align:middle}footer #social ul li img{width:24px;height:24px}footer .icon-svg{height:24px;fill:#fff}footer a:hover .icon-svg,footer a:hover .icon-svg.icon-tiktok-svg .tiktokmain{fill:#deb93b}footer #social ul li .icon-footer-twitter img{width:30px}.icon-svg.icon-tiktok-svg{height:29px;margin:0 -5px}.icon-svg.icon-youtube-svg{height:39px;margin:0 -7px}footer .viacom-wrapper{margin-bottom:18px}footer .icon-logo-viacom{color:#fff;display:inline;font-size:60px;vertical-align:middle;margin:0 5px 0 0;line-height:14px}footer #copyright{font-family:MTV Gravity;font-size:14px;line-height:18px;color:#fff}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}a:hover{text-decoration:none}ul{list-style:none;margin:0}a.disabled-video,a.disabled-video:hover{cursor:none}.container,section{min-width:960px}.page-content .banner-container{padding:5px 0;background-color:#f2f2f2;border-bottom:1px solid #e1e1e1;border-top:1px solid #e1e1e1;margin-bottom:20px;margin-top:20px;min-height:0;width:100%;text-align:center;z-index:100;line-height:0}.ad-block{width:200px;height:400px;display:none}.row .video-list .ad{text-align:center}section#sec-ad-container{padding-bottom:0}.ad-container{text-align:center}.ad-container div{margin-left:auto;margin-right:auto}.video-block .message{font-size:22px;line-height:24px;font-weight:700;display:table;width:100%;height:100%}@media (min-width:1200px){.container{max-width:1200px}}body{font-size:1.7rem;line-height:1.4}[class*=btn-]{font-family:MTV Gravity}[class*=display-]{font-weight:800}[class*=section-header-]{text-transform:lowercase}.icon-logo-viacom{font-size:70px;display:none!important}.top-ad.ad-container{background-color:#1f0f33;display:block;text-align:center}.page-initialized{height:100%}@media (max-width:979px){.container{padding:0 10px}.row{margin-left:-10px;margin-right:-10px}[class*=col-]{padding-left:10px;padding-right:10px}[class*=col-lg]{width:100%;position:relative}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:0}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:660px) and (max-width:979px){body{margin-top:0}.ad-block{text-align:center;width:48.61878453038674%;*width:48.56559304102504%;height:auto;display:inline-block;margin-left:2.7624309392265194%;*margin-left:2.709239449864817%}.ad-block .ad-container{margin:10px 0 20px 10px}}@media (max-width:979px){.container,section{min-width:0}body{margin-top:0;padding-top:0}}@media (min-width:729px){footer a:hover{color:#ff0}}@media (max-width:979px) and (min-width:660px){div#page_root .hidden-lg{display:inline}div#page_root .hidden-md{display:none}.hidden-lg,.hidden-sm{display:block!important}.hidden-md{display:none!important}}@media (max-width:659px){body{padding:0;margin-top:0}.container{padding:0 10px}.sub-header{height:auto;overflow:hidden;padding-top:0}.filter-menu{padding-left:0}.message .headline-l{font-size:23px}.row .ad>div{margin:5px auto;min-width:300px;line-height:0;text-align:center}.row .ad>div[data-ad=\"300x50,320x50\"]{margin:5px 0 5px -10px}.show-metadata-container .row [class*=span]:first-child>.ad-container{margin-bottom:35px;margin-top:-20px}footer .legal li{float:left;margin:5px 0;width:45%}footer .legal{margin-bottom:5px}.row .video-list .ad{background-color:#f2f2f2;border-top:1px solid #e1e1e1;border-bottom:1px solid #e1e1e1;margin-top:20px;margin-bottom:40px;min-height:0}}@media (max-width:480px){.nav-collapse{-webkit-transform:translateZ(0);transform:translateZ(0)}input[type=checkbox],input[type=radio]{border:1px solid #ccc}}@media (max-width:659px){[class*=col-md]{width:100%;position:relative}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:0}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}body{margin:0}body>.modal{overflow:hidden;width:100%;position:fixed;top:0;right:0;bottom:0;left:0;z-index:5999999;background-color:transparent;-webkit-transform:translateZ(0);transform:translateZ(0)}@-webkit-keyframes uil-ring-anim{0%{-ms-transform:rotate(0deg);-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-ms-transform:rotate(1turn);-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes uil-ring-anim{0%{-ms-transform:rotate(0deg);-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-ms-transform:rotate(1turn);-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.uil-ring-css{background:none;position:relative;width:200px;height:200px;margin:0 auto}.uil-ring-css>div{position:absolute;display:block;width:160px;height:160px;top:20px;left:20px;border-radius:80px;-webkit-box-shadow:0 6px 0 0 #888;box-shadow:0 6px 0 0 #888;-webkit-animation:uil-ring-anim 1s linear infinite;animation:uil-ring-anim 1s linear infinite}#header{background-color:#3f2066;width:100%;font-weight:800;font-size:0}#header .nav-header,#header .navbar{width:100%;margin:0 auto}#header .nav-header{background:#3f2066;height:44px;padding:0 20px}#header .nav-header .mtv-logo{background-image:url(\"https://content.votenow.tv/app/projects/mtv/mtva-2023/images/mobile-logo.svg\");background-repeat:no-repeat;background-size:100%;width:167px;height:30px}#header .wrapper{height:100%;margin:0 auto;position:relative}#header .wrapper.logo{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}#header .nav-header .logo .icon-menu-wrapper,#header .nav-header .logo a{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;cursor:pointer}#header .nav-header .logo a{border:none;position:absolute;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%)}#header .nav-header .icon-logo-mtv:before{content:\"\\E627\"}#header a{text-decoration:none;text-transform:uppercase;font-family:MTV Gravity}#header ul li:hover{border-bottom:2px solid #fff}#header ul li:hover a{color:#fff}#header{position:-webkit-sticky;position:sticky;top:0;z-index:5}#header .navbar{background:#3f2066;font-size:18px;overflow:hidden;font-size:12px;line-height:15px}#header .navbar .wrapper{height:0}#header .icon-menu{width:20px;height:14px}#header .icon-x{display:none;width:20px;height:16px;padding:0 2px}body.menu-open{overflow:hidden}#header.open .navbar{overflow:visible}#header.open .navbar .wrapper{background-color:#000;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;height:100vh}#header.open .icon-menu{display:none}#header.open .icon-x{display:block}#header .nav-collapse{overflow:hidden;text-align:center;width:100%}#header ul{list-style:none;margin:0;padding:0}#header ul li{border-bottom:2px solid #00000020;cursor:pointer;text-align:left}#header ul li a{color:#fff;display:block;font-size:20px;font-weight:800;line-height:25px;padding:22px 20px}#header ul li a:hover{color:#fff}#header a:active,#header a:focus{outline:none}#header .social-items{position:absolute;right:0;padding-right:10px}#header li.social{padding:0 6px;position:relative}#header li.social:before{color:#f9f9f9;position:absolute;font-size:18px}#header .social-items{padding:11px 18px 10px 0}#header .social-items a{color:#e70c1e;background:#fff;-moz-border:1px solid transparent;-webkit-border:1px solid transparent;border:1px solid transparent;border-radius:50%;padding:7px;position:relative;vertical-align:top;cursor:pointer;font-size:12px;line-height:12px;width:32px;height:32px;display:inline-block}#header .social-items a.facebook,#header .social-items a.twitter{margin-right:10px}#header .social-items a.facebook:before{content:\"\\F104\";top:50%;left:65%;font-weight:800}#header .social-items a.facebook:before,#header .social-items a.twitter:before{position:absolute;-ms-transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);display:inline-block;font-family:fontcustom;font-style:normal;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none}#header .social-items a.twitter:before{content:\"\\F105\";top:56%;left:53%;font-weight:400}#header .social-items a.instagram:before{content:\"\\E640\";position:absolute;top:51%;left:51%;-ms-transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);display:inline-block;font-family:mtv;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none}#header .social-items a:before{font-size:19px}#header .social-items a:hover{background-color:hsla(0,0%,98%,.85)}#header .social-items a:hover:before{color:#c43131}@media (min-width:900px){#header.sticky{position:-webkit-sticky;position:sticky;top:-200px;z-index:5}#header.sticky .wrapper.logo{position:absolute;top:200px;left:48px;height:auto}#header.sticky .wrapper.logo a .mtv-logo{background-image:url(\"https://content.votenow.tv/app/projects/mtv/mtva-2023/images/mobile-logo.svg\");width:167px;height:30px}#header a{font-family:MTV Gravity}#header ul li a{text-transform:uppercase}#header ul li:hover{border-bottom:2px solid #f3f3f3}#header ul li:hover a{color:#f3f3f3}#header .wrapper.logo{-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}#header .nav-header{-webkit-transition:height .3s;-o-transition:height .3s;transition:height .3s;height:200px;padding:0 45px}#header .nav-header .mtv-logo{background-image:url(\"https://content.votenow.tv/app/projects/mtv/mtva-2023/images/desktop-logo.svg\");width:233px;height:150px;margin-top:20px}#header .nav-header .logo a{position:static;-webkit-transform:none;-ms-transform:none;transform:none}#header .nav-header .logo .icon-menu-wrapper{display:none}#header .navbar{height:71px;padding-top:27px}#header.open .navbar .wrapper{height:0}#header ul li{border:none;display:inline-block}#header ul li a{color:#f3f3f3;font-size:12px;line-height:15px;padding:0 20px 27px}#header ul li:hover{border-bottom:2px solid #fff}#header ul li:hover a{color:#fff}}@media (max-width:931px){#header .social-items{position:relative;left:0;display:block}#header.open .navbar .nav-collapse{position:absolute;width:100%;z-index:100}#header ul li.menu{display:block;text-transform:lowercase}#header .social-items a.facebook{margin-left:13px;-moz-border-bottom:none;-webkit-border-bottom:none;border-bottom:none}#header .social-items a:active{border:1px solid #1d1d3b}}@-webkit-keyframes loading_dots{0%{background:hsla(0,0%,100%,.3)}50%{background:#fff;-webkit-transform:scaleX(.8) scaleY(.8) scaleZ(.8);transform:scaleX(.8) scaleY(.8) scaleZ(.8)}to{background:hsla(0,0%,100%,.3)}}@keyframes loading_dots{0%{background:hsla(0,0%,100%,.3)}50%{background:#fff;-webkit-transform:scaleX(.8) scaleY(.8) scaleZ(.8);transform:scaleX(.8) scaleY(.8) scaleZ(.8)}to{background:hsla(0,0%,100%,.3)}}.no-scroll{height:100%;overflow:hidden;position:fixed;width:100%}.fade-in{opacity:1;-webkit-animation-name:fadeInOpacity;animation-name:fadeInOpacity;-webkit-animation-iteration-count:1;animation-iteration-count:1;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;-webkit-animation-duration:.2s;animation-duration:.2s}.fade-out{opacity:1;-webkit-animation-name:fadeOutOpacity;animation-name:fadeOutOpacity;-webkit-animation-iteration-count:1;animation-iteration-count:1;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;-webkit-animation-duration:.2s;animation-duration:.2s}@-webkit-keyframes fadeInOpacity{0%{opacity:0}to{opacity:1}}@keyframes fadeInOpacity{0%{opacity:0}to{opacity:1}}@-webkit-keyframes fadeOutOpacity{0%{opacity:1}to{opacity:0}}@keyframes fadeOutOpacity{0%{opacity:1}to{opacity:0}}.modal:empty{display:none!important}.modal-window{background-color:rgba(0,0,0,.8);position:absolute;top:0;right:0;bottom:0;left:0;z-index:1000000;overflow-y:auto;overflow-y:overlay;min-height:100%;min-width:100%}.modal-window::-webkit-scrollbar{-webkit-appearance:none;appearance:none}.modal-window::-webkit-scrollbar-track{background-color:transparent}.modal-window::-webkit-scrollbar-thumb,.modal-window::-webkit-scrollbar-thumb:window-inactive{background:transparent}.modal-wrapper{display:table;height:100%;width:100%}.modal-layout{display:table-cell;text-align:center;vertical-align:middle}.modal-content{color:#fff;position:relative;padding:30px;background-color:#11091b;margin:auto;max-width:502px;top:auto;left:auto;width:90%;outline:2px solid #11091b}.modal-content h1{font-family:MTV Gravity;font-weight:800;font-size:20px;line-height:25px;margin:0 0 12px;text-transform:none}.modal-content p{font-family:MTV Gravity;font-size:16px;line-height:24px;margin-bottom:24px}.modal-content button.btn-close,.modal-content button.btn-poll,.modal-content button[type=submit]{background-color:#deb93b;text-transform:uppercase;color:#1f0f33;font-weight:800;font-size:14px;line-height:18px;height:43px;width:100%}.modal-content button.btn-close:hover,.modal-content button.btn-poll:hover,.modal-content button[type=submit]:hover{background-color:#f8efd3;color:#1f0f33}.modal-content .close{color:#fff;cursor:pointer;max-width:24px;position:absolute;top:18px;right:18px}.modal-content.style-auth{position:static}.modal-content.style-sweeps,.modal-content.style-thanks{max-width:466px;position:static}.modal-content.style-sweeps .close-wrapper,.modal-content.style-thanks .close-wrapper{display:inline-block;margin-bottom:24px;padding-bottom:3px;width:100%;background-color:#deb93b;outline:1px solid #000}.modal-content.style-sweeps a.mtv-close,.modal-content.style-thanks a.mtv-close{color:#1f0f33;text-transform:uppercase;font-weight:800;font-size:16px;line-height:43px;text-decoration:none;display:block;width:100%;height:100%;border:1px solid #deb93b;-webkit-transform:translateZ(0);transform:translateZ(0)}.modal-content.style-video{background-color:transparent;padding:49px 0 0;position:static;width:calc(100% - 100px);outline:none}@media (min-width:660px){.modal-content{padding:54px;width:100%}.modal-content .close{top:24px;right:24px}.modal-content h1{font-size:24px;line-height:30px}.modal-content.style-auth,.modal-content.style-sweeps,.modal-content.style-thanks{position:relative}.modal-content.style-sweeps,.modal-content.style-thanks{padding:36px;padding-top:54px}.modal-content.style-video{max-width:812px;padding:0;position:relative;width:calc(100% - 180px)}}.sponsor{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.sponsor span{color:#f3f3f3;font-size:12px;line-height:15px;margin-bottom:6px;text-transform:uppercase}.sponsor img{max-width:90px}.view-share{margin-bottom:24px}.view-share p{font-size:12px;line-height:18px}.view-share a{border-radius:50%;color:#f8f8f8;display:inline-block;margin-right:18px;vertical-align:middle}.view-share a:hover{color:#f8f8f8}.view-share a:last-child{margin-right:0}.view-share a div{border-radius:50%;width:42px;height:42px;position:relative;font-size:18px}.view-share a.email div{background-color:#3b3b3b;line-height:48px}.view-share a.facebook div{background-color:#1877f2;line-height:42px;padding-left:9px}.view-share a.twitter div{background:#1da1f2;line-height:46px;padding-left:1px}.view-share a.whatsapp{display:none}.view-share a.whatsapp div{background:#25d367;line-height:46px;padding-left:2px}.no-touch .view-share .whatsapp{display:none}.view-header.extended .vote-cta{min-height:375px;position:relative}.vote-cta{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.section-2-header,.vote-cta{background-color:#3f2066;text-align:center;width:100%;text-transform:uppercase}.section-2-header .text-wrapper,.vote-cta .text-wrapper{padding:36px 20px}.section-2-header .description,.section-2-header .headline,.section-2-header .subheadline,.vote-cta .description,.vote-cta .headline,.vote-cta .subheadline{color:#fff}.section-2-header .headline,.vote-cta .headline{font-weight:800;font-family:MTV Gravity;font-size:30px;text-transform:uppercase;margin:0 0 18px}.section-2-header .subheadline,.vote-cta .subheadline{font-family:MTV Gravity;font-size:20px;font-weight:800;text-transform:uppercase;line-height:23px;margin:0 0 12px}.section-2-header .description,.vote-cta .description{font-family:MTV Gravity;font-weight:400;font-size:16px;line-height:24px;margin:0 auto;max-width:615px;text-transform:none}.section-2-header .sponsor,.vote-cta .sponsor{margin-top:24px}.section-2-header .sponsor span,.vote-cta .sponsor span{color:#fff}.turbo-wrapper{background-color:#f3371d;padding:30px 0;text-align:center}.turbo-wrapper .headline{color:#1f0f33;font-family:MTV Gravity;font-size:28px;font-weight:800;letter-spacing:normal;text-transform:uppercase;margin:0 0 12px}.turbo-wrapper .description{color:#1f0f33;font-family:MTV Gravity;font-size:16px;line-height:21px;margin:0;padding:0 10px}@media (min-width:660px){.view-header.extended .vote-cta{min-height:493px}.section-2-header .text-wrapper,.vote-cta .text-wrapper{padding:42px 20px}.section-2-header .headline,.vote-cta .headline{font-size:42px;margin:0 0 24px}.section-2-header .subheadline,.vote-cta .subheadline{font-size:16px;line-height:22px}.section-2-header .description,.vote-cta .description{font-size:16px;padding:0}}.category-button{background-color:#1f0f33;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;padding:24px 0;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-transition:.3s ease;-o-transition:.3s ease;transition:.3s ease;z-index:1;-webkit-transform:translateZ(0)}.category-button,.category-button .wrapper{overflow:hidden;position:relative;text-transform:uppercase}.category-button .wrapper{max-width:1200px;margin:0 auto;width:100%;display:block;text-align:center;padding:0 40px;opacity:.4}.category-button .wrapper:hover{opacity:1}.category-button .cat-title{color:#f3f3f3;font-family:MTV Gravity;font-size:16px;letter-spacing:normal;position:relative;text-align:center;word-wrap:break-word;font-weight:800;display:inline}.category-button .chev-icon{position:absolute;right:-22px;top:6px;-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}.category-button .cat-title .chev-icon{width:10px;height:10px;display:inline-block;background-color:#f3f3f3;-webkit-mask-size:10px 10px;mask-size:10px 10px;-webkit-mask-image:url(\"https://content.votenow.tv/app/projects/cmt/2023/assets/chev-down.svg\");mask-image:url(\"https://content.votenow.tv/app/projects/cmt/2023/assets/chev-down.svg\")}.category-button .votes-closed,.category-button .votes-live-vote,.category-button .votes-remaining-wrapper,.category-button .votes-social{color:#fff;font-family:MTV Gravity;text-transform:uppercase;font-weight:800;font-size:14px;line-height:18px;text-align:center}.category-button .votes-submitted{font-family:MTV Gravity;font-size:14px;color:#fff}.category-button.locked{cursor:default}.category-button.locked .chev-icon{display:none}.live-vote{text-align:center;margin-bottom:30px}.live-vote a{display:inline-block;background:#009cf5;color:#fff;width:auto;font-size:14px;padding:10px;text-align:center;line-height:14px;font-family:MTV Gravity}.live-vote a img{display:inline;height:16px;margin-right:5px}.category-button.active,.category-button:active{background-color:#1f0f33;opacity:1;z-index:0}.category-button.active .wrapper,.category-button:active .wrapper{opacity:1}.category-button.active .cat-title,.category-button:active .cat-title{color:#f3f3f3}.category-button.active .cat-title .chev-icon,.category-button:active .cat-title .chev-icon{-webkit-mask-image:url(\"https://content.votenow.tv/app/projects/cmt/2023/assets/chev-up.svg\");mask-image:url(\"https://content.votenow.tv/app/projects/cmt/2023/assets/chev-up.svg\")}.category-button.active .votes-live-vote,.category-button.active .votes-remaining-wrapper,.category-button.active .votes-social,.category-button.active .votes-submitted,.category-button:active .votes-live-vote,.category-button:active .votes-remaining-wrapper,.category-button:active .votes-social,.category-button:active .votes-submitted{color:#fff;font-family:MTV Gravity;text-transform:uppercase;font-weight:800}.no-touch .category-button:hover:not(.active){background-color:#1f0f33;-webkit-box-shadow:0 8px 22px -5px rgba(0,0,0,.3);box-shadow:0 8px 22px -5px rgba(0,0,0,.3);opacity:1;z-index:3}.no-touch .category-button:hover:not(.active) .cat-title{color:#f3f3f3}.no-touch .category-button:hover:not(.active) .votes-live-vote,.no-touch .category-button:hover:not(.active) .votes-remaining-wrapper,.no-touch .category-button:hover:not(.active) .votes-social,.no-touch .category-button:hover:not(.active) .votes-submitted{color:#fff}.professional .cat-title{margin-bottom:0}.cat-section .view-submit{margin-top:0}.grid-container{display:block;margin:0 auto;max-width:1200px;overflow:hidden;text-align:center;width:100%}.grid-container .flex-container{margin:auto auto 24px;position:relative;text-align:left}.grid-container .flex-container.submitted{margin-bottom:12px}.grid-container .description-wrapper{margin-bottom:30px;text-align:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;margin-top:24px}.grid-container .cat-description{display:inline-block;color:#f3f3f3;text-transform:none;font-size:14px;line-height:21px;margin-bottom:0;max-width:615px;padding:0 20px;margin:0 auto;text-align:center;vertical-align:middle}.grid-container .sponsor{margin:15px auto}.professional-grid .flex-container{margin-bottom:30px}.view-submit{margin-top:36px;margin-bottom:42px}.view-submit .votes-remaining-wrapper{color:#f3f3f3;font-size:18px;line-height:23px}.view-submit .btn-submit,.view-submit .votes-remaining-wrapper{font-family:MTV Gravity;text-transform:uppercase;font-weight:800}.view-submit .btn-submit{background-color:#deb93b;color:#1f0f33;font-size:14px;line-height:18px;margin-top:24px;padding:12px 16px}.view-submit .btn-submit:active{background-color:#f8efd3;color:#1f0f33}.view-submit .btn-submit:disabled{pointer-events:none;opacity:.6}.social-generic-category .cta{margin-bottom:42px;text-align:center}.social-generic-category .social-cta{display:inline-block}.social-generic-category .social-cta img{max-width:238px}.social-category-live-vote .finalists{display:none;text-align:center}.social-category-live-vote .hashtag{margin-top:24px;text-align:center}.social-category-live-vote .hashtag img{border-radius:50%;display:inline-block;margin-right:18px;width:48px;height:48px;vertical-align:middle}.social-category-live-vote .hashtag a{display:inline-block}.social-category-live-vote .hashtag span{color:#f8f8f8;display:inline-block;font-size:20px;font-weight:800;line-height:25px;vertical-align:middle}.social-category-live-vote .runner-up h1{color:#f3f3f3;display:none;font-size:28px;font-weight:800;line-height:35px;margin:12px 0 36px;text-align:center;font-family:MTV Gravity;text-transform:none}.contestants-wrapper{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}@media (min-width:660px){.live-vote{margin-bottom:50px}.category-button{padding:36px 0}.category-button .wrapper{padding:0 110px}.category-button .cat-title{font-size:30px;letter-spacing:normal}.category-button .cat-title .chev-icon{-webkit-mask-size:24px 24px;mask-size:24px 24px;width:24px;height:24px;top:15px}.professional .cat-title{margin-bottom:0}.grid-container .description-wrapper,.grid-container .flex-container.submitted{margin-bottom:30px}.grid-container .cat-description{font-size:16px;line-height:24px}.grid-container .sponsor{margin:0 25px 10px auto}.grid-container .social-category-live-vote .sponsor{margin:22px auto 56px}.grid-container .social-generic-category .sponsor{margin:0 auto 20px}.grid-container .cta{position:relative}.grid-container .cta .sponsor{top:0}.view-submit{margin-bottom:54px}.view-submit .btn-submit:hover{background-color:#f8efd3;color:#1f0f33}.social-generic-category .cta{margin-bottom:54px}.social-category-live-vote .hashtag span{font-size:24px;line-height:30px}}.contestant{display:inline-block;margin-bottom:24px;padding-left:20px;padding-right:20px;vertical-align:top;width:100%;-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}.contestant .badge{display:inline-block;padding:3px 6px;background:#ff3c3c;color:#000;font-family:MTV Gravity;font-size:12px;font-weight:700;text-transform:uppercase;margin-bottom:12px}.contestant .thumbnail{background-color:transparent;border-width:0;cursor:pointer;width:100%;height:auto;position:relative}.contestant .thumbnail.no-video-url{cursor:default}.contestant .img-position{border-width:0;width:100%;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.08);box-shadow:0 2px 4px 0 rgba(0,0,0,.08)}.contestant .img-position .img-wrapper:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;background-image:-webkit-gradient(linear,left bottom,right top,from(rgba(0,0,0,.6)),to(transparent));background-image:-webkit-linear-gradient(bottom left,rgba(0,0,0,.6),transparent);background-image:-o-linear-gradient(bottom left,rgba(0,0,0,.6),transparent);background-image:linear-gradient(to top right,rgba(0,0,0,.6),transparent)}.contestant .img-position img{width:100%}.contestant .text-container{position:absolute;bottom:18px;left:18px;text-align:left;width:calc(100% - 36px)}.contestant .text-line1{color:#fff;font-family:MTV Gravity;font-weight:800;font-size:24px;margin-bottom:6px;word-break:break-word;text-transform:none}.contestant .text-line2{font-weight:400;line-height:21px}.contestant .text-line2,.contestant .text-line3{color:#fff;font-family:MTV Gravity;font-size:14px;word-break:break-word;text-transform:none}.contestant .text-line3{font-weight:800;line-height:19px;margin-top:6px}.contestant .watch-video{color:#f7f908;font-size:14px;font-family:MTV Gravity;font-weight:800;line-height:18px;margin-top:12px;text-transform:none}.contestant .watch-video img,.contestant .watch-video span{display:inline-block;vertical-align:middle}.contestant .watch-video img{margin-left:6px;width:8px}.contestant .edit-container{padding:12px 0;text-align:center;-ms-touch-action:manipulation;touch-action:manipulation;background:#1f0f33;-webkit-box-shadow:rgba(0,0,0,.08) 0 2px 4px 0;box-shadow:0 2px 4px 0 rgba(0,0,0,.08)}.contestant .edit-container .vote-count-wrapper,.contestant .edit-container button{display:inline-block;vertical-align:middle;margin-top:0;padding:0}.contestant .edit-container button:hover{opacity:.8}.contestant .edit-container button[disabled],.contestant .edit-container button[disabled]:hover{opacity:.2}.contestant .edit-container .btn-allocate{background:transparent;width:48px;height:48px}.contestant .edit-container .btn-allocate svg circle{fill:#deb93b}.contestant .edit-container .btn-allocate svg path,.contestant .edit-container .btn-allocate svg rect{fill:#000}.contestant .edit-container .btn-minus{margin-right:39px}.contestant .edit-container .btn-plus{margin-left:39px}.contestant .edit-container .vote-count-wrapper{width:50px;color:#f3f3f3}.contestant .edit-container .vote-count-wrapper span{display:block}.contestant .edit-container .vote-count{font-family:MTV Gravity;font-size:40px;font-weight:800;letter-spacing:2px;line-height:40px}.contestant .edit-container .vote-label{font-family:MTV Gravity;font-size:12px;font-weight:400;line-height:18px}.finalists .btn-submit{background-color:#deb93b;text-transform:uppercase;color:#000;font-weight:800;font-size:21px;line-height:18px;height:100px;width:100%;background-position:50%;background-repeat:no-repeat;-webkit-transition:.1s;-o-transition:.1s;transition:.1s}.finalists .btn-submit:hover{background-color:#f8efd3;color:#000}.finalists .btn-submit.btn-complete{background-image:url(\"https://content.votenow.tv/app/projects/mtv/vmas-2022/checkmark.svg\")}.finalists .btn-submit.btn-complete,.finalists .btn-submit.btn-loading{background-size:24px 24px;text-indent:-999999px;color:#deb93b;font-size:1px}.finalists .btn-submit.btn-loading{background-image:url(\"https://content.votenow.tv/app/projects/mtv/vmas-2022/loading.svg\")}.finalists .btn-submit:disabled{pointer-events:none;opacity:.6}.contestant.winner{-webkit-box-ordinal-group:1;-webkit-order:0;-ms-flex-order:0;order:0}@media (min-width:660px){.contestant{padding-left:12px;padding-right:12px;width:50%}.contestant .text-container{bottom:24px;left:24px;width:calc(100% - 48px)}.contestant .text-line1{font-size:24px}}@media (min-width:980px){.badge{font-size:18px}.contestant{width:33.33333%}}.grid-container .view-ad{display:inline-block;margin-top:36px;text-align:center;vertical-align:middle;width:100%;-webkit-box-ordinal-group:100;-webkit-order:99;-ms-flex-order:99;order:99}.grid-container .view-ad div{margin:0 auto}@media (min-width:660px){.grid-container .view-ad{padding:0 12px;margin:0;width:50%}}@media (min-width:980px){.grid-container .view-ad{width:33.33333%}}.view-confirm h1{margin:0 0 24px}.view-confirm .confirm-wrapper{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.view-confirm .btn-edit,.view-confirm .btn-submit{padding:0;width:100%;height:42px;font-size:14px;text-transform:uppercase;font-weight:800;font-family:MTV Gravity}.view-confirm .btn-edit{background-color:#1f0f33;color:#fff;margin:0 0 0 12px}.view-confirm .btn-edit:hover{background-color:#fff;color:#1f0f33}.view-confirm .btn-submit{background-color:#deb93b;color:#1f0f33}.view-confirm .btn-submit:hover{background-color:#f8efd3;color:#1f0f33}@media (min-width:378px){.view-confirm .confirm-wrapper{display:block}.view-confirm .btn-edit,.view-confirm .btn-submit{width:133px;height:39px}}@media (min-width:660px){.view-confirm .btn-edit,.view-confirm .btn-submit{width:185px;height:42px}.view-confirm .btn-edit{margin:0 0 0 24px}}.view-sweeps input[type=email],.view-sweeps input[type=text]{background:#3b3b3b;border:none;border-radius:0;color:#f8f8f8;font-size:14px;height:45px;line-height:21px;padding:0 24px;text-align:left}.view-sweeps input[type=email]:active,.view-sweeps input[type=email]:focus,.view-sweeps input[type=text]:active,.view-sweeps input[type=text]:focus{border:1px solid #f8f8f8;-webkit-box-shadow:none;box-shadow:none}.view-sweeps input[type=email].has-error,.view-sweeps input[type=text].has-error{border:1px solid #e0182d}.view-sweeps ::-webkit-input-placeholder{color:#f8f8f8}.view-sweeps ::-moz-placeholder{color:#f8f8f8}.view-sweeps :-ms-input-placeholder{color:#f8f8f8}.view-sweeps :-moz-placeholder{color:#f8f8f8}.view-sweeps input[type=email]{margin:0 auto 30px}.view-sweeps .error-message{color:#fb156b;display:block;text-align:left;font-size:12px;line-height:15px;position:absolute;bottom:-18px;left:0;width:100%}.view-sweeps .form-group{margin-bottom:18px}.view-sweeps .email.form-group{margin-bottom:30px;position:relative}.view-sweeps .submit-terms{color:#8b8b8b;font-size:12px;line-height:15px;margin:12px 0 24px}.view-sweeps .submit-terms a{color:#8b8b8b}.view-thanks{border:1px solid hsla(0,0%,6%,.1)}.view-thanks h1{margin-bottom:18px;color:#fff}.view-thanks .thanks-image{margin:40px auto}.view-thanks p{margin-bottom:12px}.view-auth{font-family:MTV Gravity}.view-auth h1{margin:0 0 24px}.view-auth button{width:100%;max-width:400px;height:42px;-webkit-transition:.3s ease;-o-transition:.3s ease;transition:.3s ease}.view-auth button.facebook{background-color:#1877f2}.view-auth button.facebook img{height:50%;margin:-2px 10px 0 0;display:inline}.view-auth #gSignIn{margin:0 auto 18px;display:inline-block}.view-auth .social-login button span{font-family:MTV Gravity;font-size:12px;text-transform:uppercase}.view-auth .or{display:block;font-size:12px;line-height:15px;margin:18px;text-align:center;text-transform:uppercase}.view-auth .email-form{position:relative}.view-auth input[type=email],.view-auth input[type=text]{background-color:#1f0f33;border:none;border-radius:0;color:#fff;font-size:14px;height:45px;line-height:21px;margin:0 auto 30px;padding:0 24px}.view-auth input[type=email]:active,.view-auth input[type=email]:focus,.view-auth input[type=text]:active,.view-auth input[type=text]:focus{border:1px solid #1f0f33;-webkit-box-shadow:none;box-shadow:none}.view-auth input[type=email].error-formbox,.view-auth input[type=text].error-formbox{border:1px solid #ce3336}.view-auth ::-webkit-input-placeholder{color:#fff!important}.view-auth ::-moz-placeholder{color:#fff!important}.view-auth :-ms-input-placeholder{color:#fff!important}.view-auth :-moz-placeholder{color:#fff!important}.view-auth ::-ms-input-placeholder{color:#fff!important}.view-auth ::placeholder{color:#fff!important}.view-auth .confirmation{margin-bottom:12px}.view-auth .rules .label{color:#fff;cursor:default;font-size:12px;font-weight:800;line-height:15px;margin-bottom:0;text-transform:uppercase}.view-auth .rules a{color:#fff;font-weight:400;text-decoration:underline}.view-auth .rules a:active{color:#deb93b}.view-auth .error-message{color:#ce3336;display:block;text-align:left;font-size:12px;line-height:15px;position:absolute;bottom:-18px;left:0;width:100%}@media (min-width:728px){.view-auth .rules a:hover{color:#deb93b}}.view-footer{background-color:#3f2066;border-bottom:1px solid;font-family:MTV Gravity;padding:36px 0}.view-footer .auth{text-align:center}.view-footer .user{padding-top:18px}.view-footer .sign-out{color:#deb93b;cursor:pointer;display:inline-block;font-size:14px;font-family:MTV Gravity;font-weight:800;line-height:15px;text-transform:uppercase}.tswdg-countdown{text-align:center}.tswdg-countdown .headline{background-color:#ff3c3c;color:#000;font-weight:800;font-family:MTV Gravity;display:inline-block;font-size:12px;line-height:15px;margin-top:0;margin-bottom:12px;padding:4px 6px 2px;outline:1px solid #000}.tswdg-countdown .headline:empty{display:none}.tswdg-countdown .colon,.tswdg-countdown .countdown-unit .countdown-value{color:#fff;font-size:24px;line-height:30px;font-weight:800;font-family:MTV Gravity}.tswdg-countdown .countdown-unit{display:inline-block}.tswdg-countdown .colon{display:inline-block;vertical-align:top}.tswdg-countdown .countdown-value{width:32px}.tswdg-countdown .countdown-unit-label{color:#fff;display:block;font-size:14px;font-weight:400;line-height:18px;margin-top:3px}.tswdg-countdown .countdown-copy{color:#fff;display:inline-block;font-size:15px;line-height:18px;margin:18px 0 0;padding:0 20px}.vote-progress{display:none;position:relative;z-index:4}.vote-progress .view-progress{background-color:#3f2066;color:#fff;text-transform:none;font-family:MTV Gravity;font-size:18px;font-weight:800;line-height:23px;padding:18px 15px;text-align:center}.vote-progress .view-progress.progress-fixed{position:fixed;bottom:0;right:0;left:0}.vote-progress .view-progress .btn-submit{background-color:#deb93b;color:#1f0f33;font-size:14px;font-weight:800;line-height:18px;margin-top:10px;padding:12px 16px}.vote-progress .view-progress .btn-submit:active{background-color:#f8efd3;color:#1f0f33}.vote-progress .view-progress .btn-submit:hover{background-color:#f8efd3;color:#fff}.vote-progress .view-progress .btn-submit:disabled{pointer-events:none;opacity:.6}.vote-progress.progress-show{display:block}.no-progress .vote-progress,.no-progress .vote-progress.progress-show{display:none}@media (min-width:348px){.vote-progress .view-progress .btn-submit{margin-top:0;margin-left:20px}}@media (min-width:660px){.view-footer{border:none;padding:42px 0}.view-footer .user{padding-top:24px}.tswdg-countdown .countdown-copy{margin:24px 0 0}.vote-progress .view-progress .btn-submit{margin-top:0}}.view-video{text-transform:none}.view-video .headline-wrapper{background-color:transparent;height:49px;position:relative;text-align:left}.view-video h1{margin:0;padding:12px 0;position:absolute;top:0;left:0;width:100%}.view-video .video-information{color:#f8f8f8;margin-top:12px;text-align:left}.view-video .video-information .text-line1{font-size:20px;font-weight:800;line-height:25px;margin-bottom:6px;word-break:break-word}.view-video .video-information .text-line-2{font-size:14px;line-height:21px;word-break:break-word}.view-video .video-information .text-line3{font-size:14px;font-weight:800;line-height:19px;margin-top:6px;word-break:break-word}.video-player{position:relative}.video-player .iframe-player{position:relative;height:0;padding-bottom:56.25%}.video-player .iframe-player iframe{position:absolute;top:0;left:0;width:100%;height:100%}.video-player .pjs{overflow:visible}.video-player .image-placeholder{background-color:#000}.video-player .image-placeholder img{margin:0 auto;max-height:280px}.video-player .video-nav{background-color:transparent;cursor:pointer;position:absolute;width:30px;height:30px;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.video-player .video-nav.next{right:-30px}.video-player .video-nav.prev{left:-30px}.video-player .video-nav img{margin:6px 0 0 10px;width:10px;height:18px}@media (min-width:660px){.view-video .headline-wrapper{height:78px}.view-video h1{padding:25px 0 23px}.view-video .video-information{margin-top:18px}.view-video .video-information .text-line1{font-size:24px;line-height:30px}.video-player .image-placeholder img{max-height:457px}.video-player .video-nav{width:60px;height:60px}.video-player .video-nav.next{right:-60px}.video-player .video-nav.prev{left:-60px}.video-player .video-nav img{margin:18px 0 0 25px;width:14px;height:26px}}.style-poll{background:#fff;color:#000}.style-poll .btn-close{top:10px;right:10px}.style-poll .btn-close img{width:18px;height:18px}.view-poll{color:#000}.view-poll h1{font-weight:700;margin-top:0 0 24px}.view-poll h2{margin-bottom:40px;font-weight:700}.view-poll .poll-wrapper{margin-bottom:50px}.view-poll .poll-wrapper img{width:100%;margin-bottom:40px}.view-poll .thanks-wrapper h2{margin:0}.view-poll .thanks-wrapper p{line-height:normal;margin:0}.view-poll .thanks-wrapper p a,.view-poll .thanks-wrapper p a:hover{color:#000;text-decoration:underline}.view-poll .thanks-wrapper p.code{font-weight:700}.view-poll .answer-group{width:100%;height:60px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin-bottom:5px}.view-poll .answer-group img{width:60px;height:60px;margin:0 5px 0 0}.view-poll .answer-group button,.view-poll .answer-group button:active,.view-poll .answer-group button:hover{font-family:Flame,MTV Gravity;height:60px;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;color:#fff;padding:0 0 0 14px;font-size:14px;background-color:#4f2313;text-align:left}.view-poll .sponsor span{color:#fff}@media (min-width:375px){.style-poll .btn-close{top:18px;right:18px}.style-poll .btn-close img{width:auto;height:auto}}@media (min-width:768px){.view-poll .answer-group{margin-bottom:10px}.view-poll .answer-group img{margin:0 10px 0 0}.view-poll .answer-group button,.view-poll .answer-group button:active,.view-poll .answer-group button:hover{padding:0 0 0 22px;font-size:22px}}#global-banner{width:100%;padding:0}#global-banner .global-banner-container{width:100%}#global-banner .banner{width:100%;background-color:#deb93b;padding:6px 15px;display:block;text-align:center;color:#000}#global-banner p{-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;text-align:center;-o-text-overflow:ellipsis;text-overflow:ellipsis;font:normal 400 16px MTV Gravity;margin-right:18px;display:none}#global-banner .button,#global-banner p{white-space:nowrap;vertical-align:middle}#global-banner .button{font:normal 800 14px MTV Gravity;text-transform:uppercase;display:inline-block;line-height:normal;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-transition-duration:.3s;-o-transition-duration:.3s;transition-duration:.3s;-webkit-transition-property:background-color,border,color;-o-transition-property:background-color,border,color;transition-property:background-color,border,color;border:2px solid #000;border-radius:4px;padding:7px 16px}#global-banner a:active,#global-banner a:hover,#global-banner a:visited{color:#000}@media (min-width:521px){#global-banner p{display:inline-block}}@media (min-width:660px){#global-banner .button{font-size:14px}}.modal-content.upsell-exit{padding:0!important;margin-top:25px;max-width:640px;outline:none}.upsell-exit{overflow:hidden}.upsell-exit h1{font:700 24px/1.2 MTV Gravity;text-transform:uppercase;margin:0!important}.upsell-exit h2{font:400 14px/1.5 MTV Gravity}.upsell-mtv-close{background:transparent}.upsell-mtv-close svg{display:inline-block;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;height:24px;stroke-width:0;stroke:currentcolor;fill:#fff;cursor:pointer;position:absolute;right:16px;top:16px;z-index:1}.upsell-banner{background-size:cover;background-image:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.25)),to(rgba(0,0,0,.25))),url(https://mtv.mtvnimages.com/uri/mgid:arc:content:mtv.com:4c1aca67-085f-42f4-9b4c-442da8c608d2?quality=0.7);background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.25),rgba(0,0,0,.25)),url(https://mtv.mtvnimages.com/uri/mgid:arc:content:mtv.com:4c1aca67-085f-42f4-9b4c-442da8c608d2?quality=0.7);background-image:-o-linear-gradient(bottom,rgba(0,0,0,.25),rgba(0,0,0,.25)),url(https://mtv.mtvnimages.com/uri/mgid:arc:content:mtv.com:4c1aca67-085f-42f4-9b4c-442da8c608d2?quality=0.7);background-image:linear-gradient(0deg,rgba(0,0,0,.25),rgba(0,0,0,.25)),url(https://mtv.mtvnimages.com/uri/mgid:arc:content:mtv.com:4c1aca67-085f-42f4-9b4c-442da8c608d2?quality=0.7);background-position:50%;height:0;max-width:100%;overflow:hidden;position:relative;padding-bottom:100%}.upsell-banner,.upsell-banner-content{-webkit-box-sizing:border-box;box-sizing:border-box}.upsell-banner-content{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;color:#fff;position:absolute;top:0;left:0;width:100%;height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.upsell-mtv-logo{margin-bottom:8px;width:auto;height:32px}.upsell-info{-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;background-color:#fff;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-webkit-flex:1 1 0%;-ms-flex:1 1 0%;flex:1 1 0%;padding:24px 24px 32px;color:#000}.upsell-info,.upsell-info ul{font:400 14px/1.5 MTV Gravity}.upsell-info ul{margin-bottom:32px;-webkit-padding-start:16px;padding-inline-start:16px;display:block;list-style-type:disc;-webkit-padding-start:40px;padding-inline-start:40px}.upsell-info ul li:not(:last-child){margin-bottom:12px}.upsell-info ul li{-webkit-padding-start:16px;padding-inline-start:16px;text-align:left;line-height:inherit}.upsell-link{font:700 12px MTV Gravity;padding:.71428em 1.14285em .92857em;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-transition-duration:.3s;-o-transition-duration:.3s;transition-duration:.3s;-webkit-transition-property:background-color,border,color;-o-transition-property:background-color,border,color;transition-property:background-color,border,color;color:#000;background-color:#deb93b;text-transform:none;display:block;text-align:center}.upsell-link:hover{background-color:#fff}.upsell-banner-content-wrapper{-webkit-box-sizing:border-box;box-sizing:border-box;display:grid;gap:8px;place-items:center;text-align:center;background:-webkit-gradient(linear,left top,left bottom,from(transparent),to(rgba(0,0,0,.9)));background:-webkit-linear-gradient(transparent,rgba(0,0,0,.9));background:-o-linear-gradient(transparent 0,rgba(0,0,0,.9) 100%);background:linear-gradient(transparent,rgba(0,0,0,.9));padding:40px 24px}@media (min-width:520px){.upsell-banner{padding-bottom:56.25%}.upsell-banner h2{font:400 16px/1.5 MTV Gravity}.upsell-mtv-logo{height:40px}.upsell-info{background-color:#000;color:#fff;padding:40px 72px 56px}.upsell-info,.upsell-info ul{font:400 16px/1.5 MTV Gravity}.upsell-info ul{margin-bottom:40px}.upsell-info ul li:not(:last-child){margin-bottom:16px}.upsell-banner-content-wrapper{gap:16px;padding:72px 72px 56px}}@media (min-width:660px){.upsell-banner h1{line-height:1;font-size:28px}.upsell-banner h2{font-size:15px}.upsell-link{line-height:1;font-size:14px}}.view-home .main{background-color:#1f0f33;background-image:-webkit-linear-gradient(305deg,#8a1d0e,#8a1d0e 38%,#de2b13 52%,#8a1d0e 65%,#8a1d0e);background-image:-o-linear-gradient(305deg,#8a1d0e 0,#8a1d0e 38%,#de2b13 52%,#8a1d0e 65%,#8a1d0e 100%);background-image:linear-gradient(145deg,#8a1d0e,#8a1d0e 38%,#de2b13 52%,#8a1d0e 65%,#8a1d0e);background-attachment:fixed;background-size:cover;background-position:bottom;background-repeat:no-repeat}", ""]);

// exports


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(196);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 196 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var slugify = __webpack_require__(34).slugify;

var Router = __webpack_require__(206);
var ModelAd = __webpack_require__(270);
var ModelAuth = __webpack_require__(271);
var ModelBase = __webpack_require__(105);
var ModelCms = __webpack_require__(106);
var ModelConnect = __webpack_require__(272);
var ModelGeo = __webpack_require__(273);
var ModelGoogle = __webpack_require__(111);
var ModelPJS = __webpack_require__(275);
var ModelShare = __webpack_require__(276);
var ModelStorage = __webpack_require__(109);
var ModelTimer = __webpack_require__(277);
var ModelFacebook = __webpack_require__(278);
var CollectionCategory = __webpack_require__(279);
var PubSub = __webpack_require__(2);

var _require = __webpack_require__(110),
    initializeGA4 = _require.initializeGA4,
    trackPageView = _require.trackPageView;

var google = __webpack_require__(111);

// constants
var CONNECT = __webpack_require__(11).CONNECT;
var APP_SETTINGS = __webpack_require__(11).APP_SETTINGS;

// helper functions
var getQueryParamByName = __webpack_require__(34).getQueryParamByName;
var getDeviceType = __webpack_require__(34).getDeviceType;
var omniture = __webpack_require__(281).omniture;

/**
 * @param options - {
 * widget_id: 'data/data.json' // REQUIRED string
 * container: $('#myWidget') // REQUIRED string || jQuery selector (https://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * modal: $('#wrapper') // string || jQuery selector (https://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * uniqueId: 'name-type-namespace-datetime' // string
 * cssUrl: 'https://a1.telesocpe.tv/styles/main.css' // string (absolute path)
 * endpoints: {cms: 'https://stateapi-fs.votenow.tv/widgets/get'} // object
 * }
 */
function Controller(options) {

    options = options || {};
    options.widget_id = options.widget_id || '1110c12034e25961';
    options.endpoints = options.endpoints || {};

    _.extend(options.endpoints, {
        twitter: {
            url: 'https://twitterauth.votenow.tv', // overwritten in cms settigns
            tokenEndpoint: '/api/v1/auth/twitter/token',
            authEndpoint: '/api/v1/auth/twitter',
            sessionEndpoint: '/api/v1/auth/me'
        }
    });

    // properties
    this.nativeApp = options.native || false;
    this.device = getDeviceType();
    this.options = options;
    this.userAuth = false;
    this.selectedCategory = null;
    this.env = options.env;
    this.gaAllowed = false;
    this.cookieData = {};

    // other properties
    this.Models = {};
    this.Collections = {};
    this.Views = {};
    this.Routers = {};
    this.Data = {
        shareUrl: options.shareUrl
    };

    this.createCmsModel().then(this.createGeoModel.bind(this)).then(this.createAuthModels.bind(this)).then(this.createCategoriesModel.bind(this)).then(this.createConnectModel.bind(this)).then(this.createContestantsModel.bind(this)).then(this.createPlayerModel.bind(this))
    //.then( this.createVevoModel.bind( this ))
    // .then( this.createYoutubeModel.bind( this ))
    .then(this.createAdModel.bind(this)).then(this.createShareModel.bind(this)).then(this.createTimerModel.bind(this)).then(this.createTimerModelClosed.bind(this)).then(this.createHeaderModel.bind(this)).then(this.createCollections.bind(this)).then(this.createFooterModel.bind(this)).then(this.createProgressModel.bind(this)).then(this.createGridModel.bind(this)).then(this.setMiscellaneous.bind(this)).then(this.setListeners.bind(this)).then(this.createTurboVoteModel.bind(this)).then(this.createRouter.bind(this));
}

Controller.prototype = _.extend({
    /**
     * createCmsModel
     */
    createCmsModel: function createCmsModel() {
        this.Models.Cms = new ModelCms({
            wid: this.options.widget_id,
            apiUrl: this.options.endpoints.cms,
            localTime: new Date().getTime()
        }, {
            ignoreQSP: false
        });

        return this.Models.Cms.fetch();
    },
    /**
     * createGeoModel
     */
    createGeoModel: function createGeoModel() {
        // Akamai Geo Location
        this.Models.Geo = new ModelGeo({
            countries: this.Models.Cms.get('settings').countries
        });

        var updatedEndpoint = this.options.appRoot + 'api/getregion.json';
        this.Models.Geo.urlRoot = updatedEndpoint;
        this.Models.Geo.url = updatedEndpoint;

        return this.Models.Geo.fetch();
    },
    /**
     * createGoogleModel
     */
    createAuthModels: function createAuthModels() {
        this.createFacebookModel();

        // Create Google Login model
        var googleClientId = this.Models.Cms.get('settings').google_client_id;

        this.Models.GoogleLogin = new ModelGoogle({
            googleClientId: googleClientId
        });

        // Create models for local storage and cookies
        this.Models.Storage = new ModelStorage();
        this.Models.Cookie = new ModelStorage({
            storageMethod: 'cookie'
        });

        // Create our Auth model
        this.Models.Auth = new ModelAuth({}, {
            google: this.Models.GoogleLogin,
            storage: this.Models.Storage,
            facebook: this.Models.Facebook
        });

        this.listenTo(this.Models.GoogleLogin, 'prompt', function () {
            if (this.Models.Auth.get('authType') === null) {
                window.google.accounts.id.prompt();
            }
        });

        // Model for Google Analytics
        if (window.cbsoptanon) {
            window.cbsoptanon.cmd.push(function (cmp) {
                cmp.ot.performanceAllowed(function (allowed) {
                    this.gaAllowed = allowed;
                    if (allowed) {
                        initializeGA4(this.Models.Cms.get('settings').google_analytics);
                    }
                }.bind(this));
            }.bind(this));
        }
    },
    createFacebookModel: function createFacebookModel() {
        var socialSettings = this.Models.Cms.get('social');
        var authSettings = this.Models.Cms.get('text').view_auth;

        var appId = socialSettings.fb.id;

        if (_.checkIfTrue(authSettings.enable_facebook_login)) {
            var fbModel = this.Models.Facebook = new ModelFacebook({
                appId: appId
            }, {
                version: 'v16.0',
                manageFbloCookie: false
            });

            this.listenTo(fbModel, 'change:id', function () {
                var fbId = fbModel.get('id');
                if (fbId) {
                    this.Models.Auth.signInSuccess('facebook', fbModel);
                    PubSub.trigger('directRoute', 'closeCurrentModal');
                }
            }.bind(this));
        }
    },
    /**
     * create camp stats model
     */
    createTurboVoteModel: function createTurboVoteModel() {
        var cmsSettings = this.Models.Cms.get('settings');
        var enableTurboPolling = _.checkIfTrue(this.Models.Cms.get('text').enable_turbo_polling);
        var p = $.Deferred();

        this.Models.TurboVote = new ModelConnect({
            apiKey: cmsSettings.apiKey_turbo
        }, {
            cms: this.Models.Cms,
            getContextData: this.getContextData.bind(this),
            getUserData: function getUserData() {
                return {};
            },
            version_id: cmsSettings.version_id_turbo
        });

        this.Models.TurboVote.versionCheck = CONNECT.TURBO_VERSION_CHECK;

        if (this.env === 'test') {
            this.Models.TurboVote.apiUrl = 'https://voteapi-test.votenow.tv/s2/vote';
        }

        this.Models.TurboVoteProperty = new Backbone.Model({
            value: 'false',
            voteLimit: this.Models.Cms.get('text').vote_limit
        });

        this.Models.Cms.turboVote = this.Models.TurboVoteProperty;

        this.listenTo(this.Models.TurboVote, 'change:requestActionGetPayload', function () {
            var turboWindow = this.Models.TurboVote.get('requestActionGetPayload').turbo_window;
            var isTurbo = _.checkIfTrue(turboWindow);
            var text = this.Models.Cms.get('text');

            var props = {
                voteLimit: isTurbo ? text.turbo_vote_limit : text.vote_limit,
                value: turboWindow
            };

            this.Models.TurboVoteProperty.set(props);

            this.stopListening(this.Models.TurboVoteProperty, 'change:value', this.refreshPage);
            this.listenTo(this.Models.TurboVoteProperty, 'change:value', this.refreshPage);

            p.resolve();
        }.bind(this));

        if (this.Models.Cms.get('appState') === 'open' && enableTurboPolling) {
            this.Models.TurboVote.getEvery(parseInt(cmsSettings.turbo_window_poll_rate_ms, 10));
        } else {
            p.resolve();
        }

        return p;
    },
    /**
     * createConnectModel
     */
    createConnectModel: function createConnectModel() {
        var settings = this.Models.Cms.get('settings');
        var isLiveVote = _.checkIfTrue(this.Models.Cms.get('text').live_vote);
        var apiKey = isLiveVote ? settings.apiKey_twttr : settings.apiKey;
        var versionId = isLiveVote ? settings.version_id_twttr : settings.version_id;
        var versionCheck = isLiveVote ? CONNECT.TWITTER_VERSION_CHECK : CONNECT.CONNECT_VERSION_CHECK;
        var numCategories = this.Models.Categories.get('data').length;

        this.Models.Connect = new ModelConnect({
            apiKey: apiKey
        }, {
            cms: this.Models.Cms,
            getContextData: this.getContextData.bind(this),
            getUserData: this.getUserData.bind(this),
            version_id: versionId,
            numberOfCategories: numCategories
        });

        this.Models.Connect.versionCheck = versionCheck;

        if (this.env === 'test') {
            this.Models.Connect.apiUrl = 'https://voteapi-test.votenow.tv/s2/vote';
        }
    },
    /**
     * createPlayerModel
     */
    createPlayerModel: function createPlayerModel() {
        this.Models.Player = new ModelPJS({}, {});
    },
    /**
     * createVevoModel
     */
    // createVevoModel: function() {
    //     this.Models.Vevo = new ModelVevo({}, {});
    // },
    /**
     * createYoutubeModel
     */
    // createYoutubeModel: function() {
    //     this.Models.YouTube = new ModelYoutube({}, {});
    // },
    /**
     * createAdModel
     */
    createAdModel: function createAdModel() {
        this.Models.Ad = new ModelAd({}, {});
    },
    /**
     * createShareModel
     */
    createShareModel: function createShareModel() {
        var cmsText = this.Models.Cms.get('text');
        this.Models.Share = new ModelShare({
            copy: cmsText.view_share,
            share: cmsText.view_share.share,
            uid: this.uniqueId,
            native: this.nativeApp,
            fbId: this.Models.Cms.get('social').fb.id
        }, {});
    },
    /**
     * createTimerModel
     * This uses a reset given only the time, so let's add the date today
     */
    createTimerModel: function createTimerModel() {
        var countdownCopy = this.Models.Cms.get('text').view_countdown;
        var endDate = new Date(new Date(this.Models.Cms.get('text').view_countdown.end_date).toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
        var date = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
        var month = date.getMonth() + 1; // January returns 0
        var day = date.getDate();
        var year = date.getFullYear();

        var resetDate = ('0' + month).slice(-2) + '/' + ('0' + day).slice(-2) + '/' + year + ' ' + countdownCopy.reset_time;
        var timeRemaining = parseInt((new Date(resetDate).getTime() - this.Models.Cms.get('ts')) / 1000, 10);

        if (timeRemaining <= 0) {
            // If the reset time has expired, set for the next day
            var tomorrow = new Date(date);
            tomorrow.setDate(tomorrow.getDate() + 1);
            var tomorrowMonth = tomorrow.getMonth() + 1; // January returns 0
            var tomorrowDay = tomorrow.getDate();
            var tomorrowYear = tomorrow.getFullYear();

            resetDate = ('0' + tomorrowMonth).slice(-2) + '/' + ('0' + tomorrowDay).slice(-2) + '/' + tomorrowYear + ' ' + countdownCopy.reset_time;
        }

        // only reset the timer if the end date is not reached yet
        var endTimestamp = endDate.getTime();
        var useResetDate = date.getTime() < endTimestamp;

        this.Models.Timer = new ModelTimer({
            endTime: useResetDate ? resetDate : endDate,
            endTimestamp: endTimestamp,
            isResetting: useResetDate
        }, { cms: this.Models.Cms });
    },
    /**
     * createTimerModelClosed
     */
    createTimerModelClosed: function createTimerModelClosed() {
        var countdownCopy = this.Models.Cms.get('text').view_countdown_closed;
        var date = new Date(new Date());
        var endDate = new Date(new Date(this.Models.Cms.get('text').view_countdown_closed.end_date));
        var endTimestamp = endDate.getTime();
        var useResetDate = date.getTime() < endTimestamp;

        this.Models.TimerClosed = new ModelTimer({
            enableDays: true,
            endTime: endDate,
            endTimestamp: endTimestamp,
            isResetting: useResetDate
        }, { cms: this.Models.Cms });
    },
    /**
     * createHeaderModel
     */
    createHeaderModel: function createHeaderModel() {
        this.Models.Header = new ModelBase({
            copy: this.Models.Cms.get('text').view_header,
            countdownCopy: this.Models.Cms.get('text').view_countdown_closed,
            uid: this.options.uniqueId,
            window: this.Models.Cms
        }, {
            textKey: 'view_header',
            cms: this.Models.Cms
        });
    },
    /**
     * createFooterModel
     */
    createFooterModel: function createFooterModel() {
        this.Models.Footer = new ModelBase({
            copy: this.Models.Cms.get('text').view_footer,
            uid: this.options.uniqueId,
            countdownCopy: this.Models.Cms.get('text').view_countdown,
            auth: this.Models.Auth,
            window: this.Models.Cms
        }, {
            textKey: 'view_footer',
            cms: this.Models.Cms
        });
    },
    /**
     * createCategoriesModel
     */
    createCategoriesModel: function createCategoriesModel() {
        var wid = getQueryParamByName('category_wid') || this.Models.Cms.get('settings').category_wid;
        var sid = getQueryParamByName('category_sid') || undefined;

        // create the categories model and fetch the data
        this.Models.Categories = new ModelCms({
            id: APP_SETTINGS.CATEGORY_CMS_ID,
            wid: wid,
            sid: sid,
            updateFrequency: APP_SETTINGS.CMS_POLL_RATE,
            copy: this.Models.Cms.get('text').view_grid
        }, {
            ignoreQSP: true
        });

        return this.Models.Categories.fetch();
    },
    /**
     * createContestantsModel
     */
    createContestantsModel: function createContestantsModel() {
        var wid = getQueryParamByName('contestant_wid') || this.Models.Cms.get('settings').contestant_wid;
        var sid = getQueryParamByName('contestant_sid') || undefined;

        // create the contestants model and fetch the data
        this.Models.Contestants = new ModelCms({
            id: APP_SETTINGS.CONTESTANT_CMS_ID,
            wid: wid,
            sid: sid,
            updateFrequency: APP_SETTINGS.CMS_POLL_RATE
        }, {
            ignoreQSP: true
        });

        return this.Models.Contestants.fetch();
    },
    /**
     * createCollections
     */
    createCollections: function createCollections() {
        var categoryOptions = _.clone(this.Models.Categories.get('data'), true);
        var categories = _.where(categoryOptions, { professional: '0' });
        var professionals = _.where(categoryOptions, { professional: '1' });
        var voteOptions = _.clone(this.Models.Contestants.get('data'), true);
        var mergedData = this.mergeDataSets(categories, voteOptions);
        var mergedDataProfessional = this.mergeDataSets(professionals, voteOptions);

        this.Collections.Categories = new CollectionCategory(mergedData);
        this.Collections.Professional = new CollectionCategory(mergedDataProfessional);
    },
    /**
     * createProgressModel
     */
    createProgressModel: function createProgressModel() {
        var cmsModel = this.Models.Cms;
        this.Models.Progress = new ModelBase({
            copy: cmsModel.get('text').view_progress,
            uid: this.options.uniqueId,
            auth: this.Models.Auth,
            categories: this.Collections.Categories,
            window: cmsModel
        }, {
            textKey: 'view_progress',
            cms: cmsModel
        });
    },

    /**
     * createGridModel
     */
    createGridModel: function createGridModel() {
        var cmsModel = this.Models.Cms;
        var cmsText = cmsModel.get('text');
        this.checkWindow();

        this.Models.Grid = new ModelBase({
            uid: this.options.uniqueId,
            collection: this.Collections.Categories,
            professionals: this.Collections.Professional,
            user: this.Models.Auth,
            dimensions: cmsText.customization.contestant_images,
            copy: cmsText.view_grid,
            window: cmsModel
        }, {
            textKey: 'view_grid',
            cms: cmsModel
        });
    },
    /**
     * setMiscellanous
     */
    setMiscellaneous: function setMiscellaneous() {
        // fetch the device information
        this.tacobellID = this.Models.Cms.get('text').customization.tacobell_category_id || "7";
    },
    /**
     * setListeners
     */
    setListeners: function setListeners() {
        var authModel = this.Models.Auth;
        var categoriesModel = this.Models.Categories;
        var cmsModel = this.Models.Cms;

        // Controller Model Listeners

        this.listenTo(this.Models.Auth, 'change:userID', this.getUserVotes.bind(this));
        this.listenTo(this.Models.Auth, 'change:authType', function () {
            if (this.Models.Auth.get('authType') !== 'google' && window.google) {
                window.google.accounts.id.cancel();
            }
        }.bind(this));
        this.Models.Auth.initializeType();

        this.listenTo(cmsModel, 'change:windowStatus', this.checkWindow.bind(this));
        this.listenTo(this.Models.Contestants, 'change:data', this.updateCategory.bind(this, this));
        this.listenTo(cmsModel, 'change:sid', this.refreshPage);

        // Categories Model
        this.listenTo(categoriesModel, 'change:windowStatus', this.checkWindow.bind(this));
        this.listenTo(categoriesModel, 'change:data', this.updateCategory.bind(this, this));
        this.listenTo(categoriesModel, 'change:sid', this.refreshPage);

        this.listenTo(cmsModel, 'change:appState', function (model, appState) {
            PubSub.trigger('appState', appState);
        });

        this.listenTo(PubSub, 'authenticated', authModel.signInSuccess.bind(authModel));
        this.listenTo(PubSub, 'logout', this.logout.bind(this));
        this.listenTo(PubSub, 'submitVotes', this.registerUserVote.bind(this));
        this.listenTo(PubSub, 'retryVoteAction', this.registerUserVote.bind(this));
        this.listenTo(PubSub, 'userCancelVote', this.clearUserVote.bind(this));
        this.listenTo(PubSub, 'resetAll', this.resetAll.bind(this));
        this.listenTo(PubSub, 'resetCategories', this.resetCategories.bind(this));

        // Handle instance a user cancels their auth registration
        // To clear the users cached data from the above PubSub
        this.listenTo(PubSub, 'userCancelAuth', function () {
            this.Models.Auth.set({ isAuthorized: true }, { silent: true });
            this.Models.Auth.set({ isAuthorized: false });
        }.bind(this));

        this.listenTo(PubSub, 'emailLogin', authModel.signInSuccess.bind(authModel, 'email'));
        this.listenTo(PubSub, 'linkClick', this.trackLinkClick.bind(this));

        this.listenTo(PubSub, 'submitSweepstakes', function (params) {

            this.listenToOnce(PubSub, 'sweepsSuccess', function (data) {
                this.voteData = null;
                PubSub.trigger('navigate', 'thanks');
            }.bind(this));

            this.Models.Connect.requestActionSweeps(params);
        }.bind(this));

        /* MMA-692: multiple pageviews called on initial load
         * Because of our how app loads, the first category will always load first,
         * and once the action_type=get call fires, the next votable category will load
         * based on the user's vote string.  This is a workaround, but not ideal.
         */
        this.listenTo(PubSub, 'pageView', _.debounce(function (omParams, gaParams) {
            if (gaParams && this.gaAllowed) {
                trackPageView(gaParams.eventAction);
            }

            omParams.page = slugify(omParams.page);
            omniture.sendPageEvent(omParams);
        }.bind(this), 1000));
    },
    /**
     * createRouter
     */
    createRouter: function createRouter() {
        var options = this.options;

        // MMA-441 - send initial page event
        omniture.sendPageEvent();

        this.Routers.Router = new Router({
            el: options.container,
            modal: options.modal,
            uid: options.uniqueId,
            controller: this,
            route: options.route,
            appRoot: options.appRoot
        });

        var backboneRoot = options.appRoot;

        Backbone.history.start({
            pushState: true,
            root: backboneRoot
        });
    },

    /* Helper Functions
    ------------------------------------------ */
    /**
     * delegateVote
     */
    delegateVote: function delegateVote(data) {
        var isLiveVote = !!data.categoryVoteData.contestant;

        this.voteData = data;

        this.listenToOnce(PubSub, 'voteSuccess', function (response) {
            var recentVotedCategory = this.Collections.Categories.getCategoryById(this.voteData.categoryID);

            var currentCookie = this.Models.Cookie.fetch('votestring');
            // if current vote window id doesn't match id in current cookie, destroy cookie first to reset vote data
            if (currentCookie && this.cookieData['windowId'] !== response.window_id) {
                this.Models.Cookie.destroy('votestring');
            }

            // save the votestring and vote window to a cookie in case the user's IP is blocked
            var voteHistory = response.votestring.length > 0 ? JSON.parse(response.votestring) : {};
            this.cookieData['windowId'] = response.window_id;

            Object.keys(voteHistory).forEach(function (catId) {
                var categoryData = voteHistory[catId];

                if (this.cookieData[catId]) {
                    var rulesetTotal = categoryData.total;
                    var localTotal = this.cookieData[catId].total || 0;

                    if (rulesetTotal > 1) {
                        localTotal = rulesetTotal;
                    } else {
                        localTotal += 1;
                    }

                    this.cookieData[catId] = _.extend({}, this.cookieData[catId], categoryData, {
                        total: localTotal
                    });
                } else {
                    this.cookieData[catId] = categoryData;
                }
            }.bind(this));

            this.Models.Cookie.save('votestring', JSON.stringify(this.cookieData), '04:00:00 GMT');

            var lastVotedCatID = parseInt(this.voteData.categoryID, 10);

            if (recentVotedCategory) {

                var _gaParams = {
                    eventCategory: 'Vote Category Submit',
                    eventAction: 'Unique Voter Category ' + this.voteData.categoryID
                };
                var catId = 'cat' + recentVotedCategory.get('id');

                this.trackLinkClick(null, _gaParams);

                var isLiveCategory = _.checkIfTrue(recentVotedCategory.get('live_vote'));

                if (isLiveCategory && response.votestring) {
                    var categoryVoteHistory = this.cookieData[catId];

                    var totalVotes = recentVotedCategory.get('categoryVotesTotal');
                    var voteLimit = parseInt(this.Models.TurboVoteProperty.get('voteLimit'), 10);
                    var isSubmitted = totalVotes >= voteLimit;

                    if (categoryVoteHistory) {
                        recentVotedCategory.set({
                            categoryVotesTotal: categoryVoteHistory.total,
                            categoryVotes: _.omit(categoryVoteHistory, 'total'),
                            isSubmitted: isSubmitted
                        });
                    }
                } else {
                    recentVotedCategory.set('isSubmitted', true);
                }
            }

            if (!isLiveVote) {
                this.routeUserBasedOnVoting(lastVotedCatID);
            }
        }.bind(this));

        var omParams = {
            name: 'submit vote button_' + this.voteData.categoryName,
            section: slugify(this.voteData.categoryName),
            url: window.location.href
        };

        var gaParams = { eventCategory: 'Button Click', eventAction: 'Vote Submit' };
        this.trackLinkClick(omParams, gaParams);

        this.Models.Connect.requestActionVote(data);
    },
    /**
     * getContextData
     */
    getContextData: function getContextData() {
        var data = {
            timestamp: this.Models.Cms.get('ts'),
            country: this.Models.Geo.get('country'),
            state: this.Models.Geo.get('geoheaders').region
        };
        return data;
    },
    /**
     * getUserData
     */
    getUserData: function getUserData() {
        var data = {
            user_id: this.Models.Auth.get('userID')
        };

        switch (this.Models.Auth.get('authType')) {
            case 'email':
                data.method = 'email';
                break;
            case 'facebook':
                data.method = 'fb';
                data.fb_first_name = this.Models.Auth.get('firstName');
                data.fb_email = this.Models.Auth.get('email');
                break;
            case 'google':
                data.email = this.Models.Auth.get('email');
                data.google_name = this.Models.Auth.get('userName');
                data.method = 'google';
                break;
        }

        Object.keys(data).forEach(function (key) {
            if (data[key] === undefined || data[key] === '') {
                delete data[key];
            }
        });

        return data;
    },
    /**
     * Get Call for User Votes
     */
    getUserVotes: function getUserVotes(model, value, options) {
        if (!_.isNull(value)) {
            /**
             * ALL CLOSED - both main and categories widget will have open snapshots and the only indicator we
             * have that it's a closed state is there are no active categories, so we check if there are none
             */
            var activeCats = this.Models.Categories.get('data').filter(function (cat) {
                return cat.active === '1';
            });

            // return if there are no active categories OR any snapshot is closed
            if (!activeCats || this.Models.Categories.get('windowStatus') === 0 || this.Models.Cms.get('settings').window_status === '0') return;

            // set the namespace for the Cookie storage model
            this.Models.Cookie.set({ namespace: value });

            this.listenToOnce(this.Models.Connect, 'change:requestActionGetPayload', this.updateFromVoteHistory.bind(this));
            this.Models.Connect.requestActionGet();
        }
    },
    /**
     * Update the categories if votes have been submitted based on the user vote history
     */
    updateFromVoteHistory: function updateFromVoteHistory() {
        var voteString = this.Models.Connect.get('requestActionGetPayload');
        var votableCategories = this.Collections.Categories.getVotableCategories();

        if (!voteString) {
            // check for a votestring cookie if there is no votestring returned from the GET request
            var cookieVoteString = this.Models.Cookie.fetch('votestring');
            if (cookieVoteString) voteString = JSON.parse(cookieVoteString);
        } else {
            // destroy the votestring cookie if there is a votestring returned from the GET request
            this.Models.Cookie.destroy('votestring');
        }

        _.forEach(voteString, function (value, key) {

            var updatedKey = key.replace('cat', '');
            var votedCategory = this.Collections.Categories.getCategoryById(updatedKey);

            if (votedCategory) {
                var isLiveCategory = _.checkIfTrue(votedCategory.get('live_vote'));
                var totalVotes = parseInt(value.total, 10);
                var voteLimit = parseInt(this.Models.TurboVoteProperty.get('voteLimit'), 10);
                var isSubmitted = isLiveCategory ? totalVotes >= voteLimit : true;

                votedCategory.set({
                    isSubmitted: isSubmitted,
                    categoryVotes: _.omit(value, 'total'),
                    categoryVotesTotal: totalVotes
                });
            }
        }.bind(this));

        if (!votableCategories.length) {
            return PubSub.trigger('closeAllCategories');
        }

        this.routeUserBasedOnVoting();
        this.selectedCategory = null;
    },
    /**
     * [logout description]
     * @return {[type]} [description]
     */
    logout: function logout() {

        var authType = this.Models.Auth.get('authType');
        this.selectedCategory = null;

        if (_.isNull(authType)) return;

        switch (authType) {
            case "facebook":
                this.Models.Facebook.logout();
                var appId = this.Models.Facebook.get('appId');
                this.Models.Facebook.set(_.extend({}, this.Models.Facebook.defaults, {
                    appId: appId
                }));
                break;
            case "google":
                this.Models.GoogleLogin.signout();
                break;
            case "email":
                this.Models.Auth.deAuthorize();
                break;
            default:
        }

        this.resetAll();
    },
    /**
     * Reset the Auth model and Category collection
     */
    resetAll: function resetAll() {
        this.Models.Auth.set(this.Models.Auth.defaults);
        this.cookieData = {};
        this.voteData = null;
        $('.votes-remaining').text(this.Models.TurboVoteProperty.get('voteLimit'));
        this.resetCategories();
    },
    /**
     * Reset the Category collection when the daily countdown ends
     */
    resetCategories: function resetCategories() {
        this.Collections.Categories.forEach(function (category) {
            category.set({
                categoryVotes: {},
                hasAlreadyConfirmed: false,
                isSubmitted: false,
                totalAllocatedVotes: 0,
                categoryVotesTotal: 0
            });
        });

        var route = this.Collections.Categories.getNextVotableCategory(0);

        if (route) {
            PubSub.trigger('closeAllCategories', route.get('displayName'), route.get('id'));
        }
    },
    /**
     * [checkWindow description]
     * @return {[type]} [description]
     */
    checkWindow: function checkWindow() {

        var windowStatus = parseInt(this.Models.Cms.get('windowStatus'));
        var windowStatusCategory = parseInt(this.Models.Categories.get('windowStatus'));

        switch (windowStatus) {
            /**
             * OPEN WINDOW
             */
            case 1:
                // do nothing since the window is open
                if (windowStatusCategory) {
                    // set an attribute to listen to
                    // voting window is opened, allow all voting to continue
                    this.Models.Cms.set({ appState: "open" });
                } else {
                    // set an attribute to listen to
                    // voting window is closed, display the accordian only and update the text
                    this.Models.Cms.set({ appState: "closed" });
                }
                break;
            /**
             * CLOSED WINDOW
             */
            case 0:
                // Show Closed Window
                // display the categories and the winners for each category
                // remove the winner from the nominees

                this.Models.Cms.set({ appState: "winner" });
                break;
        }
    },
    /**
     * [routeUserBasedOnVoting description]
     * @return {[type]} [description]
     */
    routeUserBasedOnVoting: function routeUserBasedOnVoting(lastVotedCatID) {

        if (!this.Models.Auth.get('isAuthorized')) return;
        var selectedCategoryID = this.selectedCategory ? this.selectedCategory.categoryID : null;
        var nextRoute = void 0;

        if (!lastVotedCatID) {
            nextRoute = this.Collections.Categories.getNextVotableCategory(null, selectedCategoryID);
        }

        if (!nextRoute) {
            nextRoute = this.Collections.Categories.getNextVotableCategory(lastVotedCatID, selectedCategoryID);
        }

        if (!lastVotedCatID && !nextRoute) {
            return PubSub.trigger('closeAllCategories');
        }

        // if user did not vote and the selected category is the same as the next votable category, return early
        if (!lastVotedCatID && nextRoute && this.selectedCategory && nextRoute.get('id') === this.selectedCategory.categoryID) {
            return;
        }

        if (!nextRoute) {
            PubSub.trigger('closeAllCategories');

            var intersitialRoute = 'thanks';
            var displaySweeps = _.checkIfTrue(this.Models.Cms.get('text').view_sweepstakes.display);
            var displayPoll = _.checkIfTrue(this.Models.Cms.get('text').view_poll.display);

            if (displaySweeps) {
                intersitialRoute = 'sweeps';
            } else if (displayPoll) {
                intersitialRoute = 'poll';
            } else {
                intersitialRoute = 'thanks';
            }

            PubSub.trigger('navigate', intersitialRoute);
            return;
        }

        var hideAnimation = !(lastVotedCatID || selectedCategoryID);
        PubSub.trigger('closeAllCategories', nextRoute.get('displayName'), nextRoute.get('id'), null, hideAnimation);
    },
    /**
     * Check if the user is logged in before submitting the category votes
     */
    registerUserVote: function registerUserVote(data) {
        if (!this.Models.Auth.get('isAuthorized')) {
            this.Models.Auth.once('change:isAuthorized', function (data, cb) {
                if (!this.Models.Auth.get('isAuthorized')) return;
                this.delegateVote(data);
            }.bind(this, data));

            var selected = {
                categoryID: data.categoryID,
                contestantID: data.contestantID
            };
            PubSub.trigger('directRoute', 'auth', selected);
            return;
        }
        this.delegateVote(data);
    },
    /**
     *
     */
    clearUserVote: function clearUserVote() {
        this.voteData = null;
        this.callback = null;
    },
    /**
     * Track link clicks on Google Analytics and Omniture
     */
    trackLinkClick: function trackLinkClick(omParams) {
        if (omParams) omniture.sendClickEvent(omParams);
    },
    /**
     * mergeDataSets
     */
    mergeDataSets: function mergeDataSets(categories, dataOptions) {

        categories.forEach(function (cat, index, list) {

            var voteOptions = dataOptions.filter(function (option) {
                return option.category_id === cat.id;
            });

            cat.winner = voteOptions.find(function (option) {
                return option.winner === '1';
            });

            cat.copy = this.Models.Cms.get('text').view_grid;

            cat.voteData = voteOptions.sort(function (a, b) {
                if (a.winner !== b.winner) return parseInt(b.winner, 10) - parseInt(a.winner, 10);
                return parseInt(a.order, 10) - parseInt(b.order, 10);
            });

            cat.ad = this.Models.Ad;
            cat.displayName = slugify(cat.name);
        }.bind(this));

        return categories;
    },
    /**
     * updateCategory
     */
    updateCategory: _.debounce(function (controller) {

        var categories = _.clone(controller.Models.Categories.get('data'), true);
        var category = categories.filter(function (cat) {
            return cat.professional === '0';
        });
        var professional = categories.filter(function (cat) {
            return cat.professional === '1';
        });

        var voteOptions = _.clone(controller.Models.Contestants.get('data'), true);

        var mergedData = this.mergeDataSets(category, voteOptions);
        var mergedDataPromoted = this.mergeDataSets(professional, voteOptions);

        if (controller.Collections.Categories instanceof CollectionCategory) {
            controller.Collections.Categories.set(mergedData, { merge: true });
        }

        if (controller.Collections.Professional instanceof CollectionCategory) {
            controller.Collections.Professional.set(mergedDataPromoted, { merge: true });
        }

        category = professional = voteOptions = mergedData = null;
    }, 1000, { leading: true }),
    /**
     * refreshPage
     */
    refreshPage: function refreshPage() {
        try {
            window.location.reload();
        } catch (e) {
            var href = window.location.href.split('#')[0];
            window.location = href;
        }
    }

}, Backbone.Events);

module.exports = function (options) {
    new Controller(options);
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    CMS_POLL_RATE: 10, // in seconds
    CATEGORY_CMS_ID: 'category',
    CONTESTANT_CMS_ID: 'contestant'
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    CONNECT_VERSION_CHECK: '8hEqnttAU4QezPHrtpjc',
    TWITTER_VERSION_CHECK: '',
    TURBO_VERSION_CHECK: '9wfx3UkLAzrQKRuzEsxL'
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    SINGULAR: {
        MM: '',
        D: 'DAY',
        h: 'HRS',
        m: 'MIN',
        s: 'SEC'
    },
    PLURAL: {
        MM: '',
        D: 'DAYS',
        h: 'HRS',
        m: 'MINS',
        s: 'SECS'
    }
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    SCOPE: 'email',
    VERSION: 'v7.0'
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    // click event
    CLICK_LINK_TYPE: 'o',
    CLICK_ACTIVITY: 'actionCall',
    CLICK_NO_DEST: 'no destination',

    // page view event
    PAGE_NAME: 'mtv|events|voting|2023-mtv-movie-and-tv-awards',
    PAGE_CHANNEL: 'events',
    PAGE_EVENT: 'M&TVAs',
    PAGE_FRANCHISE: '2023 M&TVAs',
    PAGE_SERIES: 'no-series',
    PAGE_TYPE: 'voting',
    PAGE_ACTIVITY: 'pageview',
    PAGE_VID_FRANCHISE: 'no-franchise',
    PREV_PAGE_NAME: 'n/a',
    WEB_VERSION: 'WebPlex 3.2.0',

    APP_NAME: 'M&TVAs web',
    BRAND_ID: 'mtv-us',
    LANGUAGE: 'en-us',
    COUNTRY_NAME: 'us',
    VENDOR: 'Telescope',
    MOD_NAME: 'voting_items',
    MOD_NAME_SOCIAL: 'voting',
    SOC_METHOD: 'instagram',

    // other settings
    MAX_ATTEMPTS: 10,
    RETRY_DELAY: 800
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    SWEEPS_INPUT: /^[\w\-\s]+$/,
    EMAIL_VALIDATION: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    EMAIL_KEY: 'mtv_auth_email',
    AUTH_KEY_TW: 'auth_tw',
    KEY_PREFIX: 'mtva2023',
    USER: 'auth_user'
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    UNSUPPORTED: /Mobile|webOS|iPod|Kindle|BlackBerry|PalmOS|PalmSource|Opera Mini|IEMobile|SonyEricsson|smartphone/i,
    SUPPORTED: /Android|iPhone|iPad/i
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);

// views and models
var ViewError = __webpack_require__(207);
var ViewLoading = __webpack_require__(209);
var ViewHome = __webpack_require__(211);
var ViewCategory = __webpack_require__(226);
var ViewConfirm = __webpack_require__(232);
var ViewModal = __webpack_require__(234);
var ViewAuth = __webpack_require__(236);
var ViewVideo = __webpack_require__(238);
var ViewThanks = __webpack_require__(240);
var ViewSocial = __webpack_require__(243);
var ViewLiveVote = __webpack_require__(245);
var ModelBase = __webpack_require__(105);
var ViewSweeps = __webpack_require__(249);
var ViewGlobalBanner = __webpack_require__(251);
var ViewUpsell = __webpack_require__(253);
var PollView = __webpack_require__(256);

// util functions
var getScrollY = __webpack_require__(103);

module.exports = Backbone.Router.extend({
    controller: null,
    currentView: null,
    currentModal: null,
    routes: {
        '': 'category',
        'auth': 'auth',
        'error/:name': 'error',
        'loading/:name': 'loading',
        'thanks': 'thanks',
        'sweeps': 'sweeps',
        'poll': 'poll',
        ':category': 'category',
        'video/:id': 'video'
    },
    _windowDimensions: {},
    history: [],
    openCategories: [],
    openPositions: [],
    indexPage: false,
    /**
     *
     */
    initialize: function initialize(options) {
        if (_.isUndefined(options)) return;

        // https://jira.telescope.tv/browse/MMA-352
        // https://stackoverflow.com/questions/7035331/prevent-automatic-browser-scroll-on-refresh
        $(window).on('beforeunload', function (e) {
            var $elAttr = $(document.activeElement).attr('href');
            if ($elAttr && $elAttr.indexOf('mailto') > -1) return;
            $(window).scrollTop(0);
        });

        if ("ontouchstart" in document.documentElement || "ontouchstart" in window) $('body').attr('ontouchstart', '');

        this.route = options.route || "-1";
        this.isInitialized = true;
        this.winnerPageViewFired = false;
        this.appRoot = options.appRoot || '/';

        this.controller = options.controller;
        this.instanceID = $(options.el || document.body).attr('id');
        this.uid = options.uid;
        this.uniqueId = this.uid + "_" + Math.round(Math.random() * 1000000);

        this.lastTrackedPage = null;
        this.transitionAnimation = parseInt(this.controller.Models.Cms.get('text').customization.transition_time) || 500;
        this.registerListeners();

        this.$body = $(options.el || document.body);
        this.$modalScope = $(options.modal || this.$body);

        this.$modal = $('<div class="modal"' + (_.isEqual(options.container, options.modal) ? '' : ' id="' + options.uid + 'Modal"') + ' />');
        this.$modalScope.append(this.$modal);

        this.renderPage();

        this.listenTo(this.controller.Models.Cms, 'change:appState', this.renderPage);
    },
    /**
     * [registerListeners description]
     * @return {[type]} [description]
     */
    registerListeners: function registerListeners() {

        this.listenTo(PubSub, '_back', this._back.bind(this));
        this.listenTo(PubSub, 'loadVideo', this.video.bind(this));
        this.listenTo(PubSub, 'modalConfirm', this.confirm.bind(this));

        this.listenTo(PubSub, 'navigate', function (route, options) {
            options = options || { trigger: true };
            if (this.route == route || options.isCategory) {
                var uri = '/' + route.replace('/', '').toLowerCase();
                this.navigate(uri, { trigger: false });
                this.category(route.replace('/', ''), options.hideAnimation);
            } else {
                this.navigate(route, options);
            }
        }.bind(this));

        this.listenTo(PubSub, 'directRoute', function (route, options) {
            if (_.isUndefined(options)) options = null;
            this[route](options);
        }.bind(this));

        this.listenTo(PubSub, 'openFirstCategory', function () {
            var categoryToOpen = this.controller.Collections.Categories.findWhere({ active: '1' });
            var categoryHeader = this.$app.find('.category-button[data-category-id=' + categoryToOpen.get('id') + ']');
            categoryHeader.addClass('active');

            // open the category with the scroll animation to the top of the category
            PubSub.trigger('navigate', categoryToOpen.get('displayName'), { isCategory: true, trigger: true });

            // open the category without the scroll animation to the top of the category
            // this.category(categoryToOpen.get('displayName'), true);
        }.bind(this));

        // Event Listener to hide individual categories
        // For window view and open view, when a user directly clicks the category to hide
        this.listenTo(PubSub, 'hideCategory', function (model, $category) {
            var categoryView = _.findWhere(this.openCategories, { model: model });
            // in the instance that categoryView returns undefined, find the category by displayName
            if (!categoryView) {
                categoryView = _.findWhere(this.openCategories, { id: model.get('displayName') });
            }

            var position = this.openCategories.indexOf(categoryView);
            var destroyHTML = this.openPositions[position];

            if (categoryView) {
                categoryView.$el.animate({
                    height: 0
                }, this.transitionAnimation, function () {

                    // remove the class "active" only after the closing animation
                    if ($category && $category.hasClass('active')) {
                        $category.removeClass('active');
                    }

                    categoryView.remove();
                    categoryView = null;
                    this.openCategories.splice(position, 1);
                    destroyHTML.html(null);
                    this.openPositions.splice(position, 1);

                    $(window).trigger('resize.unveil');
                }.bind(this));
            }
        }.bind(this));

        this.listenTo(PubSub, 'openSocialCategory', function () {
            var categoryToOpen = this.controller.Collections.Categories.findSocialCategory();
            PubSub.trigger('closeAllCategories', categoryToOpen.get('displayName'), categoryToOpen.get('id'));
        }.bind(this));

        this.listenTo(PubSub, 'openAllCategories', function (initialized) {

            this._openAllCategoriesCalled = true;

            _.forEach(this.controller.Collections.Professional.models, function (model, index) {
                var view = new ViewCategory({
                    model: model,
                    turbo: this.controller.Models.TurboVoteProperty,
                    user: this.controller.Models.Auth,
                    dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                    copy: this.controller.Models.Cms.get('text').view_grid,
                    cms: this.controller.Models.Cms,
                    css: this.controller.Models.Cms.get('text')['customization']['css'],
                    uid: this.uid,
                    hideAnimation: true
                });

                var index = parseInt(model.get('id'));
                this.setCurrentView(view, index, true);
            }.bind(this));

            _.forEach(this.controller.Collections.Categories.models, function (model, index) {
                var view = new ViewCategory({
                    model: model,
                    user: this.controller.Models.Auth,
                    dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                    copy: this.controller.Models.Cms.get('text').view_grid,
                    cms: this.controller.Models.Cms,
                    css: this.controller.Models.Cms.get('text')['customization']['css'],
                    uid: this.uid,
                    hideAnimation: true
                });

                var index = parseInt(model.get('id'));

                this.setCurrentView(view, index, true);

                this._isOpen('/');
            }.bind(this));

            if (initialized) this.isInitialized = true;
        }.bind(this));

        this.listenTo(PubSub, 'closeAllCategories', this.closeAllCategories.bind(this));

        this.listenTo(PubSub, 'openUpsell', this.openUpsell.bind(this));

        this.mtvAdCreated = false;

        this.on('route', this._saveHistory.bind(this));
        $(window).on('scroll', this._handleScroll.bind(this));
        $(window).on('resize', this._handleResize.bind(this));
    },
    /**
     * Login modal - only shows up when a user clicks on the plus button for a contestant
     */
    auth: function auth(selectedCategory) {
        var data = this.controller.Models.Cms.get('text')['view_auth'];

        // save the selected category to see if we need to increase votes after log in
        this.controller.selectedCategory = selectedCategory;

        var view = new ViewAuth({
            model: data,
            css: this.controller.Models.Cms.get('text')['customization']['css'],
            uid: this.uid,
            native: this.controller.nativeApp,
            google: this.controller.Models.GoogleLogin,
            facebook: this.controller.Models.Facebook
        });

        this.setCurrentModal(view);
        this.isInitialized = false;
    },
    /**
     *
     */
    category: function category(_category, hideAnimation) {
        if (this._openAllCategoriesCalled) {
            this.isInitialized = false;
            this._openAllCategoriesCalled = false;
            return;
        }

        var initialCategoryNotFound = false;

        if (!this._isOpen(_category)) return;

        var initialAnimation = !(_.isNull(_category) && this.controller.Models.Cms.get('appState') === 'winner');

        if (this.isInitialized) {
            _category = this.route.replace("/", "");
        }

        var model = this.controller.Collections.Professional.findCategoryByDisplayName(_category) || this.controller.Collections.Categories.findCategoryByDisplayName(_category);
        // in the instance there is no hash route on initialization,
        // we default to the first category in the collection
        if (_.isUndefined(model)) {
            model = this.controller.Collections.Categories.findWhere(function (category) {
                return category.get('active') === '1' && category.get('voteData').length > 0;
            }) || this.controller.Collections.Categories.models[0];

            initialCategoryNotFound = true;
        }

        if (model.get('voteData').length === 0) {
            return;
        }

        // upon initialization, the grid view will not have the active style
        // applied to it, we will need to add it accordingly
        if (this.isInitialized && model) {
            var categoryHeader = this.$app.find('.category-button[data-category-id=' + model.id + ']');

            categoryHeader.addClass('active');

            // if we are in the winnners state, the grid view will handle all the opening and closing of the categories
        } else if (this.controller.Models.Cms.get('appState') == 'winners') {
            return;
        }

        if (hideAnimation) {
            initialCategoryNotFound = true;
        }

        // undefined for model.get('social') if the category JSON has not been updated
        // this is to prevent it from loading the incorrect view
        var view;

        // check if we need to increment a contestant vote after a user logs in
        var contestantToIncrementID = null;
        if (this.controller.selectedCategory && this.controller.selectedCategory.categoryID === model.id) {
            contestantToIncrementID = this.controller.selectedCategory.contestantID;
        }
        this.controller.selectedCategory = null;

        if ((model.get('social') == '0' || model.get('social') == undefined) && model.get('live_vote') == '0') {
            view = new ViewCategory({
                model: model,
                user: this.controller.Models.Auth,
                dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                copy: this.controller.Models.Cms.get('text').view_grid,
                cms: this.controller.Models.Cms,
                css: this.controller.Models.Cms.get('text')['customization']['css'],
                uid: this.uid,
                hideAnimation: initialCategoryNotFound,
                initialAnimation: initialAnimation,
                contestantToIncrementID: contestantToIncrementID
            });
        } else if (model.get('live_vote') == '0') {
            var socialId = model.get('social');
            var socialKey = 'social_';
            var copy = this.controller.Models.Cms.get('text').view_social_category[socialKey + socialId];

            var copy = new ModelBase({
                copy: copy,
                uid: this.uniqueId
            }, {
                textKey: 'view_social_category',
                cms: this.controller.Models.Cms
            });

            view = new ViewSocial({
                model: model,
                user: this.controller.Models.Auth,
                dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                copy: copy,
                cms: this.controller.Models.Cms,
                css: this.controller.Models.Cms.get('text')['customization']['css'],
                uid: this.uid,
                hideAnimation: initialCategoryNotFound
            });
        } else {
            var copy = new ModelBase({
                copy: this.controller.Models.Cms.get('text').view_live_vote_category,
                uid: this.uniqueId
            }, {
                textKey: 'view_live_vote_category',
                cms: this.controller.Models.Cms
            });

            view = new ViewLiveVote({
                model: model,
                user: this.controller.Models.Auth,
                dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                copy: copy,
                cms: this.controller.Models.Cms,
                css: this.controller.Models.Cms.get('text')['customization']['css'],
                uid: this.uid,
                hideAnimation: initialCategoryNotFound
            });
        }

        var index = parseInt(model.get('id'));

        this.controller.pageName = model.get('displayName');

        if (initialCategoryNotFound && this.controller.pageName !== _category) {
            var uri = '/' + model.get('displayName').replace('/', '').toLowerCase();
            this.navigate(uri, { trigger: false });
        }

        this.setCurrentView(view, index);
    },
    /**
     * Close all the open categories
     * @param viewToOpen - name of the view to navigate to
     * @param viewID - reference to the view to be opened
     * @param callback - callback function
     */
    closeAllCategories: function closeAllCategories(viewToOpen, viewID, callback, hideAnimation) {

        if (this.openCategories.length === 0) {
            if (viewToOpen) PubSub.trigger('navigate', viewToOpen);else if (typeof callback === 'function') callback();
            return;
        }

        var ctr = 0;
        var totalOpenCategories = this.openCategories.length;

        this.openCategories.forEach(function (value) {

            var position = this.openCategories.indexOf(value);
            var destroyHTML = this.openPositions[position];

            value.$el.animate({ height: 0 }, 250, function () {

                ctr++;
                value.remove();
                value = null;

                this.openCategories.splice(position, 1);
                destroyHTML.html(null);
                this.openPositions.splice(position, 1);

                if (totalOpenCategories === ctr && viewToOpen) {
                    PubSub.trigger('navigate', viewToOpen, { isCategory: true, trigger: true, hideAnimation: hideAnimation });
                } else if (totalOpenCategories === ctr && typeof callback == 'function') {
                    callback();
                }
            }.bind(this));
        }.bind(this));
    },
    /**
     * Confirmation modal that prompts the user with the following options:
     * Submit - this submits the votes for the category
     * Edit - this closes the modal and lets the user make changes to votes
     */
    confirm: function confirm(category) {
        if (category.get('hasAlreadyConfirmed')) return;

        var view = new ViewConfirm({
            copy: this.controller.Models.Cms.get('text').view_confirmation,
            model: category
        });
        this.setCurrentModal(view);

        category.set('hasAlreadyConfirmed', true);
    },
    /**
     *
     */
    closeCurrentModal: function closeCurrentModal() {
        this.closedCurrentModal();
    },
    /**
     *
     */
    closedCurrentModal: function closedCurrentModal() {
        if (this.currentModal !== null) {

            if (_.isObject(this.currentModal.model.view)) {
                this.currentModal.model.view.remove();
            }
            this.currentModal.remove();
            this.currentModal = this.controller.Views.Modal = null;
            this.$modalScope.alterClass('modal-has-*', '');
            this.$modalScope.removeClass('no-scroll');
            this.$modalScope.css('top', '');
            window.scrollTo(0, this.currentScroll || 0);
        }
    },
    /**
     *
     */
    error: function error(name) {
        var data = this.controller.Models.Cms.get('text')['views_error'][name];
        data = _.isObject(data) ? data : this.controller.Models.Cms.get('text')['views_error']['generic'];

        var view = new ViewError({
            model: data,
            name: name
        });

        this.setCurrentModal(view);
        this.isInitialized = false;
    },
    /**
     *
     */
    loading: function loading(name, requestedFragment) {
        var data = this.controller.Models.Cms.get('text')['views_loading'][name];
        data = _.isObject(data) ? data : this.controller.Models.Cms.get('text')['views_loading']['generic'];

        var view = new ViewLoading({
            model: data,
            controller: this.controller,
            route: requestedFragment
        });

        this.setCurrentModal(view);
    },

    /**
     * renderPage
     */
    renderPage: function renderPage(model, val) {
        // remove checkmarks when transitioning to winner state
        if (val && val === 'winner') return;
        // we only rerender from closed to open - page load is allowed
        if (val && val !== 'open') return;

        _.forEach(this.openCategories, function (view) {
            view.remove();
        });

        // reset references to category views
        this.openCategories = [];
        this.openPositions = [];

        // remove current view
        this.currentView && this.currentView.remove();

        // remove page if it exists
        this.page && this.page.remove();

        this.initGlobalBanner();

        this.page = new ViewHome({
            model: {
                header: this.controller.Models.Header,
                footer: this.controller.Models.Footer,
                progress: this.controller.Models.Progress,
                grid: this.controller.Models.Grid,
                timer: this.controller.Models.Timer,
                timerClosed: this.controller.Models.TimerClosed,
                turbo: this.controller.Models.TurboVoteProperty
            },
            cms: this.controller.Models.Cms,
            uid: this.uid,
            native: this.controller.nativeApp
        });

        this.page.render();
        this.$app = this.page.$el;
        this.$body.html(this.page.$el);
        this.$body.addClass(this.uniqueID);
        this.page.renderedToDom();
    },

    initGlobalBanner: function initGlobalBanner() {
        var data = window.MTVBanner;
        if (data) {
            this.globalBanner = new ViewGlobalBanner({
                model: {
                    copy: data.copy,
                    promoResourceLinks: data.promoResourceLinks,
                    upSellExit: data.parameters ? data.parameters.upSellExit : false
                }
            });
            this.globalBanner.render();

            $('#global-banner').html(this.globalBanner.$el);
        }
    },

    openUpsell: function openUpsell() {

        var data = window.MTVUpSell;
        if (data) {
            var backgroundImageData = data.images.find(function (image) {
                return image.imageUsageType === 'background';
            });
            var showLogoData = data.images.find(function (image) {
                return image.imageUsageType === 'show_logo';
            });

            var view = new ViewUpsell({
                model: {
                    backgroundImage: backgroundImageData,
                    copy: data.copy,
                    headerText: data.headerText,
                    promoResourceLinks: data.promoResourceLinks,
                    showLogo: showLogoData,
                    subheaderText: data.subheaderText
                }
            });
            this.setCurrentModal(view, true);
            this.isInitialized = false;
        }
    },
    /**
     *
     */
    setCurrentModal: function setCurrentModal(view, alternate) {
        var modalContext = 'modal-has-' + view.className;

        var modal = new ViewModal({
            model: { view: view }, controller: this.controller
        });

        if (this.currentModal !== null) {
            if (_.isObject(this.currentModal.model.view)) {
                this.currentModal.model.view.remove();
            }
            this.currentModal.remove();
            this.currentModal = this.controller.Views.Modal = null;
        }

        this.currentScroll = window.pageYOffset;
        this.$modalScope.alterClass('modal-has-*', modalContext);
        this.$modalScope.addClass('no-scroll');
        this.$modalScope.css('top', -this.currentScroll + 'px');

        this.$modal.html(modal.render().$el);

        // target specific modals
        modal.$el.find('.modal-content').addClass(view.className.replace('view-', 'style-'));
        if (view.className === 'view-video') {
            modal.$el.find('.modal-content').addClass('fade-in');
        }

        if (alternate) {
            this.$modal.find('.view-modal').addClass('alternate');
        } else {
            this.$modal.find('.view-modal').removeClass('alternate');
        }

        // store current modal
        this.currentModal = this.controller.Views.Modal = modal;

        if (typeof this.currentModal.model.view.renderedToDom === 'function') {
            this.currentModal.model.view.renderedToDom();
        }

        if (/(sweeps)/.test(view.className) || /(thanks)/.test(view.className)) {
            var pageName = /(sweeps)/.test(view.className) ? 'Sweeps Modal' : 'Thanks Modal';

            var googleParams = {
                eventCategory: 'Page View',
                eventAction: pageName,
                eventLabel: pageName + ' : ' + this.controller.device
            };

            var omnitureParams = {
                page: pageName,
                url: window.location.href
            };

            PubSub.trigger('pageView', omnitureParams, googleParams);
        }
    },
    /**
     *
     */
    setCurrentView: function setCurrentView(view, index, initialWindowClosed) {
        var isWinner = this.controller.Models.Cms.get('appState') === 'winner';
        // on windowClosed views, this.$app is undefined initially
        // set it here so the application can fully build
        if (initialWindowClosed) {
            this.$app = this.page.$el;
        } else {
            // garbage clean up in the instance that the category remains in the
            // openCategories and openPositions arrays
            var categoryOpen = _.findWhere(this.openCategories, { id: view.model.get('displayName') });

            if (categoryOpen && !categoryOpen.model) {
                // console.warn('currentView already exists, remove the view and reopen!!!');

                var position = this.openCategories.indexOf(categoryOpen);
                var destroyHTML = this.openPositions[position];

                categoryOpen.remove();
                this.openCategories.splice(position, 1);

                destroyHTML.html(null);
                this.openPositions.splice(position, 1);
            }
        }

        if (this.currentView == view) {
            return;
        }
        this.closeCurrentModal();

        var bodyContext = 'body-' + view.className;
        this.$body.alterClass('body-*', bodyContext);

        var elementToRender = this.$app.find('.grid-container[data-category-id=' + index + ']');
        // var elementToRender = this.$app.find('.grid-container')[parseInt(index) - 1];

        if (!this.$app.find('.category-button[data-category-id=' + index + ']').hasClass('toggle-animations') && this.controller.Models.Cms.get('appState') === 'winner') {
            view.initialAnimation = false;
        }; // MMA-352

        // store current view
        this.currentView = view;

        $(elementToRender).html(this.currentView.render().$el);

        this.currentView.id = this.currentView.model.get('displayName');
        this.route = this.currentView.id;

        if (typeof this.currentView.renderedToDom === 'function') {
            this.currentView.renderedToDom();
        }

        this.openCategories.push(this.currentView);
        this.openPositions.push($(elementToRender));

        var pageName = this.currentView.model.get('name');

        if (isWinner && !this.winnerPageViewFired) {
            var omnitureParams = {
                page: 'winner-page',
                url: window.location.href
            };

            PubSub.trigger('pageView', omnitureParams);
            this.winnerPageViewFired = true;
        } else if (!isWinner && index !== undefined && !_.isUndefined(pageName) && initialWindowClosed !== true) {
            var omnitureParams = {
                page: pageName,
                url: window.location.href
            };

            if (this.lastTrackedPage !== pageName) {
                PubSub.trigger('pageView', omnitureParams);

                this.lastTrackedPage = pageName;
            }
        }

        // commented out this portion as we are on standby for
        // SEO updates, uncomment when ready to go!
        this._updateMetaData(initialWindowClosed);

        this.isInitialized = false;

        // used for lazy load to display the images on the page
        $(window).scroll();
    },
    /**
     *
     */
    setupMTVHeaderAd: function setupMTVHeaderAd() {
        if (this.mtvAdCreated) return;

        var windowWidth = $(window).width();
        var windowHeight = $(window).scrollTop();
        var mtvHeader = document.getElementById('header').scrollHeight;

        if (windowHeight <= mtvHeader) {
            if (windowWidth > 728) {
                this.controller.Models.Ad.createAd('skybox_leader_plus_sticky');
            } else {
                this.controller.Models.Ad.createAd('mobile_skybox_plus_sticky');
            }
            this.mtvAdCreated = true;
        }
    },
    /**
     *
     */
    sweeps: function sweeps() {
        var user = this.controller.Models.Auth.get('share');
        var thanks = this.controller.Models.Cms.get('text')['view_thanks'];
        var copy = this.controller.Models.Cms.get('text')['view_sweepstakes'];

        var model = {
            user: user,
            copy: copy,
            native: this.controller.nativeApp,
            thanks: thanks
        };

        var view = new ViewSweeps({
            model: model,
            uid: this.uid,
            shareModel: this.controller.Models.Share,
            shareUrl: this.controller.Data.shareUrl
        });

        this.setCurrentModal(view, true);
        this.isInitialized = false;
    },
    /**
     *
     */
    poll: function poll() {
        var config = this.controller.Models.Cms.get('text')['view_poll'];

        var view = new PollView({
            uid: this.uid,
            userModel: this.controller.Models.Auth,
            pollWidgetId: config.poll_wid,
            getContextData: this.controller.getContextData.bind(this.controller),
            getUserData: this.controller.getUserData.bind(this.controller)
        });

        this.setCurrentModal(view, true);
        this.isInitialized = false;
    },
    /**
     *
     */
    thanks: function thanks() {
        var user = this.controller.Models.Auth.get('share');
        var copy = this.controller.Models.Cms.get('text')['view_thanks'];

        var model = {
            user: user,
            copy: copy,
            native: this.controller.nativeApp
        };

        var view = new ViewThanks({
            model: model,
            css: this.controller.Models.Cms.get('text')['view_thanks']['customization'],
            uid: this.uid,
            shareModel: this.controller.Models.Share,
            shareUrl: this.controller.Data.shareUrl
        });

        this.setCurrentModal(view, true);
        this.isInitialized = false;
    },
    /**
     *
     */
    video: function video(model, category) {
        var view = new ViewVideo({
            model: model,
            category: category
        });

        this.setCurrentModal(view, true);
    },
    /**
     * [window description]
     * @param  {[type]} category [description]
     * @return {[type]}          [description]
     */
    window: function window() {},
    /**
     *
     */
    _back: function _back() {
        this.history.shift();
        var previous = this.history[0];
        this[previous.route](previous.params);
    },
    /**
     * _debouncedHandleScroll
     */
    _debouncedHandleScroll: _.debounce(function () {
        this.setupMTVHeaderAd();
    }, 500),
    /**
     * _debouncedHandleResize
     */
    _debouncedHandleResize: _.debounce(function () {
        this.setupMTVHeaderAd();
    }, 500),
    /**
     * _handleScroll
     */
    _handleScroll: function _handleScroll(e) {
        var nav = document.getElementById('mtv-mobile-menu');
        var header = document.getElementById('header');

        if (window.scrollY >= nav.offsetTop) {
            header.classList.add('sticky');
        } else if (window.scrollY < nav.offsetTop) {
            header.classList.remove('sticky');
        }

        var scrollPos = getScrollY();
        this._debouncedHandleScroll();
        PubSub.trigger('window:scroll', scrollPos);
    },
    /**
     * _handleResize
     */
    _handleResize: function _handleResize() {
        PubSub.trigger('window:resize');
        this._debouncedHandleResize();
    },
    /**
     *
     */
    _isOpen: function _isOpen(requestedFragment) {
        // 1. If we are in one of the allowed regions, AND the window
        //    is open, immedately return true.  In all other cases,
        //    return false.
        // 2. If the region data has not returned yet, CHANGE the url
        //    to show loading, then once the region is available, CHANGE
        //    the url back to what it was at the time of the call
        // 3. If the region data has returned, but is not valid, CHANGE
        //    the url show out-of-geo
        // 4. If the region data has returned and is good, but the window
        //    is not open, CHANGE the url to the closed window page
        if (requestedFragment) {
            this.requestedFragment = requestedFragment;
        }

        // is the user out of the geographically acceptable region
        if (_.isNull(this.controller.Models.Geo.get('inRegion'))) {
            this.controller.Models.Geo.once('change:inRegion', function () {
                this.navigate(requestedFragment, { trigger: true });
            }.bind(this));
            // direct navigate to loading view without storing in browser history
            this.loading('generic', requestedFragment);
            // this.navigate('loading/generic', {trigger: true});
            return false;
        } else if (!this.controller.Models.Geo.get('inRegion')) {
            PubSub.trigger('directRoute', 'error', 'geo');
            return false;
        }

        // NOTES: This version of the MTV VMAs does not have a true window closed state
        // as users are able to open and close categories. The grid view and category views handle
        // the window closed view so we no longer need to route directly to the window closed view
        // IF MTV changes how the window closed view will look, this will need to be updated

        // is the window closed?
        // if(parseInt(this.controller.Models.Cms.get('settings').window_status, 10) === 0){
        //     this.window();
        //     return false;
        // }

        return true;
    },
    /**
     *
     */
    _modifyDisplayName: function _modifyDisplayName(displayName) {
        var arrayName = displayName.split('-');
        var modifiedName = "";

        _.forEach(arrayName, function (name, index) {
            if (index == 0) {
                modifiedName = name.charAt(0).toUpperCase() + name.slice(1);
            } else {
                modifiedName = modifiedName + " " + name.charAt(0).toUpperCase() + name.slice(1);
            }
        });

        return modifiedName;
    },
    /**
     *
     */
    _saveHistory: function _saveHistory(route, params) {
        this.history.unshift({
            route: route,
            params: params
        });
    },
    /**
     *
     */
    _updateMetaData: function _updateMetaData(initialWindowClosed) {
        if (initialWindowClosed) return;

        var displayName = this.currentView.model.get('name');
        var metaData = this.controller.Models.Cms.get('text').customization.meta_data.deep_link;

        var description = metaData.description.replace('{{LINK}}', displayName);
        var title = metaData.title.replace('{{LINK}}', displayName);

        // update the document title
        document.title = title;

        $('meta[name=description]').attr('content', description);
    }
});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(208);

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-error',
    events: {
        'click .btn-close': 'close'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');
        this.name = options.name;
    },
    /**
     *
     */
    render: function render() {
        var model = {
            copy: this.model,
            name: this.name
        };

        this.$el.html(template(model));
        return this;
    },
    /**
     *
     * @param e
     */
    close: function close(e) {
        e.preventDefault();

        if (e.currentTarget.tagName !== 'BUTTON' || this.model.button.route == 'home') {
            PubSub.trigger('directRoute', 'closeCurrentModal');
            PubSub.trigger('userCancelVote');
            return;
        }

        PubSub.trigger('retryVoteAction');
    }
});

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h1><%- copy.headline1 %></h1> <p><%- copy.paragraph1 %></p> <% if(copy.button.display == 'true') { %> <button class=\"btn-close\"><%= copy.button.text %></button> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h1>', (__stack.lineno=1,  copy.headline1 ), '</h1> <p>', (__stack.lineno=1,  copy.paragraph1 ), '</p> ');__stack.lineno=1; if(copy.button.display == 'true') { ; buf.push(' <button class="btn-close">', escape((__stack.lineno=1,  copy.button.text )), '</button> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var template = __webpack_require__(210);
var PubSub = __webpack_require__(2);

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-loading',
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');
        this.requestedRoute = options.route;
    },
    /**
     *
     */
    render: function render() {
        this.$el.html(template(this.model));
        return this;
    },
    /**
     * 
     */
    renderedToDom: function renderedToDom() {
        this.waiting = setTimeout(function () {
            PubSub.trigger('directRoute', 'category', this.requestedRoute);
        }.bind(this), 1000);
    },
    /**
     * 
     */
    remove: function remove() {
        if (this.waiting) clearTimeout(this.waiting);
        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h1><%- headline1 %></h1> <h4><%- paragraph1 %></h4> <div style=\"padding-top: 15px;\"> <h6 class=\"loading-label\"><%- headline2 %></h6> <div class=\"progress progress-striped active\"> <div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 100%\"></div> </div> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h1>', (__stack.lineno=1,  headline1 ), '</h1> <h4>', (__stack.lineno=1,  paragraph1 ), '</h4> <div style="padding-top: 15px;"> <h6 class="loading-label">', (__stack.lineno=1,  headline2 ), '</h6> <div class="progress progress-striped active"> <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div> </div> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var ViewTopCta = __webpack_require__(212);
var ViewFooter = __webpack_require__(217);
var ViewProgress = __webpack_require__(220);
var ViewGrid = __webpack_require__(222);
var template = __webpack_require__(225);

module.exports = Backbone.View.extend({
    className: 'view-home',
    events: {},
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        this.ctaView = new ViewTopCta({
            model: this.model.header,
            turbo: this.model.turbo,
            modelTimerClosed: this.model.timerClosed,
            uid: options.uid
        });

        this.progressView = new ViewProgress({
            model: this.model.progress,
            css: options.css,
            uid: options.uid,
            cms: options.cms
        });

        this.gridView = new ViewGrid({
            model: this.model.grid,
            cms: options.cms,
            css: options.css,
            uid: options.uid
        });

        this.footerView = new ViewFooter({
            model: this.model.footer,
            modelTimer: this.model.timer,
            uid: options.uid
        });

        // THIS PORTION WAS USED TO DETERMINE IF WE WERE IN THE NATIVE WRAPPER
        // IF SO, ON RENDEREDTODOM FUNCTION WE ADDED A CLASS TO HANDLE HIDDING
        // DIFFERENT OPTIONS FOR LOGGING IN AND SHARING
        this.native = options.native;
    },
    /**
     *
     */
    render: function render() {
        this.$el.html(template());

        this.$el.addClass((top === self ? 'frame-false' : 'frame-true') + (!("ontouchstart" in document.documentElement) || !("ontouchstart" in window) ? ' no-touch' : ' touch'));

        this.$('.cta-container').append(this.ctaView.$el);
        this.$('div[role="main"]').append(this.gridView.$el);
        this.$('footer').append(this.footerView.$el);
        this.$('.vote-progress').append(this.progressView.$el);

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom() {
        // once the DOM is fully rendered, display the various views
        this.ctaView.render();
        this.ctaView.renderedToDom();

        this.progressView.render();
        this.progressView.renderedToDom();

        this.gridView.render();
        this.gridView.renderedToDom();

        this.footerView.render();
        this.footerView.renderedToDom();

        if (this.native) {
            this.$el.addClass('native');
        }
    },
    /**
     * remove
     */
    remove: function remove() {

        this.ctaView.remove();
        this.progressView.remove();
        this.gridView.remove();
        this.footerView.remove();

        Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var ViewTimer = __webpack_require__(102);
var template = __webpack_require__(214);
var templateCSS = __webpack_require__(215);
var CSSView = __webpack_require__(35);

module.exports = Backbone.View.extend({
    className: 'view-vote-cta',
    /**
     *
     */
    initialize: function initialize(options) {

        _.bindAll(this, 'render');

        options = options || {};

        this.uid = options.uid;
        this.style_id = this.className + "_" + Math.round(Math.random() * 1000000);

        this.$el.addClass(this.style_id);

        this.css = _.extend({
            turbo_vote_banner: this.model.get('copy').turbo_vote_banner,
            turbo_vote_banner_mobile: this.model.get('copy').turbo_vote_banner_mobile
        }, this.model.get('copy')['customization']);

        this.window = this.model.get('window');
        this.turbo = options.turbo;

        this.countdownView = new ViewTimer({
            model: options.modelTimerClosed,
            allowReset: false,
            countdownCopy: this.model.get('countdownCopy')
        });

        this.listenTo(this.window, 'change:appState', this.renderAll.bind(this));
        this.listenTo(this.model, 'change:copy', this.renderAll.bind(this));
    },
    /**
     *
     */
    render: function render() {

        if (this.CSSView) {
            this.CSSView.remove();
        }

        this.CSSView = new CSSView({
            model: this.css,
            namespace: '#' + this.uid + ' .' + this.style_id + '.' + this.className,
            template: templateCSS
        });

        Backbone.$('head').append(this.CSSView.render().$el);

        var windowState = this.window.get('appState');
        var isClosed = windowState === 'closed' || windowState === 'winner';

        var isTurboWindow = _.checkIfTrue(this.turbo.get('value'));
        var isTurbo = isTurboWindow && !isClosed;

        var appState = isTurbo ? 'turbo' : windowState;

        var viewModel = _.extend({}, this.model.get('copy')[appState], {
            sponsor_text: this.model.get('copy').sponsor_text,
            sponsor_img: this.model.get('copy').sponsor_image,
            isTurbo: isTurbo,
            turbo_vote_headline: this.model.get('copy').turbo_vote_headline,
            turbo_vote_paragraph: this.model.get('copy').turbo_vote_paragraph
        });

        this.$el.html(template(viewModel));

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom() {
        var appState = this.window.get('appState');
        var backgroundImage = this.model.get('copy')['customization']['background_image'];
        var displayCountdown = _.checkIfTrue(this.model.get('copy')['closed']['display_countdown']) && new Date(this.countdownView.model.attributes.endTime) > new Date();

        if (appState === 'closed' && displayCountdown) {
            this.$el.find('.tswdg-countdown').show();
            this.$el.find('.tswdg-countdown').html(this.countdownView.render().$el);
            this.countdownView.renderedToDom();
        } else {
            this.$el.find('.tswdg-countdown').hide();
        }

        if (backgroundImage.length) {
            this.$el.addClass('extended');
        } else {
            this.$el.removeClass('extended');
        }
    },
    /**
     * 
     */
    renderAll: function renderAll() {
        this.render();
        this.renderedToDom();
    },
    /**
     * Remove header view
     */
    remove: function remove() {
        this.countdownView.remove();
        this.stopListening();
        Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"countdown-container\"> <h1 class=\"headline\"><%= text.headline1 %></h1> <div class=\"countdown-time\"> <% if (parseInt(text.show_days)) { %> <div class=\"countdown-unit countdown-days\"> <span class=\"countdown-unit-cell\"> <div class=\"countdown-value\"><%= timer.days %></div> <% if (parseInt(text.display_text)) { %><span class=\"countdown-unit-label\"><%= (timer.days === 1? labels.singular.D : labels.plural.D) %></span><% } %> </span> </div> <div class=\"colon\"> <div class=\"text\">:</div> </div> <% } %> <% if (parseInt(text.show_hours)) { %> <div class=\"countdown-unit countdown-hours\"> <span class=\"countdown-unit-cell\"> <div class=\"countdown-value\"><%= timer.hours %></div> <% if (parseInt(text.display_text)) { %><span class=\"countdown-unit-label\"><%= (timer.hours === 1? labels.singular.h : labels.plural.h) %></span><% } %> </span> </div> <div class=\"colon\"> <div class=\"text\">:</div> </div> <% } %> <% if (parseInt(text.show_minutes)) { %> <div class=\"countdown-unit countdown-minutes\"> <span class=\"countdown-unit-cell\"> <div class=\"countdown-value\"><%= timer.minutes %></div> <% if (parseInt(text.display_text)) { %><span class=\"countdown-unit-label\"><%= (timer.minutes === 1? labels.singular.m : labels.plural.m) %></span><% } %> </span> </div> <div class=\"colon\"> <div class=\"text\">:</div> </div> <% } %> <% if (parseInt(text.show_seconds)) { %> <div class=\"countdown-unit countdown-seconds last\"> <span class=\"countdown-unit-cell\"> <div class=\"countdown-value\"><%= timer.seconds %></div> <% if (parseInt(text.display_text)) { %><span class=\"countdown-unit-label\"><%= (timer.seconds === 1? labels.singular.s : labels.plural.s) %></span><% } %> </span> </div> <% } %> </div> <p class=\"countdown-copy\"><%= text.paragraph1 %></p> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="countdown-container"> <h1 class="headline">', escape((__stack.lineno=1,  text.headline1 )), '</h1> <div class="countdown-time"> ');__stack.lineno=1; if (parseInt(text.show_days)) { ; buf.push(' <div class="countdown-unit countdown-days"> <span class="countdown-unit-cell"> <div class="countdown-value">', escape((__stack.lineno=1,  timer.days )), '</div> ');__stack.lineno=1; if (parseInt(text.display_text)) { ; buf.push('<span class="countdown-unit-label">', escape((__stack.lineno=1,  (timer.days === 1? labels.singular.D : labels.plural.D) )), '</span>');__stack.lineno=1; } ; buf.push(' </span> </div> <div class="colon"> <div class="text">:</div> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (parseInt(text.show_hours)) { ; buf.push(' <div class="countdown-unit countdown-hours"> <span class="countdown-unit-cell"> <div class="countdown-value">', escape((__stack.lineno=1,  timer.hours )), '</div> ');__stack.lineno=1; if (parseInt(text.display_text)) { ; buf.push('<span class="countdown-unit-label">', escape((__stack.lineno=1,  (timer.hours === 1? labels.singular.h : labels.plural.h) )), '</span>');__stack.lineno=1; } ; buf.push(' </span> </div> <div class="colon"> <div class="text">:</div> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (parseInt(text.show_minutes)) { ; buf.push(' <div class="countdown-unit countdown-minutes"> <span class="countdown-unit-cell"> <div class="countdown-value">', escape((__stack.lineno=1,  timer.minutes )), '</div> ');__stack.lineno=1; if (parseInt(text.display_text)) { ; buf.push('<span class="countdown-unit-label">', escape((__stack.lineno=1,  (timer.minutes === 1? labels.singular.m : labels.plural.m) )), '</span>');__stack.lineno=1; } ; buf.push(' </span> </div> <div class="colon"> <div class="text">:</div> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (parseInt(text.show_seconds)) { ; buf.push(' <div class="countdown-unit countdown-seconds last"> <span class="countdown-unit-cell"> <div class="countdown-value">', escape((__stack.lineno=1,  timer.seconds )), '</div> ');__stack.lineno=1; if (parseInt(text.display_text)) { ; buf.push('<span class="countdown-unit-label">', escape((__stack.lineno=1,  (timer.seconds === 1? labels.singular.s : labels.plural.s) )), '</span>');__stack.lineno=1; } ; buf.push(' </span> </div> ');__stack.lineno=1; } ; buf.push(' </div> <p class="countdown-copy">', escape((__stack.lineno=1,  text.paragraph1 )), '</p> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if( isTurbo ) { %> <div class=\"turbo-wrapper\"> <h1 class=\"headline\"><%- turbo_vote_headline %></h1> <p class=\"description\"><%- turbo_vote_paragraph %></p> </div> <% } %> <div class=\"vote-cta\"> <div class=\"text-wrapper\"> <h1 class=\"headline\"><%- headline1 %></h1> <% if(headline2.length > 0) { %> <h2 class=\"subheadline\"><%- headline2 %></h2> <% } %> <% if(headline3.length) { %> <h3 class=\"description\"><%- headline3 %></h3> <% } %> <% if(sponsor_img !== '') { %> <div class=\"sponsor\"> <span><%- sponsor_text %></span><img src=\"<%= sponsor_img %>\" alt=\"\"> </div> <% } %> <div class=\"tswdg-countdown\"></div> </div> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if( isTurbo ) { ; buf.push(' <div class="turbo-wrapper"> <h1 class="headline">', (__stack.lineno=1,  turbo_vote_headline ), '</h1> <p class="description">', (__stack.lineno=1,  turbo_vote_paragraph ), '</p> </div> ');__stack.lineno=1; } ; buf.push(' <div class="vote-cta"> <div class="text-wrapper"> <h1 class="headline">', (__stack.lineno=1,  headline1 ), '</h1> ');__stack.lineno=1; if(headline2.length > 0) { ; buf.push(' <h2 class="subheadline">', (__stack.lineno=1,  headline2 ), '</h2> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(headline3.length) { ; buf.push(' <h3 class="description">', (__stack.lineno=1,  headline3 ), '</h3> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(sponsor_img !== '') { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=1,  sponsor_text ), '</span><img src="', escape((__stack.lineno=1,  sponsor_img )), '" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' <div class="tswdg-countdown"></div> </div> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if(background_color !== '') { %> <%= namespace %> { background-color: <%= background_color %>; } <% } %> <% if(headline1_color !== '') { %> <%= namespace %> .header-text h1 { color: <%= headline1_color %>; } <% } %> <% if(headline2_color !== '') { %> <%= namespace %> .header-text h2 { color: <%= headline2_color %>; } <% } %> <% if(paragraph_color !== '') { %> <%= namespace %> .header-text p, <%= namespace %> .header-text span { color: <%= paragraph_color %>; } <% } %> <% if(background_image_mobile.length) { %> <%= namespace %> .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url('<%= background_image_mobile %>'); background-repeat: no-repeat; background-position: center; background-size: cover; } <% } else if(background_image_tablet.length) { %> <%= namespace %> .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url('<%= background_image_tablet %>'); background-repeat: no-repeat; background-position: center; background-size: cover; } <% } else if(background_image.length) { %> <%= namespace %> .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url('<%= background_image %>'); background-repeat: no-repeat; background-position: center; background-size: cover; } <% } %> @media(min-width: 660px) { <% if(background_image_tablet.length) { %> <%= namespace %> .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url('<%= background_image_tablet %>'); background-repeat: no-repeat; background-position: center; background-size: cover; } <% } else if(background_image.length) { %> <%= namespace %> .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url('<%= background_image %>'); background-repeat: no-repeat; background-position: center; background-size: cover; } <% } %> } @media(min-width: 980px) { <% if(background_image.length) { %> <%= namespace %> .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url('<%= background_image %>'); background-repeat: no-repeat; background-position: center; background-size: cover; } <% } %> }", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if(background_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' { background-color: ', escape((__stack.lineno=1,  background_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(headline1_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .header-text h1 { color: ', escape((__stack.lineno=1,  headline1_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(headline2_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .header-text h2 { color: ', escape((__stack.lineno=1,  headline2_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(paragraph_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .header-text p, ', escape((__stack.lineno=1,  namespace )), ' .header-text span { color: ', escape((__stack.lineno=1,  paragraph_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(background_image_mobile.length) { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url(\'', escape((__stack.lineno=1,  background_image_mobile )), '\'); background-repeat: no-repeat; background-position: center; background-size: cover; } ');__stack.lineno=1; } else if(background_image_tablet.length) { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url(\'', escape((__stack.lineno=1,  background_image_tablet )), '\'); background-repeat: no-repeat; background-position: center; background-size: cover; } ');__stack.lineno=1; } else if(background_image.length) { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url(\'', escape((__stack.lineno=1,  background_image )), '\'); background-repeat: no-repeat; background-position: center; background-size: cover; } ');__stack.lineno=1; } ; buf.push(' @media(min-width: 660px) { ');__stack.lineno=1; if(background_image_tablet.length) { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url(\'', escape((__stack.lineno=1,  background_image_tablet )), '\'); background-repeat: no-repeat; background-position: center; background-size: cover; } ');__stack.lineno=1; } else if(background_image.length) { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url(\'', escape((__stack.lineno=1,  background_image )), '\'); background-repeat: no-repeat; background-position: center; background-size: cover; } ');__stack.lineno=1; } ; buf.push(' } @media(min-width: 980px) { ');__stack.lineno=1; if(background_image.length) { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .vote-cta { background: linear-gradient(225deg, transparent, rgba(0,0,0,.7)), url(\'', escape((__stack.lineno=1,  background_image )), '\'); background-repeat: no-repeat; background-position: center; background-size: cover; } ');__stack.lineno=1; } ; buf.push(' }'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if(background_color !== '') { %> <%= namespace %> .cta-container { background-color: <%= background_color %>; } <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if(background_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .cta-container { background-color: ', escape((__stack.lineno=1,  background_color )), '; } ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var ViewTimer = __webpack_require__(102);
var template = __webpack_require__(218);
var templateCSS = __webpack_require__(219);
var CSSView = __webpack_require__(35);

module.exports = Backbone.View.extend({
    className: 'view-footer',
    events: {
        'click .sign-out': 'signout',
        'click .login': 'login'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.uid = options.uid;
        this.style_id = this.className + "_" + Math.round(Math.random() * 1000000);
        this.css = this.model.get('copy')['customization'];
        this.$el.addClass(this.style_id);
        this.auth = this.model.get('auth');
        this.window = this.model.get('window');
        this.modelTimer = options.modelTimer;

        this.initCountdown();

        this.listenTo(this.auth, 'change:isAuthorized', this.updateLogoutButton.bind(this));
        this.listenTo(this.model, 'change:copy', this.renderAll.bind(this));
        this.listenTo(this.window, 'change:appState', this.updateCountdown.bind(this));
    },
    /**
     *
     */
    render: function render() {
        if (this.CSSView) this.CSSView.remove();

        this.CSSView = new CSSView({
            model: this.css,
            namespace: '#' + this.uid + ' .' + this.style_id + '.' + this.className,
            template: templateCSS
        });

        Backbone.$('head').append(this.CSSView.render().$el);
        this.$el.html(template(this.model.get('copy')));
        return this;
    },
    /**
     *
     */
    renderedToDom: function renderedToDom() {
        if (this.window.get('appState') === 'open' && this.model.get('copy').display_countdown === '1' && this.modelTimer.attributes.isResetting) {
            this.$('.tswdg-countdown').append(this.countdownView.render().$el);
            this.countdownView.renderedToDom();
        }
        this.updateLogoutButton();
    },
    /**
     * Call the render and renderedToDom functions
     */
    renderAll: function renderAll() {
        this.render();
        this.renderedToDom();
    },
    /**
     * Initialize the countdown timer
     */
    initCountdown: function initCountdown() {
        this.countdownView = new ViewTimer({
            model: this.modelTimer,
            allowReset: true,
            countdownCopy: this.model.get('countdownCopy')
        });
    },
    /**
     * Updates the countdown timer
     */
    updateCountdown: function updateCountdown() {
        if (this.window.get('appState') !== 'open') {
            this.countdownView.remove();
        } else {
            this.initCountdown();
        }
        this.renderAll();
    },
    /**
     * Updates the log out button
     */
    updateLogoutButton: function updateLogoutButton() {
        if (this.auth.get('isAuthorized')) {
            this.$('.auth').show();
        } else {
            this.$('.auth').hide();
        }
    },
    /**
     * [signout description]
     * @return {[type]} [description]
     */
    signout: function signout() {
        var omParams = { name: 'logout button', url: window.location.href };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Logout' };

        PubSub.trigger('linkClick', omParams, gaParams);
        PubSub.trigger('logout');
    },
    /**
     * [login description]
     * @return {[type]} [description]
     */
    login: function login() {
        var omParams = { name: 'login button', url: window.location.href };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Login' };

        PubSub.trigger('linkClick', omParams, gaParams);
        PubSub.trigger('directRoute', 'auth');

        $('.navbar').removeClass('open');
    },
    /**
     * Remove the footer view
     */
    remove: function remove() {
        this.countdownView.remove();
        this.stopListening();
        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"tswdg-countdown\"></div> <div class=\"auth\"> <div class=\"user\"> <span class=\"sign-out\"><%= logout_text %></span> </div> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="tswdg-countdown"></div> <div class="auth"> <div class="user"> <span class="sign-out">', escape((__stack.lineno=1,  logout_text )), '</span> </div> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if(share_color !== '') { %> <%= namespace %> .share { color: <%= share_color %>; } <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if(share_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .share { color: ', escape((__stack.lineno=1,  share_color )), '; } ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(221);
var getScrollY = __webpack_require__(103);

module.exports = Backbone.View.extend({
    className: 'view-progress',
    _domRefs: {},
    _headerHeight: 0,
    _windowHeight: 0,
    _elsCached: false,
    _handleScrollRef: null,
    events: {
        'click .btn-submit': 'submitVotes'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');
        options = options || {};

        this.auth = this.model.get('auth');
        this.categories = this.model.get('categories');
        this.window = this.model.get('window');
        this.cms = options.cms;

        var isPrenomPhase = _.checkIfTrue(this.model.get('copy')['submit_button']['display']);
        this.isSubmitDisabled = true;

        this.listenTo(this.window, 'change:appState', this.render.bind(this));
        this.listenTo(this.categories, 'change', this.render.bind(this));
        this.listenTo(this.auth, 'change:voteData', this.render.bind(this));
        this.listenTo(this.model, 'change:copy', this.render.bind(this));
        this.listenTo(PubSub, 'window:scroll', this.handleScroll.bind(this));
        this.listenTo(PubSub, 'window:resize', this.handleResize.bind(this));
        this.listenTo(PubSub, 'vote-allocation-change', this.handleAllocationChange.bind(this));

        if (isPrenomPhase) {
            this.listenTo(PubSub, 'voteSuccess', this.handleVoteSuccessOnPrenomPhase.bind(this));
            this.listenTo(PubSub, 'logout', this.handleLogoutOnPrenomPhase.bind(this));
            this.listenTo(this.categories.models[0], 'change:isSubmitted', this.handleSubmitted.bind(this));
        }
    },
    /**
     *
     */
    render: function render() {
        var voteLimit = this.cms.turboVote.get('voteLimit');
        var votesRemaining = voteLimit - this.categories.models[0].get('totalAllocatedVotes');

        var appState = this.window.get('appState');
        var displayProgress = parseInt(this.model.get('copy').display);

        if (appState !== 'open' || !displayProgress) {
            this.$el.html('');
            document.body.classList.add('no-progress');
            return this;
        }

        var totalActiveCategories = this.categories.getTotalActiveCategories();
        var totalSubmittedCategories = this.categories.getTotalSubmittedCategories();

        var model = {
            text: this.model.get('copy').text.replace('{{CATEGORIES}}', totalActiveCategories),
            votes: totalSubmittedCategories,
            isSubmitDisplayed: _.checkIfTrue(this.model.get('copy')['submit_button']['display']),
            isSubmitDisabled: this.isSubmitDisabled || this.categories.models[0].get('isSubmitted'),
            submitCopy: this.model.get('copy')['submit_button']['copy'],
            voteLimit: voteLimit,
            votesRemaining: votesRemaining
        };
        this.$el.html(template(model));

        this.cacheDomRefs();
        this.handleResize();

        document.body.classList.remove('no-progress');
        return this;
    },
    handleAllocationChange: function handleAllocationChange(isDisabled) {
        var isSubmitted = this.categories.models[0].get('isSubmitted');
        this.isSubmitDisabled = isDisabled || isSubmitted;
        this.render();
    },
    /**
     *
     */
    renderedToDom: function renderedToDom() {
        this.handleScroll();
    },
    /**
     * cacheDomRefs
     */
    cacheDomRefs: function cacheDomRefs() {

        if (this._elsCached) return;

        this._domRefs = ['vote-progress', 'view-progress'].reduce(function (memo, className) {

            memo[className] = $('.' + className);

            return memo;
        }, { 'mtv-header': $('#header') });

        this._elsCached = true;
    },
    /**
     * checkIfProgressBarShouldBeSticky
     * checks if the fixed position progress bar is below its container in y position
     */
    checkIfProgressShouldBeSticky: function checkIfProgressShouldBeSticky(scrollPos) {

        this.cacheDomRefs();

        var containerPosition = this._domRefs['vote-progress'].position();
        var containerHeight = this._domRefs['view-progress'].outerHeight();

        if (containerPosition) {

            var containerYPos = containerPosition.top;

            return scrollPos <= containerYPos + containerHeight - this._windowHeight;
        }

        return false;
    },
    /**
     * handleScroll
     * @param {integer} scrollPos - optional scrollY position
     */
    handleScroll: function handleScroll(scrollPos) {

        if (!this.categories.getTotalActiveCategories()) return;

        scrollPos = scrollPos || getScrollY();

        var makeSticky = this.checkIfProgressShouldBeSticky(scrollPos);
        var $progressEl = this._domRefs['view-progress'];
        var showProgress = this._headerHeight < scrollPos;

        this.$el.parent().toggleClass('progress-show', showProgress);
        $progressEl && $progressEl.toggleClass('progress-fixed', makeSticky);
    },
    submitVotes: function submitVotes() {
        var cat = this.model.get("categories").models[0];
        var data = {
            categoryID: cat.get("id"),
            categoryName: cat.get('name'),
            categoryVoteData: cat.get("categoryVotes"),
            totalAllocatedVotes: cat.get("totalAllocatedVotes")
        };
        PubSub.trigger("submitVotes", data);
    },
    /**
     *
     */
    handleResize: function handleResize() {
        this._headerHeight = this._domRefs['mtv-header'] ? this._domRefs['mtv-header'].outerHeight() : 0;
        this._windowHeight = window.innerHeight || document.documentElement.clientHeight;
    },
    /**
     * https://telescopetv.atlassian.net/browse/MV-1146
     * client requested to hide the fixed footer when a user submitted a vote.. ONLY on PRENOM phase
     */
    handleVoteSuccessOnPrenomPhase: function handleVoteSuccessOnPrenomPhase() {
        this.$el.hide();
    },
    /**
     * https://telescopetv.atlassian.net/browse/MV-1146
     * new requirements from client requires us to hide this view after the user submits a vote.
     * we now need to show the view again if the user logs out bc if we dont and another user logs in w/o
     * refreshing the browser, the view will stay hidden
     */
    handleLogoutOnPrenomPhase: function handleLogoutOnPrenomPhase() {
        this.$el.show();
    },
    /**
     * this function is needed to hide this view once the user has logged in and the app has determined that the user has voted already
     */
    handleSubmitted: function handleSubmitted(hasUserVotedAlredy) {
        if (hasUserVotedAlredy) {
            this.handleVoteSuccessOnPrenomPhase();
        }
    },
    /**
     * remove
     */
    remove: function remove() {
        clearTimeout(this._handleScrollRef);
        this.stopListening();
        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"progress-container\"> <% if(isSubmitDisplayed){ %> <span class=\"votes-remaining\"><%- votesRemaining %></span> / <span class=\"vote-limit\"><%- voteLimit %></span> votes remaining <button <%- isSubmitDisabled? 'disabled': '' %> class=\"btn-submit\"><%- submitCopy %></button> <% } else{ %> <span class=\"user-vote\"><%- votes %></span><%- text %> <% } %> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="progress-container"> ');__stack.lineno=1; if(isSubmitDisplayed){ ; buf.push(' <span class="votes-remaining">', (__stack.lineno=1,  votesRemaining ), '</span> / <span class="vote-limit">', (__stack.lineno=1,  voteLimit ), '</span> votes remaining <button ', (__stack.lineno=1,  isSubmitDisabled? 'disabled': '' ), ' class="btn-submit">', (__stack.lineno=1,  submitCopy ), '</button> ');__stack.lineno=1; } else{ ; buf.push(' <span class="user-vote">', (__stack.lineno=1,  votes ), '</span>', (__stack.lineno=1,  text ), ' ');__stack.lineno=1; } ; buf.push(' </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(223);
var templateCSS = __webpack_require__(224);
var CSSView = __webpack_require__(35);

module.exports = Backbone.View.extend({
  className: 'view-landing',
  events: {
    'click .category-button': 'routeCategory'
  },
  /**
   *
   */
  initialize: function initialize(options) {
    _.bindAll(this, 'render', 'renderedToDom', 'remove');

    this.cms = options.cms;
    this.collection = this.model.get('collection');
    this.professionals = this.model.get('professionals');

    this.user = this.model.get('user');

    this.uid = options.uid;
    this.style_id = this.className + "_" + Math.round(Math.random() * 1000000);
    this.css = this.model.get('copy')['customization'];

    this.$el.addClass(this.style_id);

    this.state = this.model.get('window');

    this.sortedCategories = this.sortAllCategories();
    this.sortedProfessionals = this.sortAllProfessionals();

    this.listenTo(this.collection, 'change:active', this.onChangeCatActive.bind(this));
    this.listenTo(this.collection, 'change:isSubmitted', this.onChangeCatSubmitted.bind(this));
    this.listenTo(this.collection, 'change:totalAllocatedVotes', this.onChangeTotalAllocatedVotes.bind(this));
    this.listenTo(this.professionals, 'change:active', this.onChangeProfessionalActive.bind(this));

    this.listenTo(this.state, 'change:appState', function () {
      var updatedProfessionals = this.sortAllProfessionals();
      var updatedCategories = this.sortAllCategories();

      if (!_.isEqual(updatedProfessionals, this.sortedProfessionals) || !_.isEqual(updatedCategories, this.sortedCategories)) {
        this.sortedCategories = updatedCategories;
        this.sortedProfessionals = updatedProfessionals;
        this.updateCategories();
      } else if (this.state.get('appState') == 'winner') {
        this.$el.find('.category-button').addClass('active');
        PubSub.trigger('openAllCategories');
      }
    }.bind(this));

    // Add in the logic to add and remove the active status when all the categories close
    this.listenTo(PubSub, 'closeAllCategories', function (viewToOpen, id) {
      /* MMA-609:
       * iOS 8.1 on iPhone 5C seems to have problems resolving the initial animation and removeClass('active') calls.
       * The .category-button divs seem to get stuck in a half active state, even when the DOM Inspector shows that
       * they do not have the .active class applied.
       * Wrapping it in a setTimeout with a zero delay puts this code back into the JS event loop and
       * allows all everything else to finish before executing this code.
       */
      setTimeout(function () {
        this.$el.find('.category-button.active').removeClass('active');
        this.$el.find('.category-button[data-category-id="' + id + '"]').addClass('active');
      }.bind(this), 0);
    }.bind(this));
  },
  /**
   *
   */
  render: function render() {

    if (this.CSSView) this.CSSView.remove();

    this.CSSView = new CSSView({
      model: this.css,
      namespace: '#' + this.uid + ' .' + this.style_id + '.' + this.className,
      template: templateCSS
    });

    Backbone.$('head').append(this.CSSView.render().$el);

    var sectionOneCategories = this.sortedCategories.filter(function (category) {
      return category.vote_section === '1';
    });
    var sectionTwoCategories = this.sortedCategories.filter(function (category) {
      return category.vote_section === '2';
    });

    var model = {
      sectionOneCategories: sectionOneCategories,
      sectionTwoCategories: sectionTwoCategories,
      professionalCategories: this.sortedProfessionals,
      copy: this.model.get('copy'),
      user: this.user.toJSON().voteData,
      closedCatDescription: this.cms.get('text').view_grid.closed_cat_description,
      socialCopy: this.cms.get('text').view_social_category,
      liveVoteBattleDescription: this.cms.get('text').view_live_vote_category.hashtag_battle_description,
      voteLimit: this.cms.turboVote.get('voteLimit'),
      window: this.state.get('appState')
    };

    this.$el.html(template(model));
    return this;
  },
  /**
   * [renderedToDom description]
   * @return {[type]} [description]
   */
  renderedToDom: function renderedToDom() {
    if (this.state.get('appState') == 'winner') {
      this.$el.find('.category-button').addClass('active');
      PubSub.trigger('openAllCategories', true);
    }
  },
  /**
   * When the active categories change, we need to refresh the grid view
   * to ensure the active ones are updated to the top of the grid
   */
  onChangeCatActive: function onChangeCatActive() {
    var updatedCategories = this.sortAllCategories();
    if (!_.isEqual(updatedCategories, this.sortedCategories)) {
      this.sortedCategories = updatedCategories;
      this.updateCategories();
    }
  },
  /**
   * Handler for when the isSubmitted attribute of a category changes
   */
  onChangeCatSubmitted: function onChangeCatSubmitted(category) {
    if (category.get('isSubmitted')) {
      this.$('.votes-submitted.cat-' + category.get('id')).show();
      this.$('.votes-remaining-wrapper.cat-' + category.get('id')).hide();
    } else {
      this.$('.votes-submitted.cat-' + category.get('id')).hide();
      this.$('.votes-remaining-wrapper.cat-' + category.get('id')).show();
    }
  },
  /**
   * When the active professional categories change, we need to refresh the
   * grid view to ensure the active ones are updated to the top of the grid
   */
  onChangeProfessionalActive: function onChangeProfessionalActive() {
    var updatedProfessionals = this.sortAllProfessionals();
    if (!_.isEqual(updatedProfessionals, this.sortedProfessionals)) {
      this.sortedProfessionals = updatedProfessionals;
      this.updateCategories();
    }
  },
  /**
   * Handler for when the totalAllocatedVotes attribute of a category changes
   */
  onChangeTotalAllocatedVotes: function onChangeTotalAllocatedVotes(category) {
    var voteLimit = this.cms.turboVote.get('voteLimit');
    var votesRemaining = voteLimit - category.get('totalAllocatedVotes');
    var isLiveVote = _.checkIfTrue(this.cms.get('text').live_vote);

    this.$('.votes-remaining.cat-' + category.get('id')).text(votesRemaining);

    // when user allocated all votes, display confirmation modal
    if (!votesRemaining && !isLiveVote) PubSub.trigger('modalConfirm', category);
  },
  /**
   * [sortAllProfessionals description]
   * @return {[type]} [description]
   */
  sortAllProfessionals: function sortAllProfessionals() {
    var updatedProfessional = [];

    var sortedCategories = _.filter(this.professionals.models, function (model) {
      var modelToStore = _.clone(model.attributes, true);

      modelToStore.winner = [];
      modelToStore.contestantCount = modelToStore.voteData.length;
      modelToStore.voteData = [];
      modelToStore.copy = {};
      modelToStore.ad = [];
      modelToStore.collectionID = model.id;

      updatedProfessional.push(modelToStore);
    });

    return updatedProfessional;
  },
  /**
   *
   */
  updateCategories: _.debounce(function () {
    PubSub.trigger('closeAllCategories', null, null, function () {
      this.render();
      this.renderedToDom();

      if (this.state.get('appState') == 'winner') {
        this.$el.find('.category-button').addClass('active');
        PubSub.trigger('openAllCategories');
      } else {
        PubSub.trigger('openFirstCategory');
      }
    }.bind(this));
  }, 200),
  /**
   *
   */
  sortAllCategories: function sortAllCategories() {
    var openCategories = [];
    var closedCategories = [];
    var unsortedCategories = [];
    var categories = [];

    var sortedCategories = _.filter(this.collection.models, function (model) {
      var modelToStore = _.extend({}, _.clone(model.attributes, true));
      modelToStore.collectionID = model.id;

      // always default the winner value and voteData to []
      // ensures changes for voteData and winner happens in the category
      // NOT the grid viw
      modelToStore.winner = [];
      modelToStore.copy = {};
      modelToStore.ad = [];
      modelToStore.contestantCount = modelToStore.voteData.length;
      modelToStore.voteData = [];

      unsortedCategories.push(modelToStore);

      if (modelToStore.active == '1') {
        openCategories.push(modelToStore);
      } else {
        closedCategories.push(modelToStore);
      }
    });

    if (this.state.get('appState') !== 'open') {
      return unsortedCategories;
    }

    categories = openCategories.concat(closedCategories);

    return categories;
  },
  /**
   *
   */
  routeCategory: _.debounce(function (e) {
    var $category = $(e.currentTarget);
    var category = null;
    var categoryID = $category.data('category-id');

    $category.addClass('toggle-animations');

    if (/(professional)/.test($category[0].className)) {
      category = this.professionals.getCategoryById(categoryID.toString());
    } else {
      category = this.collection.getCategoryById(categoryID.toString());
    }

    if (category.get('voteData').length === 0) {
      return;
    }

    if ($category.hasClass('active')) {
      PubSub.trigger('hideCategory', category, $category);
    } else {
      $category.addClass('active');
      PubSub.trigger('navigate', category.get('displayName'), { isCategory: true, trigger: true });
    }

    // Sometimes toggling categories won't trigger image unveiling. Only scroll events will. 
    // Dispatch scroll.unveil event to trigger lazy loading on category toggle 
    $(window).trigger('scroll.unveil');
  }, 700, { leading: true, trailing: false })
});

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% sectionOneCategories.forEach(function(value, index, list) {\n  var votesRemaining = voteLimit - value.totalAllocatedVotes;\n%> <div data-category-id=\"<%= value.collectionID %>\" class=\"<%= (index === (list.length-1))? 'last ' : '' %>category-button voting <%= (value.contestantCount === 0)? 'locked ' : '' %>\"> <div class=\"wrapper\"> <div class=\"cat-title wo-nominee\"> <%- value.display_name || value.name %> <span class=\"chev-icon\"></span> </div> <% if(value.social === '1') { %> <div class=\"votes-social\"><%- socialCopy['social_1']['social_description'] %></div> <% } else if (value.social === '2') { %> <div class=\"votes-social\"><%- socialCopy['social_2']['social_description'] %></div> <% } else if (value.social === '3') { %> <div class=\"votes-social\"><%- socialCopy['social_3']['social_description'] %></div> <% } else if(value.live_vote === '1') { %> <div class=\"votes-live-vote\"><%- liveVoteBattleDescription %></div> <% } else if(value.active === '0') { %> <div class=\"votes-closed\"><%- closedCatDescription %></div> <% } else { %> <div class=\"votes-remaining-wrapper cat-<%= value.collectionID %>\" style=\"<%= value.isSubmitted ? 'display:none' : '' %>\"> <span class=\"votes-remaining cat-<%= value.collectionID %>\"><%= votesRemaining %></span> / <span class=\"vote-limit\"><%= voteLimit %></span> votes remaining </div> <div class=\"votes-submitted-wrapper\"> <span class=\"votes-submitted cat-<%= value.collectionID %>\" style=\"<%= !value.isSubmitted ? 'display:none' : '' %>\">VOTES SUBMITTED</span> </div> <% } %> </div> </div> <div class=\"cat-section\"> <div class=\"<%= (index === (list.length-1))? 'last ' : '' %>grid-container\" data-category-id=\"<%= value.collectionID %>\"></div> </div> <% }); %> <% if(sectionTwoCategories.length > 0){ %> <div class=\"section-2-header\"> <div class=\"text-wrapper\"> <h1 class=\"headline\"><%- copy.vote_section_2_headline %></h1> <% if(copy.vote_section_2_subheadline.length > 0) { %> <h2 class=\"subheadline\"><%- copy.vote_section_2_subheadline %></h2> <% } %> <% if(copy.vote_section_2_description.length > 0) { %> <h3 class=\"description\"><%- copy.vote_section_2_description %></h3> <% } %> </div> </div> <% } %> <% sectionTwoCategories.forEach(function(value, index, list) {\n  var votesRemaining = voteLimit - value.totalAllocatedVotes;\n%> <div data-category-id=\"<%= value.collectionID %>\" class=\"<%= (index === (list.length-1))? 'last ' : '' %>category-button voting\"> <div class=\"wrapper\"> <div class=\"cat-title wo-nominee\"> <%- value.display_name || value.name %> <span class=\"chev-icon\"></span> </div> <% if(value.social === '1') { %> <div class=\"votes-social\"><%- socialCopy['social_1']['social_description'] %></div> <% } else if (value.social === '2') { %> <div class=\"votes-social\"><%- socialCopy['social_2']['social_description'] %></div> <% } else if (value.social === '3') { %> <div class=\"votes-social\"><%- socialCopy['social_3']['social_description'] %></div> <% } else if(value.live_vote === '1') { %> <div class=\"votes-live-vote\"><%- liveVoteBattleDescription %></div> <% } else if(value.active === '0') { %> <div class=\"votes-closed\"><%- closedCatDescription %></div> <% } else { %> <div class=\"votes-remaining-wrapper cat-<%= value.collectionID %>\" style=\"<%= value.isSubmitted ? 'display:none' : '' %>\"> <span class=\"votes-remaining cat-<%= value.collectionID %>\"><%= votesRemaining %></span> / <span class=\"vote-limit\"><%= voteLimit %></span> votes remaining </div> <div class=\"votes-submitted-wrapper\"> <span class=\"votes-submitted cat-<%= value.collectionID %>\" style=\"<%= !value.isSubmitted ? 'display:none' : '' %>\">VOTES SUBMITTED</span> </div> <% } %> </div> </div> <div class=\"cat-section\"> <div class=\"<%= (index === (list.length-1))? 'last ' : '' %>grid-container\" data-category-id=\"<%= value.collectionID %>\"></div> </div> <% }); %> <% if(professionalCategories.length > 0){ %> <div class=\"section-2-header\"> <div class=\"text-wrapper\"> <h1 class=\"headline\"><%- copy.headline_professional %></h1> <% if(copy.subheadline_professional.length > 0) { %> <h2 class=\"subheadline\"><%- copy.subheadline_professional %></h2> <% } %> </div> </div> <% } %> <% professionalCategories.forEach(function(value, index) { %> <div data-category-id=\"<%= value.collectionID %>\" class=\"category-button professional\"> <div class=\"wrapper\"> <div class=\"cat-title wo-nominee\"> <%- value.name %> <span class=\"chev-icon\"></span> </div> </div> </div> <div class=\"cat-section\"> <div class=\"grid-container professional-grid\" data-category-id=\"<%= value.collectionID %>\"></div> </div> <% }) %> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; sectionOneCategories.forEach(function(value, index, list) {
  var votesRemaining = voteLimit - value.totalAllocatedVotes;
; buf.push(' <div data-category-id="', escape((__stack.lineno=3,  value.collectionID )), '" class="', escape((__stack.lineno=3,  (index === (list.length-1))? 'last ' : '' )), 'category-button voting ', escape((__stack.lineno=3,  (value.contestantCount === 0)? 'locked ' : '' )), '"> <div class="wrapper"> <div class="cat-title wo-nominee"> ', (__stack.lineno=3,  value.display_name || value.name ), ' <span class="chev-icon"></span> </div> ');__stack.lineno=3; if(value.social === '1') { ; buf.push(' <div class="votes-social">', (__stack.lineno=3,  socialCopy['social_1']['social_description'] ), '</div> ');__stack.lineno=3; } else if (value.social === '2') { ; buf.push(' <div class="votes-social">', (__stack.lineno=3,  socialCopy['social_2']['social_description'] ), '</div> ');__stack.lineno=3; } else if (value.social === '3') { ; buf.push(' <div class="votes-social">', (__stack.lineno=3,  socialCopy['social_3']['social_description'] ), '</div> ');__stack.lineno=3; } else if(value.live_vote === '1') { ; buf.push(' <div class="votes-live-vote">', (__stack.lineno=3,  liveVoteBattleDescription ), '</div> ');__stack.lineno=3; } else if(value.active === '0') { ; buf.push(' <div class="votes-closed">', (__stack.lineno=3,  closedCatDescription ), '</div> ');__stack.lineno=3; } else { ; buf.push(' <div class="votes-remaining-wrapper cat-', escape((__stack.lineno=3,  value.collectionID )), '" style="', escape((__stack.lineno=3,  value.isSubmitted ? 'display:none' : '' )), '"> <span class="votes-remaining cat-', escape((__stack.lineno=3,  value.collectionID )), '">', escape((__stack.lineno=3,  votesRemaining )), '</span> / <span class="vote-limit">', escape((__stack.lineno=3,  voteLimit )), '</span> votes remaining </div> <div class="votes-submitted-wrapper"> <span class="votes-submitted cat-', escape((__stack.lineno=3,  value.collectionID )), '" style="', escape((__stack.lineno=3,  !value.isSubmitted ? 'display:none' : '' )), '">VOTES SUBMITTED</span> </div> ');__stack.lineno=3; } ; buf.push(' </div> </div> <div class="cat-section"> <div class="', escape((__stack.lineno=3,  (index === (list.length-1))? 'last ' : '' )), 'grid-container" data-category-id="', escape((__stack.lineno=3,  value.collectionID )), '"></div> </div> ');__stack.lineno=3; }); ; buf.push(' ');__stack.lineno=3; if(sectionTwoCategories.length > 0){ ; buf.push(' <div class="section-2-header"> <div class="text-wrapper"> <h1 class="headline">', (__stack.lineno=3,  copy.vote_section_2_headline ), '</h1> ');__stack.lineno=3; if(copy.vote_section_2_subheadline.length > 0) { ; buf.push(' <h2 class="subheadline">', (__stack.lineno=3,  copy.vote_section_2_subheadline ), '</h2> ');__stack.lineno=3; } ; buf.push(' ');__stack.lineno=3; if(copy.vote_section_2_description.length > 0) { ; buf.push(' <h3 class="description">', (__stack.lineno=3,  copy.vote_section_2_description ), '</h3> ');__stack.lineno=3; } ; buf.push(' </div> </div> ');__stack.lineno=3; } ; buf.push(' ');__stack.lineno=3; sectionTwoCategories.forEach(function(value, index, list) {
  var votesRemaining = voteLimit - value.totalAllocatedVotes;
; buf.push(' <div data-category-id="', escape((__stack.lineno=5,  value.collectionID )), '" class="', escape((__stack.lineno=5,  (index === (list.length-1))? 'last ' : '' )), 'category-button voting"> <div class="wrapper"> <div class="cat-title wo-nominee"> ', (__stack.lineno=5,  value.display_name || value.name ), ' <span class="chev-icon"></span> </div> ');__stack.lineno=5; if(value.social === '1') { ; buf.push(' <div class="votes-social">', (__stack.lineno=5,  socialCopy['social_1']['social_description'] ), '</div> ');__stack.lineno=5; } else if (value.social === '2') { ; buf.push(' <div class="votes-social">', (__stack.lineno=5,  socialCopy['social_2']['social_description'] ), '</div> ');__stack.lineno=5; } else if (value.social === '3') { ; buf.push(' <div class="votes-social">', (__stack.lineno=5,  socialCopy['social_3']['social_description'] ), '</div> ');__stack.lineno=5; } else if(value.live_vote === '1') { ; buf.push(' <div class="votes-live-vote">', (__stack.lineno=5,  liveVoteBattleDescription ), '</div> ');__stack.lineno=5; } else if(value.active === '0') { ; buf.push(' <div class="votes-closed">', (__stack.lineno=5,  closedCatDescription ), '</div> ');__stack.lineno=5; } else { ; buf.push(' <div class="votes-remaining-wrapper cat-', escape((__stack.lineno=5,  value.collectionID )), '" style="', escape((__stack.lineno=5,  value.isSubmitted ? 'display:none' : '' )), '"> <span class="votes-remaining cat-', escape((__stack.lineno=5,  value.collectionID )), '">', escape((__stack.lineno=5,  votesRemaining )), '</span> / <span class="vote-limit">', escape((__stack.lineno=5,  voteLimit )), '</span> votes remaining </div> <div class="votes-submitted-wrapper"> <span class="votes-submitted cat-', escape((__stack.lineno=5,  value.collectionID )), '" style="', escape((__stack.lineno=5,  !value.isSubmitted ? 'display:none' : '' )), '">VOTES SUBMITTED</span> </div> ');__stack.lineno=5; } ; buf.push(' </div> </div> <div class="cat-section"> <div class="', escape((__stack.lineno=5,  (index === (list.length-1))? 'last ' : '' )), 'grid-container" data-category-id="', escape((__stack.lineno=5,  value.collectionID )), '"></div> </div> ');__stack.lineno=5; }); ; buf.push(' ');__stack.lineno=5; if(professionalCategories.length > 0){ ; buf.push(' <div class="section-2-header"> <div class="text-wrapper"> <h1 class="headline">', (__stack.lineno=5,  copy.headline_professional ), '</h1> ');__stack.lineno=5; if(copy.subheadline_professional.length > 0) { ; buf.push(' <h2 class="subheadline">', (__stack.lineno=5,  copy.subheadline_professional ), '</h2> ');__stack.lineno=5; } ; buf.push(' </div> </div> ');__stack.lineno=5; } ; buf.push(' ');__stack.lineno=5; professionalCategories.forEach(function(value, index) { ; buf.push(' <div data-category-id="', escape((__stack.lineno=5,  value.collectionID )), '" class="category-button professional"> <div class="wrapper"> <div class="cat-title wo-nominee"> ', (__stack.lineno=5,  value.name ), ' <span class="chev-icon"></span> </div> </div> </div> <div class="cat-section"> <div class="grid-container professional-grid" data-category-id="', escape((__stack.lineno=5,  value.collectionID )), '"></div> </div> ');__stack.lineno=5; }) ; buf.push(' '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if(category_background !== '') { %> <%= namespace %> .grid-container { background: <%= category_background %>; } <% } %> <% if(category_color !== '') { %> <%= namespace %> .category { color: <%= category_color %>; } <% } %> <% if(sponsor_color !== '') { %> <%= namespace %> .category-details .category-header .sponsor { color: <%= sponsor_color %>; } <% } %> <% if(nominee_background !== '') { %> <%= namespace %> .category-details { background-color: <%= nominee_background %>; } <% } %> <% if(nominee_color !== '') { %> <%= namespace %> .category-details .view-contestant .vote-data .contestant-information <%= namespace %> .category-details .view-contestant .vote-data .contestant-information h3 { color: <%= nominee_color %>; } <% } %> <% if(hover_backgroud !== '') { %> <%= namespace %> .category-details .view-contestant .vote-data:hover .rect-image-overlay, <%= namespace %> .category-details .view-contestant .vote-data:hover .circle-image-overlay, <%= namespace %> .category-details .view-contestant .vote-data:hover .contestant-information { background-color: <%= hover_backgroud %>; } <% } %> <% if(hover_color !== '') { %> <%= namespace %> .category-details .view-contestant .vote-data:hover .contestant-information h3, <%= namespace %> .category-details .view-contestant .vote-data:hover .contestant-information span { color: <%= hover_color %>; } <% } %> <% if(voted_color !== '') { %> <%= namespace %> .category-details.voted .view-contestant .vote-data.voted .desktop .rect-image-overlay, <%= namespace %> .category-details.voted .view-contestant .vote-data.voted:hover .desktop .rect-image-overlay, <%= namespace %> .category-details.voted .view-contestant .vote-data.voted:hover .desktop .circle-image-overlay, <%= namespace %> .category-details.voted .view-contestant .vote-data.voted .desktop .circle-image-overlay { color: <%= voted_color %>; } <% } %> <% if(voted_background !== '') { %> <%= namespace %> .category-details .view-contestant .vote-data.voted .rect-image-overlay, <%= namespace %> .category-details .view-contestant .vote-data.voted .circle-image-overlay { background-color: <%= voted_background %>; } <% } %> <% if(already_voted_color !== '') { %> <%= namespace %> .category-details .view-contestant .vote-data .desktop .error-text h2, <%= namespace %> .category-details .view-contestant .vote-data .desktop .error-text span { color: <%= already_voted_color %>; } <% } %> <% if(already_voted_background !== '') { %> <%= namespace %> .category-details .view-contestant .vote-data .desktop .error-text { background-color: <%= already_voted_background %>; } <% } %> <% if(watch_button_background !== '') { %> <%= namespace %> .category-details .category-header .video button { background: <%= watch_button_background %>; } <% } %> <% if(watch_button_color !== '') { %> <%= namespace %> .category-details .category-header .video button { color: <%= watch_button_color %>; } <% } %> <% if(watch_button_border_color !== '') { %> <%= namespace %> .category-details .category-header .video button { border-color: <%= watch_button_border_color %>; } <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if(category_background !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .grid-container { background: ', escape((__stack.lineno=1,  category_background )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(category_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category { color: ', escape((__stack.lineno=1,  category_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(sponsor_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .category-header .sponsor { color: ', escape((__stack.lineno=1,  sponsor_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(nominee_background !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details { background-color: ', escape((__stack.lineno=1,  nominee_background )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(nominee_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data .contestant-information ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data .contestant-information h3 { color: ', escape((__stack.lineno=1,  nominee_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(hover_backgroud !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data:hover .rect-image-overlay, ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data:hover .circle-image-overlay, ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data:hover .contestant-information { background-color: ', escape((__stack.lineno=1,  hover_backgroud )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(hover_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data:hover .contestant-information h3, ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data:hover .contestant-information span { color: ', escape((__stack.lineno=1,  hover_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(voted_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details.voted .view-contestant .vote-data.voted .desktop .rect-image-overlay, ', escape((__stack.lineno=1,  namespace )), ' .category-details.voted .view-contestant .vote-data.voted:hover .desktop .rect-image-overlay, ', escape((__stack.lineno=1,  namespace )), ' .category-details.voted .view-contestant .vote-data.voted:hover .desktop .circle-image-overlay, ', escape((__stack.lineno=1,  namespace )), ' .category-details.voted .view-contestant .vote-data.voted .desktop .circle-image-overlay { color: ', escape((__stack.lineno=1,  voted_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(voted_background !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data.voted .rect-image-overlay, ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data.voted .circle-image-overlay { background-color: ', escape((__stack.lineno=1,  voted_background )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(already_voted_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data .desktop .error-text h2, ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data .desktop .error-text span { color: ', escape((__stack.lineno=1,  already_voted_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(already_voted_background !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .view-contestant .vote-data .desktop .error-text { background-color: ', escape((__stack.lineno=1,  already_voted_background )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(watch_button_background !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .category-header .video button { background: ', escape((__stack.lineno=1,  watch_button_background )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(watch_button_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .category-header .video button { color: ', escape((__stack.lineno=1,  watch_button_color )), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(watch_button_border_color !== '') { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .category-details .category-header .video button { border-color: ', escape((__stack.lineno=1,  watch_button_border_color )), '; } ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"cta-container\"></div> <div class=\"main\" role=\"main\"></div> <footer> <div class=\"vote-progress\"></div> </footer> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="cta-container"></div> <div class="main" role="main"></div> <footer> <div class="vote-progress"></div> </footer> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var ViewContestant = __webpack_require__(51);
var ViewAd = __webpack_require__(52);
var ViewCategorySubmit = __webpack_require__(229);
var template = __webpack_require__(231);

var _require = __webpack_require__(21),
    isMobile = _require.isMobile;

module.exports = Backbone.View.extend({
    className: 'flex-container',
    events: {
        'click .btn': 'loadVideo'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.voteData = null;
        this.recentlyVoted = false;
        this.timeOut = null;
        this.cms = options.cms;
        this.hideAnimation = options.hideAnimation || false;
        this.initialAnimation = _.isUndefined(options.initialAnimation) ? true : options.initialAnimation;
        this.contestantToIncrementID = options.contestantToIncrementID;

        this.dimensions = options.dimensions;
        this.user = options.user;
        this.contestantsArray = [];

        this.copy = options.copy;
        this.transitionTime = parseInt(this.cms.get('text').customization.transition_time) || 500;

        this.listenTo(this.model, 'change:totalAllocatedVotes', this.updatePlusButtons.bind(this));

        this.listenTo(this.model, 'change:isSubmitted', function (model, isSubmitted) {
            if (isSubmitted) this.renderedToDom(true);
        }.bind(this));

        this.listenTo(this.model, 'change:categoryVotes', function (model, updatedVoteCounts) {
            this.contestantsArray.forEach(function (view) {
                var model = view.model;
                var contestantId = model.get('id');
                var value = updatedVoteCounts[contestantId];

                if (value) model.set('voteCount', parseInt(value, 10));
            });
        }.bind(this));
    },

    /**
     *
     */
    render: function render() {
        var model = this.model.toJSON();
        model.copy = this.copy;
        this.$el.css({ height: '0' });
        this.$el.html(template(model));

        var sortedContestants = this.model.get('voteData');
        sortedContestants.sort(function (a, b) {
            return parseInt(a.order, 10) - parseInt(b.order, 10);
        });

        _.forEach(sortedContestants, function (value) {

            var voteCount = this.model.get('categoryVotes')[value.id] ? this.model.get('categoryVotes')[value.id] : 0;
            var contestantModel = new Backbone.Model(_.extend({ voteCount: voteCount }, value));
            var toBeIncremented = this.contestantToIncrementID === value.id;

            var contestant = new ViewContestant({
                cms: this.cms,
                model: contestantModel,
                user: this.user,
                dimensions: this.dimensions,
                person: this.model.get('person'),
                copy: this.copy,
                professional: this.model.get('professional'),
                social: this.model.get('social'),
                customization: this.cms.get('text').customization,
                category: this.model
            });

            this.contestantsArray.push(contestant);
            this.$('.contestants-wrapper').append(contestant.render().$el);
            contestant.renderedToDom(toBeIncremented);
        }.bind(this));

        this.updatePlusButtons(this.model);
        this.contestantToIncrementID = null;
        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom(update) {

        // add the submit button below the category
        if (!this.model.get('isSubmitted') && this.model.get('professional') === '0' && this.model.get('active') === '1') {
            var voteLimit = this.cms.turboVote.get('voteLimit');
            var votesRemaining = voteLimit - this.model.get('totalAllocatedVotes');
            this.categorySubmitView = new ViewCategorySubmit({
                model: this.model,
                voteLimit: voteLimit,
                votesRemaining: votesRemaining
            });
            this.$el.removeClass('submitted');
            this.$el.after(this.categorySubmitView.render().$el);
        } else {
            //If we don't need the category submit view, let's remove it.
            if (this.categorySubmitView && update) this.categorySubmitView.remove();
        }

        if (this.model.get('isSubmitted')) {
            this.$el.addClass('submitted');
        }

        this.$el.parent().css({ height: '0px' });

        if (parseInt(this.model.toJSON().person)) {
            this.$el.parent().addClass('circle');
        }

        if (_.checkIfTrue(this.model.get('display_ad')) && !update) {
            this.renderAd();
        }

        if (!this.hideAnimation && this.initialAnimation && !update) {
            this.scrollAnimation();
        } else {
            this.$el.parent().css({ height: 'auto' });
            this.$el.css({ height: 'auto' });
        }
    },
    /**
     * [renderAd description]
     * @return {[type]} [description]
     */
    renderAd: function renderAd() {

        if (this.adView instanceof ViewAd) return;

        this.adView = new ViewAd({
            categoryIndex: this.model.get('id'),
            adTag: this.model.get('ad_tag') || this.model.get('displayName'),
            model: this.model.get('ad')
        });

        var contestantEls = this.$el.find('.contestant');
        if (contestantEls.length > 0) {
            $(contestantEls[contestantEls.length - 1]).after(this.adView.render().$el);
        } else {
            this.$el.append(this.adView.render().$el);
        }

        this.adView.renderedToDom();
    },
    /**
     * When there are no more votes remaining, disable all the plus buttons
     */
    updatePlusButtons: function updatePlusButtons(model) {
        var totalAllocatedVotes = model.get('totalAllocatedVotes');
        var voteLimit = parseInt(this.cms.turboVote.get('voteLimit'), 10);
        if (totalAllocatedVotes === voteLimit) {
            model.updatePlusButtons();
        }
    },

    /**
     * [scrollAnimation description]
     * @return {[type]} [description]
     */
    scrollAnimation: function scrollAnimation() {
        var categoryButton = document.querySelector('.category-button[data-category-id="' + this.model.get('id') + '"]');
        var buttonTop = categoryButton.offsetTop;
        var mobileMenuHeight = isMobile.any() ? document.getElementById('header').offsetHeight : document.getElementById('mtv-mobile-menu').offsetHeight;
        var hasSkybox = document.body.classList.contains('skybox-loaded');
        var skyboxHeight = 0;

        if (hasSkybox) {
            skyboxHeight = isMobile.any() ? document.querySelector('#mobile_skybox_plus_sticky iframe').offsetHeight : document.querySelector('#skybox_leader_plus_sticky iframe').offsetHeight;
        }

        $('html,body').animate({
            scrollTop: buttonTop - mobileMenuHeight - skyboxHeight
        }, {
            duration: 200,
            complete: function () {
                // fixes issue when the function runs twice due to HTML and body attributes
                if (/(auto)/.test(this.$el.parent().attr('style'))) {
                    return false;
                }

                this.$el.parent().css({ height: 'auto' });
                this.$el.animate({
                    height: '1200px'
                }, this.transitionTime, function () {

                    $(this).css({ height: 'auto' });
                });
            }.bind(this)
        });
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function remove() {
        // remove the various Contestants views from the contestants array
        _.forEach(this.contestantsArray, function (value, index) {
            value.remove();
        });

        if (this.categorySubmitView) this.categorySubmitView.remove();

        this.contestantsArray = null;

        this.voteData = null;

        if (this.adView) {
            this.adView.remove();
            this.adView = null;
        }

        this.stopListening();
        this.off();

        this.model = null;
        this.copy = null;

        this.recentlyVoted = false;
        this.closedTextDisplayed = false;

        if (typeof this.timeOut == 'number') {
            clearTimeout(this.timeOut);console.warn('cancel timeout');
        };

        if (typeof this.removeClosedText == 'number') {
            clearTimeout(this.removeClosedText);console.warn('cancel timeout');
        };

        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"thumbnail<%= (video_url !== ''? \"\" : \" no-video-url\") %>\"> <% if(!video_url.length && external_url.length) { %> <a class=\"external-link\" target=\"_blank\" href=\"<%= external_url %>\"> <% } %> <% if(formatted_image.length > 0){ %> <div class=\"img-position\"> <div class=\"img-wrapper\"> <img src=\"\" data-src=\"<%= formatted_image %>\" alt=\"\"> </div> <div class=\"text-container\"> <% if( winner ) { %> <div class=\"badge\">WINNER</div> <% } %> <div class=\"text-line1\"><%- name %></div> <div class=\"text-line2\"><%- description %></div> <% if(alt_description !== '') { %><div class=\"text-line3\"><%= alt_description %></div><% } %> <% if(video_url.length) { %> <div class=\"watch-video\"> <span>Watch Video</span> <img src=\"images/icon-watch-video-chevron.png\" alt=\"\"> </div> <% } %> </div> </div> <% } %> <% if(!video_url.length && external_url.length) { %></a><% } %> </div> <% if(!singleVote && active === '1' && social === '0' && professional !== '1' && live_vote !== '1') { %> <div class=\"edit-container\"> <button class=\"btn-allocate btn-minus\" <% if(!voteCount){ %> disabled=\"disabled\" <% } %>> <svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <g> <circle cx=\"24\" cy=\"24\" r=\"24\"/> <rect x=\"18\" y=\"23.5\" width=\"12\" height=\"2\"/> </g> </svg> </button> <div class=\"vote-count-wrapper\"> <span class=\"vote-count\"><%- voteCount %></span> <span class=\"vote-label\">Votes</span> </div> <button class=\"btn-allocate btn-plus\" <% if(voteCount === voteLimit){ %> disabled=\"disabled\" <% } %>> <svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <circle cx=\"24\" cy=\"24\" r=\"24\"/> <path d=\"M25 18.5H23V23.5H18V25.5H23V30.5H25V25.5H30V23.5H25V18.5Z\"/> </svg> </button> </div> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="thumbnail', escape((__stack.lineno=1,  (video_url !== ''? "" : " no-video-url") )), '"> ');__stack.lineno=1; if(!video_url.length && external_url.length) { ; buf.push(' <a class="external-link" target="_blank" href="', escape((__stack.lineno=1,  external_url )), '"> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(formatted_image.length > 0){ ; buf.push(' <div class="img-position"> <div class="img-wrapper"> <img src="" data-src="', escape((__stack.lineno=1,  formatted_image )), '" alt=""> </div> <div class="text-container"> ');__stack.lineno=1; if( winner ) { ; buf.push(' <div class="badge">WINNER</div> ');__stack.lineno=1; } ; buf.push(' <div class="text-line1">', (__stack.lineno=1,  name ), '</div> <div class="text-line2">', (__stack.lineno=1,  description ), '</div> ');__stack.lineno=1; if(alt_description !== '') { ; buf.push('<div class="text-line3">', escape((__stack.lineno=1,  alt_description )), '</div>');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(video_url.length) { ; buf.push(' <div class="watch-video"> <span>Watch Video</span> <img src="images/icon-watch-video-chevron.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' </div> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(!video_url.length && external_url.length) { ; buf.push('</a>');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; if(!singleVote && active === '1' && social === '0' && professional !== '1' && live_vote !== '1') { ; buf.push(' <div class="edit-container"> <button class="btn-allocate btn-minus" ');__stack.lineno=1; if(!voteCount){ ; buf.push(' disabled="disabled" ');__stack.lineno=1; } ; buf.push('> <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <g> <circle cx="24" cy="24" r="24"/> <rect x="18" y="23.5" width="12" height="2"/> </g> </svg> </button> <div class="vote-count-wrapper"> <span class="vote-count">', (__stack.lineno=1,  voteCount ), '</span> <span class="vote-label">Votes</span> </div> <button class="btn-allocate btn-plus" ');__stack.lineno=1; if(voteCount === voteLimit){ ; buf.push(' disabled="disabled" ');__stack.lineno=1; } ; buf.push('> <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="24" cy="24" r="24"/> <path d="M25 18.5H23V23.5H18V25.5H23V30.5H25V25.5H30V23.5H25V18.5Z"/> </svg> </button> </div> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"ad-container bidbarrel-ad-container\"> <div class=\"bidbarrel-ad hasAdLabel\" id=\"<%= adId %>\"></div> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="ad-container bidbarrel-ad-container"> <div class="bidbarrel-ad hasAdLabel" id="', escape((__stack.lineno=1,  adId )), '"></div> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(230);

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-submit',
    events: {
        'click .btn-submit': 'submitVotes'
    },
    /**
     * Initialize view
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');
        this.voteLimit = options.voteLimit;
        this.votesRemaining = options.votesRemaining;
        this.isSubmitDisabled = !this.model.get('totalAllocatedVotes');
        this.listenTo(this.model, 'change:totalAllocatedVotes', this.handleVoteAllocationChange.bind(this));
    },
    /**
     * Render category submit
     */
    render: function render() {
        this.$el.html(template({
            id: this.model.get('id'),
            voteLimit: this.voteLimit,
            isSubmitDisabled: !this.model.get('totalAllocatedVotes'),
            votesRemaining: this.votesRemaining
        }));
        return this;
    },

    handleVoteAllocationChange: function handleVoteAllocationChange() {
        if (this.isSubmitDisabled === !!this.model.get('totalAllocatedVotes')) {
            this.isSubmitDisabled = !this.model.get("totalAllocatedVotes");
            PubSub.trigger('vote-allocation-change', this.isSubmitDisabled);
            this.render();
        }
    },
    /**
     * Submit votes for the category
     */
    submitVotes: function submitVotes(e) {
        e.preventDefault();
        if (!this.model.get('totalAllocatedVotes')) {
            return false;
        }

        e.currentTarget.setAttribute('disabled', 'disabled');

        var data = {
            categoryID: this.model.get('id'),
            categoryName: this.model.get('name'),
            categoryVoteData: this.model.get('categoryVotes'),
            totalAllocatedVotes: this.model.get('totalAllocatedVotes')
        };
        PubSub.trigger('submitVotes', data);
    }
});

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"votes-remaining-wrapper\"> <span class=\"votes-remaining cat-<%= id %>\"><%= votesRemaining %></span> / <span class=\"vote-limit\"><%= voteLimit %></span> votes remaining </div> <button <%= isSubmitDisabled? 'disabled': '' %> class=\"btn-submit\">Submit Votes</button> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="votes-remaining-wrapper"> <span class="votes-remaining cat-', escape((__stack.lineno=1,  id )), '">', escape((__stack.lineno=1,  votesRemaining )), '</span> / <span class="vote-limit">', escape((__stack.lineno=1,  voteLimit )), '</span> votes remaining </div> <button ', escape((__stack.lineno=1,  isSubmitDisabled? 'disabled': '' )), ' class="btn-submit">Submit Votes</button> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<%\n  var hasDescription = !!description.length;\n  var hasSponsor = (sponsor === '1' && sponsor_image.length);\n%> <div class=\"description-wrapper\"> <% if( hasDescription ) { %> <p class=\"cat-description\"><%- description %></p> <% } %> <% if( hasSponsor ) { %> <div class=\"sponsor\"> <span><%- (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text %></span> <img src=\"<%= sponsor_image %>\" alt=\"\"> </div> <% } %> </div> <div class=\"contestants-wrapper\"></div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1;
  var hasDescription = !!description.length;
  var hasSponsor = (sponsor === '1' && sponsor_image.length);
; buf.push(' <div class="description-wrapper"> ');__stack.lineno=4; if( hasDescription ) { ; buf.push(' <p class="cat-description">', (__stack.lineno=4,  description ), '</p> ');__stack.lineno=4; } ; buf.push(' ');__stack.lineno=4; if( hasSponsor ) { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=4,  (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text ), '</span> <img src="', escape((__stack.lineno=4,  sponsor_image )), '" alt=""> </div> ');__stack.lineno=4; } ; buf.push(' </div> <div class="contestants-wrapper"></div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(233);

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-confirm',
    events: {
        'click .btn-edit': 'close',
        'click .btn-submit': 'submitVotes'
    },
    /**
     * Initialize View
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');
        this.copy = options.copy;
    },
    /**
     * Render View
     */
    render: function render() {
        var headline = this.copy.headline.replace('{{TOTAL}}', this.model.get('totalAllocatedVotes'));
        this.$el.html(template({
            headline: headline,
            submitText: this.copy.submit_text,
            editText: this.copy.edit_text
        }));
        return this;
    },
    /**
     * Submit Votes
     */
    submitVotes: function submitVotes(e) {
        e.preventDefault();
        if (!this.model.get('totalAllocatedVotes')) {
            return false;
        }

        e.currentTarget.setAttribute('disabled', 'disabled');

        var data = {
            categoryID: this.model.get('id'),
            categoryName: this.model.get('name'),
            categoryVoteData: this.model.get('categoryVotes'),
            totalAllocatedVotes: this.model.get('totalAllocatedVotes')
        };
        PubSub.trigger('submitVotes', data);
    },
    /**
     * Close Modal
     */
    close: function close(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        PubSub.trigger('directRoute', 'closeCurrentModal');
    }
});

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h1 class=\"headline\"><%= headline %></h1> <div class=\"confirm-wrapper\"> <button class=\"btn-submit\"><%= submitText %></button><button class=\"btn-edit\"><%= editText %></button> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h1 class="headline">', escape((__stack.lineno=1,  headline )), '</h1> <div class="confirm-wrapper"> <button class="btn-submit">', escape((__stack.lineno=1,  submitText )), '</button><button class="btn-edit">', escape((__stack.lineno=1,  editText )), '</button> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var template = __webpack_require__(235);

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-modal',
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');
    },
    /**
     *
     */
    render: function render() {
        this.$el.html(template());
        this.$('.modal-content').append(_.isObject(this.model.view) ? this.model.view.render().$el : this.model.view);
        if (!("ontouchstart" in document.documentElement) || !("ontouchstart" in window)) this.$el.addClass('no-touch');
        return this;
    }
});

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"modal-window\"> <div class=\"modal-wrapper\"> <div class=\"modal-layout\"> <div class=\"modal-content\"> </div> </div> </div> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="modal-window"> <div class="modal-wrapper"> <div class="modal-layout"> <div class="modal-content"> </div> </div> </div> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(237);

module.exports = Backbone.View.extend({
    className: 'view-auth',
    events: {
        'click .facebook': 'facebookLogin',
        'click .google': 'googleSignIn',
        'input .email': 'verifyEmailInput',
        'focus .email': 'verifyEmailInput',
        'keypress .email': 'verifyEmailInput',
        'keyup .email': 'verifyEmailInput',
        'click .btn-close': 'closeModal',
        'click button[type="submit"]': 'validateForm',
        'submit .auth-form': 'validateForm',
        'click a': 'handleAnchorClick'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.userSelection = null;
        this.nativeApp = options.native;
        this.google = options.google;
        this.facebook = options.facebook;
    },
    /**
     *
     */
    render: function render() {
        var model = {
            copy: this.model,
            native: this.nativeApp
        };
        this.$el.html(template(model));
        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom() {
        var btn = this.$el.find('#gSignIn').get(0);
        this.google.renderButton(btn, this.googleSignIn.bind(this));
    },
    /**
     *
     */
    validateForm: function validateForm(e) {
        e.preventDefault();
        e.stopPropagation();
        this.authenticateEmail(e);
    },
    /**
     * [verifyEmailInput description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    verifyEmailInput: function verifyEmailInput(e) {
        e.stopPropagation();

        if (e.currentTarget.value.length > 40) {
            e.preventDefault();
            return false;
        }

        if ($('input[type="email"]').hasClass('error-formbox') && e.currentTarget.value.length === 0) {
            $('input[type="email"]').removeClass('error-formbox');
            this.$('.error-message').hide();
        }
    },
    /**
     * Handle checkbox clicks for toggling disabled buttons
     */
    checkboxClick: function checkboxClick() {
        var checkbox = this.$el.find('input[type="checkbox"]');
        if (!checkbox.is(':checked')) this.$('#gSignIn').removeClass('disabled');else this.$('#gSignIn').addClass('disabled');
    },
    /**
     * Validate optin checkbox when user submits
     */
    validateCheckbox: function validateCheckbox() {
        var checkbox = this.$el.find('input[type="checkbox"]');

        if (!checkbox.is(':checked')) {
            this.$('.error-message-checkbox').show();
            this.$el.find('.checkbox-parent').addClass('error-input');
            return false;
        }

        this.$('.error-message-checkbox').hide();
        this.$el.find('.checkbox-parent').removeClass('error-input');
        return true;
    },
    /**
     *
     */
    facebookLogin: function facebookLogin(e) {
        var omParams = { name: 'facebook login button', section: 'login-modal', url: window.location.href };

        PubSub.trigger('linkClick', omParams);

        this.facebook.login();
    },
    /**
     *
     */
    authResponse: function authResponse() {
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     *
     */
    facebookResponse: function facebookResponse(response) {
        if (response.status == 'connected') {
            PubSub.trigger('directRoute', 'closeCurrentModal');
        } else {
            // handle when a user does not update the login information for FB
        }
    },
    /**
     * Google Sign In
     */
    googleSignIn: function googleSignIn(e) {
        var omParams = { name: 'google sign in button', section: 'login-modal', url: window.location.href };

        PubSub.trigger('linkClick', omParams);
    },
    /**
     * [authenticateEmail description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    authenticateEmail: function authenticateEmail(e) {
        e.preventDefault();
        e.stopPropagation();
        var email = $('input[type=email]').val();

        if (!this.validateEmail()) return;

        var omParams = { name: 'email login button', section: 'login-modal', url: window.location.href };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Login Email' };

        PubSub.trigger('linkClick', omParams, gaParams);
        PubSub.trigger('emailLogin', email.toLowerCase().trim());
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     * Validate the email input and adjust errors
     */
    validateEmail: function validateEmail() {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var email = $('input[type="email"]').val();

        if (!re.test(email.trim())) {
            $('input[type=email]').addClass('error-formbox');
            this.$('.error-message').show();
            return false;
        } else {
            $('input[type=email]').removeClass('error-formbox');
            this.$('.error-message').hide();
            return true;
        }
    },
    /**
     * [displayEmailError description]
     * @return {[type]} [description]
     */
    displayEmailError: function displayEmailError() {},
    /**
     * [closeModal description]
     * @return {[type]} [description]
     */
    closeModal: function closeModal(e) {
        e.preventDefault();
        e.stopPropagation();
        PubSub.trigger('userCancelAuth');
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     * handleAnchorClick
     * @param {object} e - event object
     */
    handleAnchorClick: function handleAnchorClick(e) {
        var val = e.target.innerText;
        var href = e.currentTarget.href;

        var omParams = { name: 'link: ' + val, section: 'login-modal', destination: href };
        var gaParams = { eventCategory: 'Link Click', eventAction: 'Auth Link Click' };

        PubSub.trigger('linkClick', omParams, gaParams);
    }
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"close btn-close\"> <img src=\"images/btn-x.png\" alt=\"\"> </div> <h1><%- copy.headline1 %></h1> <div class=\"social-login\" <% if(native) { %> style=\"display:none;\" <% } %>> <% if(copy.enable_google_login === 'true') { %> <div id=\"gSignIn\" class=\"google auth-method\"> </div> <% } %> <% if(copy.enable_facebook_login === 'true') { %> <button class=\"facebook auth-method\"> <span class=\"btn-wrapper\"><img src=\"https://ts-cms-production.votenow.tv/campaign/10/11/1011869/167641778563ec1af9efabb3.89268878.png\" alt=\"Facebook logo\"> <%= copy.facebook_button_copy %></span> </button> <% } %> </div> <% if(copy.enable_google_login === 'true' || copy.enable_facebook_login === 'true') { %> <span class=\"or\" <% if(native) { %> style=\"display:none;\" <% } %>>or</span> <% } %> <form action=\"\" method=\"post\" class=\"auth-form\"> <div class=\"email-form\"> <input type=\"email\" maxlength=\"40\" placeholder=\"<%= copy.email_placeholder %>\" tabindex=\"0\" class=\"email auth-method\"> <span class=\"error-message\" style=\"display:none;\"><%= copy.email_error %></span> </div> <div class=\"confirmation\"> <button type=\"submit\"><%= copy.submit_button %></button> </div> <div class=\"rules\"> <div class=\"checkbox-parent\"> <label class=\"label\" for=\"general\"><%- copy.rules_text %></label> </div> <div class=\"social-media\" <% if(native) { %> style=\"display:none;\" <% } %>><%= copy.social_media_text %></div> </div> </form>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="close btn-close"> <img src="images/btn-x.png" alt=""> </div> <h1>', (__stack.lineno=1,  copy.headline1 ), '</h1> <div class="social-login" ');__stack.lineno=1; if(native) { ; buf.push(' style="display:none;" ');__stack.lineno=1; } ; buf.push('> ');__stack.lineno=1; if(copy.enable_google_login === 'true') { ; buf.push(' <div id="gSignIn" class="google auth-method"> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(copy.enable_facebook_login === 'true') { ; buf.push(' <button class="facebook auth-method"> <span class="btn-wrapper"><img src="https://ts-cms-production.votenow.tv/campaign/10/11/1011869/167641778563ec1af9efabb3.89268878.png" alt="Facebook logo"> ', escape((__stack.lineno=1,  copy.facebook_button_copy )), '</span> </button> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; if(copy.enable_google_login === 'true' || copy.enable_facebook_login === 'true') { ; buf.push(' <span class="or" ');__stack.lineno=1; if(native) { ; buf.push(' style="display:none;" ');__stack.lineno=1; } ; buf.push('>or</span> ');__stack.lineno=1; } ; buf.push(' <form action="" method="post" class="auth-form"> <div class="email-form"> <input type="email" maxlength="40" placeholder="', escape((__stack.lineno=1,  copy.email_placeholder )), '" tabindex="0" class="email auth-method"> <span class="error-message" style="display:none;">', escape((__stack.lineno=1,  copy.email_error )), '</span> </div> <div class="confirmation"> <button type="submit">', escape((__stack.lineno=1,  copy.submit_button )), '</button> </div> <div class="rules"> <div class="checkbox-parent"> <label class="label" for="general">', (__stack.lineno=1,  copy.rules_text ), '</label> </div> <div class="social-media" ');__stack.lineno=1; if(native) { ; buf.push(' style="display:none;" ');__stack.lineno=1; } ; buf.push('>', escape((__stack.lineno=1,  copy.social_media_text )), '</div> </div> </form>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(239);
var slugify = __webpack_require__(28);

module.exports = Backbone.View.extend({
    className: 'view-video',
    events: {
        'click .btn-close': 'closeModal',
        'click .video-nav': 'routeNextVideo'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        this.category = options.category;

        if (this.model.video_player == 'MTV' && this.model.video_url !== '') {
            $(window).on('resize', this.calculatePlayerSize.bind(this));
            this.listenTo(PubSub, 'resizeWindow', this.calculatePlayerSize.bind(this));
        }

        this.listenTo(PubSub, 'videoEnded', this.loadNextVideo.bind(this));
    },
    /**
     *
     */
    render: function render() {
        var model = {
            video: this.model,
            category: this.category,
            video_order: parseInt(this.model.order, 10)
        };
        this.$el.html(template(model));
        return this;
    },
    /**
     *
     */
    renderedToDom: function renderedToDom() {
        var player = this.$el.find('.video-player')[0];
        var video = player.getAttribute('data-contenturi');

        if (this.model.video_url == '') return;

        switch (this.model.video_player) {
            case 'MTV':
                player = this.$el.find('.mtv-video-player')[0];
                video = player.getAttribute('data-contenturi');

                PubSub.trigger('playVideo', video, player);
                $(window).resize();
                break;
            // case 'VEVO':
            //     PubSub.trigger('loadVEVO', video, this.model.id);
            //     break;
            // case 'YT':
            //     PubSub.trigger('loadYT', video, this.model.id);
            //     break;
            default:
                break;
        }
    },
    /**
     *
     */
    calculatePlayerSize: _.debounce(function () {
        if (_.isNull(this.model)) return;

        var video = this.$el.find('.pjs')[0];
        var height = $(video).height();
        var width = $(video).width();

        if (width == 0 || height == 0) return;

        video.setAttribute('data-aspect-ratio', height / width);
        video.removeAttribute('style');

        var updatedWidth = $(video).width();
        var updatedHeight = updatedWidth * video.getAttribute('data-aspect-ratio') + 'px';
        updatedWidth += 'px';

        var styleUpdate = "width: " + updatedWidth + "; height: " + updatedHeight;

        if (updatedWidth == '0px') {
            video.setAttribute('style', 'width: 100%; height: 100%;');
        } else {
            video.setAttribute('style', styleUpdate);
        }
    }, 100),
    /**
     *
     */
    routeNextVideo: function routeNextVideo(e) {
        var target = e.currentTarget;
        var index = parseInt(this.model.order, 10) - 1;
        var model = this.model;

        var previous = /(prev)/.test(target.className);

        if (previous) {
            model = this.category.get('voteData')[index - 1];
        } else {
            model = this.category.get('voteData')[index + 1];
        }

        var lowerCategoryName = this.category.get('name').toLowerCase();
        var lowerContestantName = model.name.toLowerCase();

        var omParams = {
            name: 'video_' + lowerCategoryName + '_' + lowerContestantName,
            section: slugify(this.category.get('name')),
            url: window.location.href
        };
        var gaParams = {
            eventCategory: 'Button Click',
            eventAction: 'Watch Video : ' + this.category.get('name') + ' : ' + model.id
        };

        PubSub.trigger('loadVideo', model, this.category);
        PubSub.trigger('linkClick', omParams, gaParams);
    },
    /**
     *
     */
    loadNextVideo: function loadNextVideo() {
        var index = parseInt(this.model.order, 10) - 1;
        var model = this.category.get('voteData')[index + 1];
        if (model) {
            PubSub.trigger('loadVideo', model, this.category);
        }
    },
    /**
     *
     */
    closeModal: function closeModal(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.$el.removeClass('fade-in').addClass('fade-out');
        setTimeout(function () {
            PubSub.trigger('directRoute', 'closeCurrentModal');
        }, 175);
    },
    /**
     *
     */
    remove: function remove() {
        this.stopListening();
        this.off();
        PubSub.trigger('removeVideoPlayer', this.model.id);
        this.model = null;
        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"headline-wrapper\"> <h1><%- category.get('name') %></h1> </div> <div class=\"close btn-close\"> <img src=\"images/btn-x.png\" alt=\"\"> </div> <% if(video.video_player === 'VEVO' && video.video_url.length) { %> <div class=\"video-player\" data-contenturi=\"<%= video.video_url %>\"> <% if(parseInt(video_order) !== 1) { %> <div class=\"video-nav prev\"> <img src=\"images/chevron-left.png\" alt=\"\"> </div> <% } %> <% if(parseInt(video_order) !== category.get('voteData').length) { %> <div class=\"video-nav next\"> <img src=\"images/chevron-right.png\" alt=\"\"> </div> <% } %> <div class=\"iframe-player\" id=\"<%= video.id %>\"></div> </div> <% } else if(video.video_player === 'YT' && video.video_url.length) { %> <div class=\"video-player\" data-contenturi=\"<%= video.video_url %>\"> <% if(parseInt(video_order) !== 1) { %> <div class=\"video-nav prev\"> <img src=\"images/chevron-left.png\" alt=\"\"> </div> <% } %> <% if(parseInt(video_order) !== category.get('voteData').length) { %> <div class=\"video-nav next\"> <img src=\"images/chevron-right.png\" alt=\"\"> </div> <% } %> <div class=\"iframe-player\"> <div id=\"<%= video.id %>\"></div> </div> </div> <% } else if (video.video_player === 'MTV'  && video.video_url.length) { %> <div class=\"video-player\"> <% if(parseInt(video_order) !== 1) { %> <div class=\"video-nav prev\"> <img src=\"images/chevron-left.png\" alt=\"\"> </div> <% } %> <% if(parseInt(video_order) !== category.get('voteData').length) { %> <div class=\"video-nav next\"> <img src=\"images/chevron-right.png\" alt=\"\"> </div> <% } %> <div class=\"mtv-video-player\" data-contenturi=\"<%= video.video_url %>\" data-auto-create data-auto-play=\"true\"></div> </div> <% } else { %> <div class=\"video-player\"> <% if(parseInt(video_order) !== 1) { %> <div class=\"video-nav prev\"> <img src=\"images/chevron-left.png\" alt=\"\"> </div> <% } %> <% if(parseInt(video_order) !== category.get('voteData').length) { %> <div class=\"video-nav next\"> <img src=\"images/chevron-right.png\" alt=\"\"> </div> <% } %> <div class=\"image-placeholder\"><img src=\"<%= video.image_url %>\" alt=\"\"></div> </div> <% } %> <div class=\"video-information\"> <% if(video.name.length) { %> <div class=\"text-line1\"><%- video.name %></div> <% } %> <% if(video.description.length) { %> <div class=\"text-line2\"><%- video.description %></div> <% } %> <% if(video.alt_description.length) { %> <div class=\"text-line3\"><%- video.alt_description %></div> <% } %> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="headline-wrapper"> <h1>', (__stack.lineno=1,  category.get('name') ), '</h1> </div> <div class="close btn-close"> <img src="images/btn-x.png" alt=""> </div> ');__stack.lineno=1; if(video.video_player === 'VEVO' && video.video_url.length) { ; buf.push(' <div class="video-player" data-contenturi="', escape((__stack.lineno=1,  video.video_url )), '"> ');__stack.lineno=1; if(parseInt(video_order) !== 1) { ; buf.push(' <div class="video-nav prev"> <img src="images/chevron-left.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(parseInt(video_order) !== category.get('voteData').length) { ; buf.push(' <div class="video-nav next"> <img src="images/chevron-right.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' <div class="iframe-player" id="', escape((__stack.lineno=1,  video.id )), '"></div> </div> ');__stack.lineno=1; } else if(video.video_player === 'YT' && video.video_url.length) { ; buf.push(' <div class="video-player" data-contenturi="', escape((__stack.lineno=1,  video.video_url )), '"> ');__stack.lineno=1; if(parseInt(video_order) !== 1) { ; buf.push(' <div class="video-nav prev"> <img src="images/chevron-left.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(parseInt(video_order) !== category.get('voteData').length) { ; buf.push(' <div class="video-nav next"> <img src="images/chevron-right.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' <div class="iframe-player"> <div id="', escape((__stack.lineno=1,  video.id )), '"></div> </div> </div> ');__stack.lineno=1; } else if (video.video_player === 'MTV'  && video.video_url.length) { ; buf.push(' <div class="video-player"> ');__stack.lineno=1; if(parseInt(video_order) !== 1) { ; buf.push(' <div class="video-nav prev"> <img src="images/chevron-left.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(parseInt(video_order) !== category.get('voteData').length) { ; buf.push(' <div class="video-nav next"> <img src="images/chevron-right.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' <div class="mtv-video-player" data-contenturi="', escape((__stack.lineno=1,  video.video_url )), '" data-auto-create data-auto-play="true"></div> </div> ');__stack.lineno=1; } else { ; buf.push(' <div class="video-player"> ');__stack.lineno=1; if(parseInt(video_order) !== 1) { ; buf.push(' <div class="video-nav prev"> <img src="images/chevron-left.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(parseInt(video_order) !== category.get('voteData').length) { ; buf.push(' <div class="video-nav next"> <img src="images/chevron-right.png" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' <div class="image-placeholder"><img src="', escape((__stack.lineno=1,  video.image_url )), '" alt=""></div> </div> ');__stack.lineno=1; } ; buf.push(' <div class="video-information"> ');__stack.lineno=1; if(video.name.length) { ; buf.push(' <div class="text-line1">', (__stack.lineno=1,  video.name ), '</div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(video.description.length) { ; buf.push(' <div class="text-line2">', (__stack.lineno=1,  video.description ), '</div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(video.alt_description.length) { ; buf.push(' <div class="text-line3">', (__stack.lineno=1,  video.alt_description ), '</div> ');__stack.lineno=1; } ; buf.push(' </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var ViewShare = __webpack_require__(104);
var template = __webpack_require__(242);

module.exports = Backbone.View.extend({
    className: 'view-thanks',
    events: {
        'click .btn-close': 'closeModal',
        'click .mtv-close': 'routeMTVLink'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render', 'closeModal');

        options = options || {};

        this.user = this.model.user;
        this.native = this.model.native;

        this.shareView = new ViewShare({
            model: options.shareModel,
            isThanks: true,
            shareUrl: options.shareUrl
        });
    },
    /**
     *
     */
    render: function render() {

        var model = {
            copy: this.model.copy,
            user: this.shareCopy,
            native: this.model.native
        };

        this.$el.html(template(model));
        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom() {
        if (this.native) this.$el.addClass('native');
        this.$el.find('.share').html(this.shareView.render().$el);
    },
    /**
     * [closeModal description]
     * @return {[type]} [description]
     */
    closeModal: function closeModal(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (parseInt(this.model.copy.route_social_category)) {
            PubSub.trigger('openSocialCategory');
            return;
        }
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     * 
     */
    routeMTVLink: function routeMTVLink(e) {
        var href = e.currentTarget.href;
        var omParams = { name: 'link to mtv', section: 'thanks-modal', destination: href };
        var gaParams = { eventCategory: 'Link Click', eventAction: 'Close Thanks Modal to MTV' };

        PubSub.trigger('linkClick', omParams, gaParams);
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function remove() {
        this.shareView.remove();
        this.share = null;
        this.user = null;
        Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<p>share</p> <% if(!native) { %> <a class=\"facebook\"> <div><i class=\"icon-facebook\"></i></div> </a><a class=\"twitter\" target=\"_blank\" href=\"//twitter.com/intent/tweet?text=<%= encodeURIComponent(share.twitter) %>\"> <div><i class=\"icon-twitter\"></i></div> </a><% } %><a class=\"whatsapp\" target=\"_blank\" href=\"https://wa.me/?text=<%= encodeURIComponent(share.whats_app) %>\" data-action=\"share/whatsapp/share\"><div> <svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\"><defs><path id=\"a\" d=\"M17.994 17.995V0H0v17.995z\"/></defs><g fill=\"none\" fill-rule=\"evenodd\"><mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"/></mask><path d=\"M13.12 10.783c-.225-.11-1.325-.65-1.53-.724-.206-.076-.355-.113-.504.11-.15.223-.578.725-.71.874-.13.148-.26.167-.484.055-.224-.112-.945-.347-1.8-1.106-.666-.59-1.115-1.32-1.246-1.544-.13-.223-.013-.344.1-.455.1-.1.223-.26.334-.39.112-.13.15-.223.224-.372.075-.148.038-.278-.018-.39-.056-.11-.504-1.208-.69-1.654-.182-.436-.367-.377-.504-.384-.13-.006-.28-.008-.43-.008-.15 0-.39.056-.596.28-.205.222-.784.76-.784 1.858 0 1.097.802 2.156.914 2.305.112.15 1.58 2.4 3.825 3.365.535.23.952.367 1.277.47.536.17 1.024.145 1.41.088.43-.064 1.324-.54 1.51-1.06.187-.52.187-.966.13-1.06-.055-.092-.204-.148-.428-.26m-4.085 5.55h-.003c-1.337 0-2.647-.357-3.79-1.032l-.272-.16-2.82.736.753-2.735-.177-.28c-.745-1.18-1.14-2.543-1.138-3.943 0-4.087 3.342-7.41 7.45-7.41 1.99 0 3.858.772 5.264 2.173 1.406 1.4 2.18 3.262 2.18 5.243-.002 4.086-3.343 7.41-7.447 7.41m6.337-13.718C13.682.93 11.432 0 9.035 0 4.095 0 .077 4 .075 8.916c0 1.572.412 3.106 1.196 4.458L0 17.994l4.75-1.24c1.308.71 2.782 1.086 4.28 1.086h.005c4.938 0 8.957-4 8.96-8.917 0-2.382-.93-4.623-2.623-6.308\" fill=\"#FFF\" mask=\"url(#b)\"/></g></svg> </div></a><a class=\"email\" href=\"mailto:?subject=<%= encodeURIComponent(share.email.subject) %>&body=<%= encodeURIComponent(share.email.body) %>\"><div><i class=\"icon-email\"></i></div></a>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<p>share</p> ');__stack.lineno=1; if(!native) { ; buf.push(' <a class="facebook"> <div><i class="icon-facebook"></i></div> </a><a class="twitter" target="_blank" href="//twitter.com/intent/tweet?text=', escape((__stack.lineno=1,  encodeURIComponent(share.twitter) )), '"> <div><i class="icon-twitter"></i></div> </a>');__stack.lineno=1; } ; buf.push('<a class="whatsapp" target="_blank" href="https://wa.me/?text=', escape((__stack.lineno=1,  encodeURIComponent(share.whats_app) )), '" data-action="share/whatsapp/share"><div> <svg width="18" height="18" viewBox="0 0 18 18"><defs><path id="a" d="M17.994 17.995V0H0v17.995z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M13.12 10.783c-.225-.11-1.325-.65-1.53-.724-.206-.076-.355-.113-.504.11-.15.223-.578.725-.71.874-.13.148-.26.167-.484.055-.224-.112-.945-.347-1.8-1.106-.666-.59-1.115-1.32-1.246-1.544-.13-.223-.013-.344.1-.455.1-.1.223-.26.334-.39.112-.13.15-.223.224-.372.075-.148.038-.278-.018-.39-.056-.11-.504-1.208-.69-1.654-.182-.436-.367-.377-.504-.384-.13-.006-.28-.008-.43-.008-.15 0-.39.056-.596.28-.205.222-.784.76-.784 1.858 0 1.097.802 2.156.914 2.305.112.15 1.58 2.4 3.825 3.365.535.23.952.367 1.277.47.536.17 1.024.145 1.41.088.43-.064 1.324-.54 1.51-1.06.187-.52.187-.966.13-1.06-.055-.092-.204-.148-.428-.26m-4.085 5.55h-.003c-1.337 0-2.647-.357-3.79-1.032l-.272-.16-2.82.736.753-2.735-.177-.28c-.745-1.18-1.14-2.543-1.138-3.943 0-4.087 3.342-7.41 7.45-7.41 1.99 0 3.858.772 5.264 2.173 1.406 1.4 2.18 3.262 2.18 5.243-.002 4.086-3.343 7.41-7.447 7.41m6.337-13.718C13.682.93 11.432 0 9.035 0 4.095 0 .077 4 .075 8.916c0 1.572.412 3.106 1.196 4.458L0 17.994l4.75-1.24c1.308.71 2.782 1.086 4.28 1.086h.005c4.938 0 8.957-4 8.96-8.917 0-2.382-.93-4.623-2.623-6.308" fill="#FFF" mask="url(#b)"/></g></svg> </div></a><a class="email" href="mailto:?subject=', escape((__stack.lineno=1,  encodeURIComponent(share.email.subject) )), '&body=', escape((__stack.lineno=1,  encodeURIComponent(share.email.body) )), '"><div><i class="icon-email"></i></div></a>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"close btn-close\"> <img src=\"images/btn-x.png\" alt=\"\"> </div> <h1><%- copy.headline1 %></h1> <% if (copy.image_url) { %> <img class=\"thanks-image\" src=\"<%= copy.image_url %>\" alt=\"\"> <% } %> <p><%- copy.paragraph1 %></p> <% if(copy.close_text.length > 0) { %> <div class=\"close-wrapper\"> <a class=\"mtv-close\" href=\"<%= copy.redirect_url %>\" target=\"_blank\" rel=\"noopener nofollow\"><%- copy.close_text %></a> </div> <% } %> <div class=\"share\"></div> <div class=\"sponsor\"> <span><%= copy.sponsor_text %></span> <img src=\"<%= copy.sponsor_logo %>\" alt=\"\"> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="close btn-close"> <img src="images/btn-x.png" alt=""> </div> <h1>', (__stack.lineno=1,  copy.headline1 ), '</h1> ');__stack.lineno=1; if (copy.image_url) { ; buf.push(' <img class="thanks-image" src="', escape((__stack.lineno=1,  copy.image_url )), '" alt=""> ');__stack.lineno=1; } ; buf.push(' <p>', (__stack.lineno=1,  copy.paragraph1 ), '</p> ');__stack.lineno=1; if(copy.close_text.length > 0) { ; buf.push(' <div class="close-wrapper"> <a class="mtv-close" href="', escape((__stack.lineno=1,  copy.redirect_url )), '" target="_blank" rel="noopener nofollow">', (__stack.lineno=1,  copy.close_text ), '</a> </div> ');__stack.lineno=1; } ; buf.push(' <div class="share"></div> <div class="sponsor"> <span>', escape((__stack.lineno=1,  copy.sponsor_text )), '</span> <img src="', escape((__stack.lineno=1,  copy.sponsor_logo )), '" alt=""> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var ViewContestant = __webpack_require__(51);
var ViewAd = __webpack_require__(52);
var template = __webpack_require__(244);
var slugify = __webpack_require__(28);

var _require = __webpack_require__(21),
    isMobile = _require.isMobile;

var GA = __webpack_require__(11).GOOGLE;
var OMNITURE = __webpack_require__(11).OMNITURE;

module.exports = Backbone.View.extend({
    className: 'flex-container',
    events: {
        'click .btn': 'loadVideo',
        'click .social-cta': 'handleSocialCtaClick'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.cms = options.cms;
        this.appState = this.cms.get('appState');

        this.dimensions = options.dimensions;
        this.user = options.user;
        this.contestantsArray = [];

        this.runnerUpsArray = [];
        this.finalistsArray = [];
        this.hideAnimation = options.hideAnimation || false;

        this.copy = options.copy;
        this.transitionTime = parseInt(this.cms.get('text').customization.transition_time) || 500;

        this.listenTo(this.copy, 'change:copy', function () {
            this.render();
            this.renderedToDom();
        }.bind(this));
    },
    /**
     *
     */
    render: function render() {
        var model = this.model.toJSON();
        model.copy = _.extend(model.copy, this.copy.get('copy'));
        model.window = this.appState;

        this.$el.addClass('social-generic-category');

        this.$el.css({ height: '0' });
        this.$el.html(template(model));

        var sortedContestants = this.model.get('voteData');
        sortedContestants.sort(function (a, b) {
            return parseInt(a.order, 10) - parseInt(b.order, 10);
        });

        _.forEach(sortedContestants, function (value, index) {

            var contestantModel = new Backbone.Model(_.extend({ voteCount: 0 }, value));

            this.contestantsArray.push(new ViewContestant({
                model: contestantModel,
                user: this.user,
                dimensions: this.dimensions,
                person: this.model.get('person'),
                copy: this.copy,
                cms: this.cms,
                professional: this.model.get('professional'),
                social: this.model.get('social'),
                customization: this.cms.get('text').customization,
                category: this.model
            }));

            this.$('.contestants-wrapper').append(this.contestantsArray[index].render().$el);
            this.contestantsArray[index].renderedToDom();
        }.bind(this));

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom(update) {

        this.$el.parent().css({ height: '0px' });

        if (parseInt(this.model.toJSON().person)) {
            this.$el.parent().addClass('circle');
        }

        if (_.checkIfTrue(this.model.get('display_ad')) && !update) {
            this.renderAd();
        }

        if (!this.hideAnimation) {
            this.scrollAnimation();
        } else {
            this.$el.parent().css({ height: 'auto' });
            this.$el.css({ height: 'auto' });
        }
    },
    /**
     * [renderAd description]
     * @return {[type]} [description]
     */
    renderAd: function renderAd() {

        if (this.adView instanceof ViewAd) return;

        this.adView = new ViewAd({
            categoryIndex: this.model.get('id'),
            adTag: this.model.get('ad_tag') || this.model.get('displayName'),
            model: this.model.get('ad')
        });

        var contestantEls = this.$el.find('.contestant');

        if (contestantEls.length > 0) {
            $(contestantEls[contestantEls.length - 1]).after(this.adView.render().$el);
        } else {
            this.$el.append(this.adView.render().$el);
        }

        this.adView.renderedToDom();
    },
    /**
     * [scrollAnimation description]
     * @return {[type]} [description]
     */
    scrollAnimation: function scrollAnimation() {
        var categoryButton = document.querySelector('.category-button[data-category-id="' + this.model.get('id') + '"]');
        var buttonTop = categoryButton.offsetTop;
        var mobileMenuHeight = isMobile.any() ? document.getElementById('header').offsetHeight : document.getElementById('mtv-mobile-menu').offsetHeight;

        var hasSkybox = document.body.classList.contains('skybox-loaded');
        var skyboxHeight = 0;

        if (hasSkybox) {
            skyboxHeight = isMobile.any() ? document.querySelector('#mobile_skybox_plus_sticky iframe').offsetHeight : document.querySelector('#skybox_leader_plus_sticky iframe').offsetHeight;
        }

        $('html,body').animate({
            scrollTop: buttonTop - mobileMenuHeight - skyboxHeight
        }, {
            duration: 200,
            complete: function () {
                // fixes issue when the function runs twice due to HTML and body attributes
                if (/(auto)/.test(this.$el.parent().attr('style'))) {
                    return false;
                }

                this.$el.parent().css({ height: 'auto' });
                this.$el.animate({
                    height: '1200px'
                }, this.transitionTime, function () {
                    $(this).css({ height: 'auto' });
                });
            }.bind(this)
        });
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function remove() {
        // remove the various Contestants views from the contestants array
        _.forEach(this.contestantsArray, function (value, index) {
            value.remove();
        });
        _.forEach(this.runnerUpsArray, function (value, index) {
            value.remove();
        });
        _.forEach(this.finalistsArray, function (value, index) {
            value.remove();
        });

        this.contestantsArray = null;
        this.runnerUpsArray = null;
        this.finalistsArray = null;

        this.voteData = null;

        if (this.adView) {
            this.adView.remove();
            this.adView = null;
        }

        this.stopListening();
        this.off();

        if (this.copy) {
            this.copy.destroy();
            this.copy = null;
        }

        this.model = null;

        this.recentlyVoted = false;
        this.closedTextDisplayed = false;

        if (typeof this.removeClosedText == 'number') {
            clearTimeout(this.removeClosedText);console.warn('cancel timeout');
        };

        return Backbone.View.prototype.remove.call(this);
    },
    /**
     * handleSocialCtaClick
     * @param {object} e - event object
     * @return {void}
     */
    handleSocialCtaClick: function handleSocialCtaClick(e) {
        var val = "instagram to vote_" + this.model.get('name');
        var href = e.currentTarget.href;

        var omParams = {
            name: val,
            section: slugify(this.model.get('name')),
            destination: href,
            isSocial: true
        };

        PubSub.trigger('linkClick', omParams);
    }
});

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"description-wrapper\"> <% if(description.length) { %> <p class=\"cat-description\"><%- description %></p> <% } %> </div> <div class=\"cta\"> <% if(sponsor === '1' && sponsor_image.length) { %> <div class=\"sponsor\"> <span><%- (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text %></span> <img src=\"<%= sponsor_image %>\" alt=\"\"> </div> <% } %> <a class=\"social-cta\" href=\"<%= copy.social_button_url %>\" target=\"_blank\" data-track=\"social category vote\"><img src=\"<%= copy.social_button_image %>\" alt=\"\"></a> </div> <div class=\"contestants-wrapper\"></div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="description-wrapper"> ');__stack.lineno=1; if(description.length) { ; buf.push(' <p class="cat-description">', (__stack.lineno=1,  description ), '</p> ');__stack.lineno=1; } ; buf.push(' </div> <div class="cta"> ');__stack.lineno=1; if(sponsor === '1' && sponsor_image.length) { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=1,  (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text ), '</span> <img src="', escape((__stack.lineno=1,  sponsor_image )), '" alt=""> </div> ');__stack.lineno=1; } ; buf.push(' <a class="social-cta" href="', escape((__stack.lineno=1,  copy.social_button_url )), '" target="_blank" data-track="social category vote"><img src="', escape((__stack.lineno=1,  copy.social_button_image )), '" alt=""></a> </div> <div class="contestants-wrapper"></div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var ViewContestant = __webpack_require__(246);
var ViewContestantAlt = __webpack_require__(51);
var ViewAd = __webpack_require__(52);
var template = __webpack_require__(248);
var GA = __webpack_require__(11).GOOGLE;
var OMNITURE = __webpack_require__(11).OMNITURE;
var slugify = __webpack_require__(28);
var PubSub = __webpack_require__(2);

var _require = __webpack_require__(21),
    isMobile = _require.isMobile;

module.exports = Backbone.View.extend({
    className: 'flex-container social-category-live-vote',
    events: {
        'click .btn': 'loadVideo',
        'click .live-vote-btn': 'handleLiveVoteClick'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.cms = options.cms;
        this.appState = this.cms.get('appState');

        this.dimensions = options.dimensions;
        this.user = options.user;

        this.contestantsArray = [];
        this.finalistsArray = [];
        this.hideAnimation = options.hideAnimation || false;

        this.copy = options.copy;
        this.transitionTime = parseInt(this.cms.get('text').customization.transition_time) || 500;

        this.adView = new ViewAd({
            categoryIndex: this.model.get('id'),
            adTag: this.model.get('ad_tag') || this.model.get('displayName'),
            model: this.model.get('ad')
        });

        this.listenTo(this.model, 'change:categoryVotesTotal', this.onChangeCategoryVotesTotal.bind(this));

        this.listenTo(this.copy, 'change:copy', function () {
            this.render();
            this.renderedToDom();
        }.bind(this));
    },
    /**
     *
     */
    render: function render() {
        var model = this.model.toJSON();
        model.copy = _.extend(model.copy, this.copy.get('copy'));
        model.window = this.appState;

        this.$el.css({ height: '0' });
        this.$el.html(template(model));

        if (this.contestantsArray.length == 0) {
            this.buildTwitterContestants();
        }

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom() {
        this.$el.parent().css({ height: '0px' });

        if (this.model.get('sponsor') == '1' || parseInt(this.model.get('order')) == 1) {
            this.$el.append(this.adView.render().$el);
            this.adView.renderedToDom();
        }

        if (!this.hideAnimation) {
            this.scrollAnimation();
        } else {
            this.$el.parent().css({ height: 'auto' });
            this.$el.css({ height: 'auto' });
        }
    },

    /**
     * Handler for when the isSubmitted attribute of a category changes
     */
    onChangeCategoryVotesTotal: function onChangeCategoryVotesTotal(category) {
        var voteLimit = this.cms.turboVote.get('voteLimit');

        if (category.get('categoryVotesTotal') >= voteLimit) {
            this.$('.btn-submit').prop('disabled', 'disabled');
            this.$('.btn-submit').removeClass('btn-complete');
            this.$('.btn-submit').removeClass('btn-loading');
            this.$('.btn-submit').text('Limit Reached');
        }
    },
    /**
     * [scrollAnimation description]
     * @return {[type]} [description]
     */
    scrollAnimation: function scrollAnimation() {
        var categoryButton = document.querySelector('.category-button[data-category-id="' + this.model.get('id') + '"]');
        var buttonTop = categoryButton.offsetTop;
        var mobileMenuHeight = isMobile.any() ? document.getElementById('header').offsetHeight : document.getElementById('mtv-mobile-menu').offsetHeight;
        var hasSkybox = document.body.classList.contains('skybox-loaded');
        var skyboxHeight = 0;

        if (hasSkybox) {
            skyboxHeight = isMobile.any() ? document.querySelector('#mobile_skybox_plus_sticky iframe').offsetHeight : document.querySelector('#skybox_leader_plus_sticky iframe').offsetHeight;
        }

        $('html,body').animate({
            scrollTop: buttonTop - mobileMenuHeight - skyboxHeight
        }, {
            duration: 200,
            complete: function () {
                // fixes issue when the function runs twice due to HTML and body attributes
                if (/(auto)/.test(this.$el.parent().attr('style'))) {
                    return false;
                }

                this.$el.parent().css({ height: 'auto' });
                this.$el.animate({
                    height: '1200px'
                }, this.transitionTime, function () {

                    $(this).css({ height: 'auto' });
                });
            }.bind(this)
        });
    },
    /**
     *
     */
    buildTwitterContestants: function buildTwitterContestants() {

        var sortedContestants = this.model.get('voteData');
        sortedContestants.sort(function (a, b) {
            return parseInt(a.order, 10) - parseInt(b.order, 10);
        });

        _.forEach(sortedContestants, function (contestant, index) {

            if (contestant.finalist == '1' && this.cms.get('appState') == 'open') {

                var voteCount = this.model.get('categoryVotes')[contestant.id] ? this.model.get('categoryVotes')[contestant.id] : 0;
                var contestantModel = new Backbone.Model(_.extend({ voteCount: voteCount }, contestant));

                this.finalistsArray.push(new ViewContestant({
                    model: contestantModel,
                    user: this.user,
                    dimensions: this.dimensions,
                    person: this.model.get('person'),
                    copy: this.model.get('copy'),
                    professional: this.model.get('professional'),
                    category: this.model,
                    cms: this.cms,
                    active: this.model.get('active')
                }));

                var currentIndex = this.finalistsArray.length - 1;
                this.$el.find('.finalists').append(this.finalistsArray[currentIndex].render().$el);
                this.finalistsArray[currentIndex].renderedToDom();
            } else {

                var constestantModel = new Backbone.Model(_.extend({ voteCount: null }, contestant));

                this.contestantsArray.push(new ViewContestantAlt({
                    model: constestantModel,
                    user: this.user,
                    dimensions: this.dimensions,
                    person: this.model.get('person'),
                    copy: this.model.get('copy'),
                    cms: this.cms,
                    professional: this.model.get('professional'),
                    category: this.model
                }));

                var currentIndex = this.contestantsArray.length - 1;
                this.$el.append(this.contestantsArray[currentIndex].render().$el);
                this.contestantsArray[currentIndex].renderedToDom();
            }
        }.bind(this));

        if (this.finalistsArray.length > 0) {
            this.$('.finalists').css('display', 'block');
        };

        if (this.contestantsArray.length > 0) {
            this.$('.runner-up h1').css('display', 'block');
        }
    },

    handleLiveVoteClick: function handleLiveVoteClick(e) {
        var val = "vote on facebook_" + this.model.get('name');
        var href = e.currentTarget.href;

        var omParams = {
            name: val,
            section: slugify(this.model.get('name')),
            destination: href
        };

        PubSub.trigger('linkClick', omParams);
    },

    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function remove() {
        // remove the various Contestants views from the contestants array
        _.forEach(this.contestantsArray, function (value, index) {
            value.remove();
        });
        _.forEach(this.finalistsArray, function (value, index) {
            value.remove();
        });

        this.contestantsArray = null;
        this.finalistsArray = null;

        this.voteData = null;

        if (this.adView) {
            this.adView.remove();
            this.adView = null;
        }

        this.stopListening();
        this.off();

        if (this.copy) {
            this.copy.destroy();
            this.copy = null;
        }

        this.model = null;

        this.recentlyVoted = false;
        this.closedTextDisplayed = false;

        if (typeof this.removeClosedText == 'number') {
            clearTimeout(this.removeClosedText);console.warn('cancel timeout');
        };

        return Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(247);
var slugify = __webpack_require__(28);

module.exports = Backbone.View.extend({
  className: 'contestant flex-child-container',
  events: {
    'click .img-position': 'loadVideo',
    'click button.btn-submit': 'submitLiveVote'
  },
  submittingVote: false,
  /**
   *
   */
  initialize: function initialize(options) {
    _.bindAll(this, 'render', 'onCloseModal', 'onVoteSuccess', 'onSubmittingVote');

    options = options || {};
    this.user = options.user;
    this.temp = options.temp;
    this.person = options.person;
    this.dimensions = options.dimensions;
    this.copy = options.copy;
    this.professional = options.professional;
    this.category = options.category;
    this.active = options.active;

    this.voteLimit = parseInt(options.cms.turboVote.get('voteLimit'), 10);

    this.imageQsp = '?';
  },
  /**
   *
   */
  render: function render() {

    var modelData = _.extend({}, this.model.toJSON(), {
      voteData: {},
      copy: this.copy,
      professional: this.professional,
      twitter: parseInt(this.category.get('live_vote')),
      active: this.active,
      isSubmitted: this.category.get('isSubmitted')
    });

    var updatedModel = this.buildImageURLs(modelData);

    if (this.temp) {
      this.$el.addClass('temp');
    }

    if (!updatedModel.percent) {
      updatedModel.percent = "0";
    }

    this.$el.html(template(updatedModel));
    this.$el.find('img').unveil(2 * window.innerHeight);
    return this;
  },
  /**
   * [buildImageURLs description]
   * @param  {[type]} data [description]
   * @return {[type]}      [description]
   */
  buildImageURLs: function buildImageURLs(data) {
    var node = parseInt(this.person) ? 'circle' : 'rectangle';

    _.forEach(this.dimensions[node], function (value, index) {
      if (value != '') {
        this.imageQsp = this.imageQsp + index + '=' + value + "&";

        if (/(width)/.test(index)) {
          this.width = value;
        } else if (/(height)/.test(index)) {
          this.height = value;
        }
      }
    }.bind(this));

    this.imageQsp = this.imageQsp.slice(0, -1);

    data.formatted_image = data.image_url + this.imageQsp;
    data.width = this.width;
    data.height = this.height;

    return data;
  },
  /**
   * [renderedToDom description]
   * @return {[type]} [description]
   */
  renderedToDom: function renderedToDom() {
    this.listenTo(PubSub, 'voteSuccess', this.onVoteSuccess);
    this.listenTo(PubSub, 'directRoute', this.onCloseModal);
    this.listenTo(PubSub, 'submittingVote', this.onSubmittingVote);
  },
  /**
  *
  */
  onSubmittingVote: function onSubmittingVote(voteData) {
    var btn = this.$el.find('.btn-submit');

    if (voteData.contestant === this.model.get('id')) {
      this.submittingVote = true;
      btn.addClass('btn-loading');
    }
  },
  /**
  *
  */
  onCloseModal: function onCloseModal(value) {
    var btn = this.$el.find('.btn-submit');

    if (!this.submittingVote && (value === 'closeCurrentModal' || value === 'error')) {
      btn.removeClass('btn-loading');
      this.submittingVote = false;
    }
  },
  /**
   *
   */
  onVoteSuccess: function onVoteSuccess(response, voteData) {
    var btn = this.$el.find('.btn-submit');

    if (voteData.contestant === this.model.get('id')) {
      btn.removeClass('btn-loading');
      btn.addClass('btn-complete');
      this.submittingVote = false;

      setTimeout(function () {
        btn.removeClass('btn-complete');
      }.bind(this), 2000);
    }
  },
  /**
   *
   */
  loadVideo: function loadVideo(e) {
    if (this.temp || this.model.get('video_url') === '') return;

    var lowerCategoryName = this.category.get('name').toLowerCase();
    var lowerContestantName = this.model.get('name').toLowerCase();

    var omParams = {
      name: 'video_' + lowerCategoryName + '_' + lowerContestantName,
      section: slugify(this.category.get('name')),
      url: window.location.href
    };
    var gaParams = {
      eventCategory: 'Button Click',
      eventAction: 'Watch Video : ' + this.category.get('name') + ' : ' + this.model.id
    };

    PubSub.trigger('loadVideo', this.model.toJSON(), this.category);
    PubSub.trigger('linkClick', omParams, gaParams);
  },
  /**
   * [remove description]
   * @return {[type]} [description]
   */
  remove: function remove() {
    this.off();
    this.stopListening();

    this.model = null;

    if (typeof this.transitionTimeout == 'number') clearTimeout(this.transitionTimeout);

    this.imageQsp = null;
    this.person = null;
    this.dimensions = null;

    return Backbone.View.prototype.remove.call(this);
  },

  /**
   * Submit votes for the category
   */
  submitLiveVote: _.throttle(function (e) {
    e.preventDefault();

    var votes = this.model.get('voteCount');
    var categoryVotesTotal = this.category.get('categoryVotesTotal');
    var categoryVotes = this.category.get('categoryVotes');

    if (categoryVotesTotal < this.voteLimit && votes < this.voteLimit) {
      this.model.set('voteCount', votes + 1);
      this.category.voteCountUpdate('plus', this.model.get('id'), this.model.get('voteCount'));

      var data = _.extend({
        categoryID: this.category.get('id'),
        categoryName: this.category.get('name'),
        categoryVoteData: {
          contestant: this.model.get('id')
        },
        categoryVotesTotal: categoryVotesTotal + 1
      }, categoryVotes);

      PubSub.trigger('submitVotes', data);
    }
  }, 500)

});

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"thumbnail<%= (video_url !== ''? \"\" : \" no-video-url\") %>\"> <% if(!video_url.length && external_url.length) { %> <a class=\"external-link\" target=\"_blank\" href=\"<%= external_url %>\"> <% } %> <% if(formatted_image.length > 0){ %> <div class=\"img-position\"> <div class=\"img-wrapper\"> <img src=\"\" data-src=\"<%= formatted_image %>\" alt=\"\"> </div> <div class=\"text-container\"> <div class=\"text-line1\"><%- name %></div> <div class=\"text-line2\"><%- description %></div> <% if(alt_description !== '') { %><div class=\"text-line3\"><%= alt_description %></div><% } %> <% if(video_url.length) { %><div class=\"watch-video\">watch video &gt;</div><% } %> </div> </div> <% } %> <% if(!video_url.length && external_url.length) { %></a><% } %> </div> <% if(finalist === '1') { %> <div class=\"single-vote\"> <button class=\"btn-submit <% if(isSubmitted) { %>btn-limit<% } %>\" <% if(isSubmitted) { %> disabled=\"disabled\" <% } %>><%- isSubmitted ? 'Limit Reached' : 'Vote' %></button> </div> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="thumbnail', escape((__stack.lineno=1,  (video_url !== ''? "" : " no-video-url") )), '"> ');__stack.lineno=1; if(!video_url.length && external_url.length) { ; buf.push(' <a class="external-link" target="_blank" href="', escape((__stack.lineno=1,  external_url )), '"> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(formatted_image.length > 0){ ; buf.push(' <div class="img-position"> <div class="img-wrapper"> <img src="" data-src="', escape((__stack.lineno=1,  formatted_image )), '" alt=""> </div> <div class="text-container"> <div class="text-line1">', (__stack.lineno=1,  name ), '</div> <div class="text-line2">', (__stack.lineno=1,  description ), '</div> ');__stack.lineno=1; if(alt_description !== '') { ; buf.push('<div class="text-line3">', escape((__stack.lineno=1,  alt_description )), '</div>');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(video_url.length) { ; buf.push('<div class="watch-video">watch video &gt;</div>');__stack.lineno=1; } ; buf.push(' </div> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(!video_url.length && external_url.length) { ; buf.push('</a>');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; if(finalist === '1') { ; buf.push(' <div class="single-vote"> <button class="btn-submit ');__stack.lineno=1; if(isSubmitted) { ; buf.push('btn-limit');__stack.lineno=1; } ; buf.push('" ');__stack.lineno=1; if(isSubmitted) { ; buf.push(' disabled="disabled" ');__stack.lineno=1; } ; buf.push('>', (__stack.lineno=1,  isSubmitted ? 'Limit Reached' : 'Vote' ), '</button> </div> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<%\n  var hasDescription = !!description.length;\n  var hasSponsor = (sponsor === '1' && sponsor_image.length);\n%> <div class=\"description-wrapper\"> <% if( hasDescription ) { %> <p class=\"cat-description\"><%- description %></p> <% } %> <% if( hasSponsor ) { %> <div class=\"sponsor\"> <span><%- (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text %></span> <img src=\"<%= sponsor_image %>\" alt=\"\"> </div> <% } %> </div> <% if( copy.live_vote_url ) { %> <div class=\"live-vote\"> <a href=\"<%= copy.live_vote_url %>\" target=\"_blank\" class=\"live-vote-btn\" style=\"background: <%= copy.live_vote_button_background %>\"><img src=\"<%= copy.live_vote_icon_url %>\" alt=\"<%= copy.live_vote_icon_alt %>\"> <%- copy.live_vote_button_text %></a> </div> <% } %> <div class=\"finalists\"></div> <div class=\"runner-up\"> <h1><%- copy.subheadline %></h1> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1;
  var hasDescription = !!description.length;
  var hasSponsor = (sponsor === '1' && sponsor_image.length);
; buf.push(' <div class="description-wrapper"> ');__stack.lineno=4; if( hasDescription ) { ; buf.push(' <p class="cat-description">', (__stack.lineno=4,  description ), '</p> ');__stack.lineno=4; } ; buf.push(' ');__stack.lineno=4; if( hasSponsor ) { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=4,  (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text ), '</span> <img src="', escape((__stack.lineno=4,  sponsor_image )), '" alt=""> </div> ');__stack.lineno=4; } ; buf.push(' </div> ');__stack.lineno=4; if( copy.live_vote_url ) { ; buf.push(' <div class="live-vote"> <a href="', escape((__stack.lineno=4,  copy.live_vote_url )), '" target="_blank" class="live-vote-btn" style="background: ', escape((__stack.lineno=4,  copy.live_vote_button_background )), '"><img src="', escape((__stack.lineno=4,  copy.live_vote_icon_url )), '" alt="', escape((__stack.lineno=4,  copy.live_vote_icon_alt )), '"> ', (__stack.lineno=4,  copy.live_vote_button_text ), '</a> </div> ');__stack.lineno=4; } ; buf.push(' <div class="finalists"></div> <div class="runner-up"> <h1>', (__stack.lineno=4,  copy.subheadline ), '</h1> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var ViewShare = __webpack_require__(104);
var template = __webpack_require__(250);
var REGEX = __webpack_require__(11).REGEX;

module.exports = Backbone.View.extend({
    className: 'view-sweeps',
    events: {
        'click .btn-close': 'closeModal',
        'click .mtv-close': 'routeMTVLink',
        'click .submit': 'submitSweepstakes',
        'submit #vma-sweepstakes': 'submitSweepstakes',
        'click a': 'handleAnchorClick'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render', 'closeModal', 'submitSweepstakes');

        options = options || {};

        this.user = this.model.user;
        this.native = this.model.native;

        this.shareView = new ViewShare({
            model: options.shareModel,
            isThanks: true,
            shareUrl: options.shareUrl
        });
    },
    /**
     *
     */
    render: function render() {

        var model = {
            copy: _.extend({}, this.model.copy, {
                redirect_url: this.model.thanks.redirect_url,
                close_text: this.model.thanks.close_text
            }),
            native: this.model.native
        };

        this.$el.html(template(model));
        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function renderedToDom() {
        if (this.native) {
            this.$el.addClass('native');
        }

        this.$el.find('.share').html(this.shareView.render().$el);
    },
    /**
     * 
     */
    inputValueChange: function inputValueChange(e) {

        var target = $(e.currentTarget);
        var val = target.val();
        var isEmail = target[0].id === 'email';

        // email validation
        if (isEmail && !REGEX.EMAIL_VALIDATION.test(val)) {

            target.addClass('has-error');
            target.next('.error-message').show();

            // non-email validation
        } else if (!isEmail && !REGEX.SWEEPS_INPUT.test(val)) {

            target.addClass('has-error');
            target.next('.error-message').show();

            // remove errors
        } else {

            target.removeClass('has-error');
            target.next('.error-message').hide();
        }
    },
    /**
     * 
     */
    checkboxChange: function checkboxChange(e) {
        var target = $(e.currentTarget);

        if (target[0].checked) {
            target.closest('.checkbox-parent').removeClass('has-error');
            target.siblings('.error-message.terms').hide();
        } else {
            target.closest('.checkbox-parent').addClass('has-error');
            target.siblings('.error-message.terms').show();
        }
    },
    /**
     * 
     */
    submitSweepstakes: function submitSweepstakes(e) {
        e.preventDefault();

        var params = {};
        var form = this.$('#vma-sweepstakes');

        this.isValid = true;

        _.each(form.serializeArray(), function (params, data) {
            params[data.name] = data.value;

            if (data.name == 'email') {

                if (!REGEX.EMAIL_VALIDATION.test(data.value)) {
                    this.isValid = false;
                    this.$el.find('.error-message.' + data.name + '').show();
                    this.$el.find('div.' + data.name + ' input').addClass('has-error');
                } else {
                    this.$el.find('.error-message.' + data.name + '').hide();
                    this.$el.find('div.' + data.name + ' input').removeClass('has-error');
                }
            } else {

                if (data.value == '') {
                    this.$el.find('div.' + data.name + ' input').addClass('has-error');
                    this.$el.find('.error-message.' + data.name + '').show();
                    this.isValid = false;
                } else {
                    this.$el.find('div.' + data.name + ' input').removeClass('has-error');
                    this.$el.find('.error-message.' + data.name + '').hide();
                }
            }
        }.bind(this, params));

        // if the form values are all valid, time to submit the form!
        if (this.isValid) {

            var omParams = { name: 'sweeps submit button', section: 'sweeps-modal', url: window.location.href };
            var gaParams = { eventCategory: 'Button Click', eventAction: 'Submit Sweepstakes' };

            PubSub.trigger('linkClick', omParams, gaParams);
            PubSub.trigger('submitSweepstakes', params);
        }
    },
    /**
     * [closeModal description]
     * @return {[type]} [description]
     */
    closeModal: function closeModal(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     * 
     */
    routeMTVLink: function routeMTVLink(e) {
        var href = e.currentTarget.href;
        var omParams = { name: 'link to mtv', section: 'sweeps-modal', destination: href };
        var gaParams = { eventCategory: 'Link Click', eventAction: 'Close Sweeps Modal to MTV' };

        PubSub.trigger('linkClick', omParams, gaParams);
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function remove() {
        this.user = null;
        return Backbone.View.prototype.remove.call(this);
    },
    /**
     * handleAnchorClick
     * @param {object} e - event object
     * @return {void}
     */
    handleAnchorClick: function handleAnchorClick(e) {
        var val = e.target.innerText;
        var href = e.currentTarget.href;

        var omParams = { name: 'link: ' + val, section: 'sweeps-modal', destination: href };
        var gaParams = { eventCategory: 'Link Click', eventAction: 'Sweeps CTA: ' + val };

        PubSub.trigger('linkClick', omParams, gaParams);
    }
});

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"close btn-close\"> <img src=\"images/btn-x.png\" alt=\"\"> </div> <h1><%- copy.headline1 %></h1> <p><%- copy.paragraph1 %></p> <div class=\"sweeps-form-wrapper\"> <form id=\"vma-sweepstakes\" class=\"sweeps\"> <% copy.fields.forEach(function(value, index) { %> <% if(value.type == 'email') { %> <div class=\"<%= value.name %> form-group\"> <% if(value.label !== '') { %><label for=\"<%= value.name %>\"><%- value.label %></label><% } %> <input type=\"email\" id=\"<%= value.name %>\" name=\"<%= value.name %>\" placeholder=\"<%= value.placeholder %>\" maxlength=\"40\" <% if(value.required == '1') { %> required <% } %>> <span class=\"error-message <%= value.name %>\" style=\"display:none;\"><%= value.error_message %></span> </div> <% } else if(value.type == 'text') { %> <div class=\"<%= value.name %> form-group\"> <% if(value.label !== '') { %><label for=\"<%= value.name %>\"><%- value.label %></label><% } %> <input type=\"text\" id=\"<%= value.name %>\" name=\"<%= value.name %>\" placeholder=\"<%= value.placeholder %>\" maxlength=\"40\" <% if(value.required == '1') { %> required <% } %>> </div> <% } else if(value.type == 'checkbox') { %> <div class=\"checkbox-parent\"> <span class=\"faux-box\"> <input type=\"checkbox\" id=\"<%= value.name %>\" name=\"<%= value.name %>\" <% if(value.required == '1') { %> required <% } %>> <label class=\"optin-checkbox\" for=\"<%= value.name %>\"></label> </span> <label class=\"label\" for=\"<%= value.name %>\"><%- value.label %></label> <span class=\"error-message <%= value.name %>\" style=\"display:none;\"><%= value.error_message %></span> </div> <% } else if(value.type == 'submit') { %> <button type=\"submit\" name=\"<%= value.name %>\" class=\"submit\"><%- value.label %></button> <% } %> <% }); %> </form> <p class=\"submit-terms\"><%- copy.paragraph2 %></p> </div> <div class=\"close-wrapper\"> <a class=\"mtv-close\" href=\"<%= copy.redirect_url %>\" target=\"_blank\" rel=\"noopener nofollow\"><%- copy.close_text %></a> </div> <div class=\"sponsor\"> <span><%= copy.sponsor_text %></span> <img src=\"<%= copy.sponsor_logo %>\" alt=\"\"> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="close btn-close"> <img src="images/btn-x.png" alt=""> </div> <h1>', (__stack.lineno=1,  copy.headline1 ), '</h1> <p>', (__stack.lineno=1,  copy.paragraph1 ), '</p> <div class="sweeps-form-wrapper"> <form id="vma-sweepstakes" class="sweeps"> ');__stack.lineno=1; copy.fields.forEach(function(value, index) { ; buf.push(' ');__stack.lineno=1; if(value.type == 'email') { ; buf.push(' <div class="', escape((__stack.lineno=1,  value.name )), ' form-group"> ');__stack.lineno=1; if(value.label !== '') { ; buf.push('<label for="', escape((__stack.lineno=1,  value.name )), '">', (__stack.lineno=1,  value.label ), '</label>');__stack.lineno=1; } ; buf.push(' <input type="email" id="', escape((__stack.lineno=1,  value.name )), '" name="', escape((__stack.lineno=1,  value.name )), '" placeholder="', escape((__stack.lineno=1,  value.placeholder )), '" maxlength="40" ');__stack.lineno=1; if(value.required == '1') { ; buf.push(' required ');__stack.lineno=1; } ; buf.push('> <span class="error-message ', escape((__stack.lineno=1,  value.name )), '" style="display:none;">', escape((__stack.lineno=1,  value.error_message )), '</span> </div> ');__stack.lineno=1; } else if(value.type == 'text') { ; buf.push(' <div class="', escape((__stack.lineno=1,  value.name )), ' form-group"> ');__stack.lineno=1; if(value.label !== '') { ; buf.push('<label for="', escape((__stack.lineno=1,  value.name )), '">', (__stack.lineno=1,  value.label ), '</label>');__stack.lineno=1; } ; buf.push(' <input type="text" id="', escape((__stack.lineno=1,  value.name )), '" name="', escape((__stack.lineno=1,  value.name )), '" placeholder="', escape((__stack.lineno=1,  value.placeholder )), '" maxlength="40" ');__stack.lineno=1; if(value.required == '1') { ; buf.push(' required ');__stack.lineno=1; } ; buf.push('> </div> ');__stack.lineno=1; } else if(value.type == 'checkbox') { ; buf.push(' <div class="checkbox-parent"> <span class="faux-box"> <input type="checkbox" id="', escape((__stack.lineno=1,  value.name )), '" name="', escape((__stack.lineno=1,  value.name )), '" ');__stack.lineno=1; if(value.required == '1') { ; buf.push(' required ');__stack.lineno=1; } ; buf.push('> <label class="optin-checkbox" for="', escape((__stack.lineno=1,  value.name )), '"></label> </span> <label class="label" for="', escape((__stack.lineno=1,  value.name )), '">', (__stack.lineno=1,  value.label ), '</label> <span class="error-message ', escape((__stack.lineno=1,  value.name )), '" style="display:none;">', escape((__stack.lineno=1,  value.error_message )), '</span> </div> ');__stack.lineno=1; } else if(value.type == 'submit') { ; buf.push(' <button type="submit" name="', escape((__stack.lineno=1,  value.name )), '" class="submit">', (__stack.lineno=1,  value.label ), '</button> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; }); ; buf.push(' </form> <p class="submit-terms">', (__stack.lineno=1,  copy.paragraph2 ), '</p> </div> <div class="close-wrapper"> <a class="mtv-close" href="', escape((__stack.lineno=1,  copy.redirect_url )), '" target="_blank" rel="noopener nofollow">', (__stack.lineno=1,  copy.close_text ), '</a> </div> <div class="sponsor"> <span>', escape((__stack.lineno=1,  copy.sponsor_text )), '</span> <img src="', escape((__stack.lineno=1,  copy.sponsor_logo )), '" alt=""> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(252);

module.exports = Backbone.View.extend({
    className: 'global-banner-container',
    events: {
        'click .banner': 'openUpsell'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render');

        options = options || {};
        this.model = options.model;
    },
    /**
     *
     */
    render: function render() {

        this.$el.html(template(this.model));
        return this;
    },

    openUpsell: function openUpsell() {
        PubSub.trigger('openUpsell');
    }
});

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if(upSellExit === 'true') { %> <button class=\"banner\"> <p><%= copy %></p> <div class=\"button\"><%= promoResourceLinks[0].copy %></div> </button> <% } else { %> <a href=\"<%= promoResourceLinks[0].url %>\" class=\"banner\" target=\"_blank\"> <p><%= copy %></p> <div class=\"button\"><%= promoResourceLinks[0].copy %></div> </a> <% } %> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if(upSellExit === 'true') { ; buf.push(' <button class="banner"> <p>', escape((__stack.lineno=1,  copy )), '</p> <div class="button">', escape((__stack.lineno=1,  promoResourceLinks[0].copy )), '</div> </button> ');__stack.lineno=1; } else { ; buf.push(' <a href="', escape((__stack.lineno=1,  promoResourceLinks[0].url )), '" class="banner" target="_blank"> <p>', escape((__stack.lineno=1,  copy )), '</p> <div class="button">', escape((__stack.lineno=1,  promoResourceLinks[0].copy )), '</div> </a> ');__stack.lineno=1; } ; buf.push(' '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
var template = __webpack_require__(254);
var templateCSS = __webpack_require__(255);
var CSSView = __webpack_require__(35);

module.exports = Backbone.View.extend({
    className: 'upsell-exit',
    events: {
        'click .upsell-mtv-close': 'closeModal'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        _.bindAll(this, 'render', 'closeModal');

        options = options || {};
        this.model = options.model;
        this.style_id = this.className + "_" + Math.round(Math.random() * 1000000);
        this.$el.addClass(this.style_id);
    },
    /**
     *
     */
    render: function render() {
        if (this.CSSView) this.CSSView.remove();

        this.CSSView = new CSSView({
            model: { backgroundImage: this.model.backgroundImage.url },
            namespace: '.' + this.style_id + '.' + this.className,
            template: templateCSS
        });

        Backbone.$('head').append(this.CSSView.render().$el);
        this.$el.html(template(this.model));
        return this;
    },

    closeModal: function closeModal(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (this.CSSView) this.CSSView.remove();
        PubSub.trigger('directRoute', 'closeCurrentModal');
    }
});

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"upsell-banner\"> <button class=\"upsell-mtv-close\"> <svg aria-hidden=\"true\" data-display-name=\"Icon\" focusable=\"false\" preserveAspectRatio=\"xMinYMin\" xmlns=\"http://www.w3.org/2000/svg\" role=\"button\" class=\"efnjrt41 css-lfee4p-Svg-StyledCloseIcon e1t3qibb0\" viewBox=\"0 0 22 22\" data-icon-name=\"Close\"><path d=\"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zM7.404 6.178a.875.875 0 00-1.148 1.316L9.763 11l-3.507 3.506-.078.09a.875.875 0 001.226 1.226l.09-.078L11 12.237l3.506 3.507.09.078a.875.875 0 001.148-1.316L12.237 11l3.507-3.506.078-.09a.875.875 0 00-1.226-1.226l-.09.078L11 9.763 7.494 6.256l-.09-.078z\"></path></svg> </button> <div class=\"upsell-banner-content\"> <div class=\"upsell-banner-content-wrapper\"> <img src=\"<%= showLogo.url %>\" alt=\"\" class=\"upsell-mtv-logo\"> <h1><%= headerText %></h1> <h2><%= subheaderText %></h2> </div> </div> </div> <div class=\"upsell-info\"> <%- copy %> <a href=\"<%= promoResourceLinks[0].url %>\" target=\"_blank\" class=\"upsell-link\"><%= promoResourceLinks[0].copy %></a> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="upsell-banner"> <button class="upsell-mtv-close"> <svg aria-hidden="true" data-display-name="Icon" focusable="false" preserveAspectRatio="xMinYMin" xmlns="http://www.w3.org/2000/svg" role="button" class="efnjrt41 css-lfee4p-Svg-StyledCloseIcon e1t3qibb0" viewBox="0 0 22 22" data-icon-name="Close"><path d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zM7.404 6.178a.875.875 0 00-1.148 1.316L9.763 11l-3.507 3.506-.078.09a.875.875 0 001.226 1.226l.09-.078L11 12.237l3.506 3.507.09.078a.875.875 0 001.148-1.316L12.237 11l3.507-3.506.078-.09a.875.875 0 00-1.226-1.226l-.09.078L11 9.763 7.494 6.256l-.09-.078z"></path></svg> </button> <div class="upsell-banner-content"> <div class="upsell-banner-content-wrapper"> <img src="', escape((__stack.lineno=1,  showLogo.url )), '" alt="" class="upsell-mtv-logo"> <h1>', escape((__stack.lineno=1,  headerText )), '</h1> <h2>', escape((__stack.lineno=1,  subheaderText )), '</h2> </div> </div> </div> <div class="upsell-info"> ', (__stack.lineno=1,  copy ), ' <a href="', escape((__stack.lineno=1,  promoResourceLinks[0].url )), '" target="_blank" class="upsell-link">', escape((__stack.lineno=1,  promoResourceLinks[0].copy )), '</a> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if(backgroundImage.length > 0) { %> <%= namespace %> .upsell-banner { background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(<%= backgroundImage %>); } <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if(backgroundImage.length > 0) { ; buf.push(' ', escape((__stack.lineno=1,  namespace )), ' .upsell-banner { background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(', escape((__stack.lineno=1,  backgroundImage )), '); } ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
// const $ = require('jquery');
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);
// const ViewShare = require('./share');
var template = __webpack_require__(257);
var CmsModel = __webpack_require__(106);
var ConnectModel = __webpack_require__(107);
var StorageModel = __webpack_require__(109);

// const REGEX = require('../constants').REGEX;

module.exports = Backbone.View.extend({
  className: 'view-poll',
  events: {
    'click .btn-close': 'closeModal',
    'click .mtv-close': 'routeMTVLink',
    'click .btn-poll': 'onPollAnswer',
    'click a': 'handleAnchorClick'
  },
  /**
   *
   */
  initialize: function initialize(options) {
    _.bindAll(this, 'render', 'closeModal');

    options = options || {};

    this.getContextData = options.getContextData;
    this.getUserData = options.getUserData;
    this.completed = false;

    this.userModel = options.userModel;
    this.model = new CmsModel({
      id: 'pollcms',
      wid: options.pollWidgetId
    }, {
      ignoreQSP: true
    });
    this.model.poll = false;

    this.storage = new StorageModel({ storageMethod: 'cookie' });

    this.listenTo(this.model, 'change:cookieReady', this.render);

    this.model.fetch().then(function () {
      this.completed = this.readCookie();

      var settings = this.model.get('settings');
      this.connect = new ConnectModel({ apiKey: settings.apiKey }, { version_id: settings.version_id });
      this.connect.versionCheck = 'llkipqojlkjasdlkzjkaj';
    }.bind(this));
  },

  getKey: function getKey() {
    var userData = this.getUserData();
    var key = userData.user_id + this.model.get('wid') + this.model.get('data')[0].reporting_identifier;
    return key;
  },

  readCookie: function readCookie() {
    var key = this.getKey();

    if (window.cbsoptanon) {
      window.cbsoptanon.cmd.push(function (cmp) {
        cmp.ot.functionalAllowed(function (allowed) {
          if (allowed) {
            this.completed = this.storage.fetch(key);
          }
          this.model.set('cookieReady', true);
        }.bind(this));
      }.bind(this));
    }
  },

  saveCookie: function saveCookie() {
    var key = this.getKey();

    if (window.cbsoptanon) {
      window.cbsoptanon.cmd.push(function (cmp) {
        cmp.ot.functionalAllowed(function (allowed) {
          if (allowed) {
            this.storage.save(key, true, 180);
          }
        }.bind(this));
      }.bind(this));
    }
  },

  onPollAnswer: function onPollAnswer(evt) {
    var question = this.model.get('data')[0];
    var answers = question.answers;
    var answer = evt.currentTarget.textContent;
    var answerIndex = answers.indexOf(answer);

    if (answerIndex > -1) {

      var id = String.fromCharCode(65 + answerIndex);
      var data = _.extend({
        v: id,
        action_type: 'vote',
        sid: question.reporting_identifier,
        real_name: answer
      }, this.getUserData(), this.getContextData());

      var omParams = { name: 'poll answer button', section: 'poll-modal', url: window.location.href };
      var gaParams = { eventCategory: 'Button Click', eventAction: 'Submit Poll' };

      PubSub.trigger('linkClick', omParams, gaParams);

      this.connect.save(data).then(function () {
        this.completed = true;
        this.saveCookie();
        this.render();
      }.bind(this));
    }
  },
  /**
   *
   */
  render: function render() {
    if (this.model.get('initialized')) {
      this.$el.html(template(_.extend({ completed: this.completed }, this.model.toJSON())));
    }
    return this;
  },
  /**
   * [closeModal description]
   * @return {[type]} [description]
   */
  closeModal: function closeModal(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    PubSub.trigger('navigate', 'thanks');
  }
});

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"close btn-close\"> <img src=\"https://content.votenow.tv/app/projects/mtv/vmas-2021/btn-x-black.png\" alt=\"Close Modal\"> </div> <h1><%- text.header %></h1> <p><%- text.description %></p> <div class=\"poll-wrapper\"> <% data.forEach( function( question ) { %> <img src=\"<%- question.question_image %>\" alt=\"Poll Question Image\"> <% if( !completed ) { %> <h2><%- question.question %></h2> <% question.answers.forEach( function( answer, index ) { %> <div class=\"answer-group\"> <img src=\"<%= question.answer_images[index] %>\" alt=\"<%= answer %>\"> <button class=\"btn-poll\"><%- answer %></button> </div> <% }); %> <% } else { %> <div class=\"thanks-wrapper\"> <h2><%- text.thanks.header %></h2> <p><%- text.thanks.description %></p> <p class=\"code\"><%- text.thanks.code %></p> </div> <% } %> <% }); %> </div> <% if ( text.sponsor.sponsor_image  ) { %> <div class=\"sponsor\"> <span><%- text.sponsor.sponsor_label %></span> <img src=\"<%- text.sponsor.sponsor_image %>\" alt=\"\"> </div> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="close btn-close"> <img src="https://content.votenow.tv/app/projects/mtv/vmas-2021/btn-x-black.png" alt="Close Modal"> </div> <h1>', (__stack.lineno=1,  text.header ), '</h1> <p>', (__stack.lineno=1,  text.description ), '</p> <div class="poll-wrapper"> ');__stack.lineno=1; data.forEach( function( question ) { ; buf.push(' <img src="', (__stack.lineno=1,  question.question_image ), '" alt="Poll Question Image"> ');__stack.lineno=1; if( !completed ) { ; buf.push(' <h2>', (__stack.lineno=1,  question.question ), '</h2> ');__stack.lineno=1; question.answers.forEach( function( answer, index ) { ; buf.push(' <div class="answer-group"> <img src="', escape((__stack.lineno=1,  question.answer_images[index] )), '" alt="', escape((__stack.lineno=1,  answer )), '"> <button class="btn-poll">', (__stack.lineno=1,  answer ), '</button> </div> ');__stack.lineno=1; }); ; buf.push(' ');__stack.lineno=1; } else { ; buf.push(' <div class="thanks-wrapper"> <h2>', (__stack.lineno=1,  text.thanks.header ), '</h2> <p>', (__stack.lineno=1,  text.thanks.description ), '</p> <p class="code">', (__stack.lineno=1,  text.thanks.code ), '</p> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; }); ; buf.push(' </div> ');__stack.lineno=1; if ( text.sponsor.sponsor_image  ) { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=1,  text.sponsor.sponsor_label ), '</span> <img src="', (__stack.lineno=1,  text.sponsor.sponsor_image ), '" alt=""> </div> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capitalize__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fixedEncodeURIComponent__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getQueryParamByName__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isTrue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__roundByLargestRemainder__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toCamel__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__urlencode__ = __webpack_require__(265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return __WEBPACK_IMPORTED_MODULE_0__capitalize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fixedEncodeURIComponent", function() { return __WEBPACK_IMPORTED_MODULE_1__fixedEncodeURIComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryParamByName", function() { return __WEBPACK_IMPORTED_MODULE_2__getQueryParamByName__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTrue", function() { return __WEBPACK_IMPORTED_MODULE_3__isTrue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "roundByLargestRemainder", function() { return __WEBPACK_IMPORTED_MODULE_4__roundByLargestRemainder__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toCamel", function() { return __WEBPACK_IMPORTED_MODULE_5__toCamel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "urlencode", function() { return __WEBPACK_IMPORTED_MODULE_6__urlencode__["a"]; });











/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Capitalize a given string
 * @param {String} string 
 */
/* harmony default export */ __webpack_exports__["a"] = (function (string) {
  return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Modified version of the encodeURIComponent function
 * @param {String} str 
 */
/* harmony default export */ __webpack_exports__["a"] = (function(str) {
  return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
});;

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Get the query string parameter by name
 * @param {String} name
 * @return {String} - can be empty if none are found
 */
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var regexS = '[\\?&]' + name + '=([^&#]*)';
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.search);

  if (results === null) return '';
  else return decodeURIComponent(results[1].replace(/\+/g, ' '));
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Check if the given parameter has a truthy value
 * @param {*} value
 * @return {Boolean}
 */
var TRUTHY_VALUES = [ true, 1, 'true', '1', 'enabled', 'yes', 'active' ];
/* harmony default export */ __webpack_exports__["a"] = (function ( value ) {
  return TRUTHY_VALUES.indexOf( value.toLowerCase().trim() ) >= 0;
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Rounds the numbers from a given array based on their remainders
 * @param {Array} arr 
 * @param {*} target
 * @param {*} prop
 * @return {Array} - updated array with rounded numbers
 */
/* harmony default export */ __webpack_exports__["a"] = (function(arr, target, prop) {
	var pairs = [];
	var sum = 0;

	arr = JSON.parse(JSON.stringify(arr));

	//Loop through the input array to get the integers and their remainders.
	for (var i = 0; i < arr.length; i++) {
		var integer;
		var remainder;

		if (typeof arr[i] === 'number') {
			integer = Math.floor(arr[i]);
			remainder = arr[i] - integer;
			arr[i] = integer;
		} else if (typeof arr[i] === 'object' && typeof prop === 'string') {
			var number = parseFloat(arr[i][prop]);
			integer = Math.floor(number);
			remainder = number - integer;
			arr[i][prop] = integer;
		} else {
			return null;
		}

		//Add up all the integers. 'sum' should end up lower than target.
		sum += integer;

		//Put all of the integers, remainders, and indexes into an array for sorting.
		pairs.push({
			index: i,
			integer: integer,
			remainder: remainder
		});
	}

	//Sort descending by the remainders.
	var sorted = pairs.sort(function(a, b) {
		return b.remainder - a.remainder;
	});

	//Loop through the largest remainders, and add 1 to their corresponding ints.
	//Basically rounding up on the numbers with the largest integers,
	//and rounding down on the rest to reach the 'target'
	for (i = 0; i < (target - sum); i++) {
		if (typeof arr[i] === 'number') {
			arr[sorted[i].index] = sorted[i].integer + 1;
		} else if (typeof arr[i] === 'object') {
			arr[sorted[i].index][prop] = sorted[i].integer + 1;
		}
	}

	//Returns a copy of the original array with the numbers rounded by largest remainder.
	return arr;
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Update a string to camel case
 * @param {String} str
 */
/* harmony default export */ __webpack_exports__["a"] = (function (str) {
  return str.replace(/([-_][a-z])/ig, function($1){
    return $1.toUpperCase()
      .replace('-', '')
      .replace('_', '');
  });
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * https://github.com/kvz/phpjs/blob/master/functions/url/urlencode.js
 * @param {String} str
 * @return {String} encoded string
 */
/* harmony default export */ __webpack_exports__["a"] = (function(str) {
  str = (str + "").toString();
  // Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
  // PHP behavior, you would need to add '.replace(/~/g, '%7E');' to the following.
  return encodeURIComponent(str)
    .replace(/!/g, "%21")
    .replace(/'/g, "%27")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/\*/g, "%2A")
    .replace(/%20/g, "+");
});;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(29), __webpack_require__(267), __webpack_require__(268));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA256;

}));

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(29));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(29));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(29));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Utf8;

}));

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);
var PubSub = __webpack_require__(2);

var _require = __webpack_require__(21),
    isMobile = _require.isMobile;

var _require2 = __webpack_require__(101),
    pagePath = _require2.pagePath,
    ptype = _require2.ptype,
    franchise = _require2.franchise,
    event = _require2.event;

module.exports = Backbone.Model.extend(_defineProperty({
	defaults: {
		ads: []
	},
	video: null,
	/**
  *
  */
	initialize: function initialize(attrs, options) {
		_.bindAll(this, 'createAd' /*, 'loadScript'*/);

		window.BidBarrel.initialize({
			dfpPath: {
				device: isMobile.any() ? 'm' : '',
				pagePath: pagePath
			},

			targeting: {
				auto: true,
				cookie: {
					surround: true,
					consolidate: true
				}
			},

			pageTargeting: {
				ptype: ptype,
				env: 'prod',
				franchise: franchise,
				event: event
			}
		});

		this.listenTo(PubSub, 'createAd', this.createAd.bind(this));
	},
	/**
  *
  */
	removeAd: function removeAd(targetElement) {
		var ads = _.clone(this.get('ads'), true);
		ads.pop(ads.indexOf(targetElement));
		this.set({ ads: ads });
	},
	/**
  *
  */
	createAd: function createAd(adId, sponsor) {
		try {
			if (window.cbsoptanon && window.cbsoptanon.onAdsReady) {
				window.cbsoptanon.onAdsReady(function () {

					window.BidBarrel.auction([adId]);

					if (sponsor) {
						window.BidBarrel.setTargeting({
							sponsor: sponsor
						}, [adId]);
					}
				}.bind(this));
			}
		} catch (err) {
			console.error(err);
		}
	}
}, "removeAd", function removeAd(adIds) {
	if (window.BidBarrel) {
		if (!Array.isArray(adIds)) {
			adIds = [adIds];
		}

		window.BidBarrel.destroySlots(adIds);
	}
}));

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);

var _require = __webpack_require__(110),
    trackLogin = _require.trackLogin;

var STORAGE = __webpack_require__(11).STORAGE;

module.exports = Backbone.Model.extend({
    defaults: {
        authType: null,
        isAuthorized: false,
        userName: null,
        userID: null,
        firstName: null,
        lastName: null,
        avatar: null,
        email: null,
        optin: false,
        share: {}
    },
    /**
     * Initialize Auth Model
     */
    initialize: function initialize(attrs, options) {
        this.google = options.google;
        this.storage = options.storage;
        this.facebook = options.facebook;
    },
    /**
     * Check if a user is already logged in
     */
    initializeType: function initializeType() {

        if (!_.isNull(this.storage.fetch(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY))) {
            var foo = this.storage.fetch(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY);
            this.signInSuccess('email', this.storage.fetch(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY));
            trackLogin('email');
        }
    },
    /**
    *
    */
    signInSuccess: function signInSuccess(type, data) {
        switch (type) {
            case 'email':
                if (!_.isNull(this.get('userID')) && this.get('userID') !== data) {
                    this.set(this.defaults);
                }
                this.setUpEmailUser(data);
                trackLogin('email');
                break;
            case 'facebook':
                if (!_.isNull(this.get('userID')) && this.get('userID') !== this.facebook.get('id')) {
                    this.set(this.defaults);
                }
                this.setUpFacebookUser();
                trackLogin('facebook');
                break;
            case 'google':
                if (!_.isNull(this.get('userID')) && this.get('userID') !== this.google.get('user').id) {
                    this.set(this.defaults);
                }
                this.setUpGoogleUser();
                trackLogin('google');
                break;
        }
    },
    /**
     * [setUpEmailUser description]
     * @param {[type]} data [description]
     */
    setUpEmailUser: function setUpEmailUser(data) {

        this.set({
            authType: 'email',
            userName: data,
            userID: data,
            isAuthorized: true
        });
        this.storage.save(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY, data);
    },
    setUpFacebookUser: function setUpFacebookUser() {
        var fbUser = this.facebook.toJSON();

        if (!_.isNull(fbUser)) {
            this.set({
                authType: 'facebook',
                userID: fbUser.id,
                firstName: fbUser.first_name,
                email: fbUser.email,
                isAuthorized: true
            });
        }
    },

    /**
     * Set up Google User
     */
    setUpGoogleUser: function setUpGoogleUser() {
        var googleUser = this.google.get('user');
        if (!_.isNull(googleUser)) {
            this.set({
                authType: 'google',
                userID: googleUser.id,
                userName: googleUser.name,
                email: googleUser.email,
                isAuthorized: true
            });
        }
    },
    /**
    * [deAuthorize description]
    * @return {[type]} [description]
    */
    deAuthorize: function deAuthorize() {
        if (this.get('authType') === 'email') {
            this.storage.destroy(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY);
        }
    }
});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var PubSub = __webpack_require__(2);
var ModelConnect = __webpack_require__(107);

// constants
var CONNECT = __webpack_require__(11).CONNECT;

module.exports = ModelConnect.extend({
    /**
     * [defaults description]
     * @type {Object}
     */
    defaults: {
        apiKey: '',
        secretKey: '',
        version_id: '',

        requestActionGetPayload: null,
        getFailureCount: 0,
        getFailureLimit: 3,

        // vote (read-write) request fields
        requestActionVotePayload: null,
        requestActionVoteError: null,

        shareString: null
    },
    /**
     * Internal options and values
     */
    versionCheck: CONNECT.CONNECT_VERSION_CHECK,
    requestActionGetXhr: null,
    getTimer: null,
    getIntervalTimer: null,

    /**
     * Initialize
     * @param  {Object} attr    [description]
     * @param  {Object} options [description]
     */
    initialize: function initialize(attr, options) {
        _.bindAll(this, 'syncSuccess', 'syncError');
        this.cms = options.cms;
        this.getContextData = options.getContextData;
        this.getUserData = options.getUserData;
        this.secretKey = options.secretKey;
        this.version_id = options.version_id;
        this.numberOfCategories = options.numberOfCategories;
    },
    /**
     *
     */
    requestActionGet: function requestActionGet() {
        var data = _.extend(this.getContextData(), { apiKey: this.get('apiKey'), action_type: 'get' }, this.getUserData());

        var params = this.paramsLiteralToQsp(data);
        var b64hash = this.qspToHash(params);
        var xhrParams = {
            url: this.apiUrl + '?' + params,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: 'Authorization=' + encodeURIComponent(b64hash),
            success: this.actionTypeGetSuccess.bind(this),
            error: this.actionTypeGetError.bind(this)
        };

        this.getTimer = window.setTimeout(this.retryActionGet.bind(this), 7000);
        return this.requestActionGetXhr = $.ajax(xhrParams);
    },
    /**
     *
     * @param data
     * @param textStatus
     * @param jqXHR
     */
    actionTypeGetSuccess: function actionTypeGetSuccess(data, textStatus, jqXHR) {
        if (!(_.isObject(data) && _.size(data) > 0)) {
            return console.log('requestActionGetSuccess - Invalid Data Payload');
        }

        // clear timer on GET request and set to null
        clearTimeout(this.getTimer);
        this.getTimer = null;

        // silently prepare for next GET request
        this.set({
            requestActionGetPayload: 0,
            getFailureCount: 0
        }, { silent: true });
        if (this.cms.get('appState') !== 'open') return;

        switch (data.response_code) {
            case '20':
                var payload = null;
                if (data.votestring && data.votestring.length > 0) {
                    payload = unpadVoteStringCategoryIds(data.votestring);
                } else if (data.turbo_window) {
                    payload = {
                        turbo_window: data.turbo_window
                    };
                }
                this.set({ requestActionGetPayload: payload });
                break;
            default:
        }
    },
    /**
     *
     * @param jqXHR
     * @param textStatus
     * @param errorThrown
     */
    actionTypeGetError: function actionTypeGetError(jqXHR, textStatus, errorThrown) {
        if (textStatus !== 'abort') {// only handle errors, not intentionally terminated requests
            // do nothing
        }
    },
    /**
     *
     * @returns {boolean}
     */
    retryActionGet: function retryActionGet() {
        // abort failed request
        this.requestActionGetXhr.abort();
        // increment failure counter
        this.set({
            getFailureCount: parseInt(this.get('getFailureCount'), 10) + 1
        });

        // handle failure polling limit
        if (this.get('getFailureCount') >= this.get('getFailureLimit')) {
            PubSub.trigger('navigate', 'error/generic');
            PubSub.trigger('resetAll');
            return false;
        }
        // retry
        this.requestActionGet();
    },
    /**
     *
     */
    requestActionSweeps: function requestActionSweeps(data) {
        var sweepsData = data;

        var submissionData = _.extend(this.getContextData(), {
            apiKey: this.get('apiKey'),
            action_type: 'sweeps'
        }, this.getUserData(), sweepsData);

        var params = this.paramsLiteralToQsp(submissionData);
        var b64hash = this.qspToHash(params);

        var xhrParams = {
            url: this.apiUrl + '?' + params,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: 'Authorization=' + encodeURIComponent(b64hash),
            success: this.actionTypeSweepsSuccess.bind(this),
            error: this.actionTypeSweepsError.bind(this)
        };

        this.requestActionSweepsXhr = $.ajax(xhrParams);
    },
    /**
     *
     */
    actionTypeSweepsSuccess: function actionTypeSweepsSuccess(data, textStatus, jqXHR) {
        // if we don't get any valid data
        if (!(_.isObject(data) && _.size(data) > 0)) {
            this.actionTypeSweepsError();
            return false;
        }

        // silently prepare for next vote request
        this.set({ requestActionVotePayload: null, shareString: null }, { silent: true });

        // use payload to update app
        var voteString = !_.isUndefined(data.voteString) && data.voteString.length > 0 ? JSON.parse(data.voteString) : '';
        var shareString = !_.isUndefined(data.shareString) && data.shareString.length > 0 ? JSON.parse(data.shareString) : '';

        this.set({
            requestActionVotePayload: _.isObject(voteString) === true ? _.omit(voteString, 'total') : {},
            shareString: _.isObject(shareString) === true ? _.omit(shareString, 'total') : {}
        });

        // HANDLE THE SUCCESS VALUE
        switch (data.response_code) {
            case '20':
                PubSub.trigger('sweepsSuccess', data);
                break;
            case '21':
                // display the user vote error as they have already voted for the category
                PubSub.trigger('sweepsSuccess', data);
                break;
            default:
                this.actionTypeSweepsError();
                break;
        }
    },
    /**
     *
     */
    actionTypeSweepsError: function actionTypeSweepsError(jqXHR, textStatus, errorThrown) {
        PubSub.trigger('directRoute', 'error', 'generic');
    },
    /**
     *
     */
    requestActionVote: function requestActionVote(data) {
        // Always pad to at least 2 digits.
        var numDigits = Math.max(this.numberOfCategories.toString().length, 2);

        var voteData = _.extend({
            category: 'cat' + padCategoryIndex(data.categoryID, numDigits)
        }, data.categoryVoteData);

        if (data.totalAllocatedVotes !== undefined) {
            voteData = _.extend(voteData, {
                total: data.totalAllocatedVotes
            });
        }

        var dataObj = _.extend(this.getContextData(), { apiKey: this.get('apiKey'), action_type: 'vote' }, this.getUserData(), voteData);

        var params = this.paramsLiteralToQsp(dataObj);
        var b64hash = this.qspToHash(params);

        var xhrParams = {
            url: this.apiUrl + '?' + params,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: 'Authorization=' + encodeURIComponent(b64hash),
            success: this.actionTypeVoteSuccess.bind(this, voteData),
            error: this.actionTypeVoteError.bind(this)
        };

        PubSub.trigger('submittingVote', voteData);

        this.requestActionVoteXhr = $.ajax(xhrParams);
    },
    /**
     *
     * @param data
     * @param textStatus
     * @param jqXHR
     */
    actionTypeVoteSuccess: function actionTypeVoteSuccess(voteData, response, textStatus, jqXHR) {
        // if we don't get any valid data
        if (!(_.isObject(response) && _.size(response) > 0)) {
            this.actionTypeVoteError();
            return false;
        }

        // silently prepare for next vote request
        this.set({ requestActionVotePayload: null, shareString: null }, { silent: true });

        // use payload to update app
        var voteString = !_.isUndefined(response.votestring) && response.votestring.length > 0 ? unpadVoteStringCategoryIds(response.votestring) : '';
        var shareString = !_.isUndefined(response.shareString) && response.shareString.length > 0 ? JSON.parse(response.shareString) : '';

        if (voteString) {
            response.votestring = JSON.stringify(voteString);
        }

        this.set({
            requestActionVotePayload: _.isObject(voteString) === true ? _.omit(voteString, 'total') : {},
            shareString: _.isObject(shareString) === true ? _.omit(shareString, 'total') : {}
        });

        // HANDLE THE SUCCESS VALUE
        switch (response.response_code) {
            case '20':
                // update the vote option to have the "voted" text on it
                // route user to next category after '2' seconds
                PubSub.trigger('voteSuccess', response, voteData);
                break;
            case '21':
                // display the user vote error as they have already voted for the category
                PubSub.trigger('voteSuccess', response, voteData);
                break;
            // case '40':
            //     PubSub.trigger('directRoute', 'window');
            // this.controller.closeWindow();
            // break;
            default:
                this.actionTypeVoteError();
                break;
        }
    },
    /**
     *
     * @param jqXHR
     * @param textStatus
     * @param errorThrown
     */
    actionTypeVoteError: function actionTypeVoteError(jqXHR, textStatus, errorThrown) {

        //still set vote temp to null if there's an error
        // var optionId = this.controller.Collections.VoteOption.getSelected().get('id');

        // this.controller.Collections.VoteOption.get(optionId).set({voteCountTemp: null});
        PubSub.trigger('directRoute', 'error', 'voting');
        // this.controller.Routers.Router.navigate('error/voting', {trigger: true});

        this.set({ requestActionVoteError: true });
    },

    getEvery: function getEvery(interval) {
        var sanitizedInterval = Math.max(interval, 5000);
        this.stopGetting();

        this.requestActionGet().then(function () {
            this.getIntervalTimer = setTimeout(function () {
                this.getEvery(sanitizedInterval);
            }.bind(this), sanitizedInterval);
        }.bind(this));
    },

    stopGetting: function stopGetting() {
        clearTimeout(this.getIntervalTimer);
    }
});

function unpadVoteStringCategoryIds(voteString) {
    var voteHistory = JSON.parse(voteString);
    var unpaddedHistory = {};

    Object.keys(voteHistory).forEach(function (catId) {
        var unpaddedId = unpadCategoryId(catId);
        unpaddedHistory[unpaddedId] = voteHistory[catId];
    });

    return unpaddedHistory;
}

function padCategoryIndex(index, numDigits) {
    var strIndex = index + '';
    return strIndex.padStart(numDigits, '0');
}

function unpadCategoryId(catId) {
    var pattern = new RegExp(/^cat([0-9]+)$/);
    var results = catId.match(pattern);

    if (results) {
        var index = parseInt(results[1], 10);
        return 'cat' + index;
    } else {
        return catId;
    }
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
Backbone.$ = $;

module.exports = Backbone.Model.extend({
    urlRoot: '/api/getregion.json',
    url: '/api/getregion.json',

    defaults: {
        inRegion: null,
        geoheaders: {
            city: null,
            country: null,
            region: null,
            timezone: null,
            zipcode: null
        }
    },

    /**
     * Initialize
     * @param  {Object} options [description]
     */
    initialize: function (options) {
        this.countries = this.parseCountries(options.countries);
    },

    /**
     * Fetch
     * @param {Object} options [options to pass onto fetch]
     */
    fetch: function(options) {
        var deferred = $.Deferred();
        this.once('change:geoheaders', this.handleSync.bind(this,deferred,this));
        
        // call original fetch function
        Backbone.Model.prototype.fetch.call(this, options);
        
        // Returning deferred instead of fetch. 
        // Will resolve deferred after parsing geoheaders  
        return deferred;
    },

    /**
     * [parseCountries description]
     * @param  {String/Array} list [description]
     * @return {Array}             [description]
     */
    parseCountries:function(list) {
        var countries = [];
        if (list) {
            if(_.isString(list) ) {
                var splitCountries = list.split(",");
                $.each(splitCountries, function (index, country) {
                    countries.push($.trim(country));
                });
            } else if(_.isArray(list) ) {
                countries = list;
            }
        }
        return countries;
    },

    /**
     * [handleSync description]
     * @param  {Object} deferred [jQuery deferred to be resolved/rejected]
     * @param  {[type]} model [description]
     */
    handleSync: function (deferred, model) {
        var geoheaders = model.get('geoheaders');

        if (geoheaders) {
            var inRegion = this.countries.indexOf( geoheaders.country ) > -1;
            if (inRegion || this.countries.length === 0) {
                this.set({
                    inRegion: true,
                    country: geoheaders.country
                });
            } else {
                this.set({
                    inRegion: false,
                    country: 'undefined'
                });
            }
            deferred.resolve(model);
        } else {
            this.set({
                inRegion: false,
                country: 'undefined'
            });
            deferred.resolve(model);
            //deferred.reject(model);
        }
    }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvalidTokenError", function() { return n; });
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ __webpack_exports__["default"] = (o);
//# sourceMappingURL=jwt-decode.esm.js.map


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ = __webpack_require__(0),
    $ = __webpack_require__(4),
    Backbone = __webpack_require__(1),
    PubSub = __webpack_require__(2);

module.exports = Backbone.Model.extend({
	defaults: {
		scriptLoaded: false,
		player_params: {
			uri: null,
			autoPlay: true,
			allowFullScreen: true,
			flashVars: { autoPlay: true },
			scoundrelMode: true
			// params: {
			// 	autoPlay: true,
			// 	allowFullScreen: true
			// }
		},
		container: null
	},
	currentVideo: null,
	/**
  *
  */
	initialize: function initialize(attrs, options) {
		// While MTV figures out their issues with Android, we will attempt
		// to fix their performance.now function by placing it in the initialize function
		if (window.performance !== undefined && window.performance.now == undefined) {
			window.performance.now = function () {
				return new Date().getTime();
			};
		}

		this.listenTo(PubSub, 'playVideo', this.playVideo.bind(this));

		this.listenTo(PubSub, 'removeVideoPlayer', function () {
			if (this.currentVideo) {
				try {
					this.currentVideo.destroy();
					this.currentVideo = null;
				} catch (e) {}
			}
		}.bind(this));

		if ((typeof EdgePlayer === "undefined" ? "undefined" : _typeof(EdgePlayer)) === 'object' && !_.isUndefined(window._edgePlayerApiReady)) {
			this.set('scriptLoaded', true);
			return;
		} else {
			window.addEventListener('edgeplayer:PLAYLIST_METADATA', this.playerReady.bind(this));
			window.addEventListener('edgeplayer', this.loadedScript.bind(this));
			this.loadScript(document, 'script', 'edgeplayer-api');
		}
	},
	/**
  *
  */
	loadScript: function loadScript(d, s, id) {
		var js;
		var fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) return;

		js = d.createElement(s);
		js.id = id;
		js.src = 'https://player.mtvnservices.com/edge/player/3.1.10/edgeplayer.min.js';
		fjs.parentNode.insertBefore(js, fjs);
	},
	/**
  *
  */
	loadedScript: function loadedScript() {
		this.set('scriptLoaded', true);
	},
	/**
  *
  */
	playVideo: function playVideo(video, player) {
		var video_params = _.clone(this.get('player_params'), true);
		video_params.uri = video;

		this.set({ player_params: video_params, container: player });

		var events = {
			STREAM_END: function STREAM_END() {
				PubSub.trigger('videoEnded');
			},
			FULL_SCREEN_CHANGE: function FULL_SCREEN_CHANGE() {
				PubSub.trigger('resizeWindow');
			}
		};

		this.currentVideo = new EdgePlayer.Player(player, this.get('player_params'), events);

		this.registerListeners();
	},
	/**
  * [registerListeners description]
  * @return {[type]} [description]
  */
	registerListeners: function registerListeners() {
		this.currentVideo.on(EdgePlayer.Events.STREAM_END, this.mediaEnded.bind(this));

		// this.currentVideo.on('ready', this.playerReady.bind(this));
		// this.currentVideo.on('fullScreenChange', this.fullScreenChange);
	},
	/**
  * [mediaEnded description]
  * @return {[type]} [description]
  */
	mediaEnded: function mediaEnded() {
		// PubSub.trigger('resizeWindow');
		PubSub.trigger('videoEnded');
	},
	/**
  *
  */
	fullScreenChange: function fullScreenChange(event) {
		if (event.target.isFullScreen) return;

		// console.warn('fullScreenChange, resize window');
		PubSub.trigger('resizeWindow');
	},
	/**
  *
  */
	playerReady: function playerReady() {
		// play the video
		this.currentVideo.play();
	}
});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0),
    $ = __webpack_require__(4),
    Backbone = __webpack_require__(1);

module.exports = Backbone.Model.extend({
    defaults: {
        copy: {},
        uid: null,
        share: {},
        native: false
    },
    /**
     * [initialize description]
     * @param  {[type]} attrs   [description]
     * @param  {[type]} options [description]
     * @return {[type]}         [description]
     */
    initialize: function initialize(attrs, options) {},
    /**
    *
    */
    fetch: function fetch(options) {
        console.log('Share model does not support "fetch"');
    },
    /**
    *
    */
    save: function save(attrs, options) {
        console.log('Share model does not support "save"');
    },
    /**
    *
    */
    destroy: function destroy(options) {
        options = options ? _.clone(options) : {};
        var model = this;
        var wait = options.wait;

        var destroy = function destroy() {
            model.stopListening();
            model.trigger('destroy', model, model.collection, options);
        };

        if (!wait) destroy();

        console.log('Share model does not support "destroy"');
    }
});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);

module.exports = Backbone.Model.extend({
    /**
     * Default attributes
     */
    defaults: {
        // Time values
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        // Timer settings
        addZeros: true,
        enableDays: false,
        endTime: null,
        endTimestamp: null,
        isResetting: false,
        timerEnded: true
    },
    /**
     * Initialize countdown model
     */
    initialize: function initialize(attrs, options) {
        this.cms = options.cms;
        this.listenTo(this.cms, 'change:sid', this._updateTS.bind(this));
        this._setDefaults();
        this._updateTS();
        this.lastAnimateTimestamp = 0;
    },
    /**
     * Calculate for the time remaining
     */
    getTimeRemaining: function getTimeRemaining() {
        var elapsedTime = new Date().getTime() - this.cms.get('localTime');
        var startTime = this.cmsLastTS + elapsedTime;
        var endTime = new Date(this.get('endTime')).getTime();
        return parseInt((endTime - startTime) / 1000, 10);
    },
    /**
     * Start the countdown timer
     */
    startCountdown: function startCountdown() {
        this.lastAnimateTimestamp = 0;
        this.set({ timerEnded: false }, { silent: true });
        this._countdown();
    },
    /**
     * Stop the countdown timer
     */
    stopCountdown: function stopCountdown() {
        this._setDefaults();
    },
    /**
     * Calculate the time remaining
     */
    _countdown: function _countdown(currentTimestamp) {
        // Make sure there is an endTime set
        if (!this.get('endTime')) return;

        //Return if less than a second has passed.
        if (this.lastAnimateTimestamp && currentTimestamp - this.lastAnimateTimestamp < 1000) {
            requestAnimationFrame(this._countdown.bind(this));
            return;
        } else {
            this.lastAnimateTimestamp = currentTimestamp;
        }

        // Calculate the time remaining in seconds
        var timeRemaining = this.getTimeRemaining();

        if (this.get('isResetting') && timeRemaining > 0 || !this.get('isResetting') && timeRemaining >= 0) {

            // Days can be toggled depending on what's needed for the project
            var days = this.get('enableDays') ? parseInt(timeRemaining / 86400, 10) : this.get('days');
            if (this.get('enableDays')) timeRemaining = timeRemaining % 86400;

            var hours = parseInt(timeRemaining / 3600, 10);
            timeRemaining = timeRemaining % 3600;
            var minutes = parseInt(timeRemaining / 60, 10);
            timeRemaining = timeRemaining % 60;
            var seconds = parseInt(timeRemaining, 10);

            // Set the new time values
            var addZeros = this.get('addZeros');
            this.set({
                days: days,
                hours: addZeros ? ('0' + hours).slice(-2) : hours,
                minutes: addZeros ? ('0' + minutes).slice(-2) : minutes,
                seconds: addZeros ? ('0' + seconds).slice(-2) : seconds
            });

            requestAnimationFrame(this._countdown.bind(this));
        } else {
            // Stop the timer once it reaches the endTime
            this.stopCountdown();
        }
    },
    /**
     * Set default values
     */
    _setDefaults: function _setDefaults() {
        var defaultValue = this.get('addZeros') ? '00' : 0;
        this.set({
            days: 0,
            hours: defaultValue,
            minutes: defaultValue,
            seconds: defaultValue,
            timerEnded: true
        });
    },
    /**
     * Update the server TS upon CMS snapshot change
     */
    _updateTS: function _updateTS() {
        this.cmsLastTS = this.cms.get('ts');
    }
});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _ = __webpack_require__(0);
var $ = __webpack_require__(4);
var Backbone = __webpack_require__(1);

var PICTURE_LARGE   = 'large';
var PICTURE_NORMAL  = 'normal';
var PICTURE_SMALL   = 'small';
var PICTURE_SQUARE  = 'square';

var NOT_AUTHORIZED  = 'not_authorized';
var DISCONNECTED    = 'disconnected';
var CONNECTED       = 'connected';

function createCookie(name,value,days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = '; expires='+date.toGMTString();
  }
  document.cookie = name+'='+value+expires+'; path=/';
}

function eraseCookie(name) {
  createCookie(name,'',-1);
}

module.exports = Backbone.Model.extend({
    
  defaults: {
    appId: '',
    status: '',
    age_range: null,
    email: '',
    id: '',
    name: '',
    permissions: null,
    pictures: null,
    authResponse: null
  },

  options: {
    autoUpdateLoginStatus: true,
    autoLoadUserData: true,
    scope: '',
    version: 'v2.12',
    manageFbloCookie: true
  },

  /**
   * Initialize the Model
   * @param {Object} attributes 
   * @param {Object} options 
   */
  initialize: function(attributes, options) {
    _.bindAll(this, 'updateLoginStatus');

    options || (options = {});
    _.extend(this.options, options);

    if(typeof FB === 'object' && !_.isUndefined(window.fbAsyncInit)){
      this.onScriptLoaded();
      return;
    } else {
      window.fbAsyncInit = this.onScriptLoaded.bind(this);
      this.loadScript(document, 'script', 'facebook-jssdk');
    }
  },

  loadScript: function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  },

  onScriptLoaded: function() {
    this._scriptLoaded = true;

    FB.init({
      appId      : this.get('appId'),
      xfbml      : true,
      version    : this.options.version,
      cookie     : true
    });

    if(this.options.autoUpdateLoginStatus) {
      this.getLoginStatus();
    }
  },

  isConnected: function() {
    return this.get('status') === 'connected';
  },

  login: function(options){
    if(!this._scriptLoaded) {
      throw new Error('Facebook User Model: Login cannot be called before the SDK is loaded.');
    }

    if(this.options.manageFbloCookie) {
      //After login, clear this cookie.
      eraseCookie('fblo_' + this.get('appId'));
    }

    var deferred = $.Deferred();

    var callback = function(response) {
      this.updateLoginStatus(response).then(function() {
        if(response.status === CONNECTED) {
          deferred.resolve(response);
        } else {
          deferred.reject(response);
        }
      });
    }.bind(this);

    var opts = _.extend({
      scope: this.options.scope,
      return_scopes: true
    }, options);

    FB.login(callback, opts);
    return deferred;
  },

  logout: function(callback){
    if(!this._scriptLoaded) {
      throw new Error('Facebook User Model: Logout cannot be called before the SDK is loaded.');
    }

    FB.getLoginStatus(function(response) {
      if(response.status === 'connected' || response.status === 'not_authorized') {
        FB.logout(callback);
      } else {
        this.updateLoginStatus(response);
        if(typeof callback === 'function') {
          callback();
        }
      }
    }.bind(this), true);
  },

  api: fbapi,
  ui: fbui,

  getLoginStatus: function(){
    if(!this._scriptLoaded) {
      throw new Error('Facebook User Model: UpdateLoginStatus cannot be called before the SDK is loaded.');
    }
    FB.getLoginStatus(this.updateLoginStatus);
  },

  updateLoginStatus: function(response) {
    this.set('authResponse', response.authResponse);

    if(response.status === CONNECTED && this.options.autoLoadUserData) {
      return this.fetch().done(function(response) {
        this.set('status', CONNECTED);
      }.bind(this));
    } else {
      this.set('status', response.status);
      return $.Deferred().resolve();
    }
  },

  parse: function(response) {
    var attributes = _.extend(response, {
      pictures: this.profilePictureUrls(response.id)
    });

    if(response.permissions) {
      var permissions = _.filter(response.permissions.data, function(p) {
        return p.status == 'granted';
      });

      attributes.permissions = _.map(permissions, function(p) {
        if(p.status == 'granted') {
          return p.permission;
        }
      });
    }

    return attributes;
  },

  sync: function(method, model, options) {
    if(method !== 'read') throw new Error('FacebookUser is a readonly model, cannot perform ' + method);

    var deferred = $.Deferred();
    var callback = function(response) {
      if(response.error) {
        if(options.error) options.error(response);
        deferred.reject(response);
      } else {
        if(options.success) options.success(response);
        deferred.resolve(response);
      }
      return true;
    }.bind(this);

    var request = FB.api('/me?fields=id,name,permissions,age_range,email,first_name,last_name,gender', callback);
    return deferred;
  },

  profilePictureUrls: function(id) {
    id || (id = this.id);
    var urls = {};

    _.each([ PICTURE_SQUARE, PICTURE_SMALL, PICTURE_NORMAL, PICTURE_LARGE ], function(size){
      urls[size] = this.profilePictureUrl(id, size);
    }, this);

    return urls;
  },

  profilePictureUrl: function(id, size) {
    size = size || PICTURE_LARGE;

    return [
      'https://graph.facebook.com/',
      id,
      '/picture?type=',
      size,
      '&return_ssl_resources=1'
    ].join('');
  }

}, {
  PICTURE_SMALL: PICTURE_SMALL,
  PICTURE_LARGE: PICTURE_LARGE,
  PICTURE_NORMAL: PICTURE_NORMAL,
  PICTURE_SQUARE: PICTURE_SQUARE,
  NOT_AUTHORIZED: NOT_AUTHORIZED,
  DISCONNECTED: DISCONNECTED,
  CONNECTED: CONNECTED
});

function facebookAPIWrapper(args) {
  var userCallback = args[args.length - 1];
  var def = $.Deferred();

  var wrappedCallback = function(response) {
    if(typeof userCallback === 'function') {
      userCallback(response);
    }
    def.resolve(response);
  };

  if(typeof userCallback === 'function') {
    // If the user provided a callback, let's overwrite it with our wrapped version.
    args[args.length - 1] = wrappedCallback;
  } else {
    // If the user didn't provide a callback, let's add our own callback to the end of the param list.
    // This will allow the use of Deferred/Promise pattern.
    args.push(wrappedCallback);
  }

  return def;
}

function fbui() {
  if(!this._scriptLoaded) {
    throw new Error('Facebook User Model: "FB.ui" cannot be called before the SDK is loaded.');
  }

  var args = Array.prototype.slice.call(arguments);
  var def = facebookAPIWrapper(args);

  FB.ui.apply(this, args);
  return def;
}

function fbapi() {
  if(!this._scriptLoaded) {
    throw new Error('Facebook User Model: "FB.api" cannot be called before the SDK is loaded.');
  }

  var args = Array.prototype.slice.call(arguments);
  var def = facebookAPIWrapper(args);

  FB.api.apply(this, ret.args);
  return def;
}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var Model = __webpack_require__(280);

module.exports = Backbone.Collection.extend({

  model: Model,
  /**
   *
   */
  initialize: function initialize(attrs, options) {
    this.getVotableCategories();
  },
  /**
   *
   */
  modelId: function modelId(attrs) {
    return attrs.displayName;
  },
  /**
   *
   */
  activeCategories: [],
  /**
   *
   */
  comparator: 'order',
  /**
   * [next description]
   * @param  {[type]}   option [description]
   * @return {Function}        [description]
   */
  next: function next(option) {
    if (!this.contains(option)) {
      return false;
    }
    var model = this.at(this.indexOf(option) + 1);

    if (_.isUndefined(model)) {
      model = this.last();
    }

    return model;
  },
  /**
   * [prev description]
   * @param  {[type]} option [description]
   * @return {[type]}        [description]
   */
  prev: function prev(option) {
    if (!this.contains(option)) {
      return false;
    }
    var model = this.at(this.indexOf(option) - 1);

    if (_.isUndefined(model)) {
      model = this.first();
    }

    return model;
  },
  /**
   * Return the category that matches the passed ID
   * @param categoryID - ID of the category we want to look up
   */
  getCategoryById: function getCategoryById(categoryID) {
    return this.findWhere({ id: categoryID });
  },
  /**
   * [findSocialCategory description]
   * @return {[type]} [description]
   */
  findSocialCategory: function findSocialCategory() {
    var socialCategory;

    _.forEach(this.models, function (model, index) {
      if (model.get('social') == '1') {
        socialCategory = model;
      }
    });

    return socialCategory;
  },
  /**
   * [findSocialCategory description]
   * @return {[type]} [description]
   */
  findTwitterCategory: function findTwitterCategory() {
    var twitterCategory;

    _.forEach(this.models, function (model, index) {
      if (model.get('live_vote') == '1') {
        twitterCategory = model;
      }
    });

    return twitterCategory;
  },
  /**
   * Returns the next votable category
   * @param lastVotedCatID - we will look for the next votable model starting from this ID
   */
  getNextVotableCategory: function getNextVotableCategory(lastVotedCatID, selectedCatId) {
    var filteredModels = this.getVotableCategories();
    var returnModel = null;

    // if user just logged after clicking the plus button and have selected a votable category, return early
    if (!lastVotedCatID && selectedCatId) {

      returnModel = filteredModels.find(function (model) {
        return model.id === selectedCatId;
      });

      if (!returnModel) returnModel = filteredModels[0];
      return returnModel;
    }

    // if user just logged in via storage (i.e. have not seleted a category manually)
    lastVotedCatID = lastVotedCatID ? lastVotedCatID : -1;

    filteredModels.some(function (model) {
      if (model.id > lastVotedCatID) {
        returnModel = model;
      }
      return model.id > lastVotedCatID;
    });

    // If there are still votable categories and the user reached the end,
    // route them back to the first of the remaining votable categories
    if (filteredModels.length > 0 && !returnModel) {
      returnModel = filteredModels[0];
    }

    return returnModel;
  },
  /**
   * Returns the total number of active categories, including submitted ones
   */
  getTotalActiveCategories: function getTotalActiveCategories() {

    var activeCategories = this.where({
      active: '1',
      social: '0',
      live_vote: '0',
      professional: '0'
    });

    return activeCategories.length;
  },
  /**
   * Returns the total number of submitted categories
   */
  getTotalSubmittedCategories: function getTotalSubmittedCategories() {

    var submittedCategories = this.where({
      active: '1',
      social: '0',
      live_vote: '0',
      professional: '0',
      isSubmitted: true
    });

    return submittedCategories.length;
  },
  /**
   * Returns an array of all votable categories
   */
  getVotableCategories: function getVotableCategories() {

    var votableCategories = this.where({
      active: '1',
      social: '0',
      professional: '0',
      isSubmitted: false
    });

    return votableCategories;
  },
  /**
   *
   */
  findCategoryByDisplayName: function findCategoryByDisplayName(display_name) {
    var found;

    this.forEach(function (item, index, list) {
      if (item.get('displayName') == display_name) {
        found = item;
        return true;
      }
    });

    return found;
  }
});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);

module.exports = Backbone.Model.extend({
    defaults: {
        copy: {},
        id: null,
        name: null,
        person: 0,
        sponsor: null,
        professional: 0,
        isSubmitted: false,
        totalAllocatedVotes: 0,
        hasAlreadyConfirmed: false,
        categoryVotes: {},
        voteData: [],
        categoryVotesTotal: 0
    },
    /**
     * Adjust total allocated votes
     */
    voteCountUpdate: function voteCountUpdate(updateType, contestantID, contestantVoteCount) {
        var totalAllocatedVotes = this.get('totalAllocatedVotes');
        var tempCategoryVotes = _.clone(this.get('categoryVotes'));

        if (!contestantVoteCount) {
            delete tempCategoryVotes[contestantID];
        } else {
            tempCategoryVotes[contestantID] = contestantVoteCount;
        }

        this.set('categoryVotes', tempCategoryVotes);

        switch (updateType) {
            case 'minus':
                this.set('totalAllocatedVotes', totalAllocatedVotes - 1);
                break;
            case 'plus':
                this.set('totalAllocatedVotes', totalAllocatedVotes + 1);
                break;
        }
    },
    /**
     * When user chooses to edit and make changes to their current votes,
     * all the plus buttons that are disabled should be updated
     */
    updateEditButtons: function updateEditButtons() {
        this.trigger('updateEditButtons', this.get('id'));
    },
    /**
     * When user has allocated all vote available, disable all the plus buttons
     */
    updatePlusButtons: function updatePlusButtons() {
        this.trigger('updatePlusButtons', this.get('id'));
    }
});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    omniture: __webpack_require__(282)
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// constants
var CONSTANTS = __webpack_require__(11).OMNITURE;
var _ = __webpack_require__(0);

/**
 * try a specified number of times in case call fails
 */
function attemptCall(cb, attempts) {

    attempts = attempts || 0;

    if (++attempts > CONSTANTS.MAX_ATTEMPTS) return;

    try {
        cb();
    } catch (e) {
        setTimeout(attemptCall.bind(null, cb, attempts), CONSTANTS.RETRY_DELAY);
    }
}
/**
 * Track the click events
 * @param event - Object with the following properties:
 *        name - the event name
 *        section - if the user clicks within a category
 *        destination - if it's a link, the URL of the link
 *        isSocial - if the click is for a social category
 */
function clickEvent(event) {
    var contextVars = {};
    var url = event.url || window.location.href;

    contextVars['pageName'] = event.section ? CONSTANTS.PAGE_NAME + '|' + event.section : CONSTANTS.PAGE_NAME;
    contextVars['v.destination'] = event.destination ? event.destination : CONSTANTS.CLICK_NO_DEST;
    contextVars['v.actName'] = 'clicks on ' + event.name;
    contextVars['v.pageType'] = CONSTANTS.PAGE_TYPE;
    contextVars['v.pageURL'] = url;
    contextVars['v.pageFranchise'] = CONSTANTS.PAGE_FRANCHISE;
    contextVars['v.appName'] = CONSTANTS.APP_NAME;
    contextVars['v.vendor'] = CONSTANTS.VENDOR;
    contextVars['v.brandID'] = CONSTANTS.BRAND_ID;
    contextVars['v.activity'] = CONSTANTS.CLICK_ACTIVITY;
    contextVars['v.pv'] = 'false';
    contextVars['linkType'] = CONSTANTS.CLICK_LINK_TYPE;
    contextVars['v.channel'] = CONSTANTS.PAGE_CHANNEL;
    contextVars['v.pageEvent'] = CONSTANTS.PAGE_EVENT;
    contextVars['v.language'] = CONSTANTS.LANGUAGE;
    contextVars['v.countryName'] = CONSTANTS.COUNTRY_NAME;
    contextVars['v.actPageName'] = url;

    if (event.isSocial) {
        contextVars['v.modname'] = CONSTANTS.MOD_NAME_SOCIAL;
    } else {
        contextVars['v.modname'] = event.modname || CONSTANTS.MOD_NAME;
    }

    if (window.Bento) {
        window.Bento.onPageEvent(contextVars);
    }
}
/**
 * Track page events
 */
function pageEvent(event) {
    var pageName = event.page ? CONSTANTS.PAGE_NAME + '|' + event.page : CONSTANTS.PAGE_NAME;
    var url = event.url || window.location.href;

    var contextVars = {};
    contextVars['pageName'] = pageName;
    contextVars['v.channel'] = CONSTANTS.PAGE_CHANNEL;
    contextVars['v.pageType'] = CONSTANTS.PAGE_TYPE;
    contextVars['v.pageFranchise'] = CONSTANTS.PAGE_FRANCHISE;
    contextVars['v.pageSeries'] = CONSTANTS.PAGE_SERIES;
    // contextVars['v.prevPageName'] = CONSTANTS.PREV_PAGE_NAME;
    contextVars['v.pageURL'] = url;
    contextVars['v.pageEvent'] = CONSTANTS.PAGE_EVENT;
    contextVars['v.webVersion'] = CONSTANTS.WEB_VERSION;
    contextVars['v.brandID'] = CONSTANTS.BRAND_ID;
    contextVars['v.language'] = CONSTANTS.LANGUAGE;
    contextVars['v.countryName'] = CONSTANTS.COUNTRY_NAME;
    contextVars['v.vendor'] = CONSTANTS.VENDOR;
    contextVars['v.activity'] = CONSTANTS.PAGE_ACTIVITY;
    contextVars['v.pv'] = 'true';
    contextVars['v.appName'] = CONSTANTS.APP_NAME;
    contextVars['v.vidFranchise'] = CONSTANTS.PAGE_VID_FRANCHISE;

    if (window.Bento) {
        window.Bento.onNewPage(contextVars);
    }
}

document.addEventListener('omnitureClickEvent', function (event) {
    clickEvent(event.detail);
});

module.exports = {
    /**
     * send an omniture click event
     */
    sendClickEvent: function sendClickEvent(event) {
        attemptCall(clickEvent.bind(null, event));
    },
    /**
     * send an omniture page event
     */
    sendPageEvent: function sendPageEvent(pageName) {
        attemptCall(pageEvent.bind(null, pageName));
    }
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/9ebc4619825b7ede64bf.main.js